var map = {
	"./svgs/brands/500px.svg": 608,
	"./svgs/brands/accessible-icon.svg": 609,
	"./svgs/brands/accusoft.svg": 610,
	"./svgs/brands/acquisitions-incorporated.svg": 611,
	"./svgs/brands/adn.svg": 612,
	"./svgs/brands/adobe.svg": 613,
	"./svgs/brands/adversal.svg": 614,
	"./svgs/brands/affiliatetheme.svg": 615,
	"./svgs/brands/airbnb.svg": 616,
	"./svgs/brands/algolia.svg": 617,
	"./svgs/brands/alipay.svg": 618,
	"./svgs/brands/amazon-pay.svg": 619,
	"./svgs/brands/amazon.svg": 620,
	"./svgs/brands/amilia.svg": 621,
	"./svgs/brands/android.svg": 622,
	"./svgs/brands/angellist.svg": 623,
	"./svgs/brands/angrycreative.svg": 624,
	"./svgs/brands/angular.svg": 625,
	"./svgs/brands/app-store-ios.svg": 626,
	"./svgs/brands/app-store.svg": 627,
	"./svgs/brands/apper.svg": 628,
	"./svgs/brands/apple-pay.svg": 629,
	"./svgs/brands/apple.svg": 630,
	"./svgs/brands/artstation.svg": 631,
	"./svgs/brands/asymmetrik.svg": 632,
	"./svgs/brands/atlassian.svg": 633,
	"./svgs/brands/audible.svg": 634,
	"./svgs/brands/autoprefixer.svg": 635,
	"./svgs/brands/avianex.svg": 636,
	"./svgs/brands/aviato.svg": 637,
	"./svgs/brands/aws.svg": 638,
	"./svgs/brands/bandcamp.svg": 639,
	"./svgs/brands/battle-net.svg": 640,
	"./svgs/brands/behance-square.svg": 641,
	"./svgs/brands/behance.svg": 642,
	"./svgs/brands/bimobject.svg": 643,
	"./svgs/brands/bitbucket.svg": 644,
	"./svgs/brands/bitcoin.svg": 645,
	"./svgs/brands/bity.svg": 646,
	"./svgs/brands/black-tie.svg": 647,
	"./svgs/brands/blackberry.svg": 648,
	"./svgs/brands/blogger-b.svg": 649,
	"./svgs/brands/blogger.svg": 650,
	"./svgs/brands/bluetooth-b.svg": 651,
	"./svgs/brands/bluetooth.svg": 652,
	"./svgs/brands/bootstrap.svg": 653,
	"./svgs/brands/btc.svg": 654,
	"./svgs/brands/buffer.svg": 655,
	"./svgs/brands/buromobelexperte.svg": 656,
	"./svgs/brands/buy-n-large.svg": 657,
	"./svgs/brands/buysellads.svg": 658,
	"./svgs/brands/canadian-maple-leaf.svg": 659,
	"./svgs/brands/cc-amazon-pay.svg": 660,
	"./svgs/brands/cc-amex.svg": 661,
	"./svgs/brands/cc-apple-pay.svg": 662,
	"./svgs/brands/cc-diners-club.svg": 663,
	"./svgs/brands/cc-discover.svg": 664,
	"./svgs/brands/cc-jcb.svg": 665,
	"./svgs/brands/cc-mastercard.svg": 666,
	"./svgs/brands/cc-paypal.svg": 667,
	"./svgs/brands/cc-stripe.svg": 668,
	"./svgs/brands/cc-visa.svg": 669,
	"./svgs/brands/centercode.svg": 670,
	"./svgs/brands/centos.svg": 671,
	"./svgs/brands/chrome.svg": 672,
	"./svgs/brands/chromecast.svg": 673,
	"./svgs/brands/cloudscale.svg": 674,
	"./svgs/brands/cloudsmith.svg": 675,
	"./svgs/brands/cloudversify.svg": 676,
	"./svgs/brands/codepen.svg": 677,
	"./svgs/brands/codiepie.svg": 678,
	"./svgs/brands/confluence.svg": 679,
	"./svgs/brands/connectdevelop.svg": 680,
	"./svgs/brands/contao.svg": 681,
	"./svgs/brands/cotton-bureau.svg": 682,
	"./svgs/brands/cpanel.svg": 683,
	"./svgs/brands/creative-commons-by.svg": 684,
	"./svgs/brands/creative-commons-nc-eu.svg": 685,
	"./svgs/brands/creative-commons-nc-jp.svg": 686,
	"./svgs/brands/creative-commons-nc.svg": 687,
	"./svgs/brands/creative-commons-nd.svg": 688,
	"./svgs/brands/creative-commons-pd-alt.svg": 689,
	"./svgs/brands/creative-commons-pd.svg": 690,
	"./svgs/brands/creative-commons-remix.svg": 691,
	"./svgs/brands/creative-commons-sa.svg": 692,
	"./svgs/brands/creative-commons-sampling-plus.svg": 693,
	"./svgs/brands/creative-commons-sampling.svg": 694,
	"./svgs/brands/creative-commons-share.svg": 695,
	"./svgs/brands/creative-commons-zero.svg": 696,
	"./svgs/brands/creative-commons.svg": 697,
	"./svgs/brands/critical-role.svg": 698,
	"./svgs/brands/css3-alt.svg": 699,
	"./svgs/brands/css3.svg": 700,
	"./svgs/brands/cuttlefish.svg": 701,
	"./svgs/brands/d-and-d-beyond.svg": 702,
	"./svgs/brands/d-and-d.svg": 703,
	"./svgs/brands/dashcube.svg": 704,
	"./svgs/brands/delicious.svg": 705,
	"./svgs/brands/deploydog.svg": 706,
	"./svgs/brands/deskpro.svg": 707,
	"./svgs/brands/dev.svg": 708,
	"./svgs/brands/deviantart.svg": 709,
	"./svgs/brands/dhl.svg": 710,
	"./svgs/brands/diaspora.svg": 711,
	"./svgs/brands/digg.svg": 712,
	"./svgs/brands/digital-ocean.svg": 713,
	"./svgs/brands/discord.svg": 714,
	"./svgs/brands/discourse.svg": 715,
	"./svgs/brands/dochub.svg": 716,
	"./svgs/brands/docker.svg": 717,
	"./svgs/brands/draft2digital.svg": 718,
	"./svgs/brands/dribbble-square.svg": 719,
	"./svgs/brands/dribbble.svg": 720,
	"./svgs/brands/dropbox.svg": 721,
	"./svgs/brands/drupal.svg": 722,
	"./svgs/brands/dyalog.svg": 723,
	"./svgs/brands/earlybirds.svg": 724,
	"./svgs/brands/ebay.svg": 725,
	"./svgs/brands/edge.svg": 726,
	"./svgs/brands/elementor.svg": 727,
	"./svgs/brands/ello.svg": 728,
	"./svgs/brands/ember.svg": 729,
	"./svgs/brands/empire.svg": 730,
	"./svgs/brands/envira.svg": 731,
	"./svgs/brands/erlang.svg": 732,
	"./svgs/brands/ethereum.svg": 733,
	"./svgs/brands/etsy.svg": 734,
	"./svgs/brands/evernote.svg": 735,
	"./svgs/brands/expeditedssl.svg": 736,
	"./svgs/brands/facebook-f.svg": 737,
	"./svgs/brands/facebook-messenger.svg": 738,
	"./svgs/brands/facebook-square.svg": 739,
	"./svgs/brands/facebook.svg": 740,
	"./svgs/brands/fantasy-flight-games.svg": 741,
	"./svgs/brands/fedex.svg": 742,
	"./svgs/brands/fedora.svg": 743,
	"./svgs/brands/figma.svg": 744,
	"./svgs/brands/firefox-browser.svg": 745,
	"./svgs/brands/firefox.svg": 746,
	"./svgs/brands/first-order-alt.svg": 747,
	"./svgs/brands/first-order.svg": 748,
	"./svgs/brands/firstdraft.svg": 749,
	"./svgs/brands/flickr.svg": 750,
	"./svgs/brands/flipboard.svg": 751,
	"./svgs/brands/fly.svg": 752,
	"./svgs/brands/font-awesome-alt.svg": 753,
	"./svgs/brands/font-awesome-flag.svg": 754,
	"./svgs/brands/font-awesome-logo-full.svg": 755,
	"./svgs/brands/font-awesome.svg": 756,
	"./svgs/brands/fonticons-fi.svg": 757,
	"./svgs/brands/fonticons.svg": 758,
	"./svgs/brands/fort-awesome-alt.svg": 759,
	"./svgs/brands/fort-awesome.svg": 760,
	"./svgs/brands/forumbee.svg": 761,
	"./svgs/brands/foursquare.svg": 762,
	"./svgs/brands/free-code-camp.svg": 763,
	"./svgs/brands/freebsd.svg": 764,
	"./svgs/brands/fulcrum.svg": 765,
	"./svgs/brands/galactic-republic.svg": 766,
	"./svgs/brands/galactic-senate.svg": 767,
	"./svgs/brands/get-pocket.svg": 768,
	"./svgs/brands/gg-circle.svg": 769,
	"./svgs/brands/gg.svg": 770,
	"./svgs/brands/git-alt.svg": 771,
	"./svgs/brands/git-square.svg": 772,
	"./svgs/brands/git.svg": 773,
	"./svgs/brands/github-alt.svg": 774,
	"./svgs/brands/github-square.svg": 775,
	"./svgs/brands/github.svg": 776,
	"./svgs/brands/gitkraken.svg": 777,
	"./svgs/brands/gitlab.svg": 778,
	"./svgs/brands/gitter.svg": 779,
	"./svgs/brands/glide-g.svg": 780,
	"./svgs/brands/glide.svg": 781,
	"./svgs/brands/gofore.svg": 782,
	"./svgs/brands/goodreads-g.svg": 783,
	"./svgs/brands/goodreads.svg": 784,
	"./svgs/brands/google-drive.svg": 785,
	"./svgs/brands/google-play.svg": 786,
	"./svgs/brands/google-plus-g.svg": 787,
	"./svgs/brands/google-plus-square.svg": 788,
	"./svgs/brands/google-plus.svg": 789,
	"./svgs/brands/google-wallet.svg": 790,
	"./svgs/brands/google.svg": 791,
	"./svgs/brands/gratipay.svg": 792,
	"./svgs/brands/grav.svg": 793,
	"./svgs/brands/gripfire.svg": 794,
	"./svgs/brands/grunt.svg": 795,
	"./svgs/brands/gulp.svg": 796,
	"./svgs/brands/hacker-news-square.svg": 797,
	"./svgs/brands/hacker-news.svg": 798,
	"./svgs/brands/hackerrank.svg": 799,
	"./svgs/brands/hips.svg": 800,
	"./svgs/brands/hire-a-helper.svg": 801,
	"./svgs/brands/hooli.svg": 802,
	"./svgs/brands/hornbill.svg": 803,
	"./svgs/brands/hotjar.svg": 804,
	"./svgs/brands/houzz.svg": 805,
	"./svgs/brands/html5.svg": 806,
	"./svgs/brands/hubspot.svg": 807,
	"./svgs/brands/ideal.svg": 808,
	"./svgs/brands/imdb.svg": 809,
	"./svgs/brands/instagram.svg": 810,
	"./svgs/brands/intercom.svg": 811,
	"./svgs/brands/internet-explorer.svg": 812,
	"./svgs/brands/invision.svg": 813,
	"./svgs/brands/ioxhost.svg": 814,
	"./svgs/brands/itch-io.svg": 815,
	"./svgs/brands/itunes-note.svg": 816,
	"./svgs/brands/itunes.svg": 817,
	"./svgs/brands/java.svg": 818,
	"./svgs/brands/jedi-order.svg": 819,
	"./svgs/brands/jenkins.svg": 820,
	"./svgs/brands/jira.svg": 821,
	"./svgs/brands/joget.svg": 822,
	"./svgs/brands/joomla.svg": 823,
	"./svgs/brands/js-square.svg": 824,
	"./svgs/brands/js.svg": 825,
	"./svgs/brands/jsfiddle.svg": 826,
	"./svgs/brands/kaggle.svg": 827,
	"./svgs/brands/keybase.svg": 828,
	"./svgs/brands/keycdn.svg": 829,
	"./svgs/brands/kickstarter-k.svg": 830,
	"./svgs/brands/kickstarter.svg": 831,
	"./svgs/brands/korvue.svg": 832,
	"./svgs/brands/laravel.svg": 833,
	"./svgs/brands/lastfm-square.svg": 834,
	"./svgs/brands/lastfm.svg": 835,
	"./svgs/brands/leanpub.svg": 836,
	"./svgs/brands/less.svg": 837,
	"./svgs/brands/line.svg": 838,
	"./svgs/brands/linkedin-in.svg": 839,
	"./svgs/brands/linkedin.svg": 840,
	"./svgs/brands/linode.svg": 841,
	"./svgs/brands/linux.svg": 842,
	"./svgs/brands/lyft.svg": 843,
	"./svgs/brands/magento.svg": 844,
	"./svgs/brands/mailchimp.svg": 845,
	"./svgs/brands/mandalorian.svg": 846,
	"./svgs/brands/markdown.svg": 847,
	"./svgs/brands/mastodon.svg": 848,
	"./svgs/brands/maxcdn.svg": 849,
	"./svgs/brands/mdb.svg": 850,
	"./svgs/brands/medapps.svg": 851,
	"./svgs/brands/medium-m.svg": 852,
	"./svgs/brands/medium.svg": 853,
	"./svgs/brands/medrt.svg": 854,
	"./svgs/brands/meetup.svg": 855,
	"./svgs/brands/megaport.svg": 856,
	"./svgs/brands/mendeley.svg": 857,
	"./svgs/brands/microblog.svg": 858,
	"./svgs/brands/microsoft.svg": 859,
	"./svgs/brands/mix.svg": 860,
	"./svgs/brands/mixcloud.svg": 861,
	"./svgs/brands/mizuni.svg": 862,
	"./svgs/brands/modx.svg": 863,
	"./svgs/brands/monero.svg": 864,
	"./svgs/brands/napster.svg": 865,
	"./svgs/brands/neos.svg": 866,
	"./svgs/brands/nimblr.svg": 867,
	"./svgs/brands/node-js.svg": 868,
	"./svgs/brands/node.svg": 869,
	"./svgs/brands/npm.svg": 870,
	"./svgs/brands/ns8.svg": 871,
	"./svgs/brands/nutritionix.svg": 872,
	"./svgs/brands/odnoklassniki-square.svg": 873,
	"./svgs/brands/odnoklassniki.svg": 874,
	"./svgs/brands/old-republic.svg": 875,
	"./svgs/brands/opencart.svg": 876,
	"./svgs/brands/openid.svg": 877,
	"./svgs/brands/opera.svg": 878,
	"./svgs/brands/optin-monster.svg": 879,
	"./svgs/brands/orcid.svg": 880,
	"./svgs/brands/osi.svg": 881,
	"./svgs/brands/page4.svg": 882,
	"./svgs/brands/pagelines.svg": 883,
	"./svgs/brands/palfed.svg": 884,
	"./svgs/brands/patreon.svg": 885,
	"./svgs/brands/paypal.svg": 886,
	"./svgs/brands/penny-arcade.svg": 887,
	"./svgs/brands/periscope.svg": 888,
	"./svgs/brands/phabricator.svg": 889,
	"./svgs/brands/phoenix-framework.svg": 890,
	"./svgs/brands/phoenix-squadron.svg": 891,
	"./svgs/brands/php.svg": 892,
	"./svgs/brands/pied-piper-alt.svg": 893,
	"./svgs/brands/pied-piper-hat.svg": 894,
	"./svgs/brands/pied-piper-pp.svg": 895,
	"./svgs/brands/pied-piper-square.svg": 896,
	"./svgs/brands/pied-piper.svg": 897,
	"./svgs/brands/pinterest-p.svg": 898,
	"./svgs/brands/pinterest-square.svg": 899,
	"./svgs/brands/pinterest.svg": 900,
	"./svgs/brands/playstation.svg": 901,
	"./svgs/brands/product-hunt.svg": 902,
	"./svgs/brands/pushed.svg": 903,
	"./svgs/brands/python.svg": 904,
	"./svgs/brands/qq.svg": 905,
	"./svgs/brands/quinscape.svg": 906,
	"./svgs/brands/quora.svg": 907,
	"./svgs/brands/r-project.svg": 908,
	"./svgs/brands/raspberry-pi.svg": 909,
	"./svgs/brands/ravelry.svg": 910,
	"./svgs/brands/react.svg": 911,
	"./svgs/brands/reacteurope.svg": 912,
	"./svgs/brands/readme.svg": 913,
	"./svgs/brands/rebel.svg": 914,
	"./svgs/brands/red-river.svg": 915,
	"./svgs/brands/reddit-alien.svg": 916,
	"./svgs/brands/reddit-square.svg": 917,
	"./svgs/brands/reddit.svg": 918,
	"./svgs/brands/redhat.svg": 919,
	"./svgs/brands/renren.svg": 920,
	"./svgs/brands/replyd.svg": 921,
	"./svgs/brands/researchgate.svg": 922,
	"./svgs/brands/resolving.svg": 923,
	"./svgs/brands/rev.svg": 924,
	"./svgs/brands/rocketchat.svg": 925,
	"./svgs/brands/rockrms.svg": 926,
	"./svgs/brands/safari.svg": 927,
	"./svgs/brands/salesforce.svg": 928,
	"./svgs/brands/sass.svg": 929,
	"./svgs/brands/schlix.svg": 930,
	"./svgs/brands/scribd.svg": 931,
	"./svgs/brands/searchengin.svg": 932,
	"./svgs/brands/sellcast.svg": 933,
	"./svgs/brands/sellsy.svg": 934,
	"./svgs/brands/servicestack.svg": 935,
	"./svgs/brands/shirtsinbulk.svg": 936,
	"./svgs/brands/shopware.svg": 937,
	"./svgs/brands/simplybuilt.svg": 938,
	"./svgs/brands/sistrix.svg": 939,
	"./svgs/brands/sith.svg": 940,
	"./svgs/brands/sketch.svg": 941,
	"./svgs/brands/skyatlas.svg": 942,
	"./svgs/brands/skype.svg": 943,
	"./svgs/brands/slack-hash.svg": 944,
	"./svgs/brands/slack.svg": 945,
	"./svgs/brands/slideshare.svg": 946,
	"./svgs/brands/snapchat-ghost.svg": 947,
	"./svgs/brands/snapchat-square.svg": 948,
	"./svgs/brands/snapchat.svg": 949,
	"./svgs/brands/soundcloud.svg": 950,
	"./svgs/brands/sourcetree.svg": 951,
	"./svgs/brands/speakap.svg": 952,
	"./svgs/brands/speaker-deck.svg": 953,
	"./svgs/brands/spotify.svg": 954,
	"./svgs/brands/squarespace.svg": 955,
	"./svgs/brands/stack-exchange.svg": 956,
	"./svgs/brands/stack-overflow.svg": 957,
	"./svgs/brands/stackpath.svg": 958,
	"./svgs/brands/staylinked.svg": 959,
	"./svgs/brands/steam-square.svg": 960,
	"./svgs/brands/steam-symbol.svg": 961,
	"./svgs/brands/steam.svg": 962,
	"./svgs/brands/sticker-mule.svg": 963,
	"./svgs/brands/strava.svg": 964,
	"./svgs/brands/stripe-s.svg": 965,
	"./svgs/brands/stripe.svg": 966,
	"./svgs/brands/studiovinari.svg": 967,
	"./svgs/brands/stumbleupon-circle.svg": 968,
	"./svgs/brands/stumbleupon.svg": 969,
	"./svgs/brands/superpowers.svg": 970,
	"./svgs/brands/supple.svg": 971,
	"./svgs/brands/suse.svg": 972,
	"./svgs/brands/swift.svg": 973,
	"./svgs/brands/symfony.svg": 974,
	"./svgs/brands/teamspeak.svg": 975,
	"./svgs/brands/telegram-plane.svg": 976,
	"./svgs/brands/telegram.svg": 977,
	"./svgs/brands/tencent-weibo.svg": 978,
	"./svgs/brands/the-red-yeti.svg": 979,
	"./svgs/brands/themeco.svg": 980,
	"./svgs/brands/themeisle.svg": 981,
	"./svgs/brands/think-peaks.svg": 982,
	"./svgs/brands/trade-federation.svg": 983,
	"./svgs/brands/trello.svg": 984,
	"./svgs/brands/tripadvisor.svg": 985,
	"./svgs/brands/tumblr-square.svg": 986,
	"./svgs/brands/tumblr.svg": 987,
	"./svgs/brands/twitch.svg": 988,
	"./svgs/brands/twitter-square.svg": 989,
	"./svgs/brands/twitter.svg": 990,
	"./svgs/brands/typo3.svg": 991,
	"./svgs/brands/uber.svg": 992,
	"./svgs/brands/ubuntu.svg": 993,
	"./svgs/brands/uikit.svg": 994,
	"./svgs/brands/umbraco.svg": 995,
	"./svgs/brands/uniregistry.svg": 996,
	"./svgs/brands/unity.svg": 997,
	"./svgs/brands/untappd.svg": 998,
	"./svgs/brands/ups.svg": 999,
	"./svgs/brands/usb.svg": 1000,
	"./svgs/brands/usps.svg": 1001,
	"./svgs/brands/ussunnah.svg": 1002,
	"./svgs/brands/vaadin.svg": 1003,
	"./svgs/brands/viacoin.svg": 1004,
	"./svgs/brands/viadeo-square.svg": 1005,
	"./svgs/brands/viadeo.svg": 1006,
	"./svgs/brands/viber.svg": 1007,
	"./svgs/brands/vimeo-square.svg": 1008,
	"./svgs/brands/vimeo-v.svg": 1009,
	"./svgs/brands/vimeo.svg": 1010,
	"./svgs/brands/vine.svg": 1011,
	"./svgs/brands/vk.svg": 1012,
	"./svgs/brands/vnv.svg": 1013,
	"./svgs/brands/vuejs.svg": 1014,
	"./svgs/brands/waze.svg": 1015,
	"./svgs/brands/weebly.svg": 1016,
	"./svgs/brands/weibo.svg": 1017,
	"./svgs/brands/weixin.svg": 1018,
	"./svgs/brands/whatsapp-square.svg": 1019,
	"./svgs/brands/whatsapp.svg": 1020,
	"./svgs/brands/whmcs.svg": 1021,
	"./svgs/brands/wikipedia-w.svg": 1022,
	"./svgs/brands/windows.svg": 1023,
	"./svgs/brands/wix.svg": 1024,
	"./svgs/brands/wizards-of-the-coast.svg": 1025,
	"./svgs/brands/wolf-pack-battalion.svg": 1026,
	"./svgs/brands/wordpress-simple.svg": 1027,
	"./svgs/brands/wordpress.svg": 1028,
	"./svgs/brands/wpbeginner.svg": 1029,
	"./svgs/brands/wpexplorer.svg": 1030,
	"./svgs/brands/wpforms.svg": 1031,
	"./svgs/brands/wpressr.svg": 1032,
	"./svgs/brands/xbox.svg": 1033,
	"./svgs/brands/xing-square.svg": 1034,
	"./svgs/brands/xing.svg": 1035,
	"./svgs/brands/y-combinator.svg": 1036,
	"./svgs/brands/yahoo.svg": 1037,
	"./svgs/brands/yammer.svg": 1038,
	"./svgs/brands/yandex-international.svg": 1039,
	"./svgs/brands/yandex.svg": 1040,
	"./svgs/brands/yarn.svg": 1041,
	"./svgs/brands/yelp.svg": 1042,
	"./svgs/brands/yoast.svg": 1043,
	"./svgs/brands/youtube-square.svg": 1044,
	"./svgs/brands/youtube.svg": 1045,
	"./svgs/brands/zhihu.svg": 1046,
	"./svgs/duotone/abacus.svg": 1047,
	"./svgs/duotone/acorn.svg": 1048,
	"./svgs/duotone/ad.svg": 1049,
	"./svgs/duotone/address-book.svg": 1050,
	"./svgs/duotone/address-card.svg": 1051,
	"./svgs/duotone/adjust.svg": 1052,
	"./svgs/duotone/air-conditioner.svg": 1053,
	"./svgs/duotone/air-freshener.svg": 1054,
	"./svgs/duotone/alarm-clock.svg": 1055,
	"./svgs/duotone/alarm-exclamation.svg": 1056,
	"./svgs/duotone/alarm-plus.svg": 1057,
	"./svgs/duotone/alarm-snooze.svg": 1058,
	"./svgs/duotone/album-collection.svg": 1059,
	"./svgs/duotone/album.svg": 1060,
	"./svgs/duotone/alicorn.svg": 1061,
	"./svgs/duotone/alien-monster.svg": 1062,
	"./svgs/duotone/alien.svg": 1063,
	"./svgs/duotone/align-center.svg": 1064,
	"./svgs/duotone/align-justify.svg": 1065,
	"./svgs/duotone/align-left.svg": 1066,
	"./svgs/duotone/align-right.svg": 1067,
	"./svgs/duotone/align-slash.svg": 1068,
	"./svgs/duotone/allergies.svg": 1069,
	"./svgs/duotone/ambulance.svg": 1070,
	"./svgs/duotone/american-sign-language-interpreting.svg": 1071,
	"./svgs/duotone/amp-guitar.svg": 1072,
	"./svgs/duotone/analytics.svg": 1073,
	"./svgs/duotone/anchor.svg": 1074,
	"./svgs/duotone/angel.svg": 1075,
	"./svgs/duotone/angle-double-down.svg": 1076,
	"./svgs/duotone/angle-double-left.svg": 1077,
	"./svgs/duotone/angle-double-right.svg": 1078,
	"./svgs/duotone/angle-double-up.svg": 1079,
	"./svgs/duotone/angle-down.svg": 1080,
	"./svgs/duotone/angle-left.svg": 1081,
	"./svgs/duotone/angle-right.svg": 1082,
	"./svgs/duotone/angle-up.svg": 1083,
	"./svgs/duotone/angry.svg": 1084,
	"./svgs/duotone/ankh.svg": 1085,
	"./svgs/duotone/apple-alt.svg": 1086,
	"./svgs/duotone/apple-crate.svg": 1087,
	"./svgs/duotone/archive.svg": 1088,
	"./svgs/duotone/archway.svg": 1089,
	"./svgs/duotone/arrow-alt-circle-down.svg": 1090,
	"./svgs/duotone/arrow-alt-circle-left.svg": 1091,
	"./svgs/duotone/arrow-alt-circle-right.svg": 1092,
	"./svgs/duotone/arrow-alt-circle-up.svg": 1093,
	"./svgs/duotone/arrow-alt-down.svg": 1094,
	"./svgs/duotone/arrow-alt-from-bottom.svg": 1095,
	"./svgs/duotone/arrow-alt-from-left.svg": 1096,
	"./svgs/duotone/arrow-alt-from-right.svg": 1097,
	"./svgs/duotone/arrow-alt-from-top.svg": 1098,
	"./svgs/duotone/arrow-alt-left.svg": 1099,
	"./svgs/duotone/arrow-alt-right.svg": 1100,
	"./svgs/duotone/arrow-alt-square-down.svg": 1101,
	"./svgs/duotone/arrow-alt-square-left.svg": 1102,
	"./svgs/duotone/arrow-alt-square-right.svg": 1103,
	"./svgs/duotone/arrow-alt-square-up.svg": 1104,
	"./svgs/duotone/arrow-alt-to-bottom.svg": 1105,
	"./svgs/duotone/arrow-alt-to-left.svg": 1106,
	"./svgs/duotone/arrow-alt-to-right.svg": 1107,
	"./svgs/duotone/arrow-alt-to-top.svg": 1108,
	"./svgs/duotone/arrow-alt-up.svg": 1109,
	"./svgs/duotone/arrow-circle-down.svg": 1110,
	"./svgs/duotone/arrow-circle-left.svg": 1111,
	"./svgs/duotone/arrow-circle-right.svg": 1112,
	"./svgs/duotone/arrow-circle-up.svg": 1113,
	"./svgs/duotone/arrow-down.svg": 1114,
	"./svgs/duotone/arrow-from-bottom.svg": 1115,
	"./svgs/duotone/arrow-from-left.svg": 1116,
	"./svgs/duotone/arrow-from-right.svg": 1117,
	"./svgs/duotone/arrow-from-top.svg": 1118,
	"./svgs/duotone/arrow-left.svg": 1119,
	"./svgs/duotone/arrow-right.svg": 1120,
	"./svgs/duotone/arrow-square-down.svg": 1121,
	"./svgs/duotone/arrow-square-left.svg": 1122,
	"./svgs/duotone/arrow-square-right.svg": 1123,
	"./svgs/duotone/arrow-square-up.svg": 1124,
	"./svgs/duotone/arrow-to-bottom.svg": 1125,
	"./svgs/duotone/arrow-to-left.svg": 1126,
	"./svgs/duotone/arrow-to-right.svg": 1127,
	"./svgs/duotone/arrow-to-top.svg": 1128,
	"./svgs/duotone/arrow-up.svg": 1129,
	"./svgs/duotone/arrows-alt-h.svg": 1130,
	"./svgs/duotone/arrows-alt-v.svg": 1131,
	"./svgs/duotone/arrows-alt.svg": 1132,
	"./svgs/duotone/arrows-h.svg": 1133,
	"./svgs/duotone/arrows-v.svg": 1134,
	"./svgs/duotone/arrows.svg": 1135,
	"./svgs/duotone/assistive-listening-systems.svg": 1136,
	"./svgs/duotone/asterisk.svg": 1137,
	"./svgs/duotone/at.svg": 1138,
	"./svgs/duotone/atlas.svg": 1139,
	"./svgs/duotone/atom-alt.svg": 1140,
	"./svgs/duotone/atom.svg": 1141,
	"./svgs/duotone/audio-description.svg": 1142,
	"./svgs/duotone/award.svg": 1143,
	"./svgs/duotone/axe-battle.svg": 1144,
	"./svgs/duotone/axe.svg": 1145,
	"./svgs/duotone/baby-carriage.svg": 1146,
	"./svgs/duotone/baby.svg": 1147,
	"./svgs/duotone/backpack.svg": 1148,
	"./svgs/duotone/backspace.svg": 1149,
	"./svgs/duotone/backward.svg": 1150,
	"./svgs/duotone/bacon.svg": 1151,
	"./svgs/duotone/badge-check.svg": 1152,
	"./svgs/duotone/badge-dollar.svg": 1153,
	"./svgs/duotone/badge-percent.svg": 1154,
	"./svgs/duotone/badge-sheriff.svg": 1155,
	"./svgs/duotone/badge.svg": 1156,
	"./svgs/duotone/badger-honey.svg": 1157,
	"./svgs/duotone/bags-shopping.svg": 1158,
	"./svgs/duotone/bahai.svg": 1159,
	"./svgs/duotone/balance-scale-left.svg": 1160,
	"./svgs/duotone/balance-scale-right.svg": 1161,
	"./svgs/duotone/balance-scale.svg": 1162,
	"./svgs/duotone/ball-pile.svg": 1163,
	"./svgs/duotone/ballot-check.svg": 1164,
	"./svgs/duotone/ballot.svg": 1165,
	"./svgs/duotone/ban.svg": 1166,
	"./svgs/duotone/band-aid.svg": 1167,
	"./svgs/duotone/banjo.svg": 1168,
	"./svgs/duotone/barcode-alt.svg": 1169,
	"./svgs/duotone/barcode-read.svg": 1170,
	"./svgs/duotone/barcode-scan.svg": 1171,
	"./svgs/duotone/barcode.svg": 1172,
	"./svgs/duotone/bars.svg": 1173,
	"./svgs/duotone/baseball-ball.svg": 1174,
	"./svgs/duotone/baseball.svg": 1175,
	"./svgs/duotone/basketball-ball.svg": 1176,
	"./svgs/duotone/basketball-hoop.svg": 1177,
	"./svgs/duotone/bat.svg": 1178,
	"./svgs/duotone/bath.svg": 1179,
	"./svgs/duotone/battery-bolt.svg": 1180,
	"./svgs/duotone/battery-empty.svg": 1181,
	"./svgs/duotone/battery-full.svg": 1182,
	"./svgs/duotone/battery-half.svg": 1183,
	"./svgs/duotone/battery-quarter.svg": 1184,
	"./svgs/duotone/battery-slash.svg": 1185,
	"./svgs/duotone/battery-three-quarters.svg": 1186,
	"./svgs/duotone/bed-alt.svg": 1187,
	"./svgs/duotone/bed-bunk.svg": 1188,
	"./svgs/duotone/bed-empty.svg": 1189,
	"./svgs/duotone/bed.svg": 1190,
	"./svgs/duotone/beer.svg": 1191,
	"./svgs/duotone/bell-exclamation.svg": 1192,
	"./svgs/duotone/bell-on.svg": 1193,
	"./svgs/duotone/bell-plus.svg": 1194,
	"./svgs/duotone/bell-school-slash.svg": 1195,
	"./svgs/duotone/bell-school.svg": 1196,
	"./svgs/duotone/bell-slash.svg": 1197,
	"./svgs/duotone/bell.svg": 1198,
	"./svgs/duotone/bells.svg": 1199,
	"./svgs/duotone/betamax.svg": 1200,
	"./svgs/duotone/bezier-curve.svg": 1201,
	"./svgs/duotone/bible.svg": 1202,
	"./svgs/duotone/bicycle.svg": 1203,
	"./svgs/duotone/biking-mountain.svg": 1204,
	"./svgs/duotone/biking.svg": 1205,
	"./svgs/duotone/binoculars.svg": 1206,
	"./svgs/duotone/biohazard.svg": 1207,
	"./svgs/duotone/birthday-cake.svg": 1208,
	"./svgs/duotone/blanket.svg": 1209,
	"./svgs/duotone/blender-phone.svg": 1210,
	"./svgs/duotone/blender.svg": 1211,
	"./svgs/duotone/blind.svg": 1212,
	"./svgs/duotone/blinds-open.svg": 1213,
	"./svgs/duotone/blinds-raised.svg": 1214,
	"./svgs/duotone/blinds.svg": 1215,
	"./svgs/duotone/blog.svg": 1216,
	"./svgs/duotone/bold.svg": 1217,
	"./svgs/duotone/bolt.svg": 1218,
	"./svgs/duotone/bomb.svg": 1219,
	"./svgs/duotone/bone-break.svg": 1220,
	"./svgs/duotone/bone.svg": 1221,
	"./svgs/duotone/bong.svg": 1222,
	"./svgs/duotone/book-alt.svg": 1223,
	"./svgs/duotone/book-dead.svg": 1224,
	"./svgs/duotone/book-heart.svg": 1225,
	"./svgs/duotone/book-medical.svg": 1226,
	"./svgs/duotone/book-open.svg": 1227,
	"./svgs/duotone/book-reader.svg": 1228,
	"./svgs/duotone/book-spells.svg": 1229,
	"./svgs/duotone/book-user.svg": 1230,
	"./svgs/duotone/book.svg": 1231,
	"./svgs/duotone/bookmark.svg": 1232,
	"./svgs/duotone/books-medical.svg": 1233,
	"./svgs/duotone/books.svg": 1234,
	"./svgs/duotone/boombox.svg": 1235,
	"./svgs/duotone/boot.svg": 1236,
	"./svgs/duotone/booth-curtain.svg": 1237,
	"./svgs/duotone/border-all.svg": 1238,
	"./svgs/duotone/border-bottom.svg": 1239,
	"./svgs/duotone/border-center-h.svg": 1240,
	"./svgs/duotone/border-center-v.svg": 1241,
	"./svgs/duotone/border-inner.svg": 1242,
	"./svgs/duotone/border-left.svg": 1243,
	"./svgs/duotone/border-none.svg": 1244,
	"./svgs/duotone/border-outer.svg": 1245,
	"./svgs/duotone/border-right.svg": 1246,
	"./svgs/duotone/border-style-alt.svg": 1247,
	"./svgs/duotone/border-style.svg": 1248,
	"./svgs/duotone/border-top.svg": 1249,
	"./svgs/duotone/bow-arrow.svg": 1250,
	"./svgs/duotone/bowling-ball.svg": 1251,
	"./svgs/duotone/bowling-pins.svg": 1252,
	"./svgs/duotone/box-alt.svg": 1253,
	"./svgs/duotone/box-ballot.svg": 1254,
	"./svgs/duotone/box-check.svg": 1255,
	"./svgs/duotone/box-fragile.svg": 1256,
	"./svgs/duotone/box-full.svg": 1257,
	"./svgs/duotone/box-heart.svg": 1258,
	"./svgs/duotone/box-open.svg": 1259,
	"./svgs/duotone/box-up.svg": 1260,
	"./svgs/duotone/box-usd.svg": 1261,
	"./svgs/duotone/box.svg": 1262,
	"./svgs/duotone/boxes-alt.svg": 1263,
	"./svgs/duotone/boxes.svg": 1264,
	"./svgs/duotone/boxing-glove.svg": 1265,
	"./svgs/duotone/brackets-curly.svg": 1266,
	"./svgs/duotone/brackets.svg": 1267,
	"./svgs/duotone/braille.svg": 1268,
	"./svgs/duotone/brain.svg": 1269,
	"./svgs/duotone/bread-loaf.svg": 1270,
	"./svgs/duotone/bread-slice.svg": 1271,
	"./svgs/duotone/briefcase-medical.svg": 1272,
	"./svgs/duotone/briefcase.svg": 1273,
	"./svgs/duotone/bring-forward.svg": 1274,
	"./svgs/duotone/bring-front.svg": 1275,
	"./svgs/duotone/broadcast-tower.svg": 1276,
	"./svgs/duotone/broom.svg": 1277,
	"./svgs/duotone/browser.svg": 1278,
	"./svgs/duotone/brush.svg": 1279,
	"./svgs/duotone/bug.svg": 1280,
	"./svgs/duotone/building.svg": 1281,
	"./svgs/duotone/bullhorn.svg": 1282,
	"./svgs/duotone/bullseye-arrow.svg": 1283,
	"./svgs/duotone/bullseye-pointer.svg": 1284,
	"./svgs/duotone/bullseye.svg": 1285,
	"./svgs/duotone/burger-soda.svg": 1286,
	"./svgs/duotone/burn.svg": 1287,
	"./svgs/duotone/burrito.svg": 1288,
	"./svgs/duotone/bus-alt.svg": 1289,
	"./svgs/duotone/bus-school.svg": 1290,
	"./svgs/duotone/bus.svg": 1291,
	"./svgs/duotone/business-time.svg": 1292,
	"./svgs/duotone/cabinet-filing.svg": 1293,
	"./svgs/duotone/cactus.svg": 1294,
	"./svgs/duotone/calculator-alt.svg": 1295,
	"./svgs/duotone/calculator.svg": 1296,
	"./svgs/duotone/calendar-alt.svg": 1297,
	"./svgs/duotone/calendar-check.svg": 1298,
	"./svgs/duotone/calendar-day.svg": 1299,
	"./svgs/duotone/calendar-edit.svg": 1300,
	"./svgs/duotone/calendar-exclamation.svg": 1301,
	"./svgs/duotone/calendar-minus.svg": 1302,
	"./svgs/duotone/calendar-plus.svg": 1303,
	"./svgs/duotone/calendar-star.svg": 1304,
	"./svgs/duotone/calendar-times.svg": 1305,
	"./svgs/duotone/calendar-week.svg": 1306,
	"./svgs/duotone/calendar.svg": 1307,
	"./svgs/duotone/camcorder.svg": 1308,
	"./svgs/duotone/camera-alt.svg": 1309,
	"./svgs/duotone/camera-home.svg": 1310,
	"./svgs/duotone/camera-movie.svg": 1311,
	"./svgs/duotone/camera-polaroid.svg": 1312,
	"./svgs/duotone/camera-retro.svg": 1313,
	"./svgs/duotone/camera.svg": 1314,
	"./svgs/duotone/campfire.svg": 1315,
	"./svgs/duotone/campground.svg": 1316,
	"./svgs/duotone/candle-holder.svg": 1317,
	"./svgs/duotone/candy-cane.svg": 1318,
	"./svgs/duotone/candy-corn.svg": 1319,
	"./svgs/duotone/cannabis.svg": 1320,
	"./svgs/duotone/capsules.svg": 1321,
	"./svgs/duotone/car-alt.svg": 1322,
	"./svgs/duotone/car-battery.svg": 1323,
	"./svgs/duotone/car-building.svg": 1324,
	"./svgs/duotone/car-bump.svg": 1325,
	"./svgs/duotone/car-bus.svg": 1326,
	"./svgs/duotone/car-crash.svg": 1327,
	"./svgs/duotone/car-garage.svg": 1328,
	"./svgs/duotone/car-mechanic.svg": 1329,
	"./svgs/duotone/car-side.svg": 1330,
	"./svgs/duotone/car-tilt.svg": 1331,
	"./svgs/duotone/car-wash.svg": 1332,
	"./svgs/duotone/car.svg": 1333,
	"./svgs/duotone/caravan-alt.svg": 1334,
	"./svgs/duotone/caravan.svg": 1335,
	"./svgs/duotone/caret-circle-down.svg": 1336,
	"./svgs/duotone/caret-circle-left.svg": 1337,
	"./svgs/duotone/caret-circle-right.svg": 1338,
	"./svgs/duotone/caret-circle-up.svg": 1339,
	"./svgs/duotone/caret-down.svg": 1340,
	"./svgs/duotone/caret-left.svg": 1341,
	"./svgs/duotone/caret-right.svg": 1342,
	"./svgs/duotone/caret-square-down.svg": 1343,
	"./svgs/duotone/caret-square-left.svg": 1344,
	"./svgs/duotone/caret-square-right.svg": 1345,
	"./svgs/duotone/caret-square-up.svg": 1346,
	"./svgs/duotone/caret-up.svg": 1347,
	"./svgs/duotone/carrot.svg": 1348,
	"./svgs/duotone/cars.svg": 1349,
	"./svgs/duotone/cart-arrow-down.svg": 1350,
	"./svgs/duotone/cart-plus.svg": 1351,
	"./svgs/duotone/cash-register.svg": 1352,
	"./svgs/duotone/cassette-tape.svg": 1353,
	"./svgs/duotone/cat-space.svg": 1354,
	"./svgs/duotone/cat.svg": 1355,
	"./svgs/duotone/cauldron.svg": 1356,
	"./svgs/duotone/cctv.svg": 1357,
	"./svgs/duotone/certificate.svg": 1358,
	"./svgs/duotone/chair-office.svg": 1359,
	"./svgs/duotone/chair.svg": 1360,
	"./svgs/duotone/chalkboard-teacher.svg": 1361,
	"./svgs/duotone/chalkboard.svg": 1362,
	"./svgs/duotone/charging-station.svg": 1363,
	"./svgs/duotone/chart-area.svg": 1364,
	"./svgs/duotone/chart-bar.svg": 1365,
	"./svgs/duotone/chart-line-down.svg": 1366,
	"./svgs/duotone/chart-line.svg": 1367,
	"./svgs/duotone/chart-network.svg": 1368,
	"./svgs/duotone/chart-pie-alt.svg": 1369,
	"./svgs/duotone/chart-pie.svg": 1370,
	"./svgs/duotone/chart-scatter.svg": 1371,
	"./svgs/duotone/check-circle.svg": 1372,
	"./svgs/duotone/check-double.svg": 1373,
	"./svgs/duotone/check-square.svg": 1374,
	"./svgs/duotone/check.svg": 1375,
	"./svgs/duotone/cheese-swiss.svg": 1376,
	"./svgs/duotone/cheese.svg": 1377,
	"./svgs/duotone/cheeseburger.svg": 1378,
	"./svgs/duotone/chess-bishop-alt.svg": 1379,
	"./svgs/duotone/chess-bishop.svg": 1380,
	"./svgs/duotone/chess-board.svg": 1381,
	"./svgs/duotone/chess-clock-alt.svg": 1382,
	"./svgs/duotone/chess-clock.svg": 1383,
	"./svgs/duotone/chess-king-alt.svg": 1384,
	"./svgs/duotone/chess-king.svg": 1385,
	"./svgs/duotone/chess-knight-alt.svg": 1386,
	"./svgs/duotone/chess-knight.svg": 1387,
	"./svgs/duotone/chess-pawn-alt.svg": 1388,
	"./svgs/duotone/chess-pawn.svg": 1389,
	"./svgs/duotone/chess-queen-alt.svg": 1390,
	"./svgs/duotone/chess-queen.svg": 1391,
	"./svgs/duotone/chess-rook-alt.svg": 1392,
	"./svgs/duotone/chess-rook.svg": 1393,
	"./svgs/duotone/chess.svg": 1394,
	"./svgs/duotone/chevron-circle-down.svg": 1395,
	"./svgs/duotone/chevron-circle-left.svg": 1396,
	"./svgs/duotone/chevron-circle-right.svg": 1397,
	"./svgs/duotone/chevron-circle-up.svg": 1398,
	"./svgs/duotone/chevron-double-down.svg": 1399,
	"./svgs/duotone/chevron-double-left.svg": 1400,
	"./svgs/duotone/chevron-double-right.svg": 1401,
	"./svgs/duotone/chevron-double-up.svg": 1402,
	"./svgs/duotone/chevron-down.svg": 1403,
	"./svgs/duotone/chevron-left.svg": 1404,
	"./svgs/duotone/chevron-right.svg": 1405,
	"./svgs/duotone/chevron-square-down.svg": 1406,
	"./svgs/duotone/chevron-square-left.svg": 1407,
	"./svgs/duotone/chevron-square-right.svg": 1408,
	"./svgs/duotone/chevron-square-up.svg": 1409,
	"./svgs/duotone/chevron-up.svg": 1410,
	"./svgs/duotone/child.svg": 1411,
	"./svgs/duotone/chimney.svg": 1412,
	"./svgs/duotone/church.svg": 1413,
	"./svgs/duotone/circle-notch.svg": 1414,
	"./svgs/duotone/circle.svg": 1415,
	"./svgs/duotone/city.svg": 1416,
	"./svgs/duotone/clarinet.svg": 1417,
	"./svgs/duotone/claw-marks.svg": 1418,
	"./svgs/duotone/clinic-medical.svg": 1419,
	"./svgs/duotone/clipboard-check.svg": 1420,
	"./svgs/duotone/clipboard-list-check.svg": 1421,
	"./svgs/duotone/clipboard-list.svg": 1422,
	"./svgs/duotone/clipboard-prescription.svg": 1423,
	"./svgs/duotone/clipboard-user.svg": 1424,
	"./svgs/duotone/clipboard.svg": 1425,
	"./svgs/duotone/clock.svg": 1426,
	"./svgs/duotone/clone.svg": 1427,
	"./svgs/duotone/closed-captioning.svg": 1428,
	"./svgs/duotone/cloud-download-alt.svg": 1429,
	"./svgs/duotone/cloud-download.svg": 1430,
	"./svgs/duotone/cloud-drizzle.svg": 1431,
	"./svgs/duotone/cloud-hail-mixed.svg": 1432,
	"./svgs/duotone/cloud-hail.svg": 1433,
	"./svgs/duotone/cloud-meatball.svg": 1434,
	"./svgs/duotone/cloud-moon-rain.svg": 1435,
	"./svgs/duotone/cloud-moon.svg": 1436,
	"./svgs/duotone/cloud-music.svg": 1437,
	"./svgs/duotone/cloud-rain.svg": 1438,
	"./svgs/duotone/cloud-rainbow.svg": 1439,
	"./svgs/duotone/cloud-showers-heavy.svg": 1440,
	"./svgs/duotone/cloud-showers.svg": 1441,
	"./svgs/duotone/cloud-sleet.svg": 1442,
	"./svgs/duotone/cloud-snow.svg": 1443,
	"./svgs/duotone/cloud-sun-rain.svg": 1444,
	"./svgs/duotone/cloud-sun.svg": 1445,
	"./svgs/duotone/cloud-upload-alt.svg": 1446,
	"./svgs/duotone/cloud-upload.svg": 1447,
	"./svgs/duotone/cloud.svg": 1448,
	"./svgs/duotone/clouds-moon.svg": 1449,
	"./svgs/duotone/clouds-sun.svg": 1450,
	"./svgs/duotone/clouds.svg": 1451,
	"./svgs/duotone/club.svg": 1452,
	"./svgs/duotone/cocktail.svg": 1453,
	"./svgs/duotone/code-branch.svg": 1454,
	"./svgs/duotone/code-commit.svg": 1455,
	"./svgs/duotone/code-merge.svg": 1456,
	"./svgs/duotone/code.svg": 1457,
	"./svgs/duotone/coffee-pot.svg": 1458,
	"./svgs/duotone/coffee-togo.svg": 1459,
	"./svgs/duotone/coffee.svg": 1460,
	"./svgs/duotone/coffin.svg": 1461,
	"./svgs/duotone/cog.svg": 1462,
	"./svgs/duotone/cogs.svg": 1463,
	"./svgs/duotone/coin.svg": 1464,
	"./svgs/duotone/coins.svg": 1465,
	"./svgs/duotone/columns.svg": 1466,
	"./svgs/duotone/comet.svg": 1467,
	"./svgs/duotone/comment-alt-check.svg": 1468,
	"./svgs/duotone/comment-alt-dollar.svg": 1469,
	"./svgs/duotone/comment-alt-dots.svg": 1470,
	"./svgs/duotone/comment-alt-edit.svg": 1471,
	"./svgs/duotone/comment-alt-exclamation.svg": 1472,
	"./svgs/duotone/comment-alt-lines.svg": 1473,
	"./svgs/duotone/comment-alt-medical.svg": 1474,
	"./svgs/duotone/comment-alt-minus.svg": 1475,
	"./svgs/duotone/comment-alt-music.svg": 1476,
	"./svgs/duotone/comment-alt-plus.svg": 1477,
	"./svgs/duotone/comment-alt-slash.svg": 1478,
	"./svgs/duotone/comment-alt-smile.svg": 1479,
	"./svgs/duotone/comment-alt-times.svg": 1480,
	"./svgs/duotone/comment-alt.svg": 1481,
	"./svgs/duotone/comment-check.svg": 1482,
	"./svgs/duotone/comment-dollar.svg": 1483,
	"./svgs/duotone/comment-dots.svg": 1484,
	"./svgs/duotone/comment-edit.svg": 1485,
	"./svgs/duotone/comment-exclamation.svg": 1486,
	"./svgs/duotone/comment-lines.svg": 1487,
	"./svgs/duotone/comment-medical.svg": 1488,
	"./svgs/duotone/comment-minus.svg": 1489,
	"./svgs/duotone/comment-music.svg": 1490,
	"./svgs/duotone/comment-plus.svg": 1491,
	"./svgs/duotone/comment-slash.svg": 1492,
	"./svgs/duotone/comment-smile.svg": 1493,
	"./svgs/duotone/comment-times.svg": 1494,
	"./svgs/duotone/comment.svg": 1495,
	"./svgs/duotone/comments-alt-dollar.svg": 1496,
	"./svgs/duotone/comments-alt.svg": 1497,
	"./svgs/duotone/comments-dollar.svg": 1498,
	"./svgs/duotone/comments.svg": 1499,
	"./svgs/duotone/compact-disc.svg": 1500,
	"./svgs/duotone/compass-slash.svg": 1501,
	"./svgs/duotone/compass.svg": 1502,
	"./svgs/duotone/compress-alt.svg": 1503,
	"./svgs/duotone/compress-arrows-alt.svg": 1504,
	"./svgs/duotone/compress-wide.svg": 1505,
	"./svgs/duotone/compress.svg": 1506,
	"./svgs/duotone/computer-classic.svg": 1507,
	"./svgs/duotone/computer-speaker.svg": 1508,
	"./svgs/duotone/concierge-bell.svg": 1509,
	"./svgs/duotone/construction.svg": 1510,
	"./svgs/duotone/container-storage.svg": 1511,
	"./svgs/duotone/conveyor-belt-alt.svg": 1512,
	"./svgs/duotone/conveyor-belt.svg": 1513,
	"./svgs/duotone/cookie-bite.svg": 1514,
	"./svgs/duotone/cookie.svg": 1515,
	"./svgs/duotone/copy.svg": 1516,
	"./svgs/duotone/copyright.svg": 1517,
	"./svgs/duotone/corn.svg": 1518,
	"./svgs/duotone/couch.svg": 1519,
	"./svgs/duotone/cow.svg": 1520,
	"./svgs/duotone/cowbell-more.svg": 1521,
	"./svgs/duotone/cowbell.svg": 1522,
	"./svgs/duotone/credit-card-blank.svg": 1523,
	"./svgs/duotone/credit-card-front.svg": 1524,
	"./svgs/duotone/credit-card.svg": 1525,
	"./svgs/duotone/cricket.svg": 1526,
	"./svgs/duotone/croissant.svg": 1527,
	"./svgs/duotone/crop-alt.svg": 1528,
	"./svgs/duotone/crop.svg": 1529,
	"./svgs/duotone/cross.svg": 1530,
	"./svgs/duotone/crosshairs.svg": 1531,
	"./svgs/duotone/crow.svg": 1532,
	"./svgs/duotone/crown.svg": 1533,
	"./svgs/duotone/crutch.svg": 1534,
	"./svgs/duotone/crutches.svg": 1535,
	"./svgs/duotone/cube.svg": 1536,
	"./svgs/duotone/cubes.svg": 1537,
	"./svgs/duotone/curling.svg": 1538,
	"./svgs/duotone/cut.svg": 1539,
	"./svgs/duotone/dagger.svg": 1540,
	"./svgs/duotone/database.svg": 1541,
	"./svgs/duotone/deaf.svg": 1542,
	"./svgs/duotone/debug.svg": 1543,
	"./svgs/duotone/deer-rudolph.svg": 1544,
	"./svgs/duotone/deer.svg": 1545,
	"./svgs/duotone/democrat.svg": 1546,
	"./svgs/duotone/desktop-alt.svg": 1547,
	"./svgs/duotone/desktop.svg": 1548,
	"./svgs/duotone/dewpoint.svg": 1549,
	"./svgs/duotone/dharmachakra.svg": 1550,
	"./svgs/duotone/diagnoses.svg": 1551,
	"./svgs/duotone/diamond.svg": 1552,
	"./svgs/duotone/dice-d10.svg": 1553,
	"./svgs/duotone/dice-d12.svg": 1554,
	"./svgs/duotone/dice-d20.svg": 1555,
	"./svgs/duotone/dice-d4.svg": 1556,
	"./svgs/duotone/dice-d6.svg": 1557,
	"./svgs/duotone/dice-d8.svg": 1558,
	"./svgs/duotone/dice-five.svg": 1559,
	"./svgs/duotone/dice-four.svg": 1560,
	"./svgs/duotone/dice-one.svg": 1561,
	"./svgs/duotone/dice-six.svg": 1562,
	"./svgs/duotone/dice-three.svg": 1563,
	"./svgs/duotone/dice-two.svg": 1564,
	"./svgs/duotone/dice.svg": 1565,
	"./svgs/duotone/digging.svg": 1566,
	"./svgs/duotone/digital-tachograph.svg": 1567,
	"./svgs/duotone/diploma.svg": 1568,
	"./svgs/duotone/directions.svg": 1569,
	"./svgs/duotone/disc-drive.svg": 1570,
	"./svgs/duotone/disease.svg": 1571,
	"./svgs/duotone/divide.svg": 1572,
	"./svgs/duotone/dizzy.svg": 1573,
	"./svgs/duotone/dna.svg": 1574,
	"./svgs/duotone/do-not-enter.svg": 1575,
	"./svgs/duotone/dog-leashed.svg": 1576,
	"./svgs/duotone/dog.svg": 1577,
	"./svgs/duotone/dollar-sign.svg": 1578,
	"./svgs/duotone/dolly-empty.svg": 1579,
	"./svgs/duotone/dolly-flatbed-alt.svg": 1580,
	"./svgs/duotone/dolly-flatbed-empty.svg": 1581,
	"./svgs/duotone/dolly-flatbed.svg": 1582,
	"./svgs/duotone/dolly.svg": 1583,
	"./svgs/duotone/donate.svg": 1584,
	"./svgs/duotone/door-closed.svg": 1585,
	"./svgs/duotone/door-open.svg": 1586,
	"./svgs/duotone/dot-circle.svg": 1587,
	"./svgs/duotone/dove.svg": 1588,
	"./svgs/duotone/download.svg": 1589,
	"./svgs/duotone/drafting-compass.svg": 1590,
	"./svgs/duotone/dragon.svg": 1591,
	"./svgs/duotone/draw-circle.svg": 1592,
	"./svgs/duotone/draw-polygon.svg": 1593,
	"./svgs/duotone/draw-square.svg": 1594,
	"./svgs/duotone/dreidel.svg": 1595,
	"./svgs/duotone/drone-alt.svg": 1596,
	"./svgs/duotone/drone.svg": 1597,
	"./svgs/duotone/drum-steelpan.svg": 1598,
	"./svgs/duotone/drum.svg": 1599,
	"./svgs/duotone/drumstick-bite.svg": 1600,
	"./svgs/duotone/drumstick.svg": 1601,
	"./svgs/duotone/dryer-alt.svg": 1602,
	"./svgs/duotone/dryer.svg": 1603,
	"./svgs/duotone/duck.svg": 1604,
	"./svgs/duotone/dumbbell.svg": 1605,
	"./svgs/duotone/dumpster-fire.svg": 1606,
	"./svgs/duotone/dumpster.svg": 1607,
	"./svgs/duotone/dungeon.svg": 1608,
	"./svgs/duotone/ear-muffs.svg": 1609,
	"./svgs/duotone/ear.svg": 1610,
	"./svgs/duotone/eclipse-alt.svg": 1611,
	"./svgs/duotone/eclipse.svg": 1612,
	"./svgs/duotone/edit.svg": 1613,
	"./svgs/duotone/egg-fried.svg": 1614,
	"./svgs/duotone/egg.svg": 1615,
	"./svgs/duotone/eject.svg": 1616,
	"./svgs/duotone/elephant.svg": 1617,
	"./svgs/duotone/ellipsis-h-alt.svg": 1618,
	"./svgs/duotone/ellipsis-h.svg": 1619,
	"./svgs/duotone/ellipsis-v-alt.svg": 1620,
	"./svgs/duotone/ellipsis-v.svg": 1621,
	"./svgs/duotone/empty-set.svg": 1622,
	"./svgs/duotone/engine-warning.svg": 1623,
	"./svgs/duotone/envelope-open-dollar.svg": 1624,
	"./svgs/duotone/envelope-open-text.svg": 1625,
	"./svgs/duotone/envelope-open.svg": 1626,
	"./svgs/duotone/envelope-square.svg": 1627,
	"./svgs/duotone/envelope.svg": 1628,
	"./svgs/duotone/equals.svg": 1629,
	"./svgs/duotone/eraser.svg": 1630,
	"./svgs/duotone/ethernet.svg": 1631,
	"./svgs/duotone/euro-sign.svg": 1632,
	"./svgs/duotone/exchange-alt.svg": 1633,
	"./svgs/duotone/exchange.svg": 1634,
	"./svgs/duotone/exclamation-circle.svg": 1635,
	"./svgs/duotone/exclamation-square.svg": 1636,
	"./svgs/duotone/exclamation-triangle.svg": 1637,
	"./svgs/duotone/exclamation.svg": 1638,
	"./svgs/duotone/expand-alt.svg": 1639,
	"./svgs/duotone/expand-arrows-alt.svg": 1640,
	"./svgs/duotone/expand-arrows.svg": 1641,
	"./svgs/duotone/expand-wide.svg": 1642,
	"./svgs/duotone/expand.svg": 1643,
	"./svgs/duotone/external-link-alt.svg": 1644,
	"./svgs/duotone/external-link-square-alt.svg": 1645,
	"./svgs/duotone/external-link-square.svg": 1646,
	"./svgs/duotone/external-link.svg": 1647,
	"./svgs/duotone/eye-dropper.svg": 1648,
	"./svgs/duotone/eye-evil.svg": 1649,
	"./svgs/duotone/eye-slash.svg": 1650,
	"./svgs/duotone/eye.svg": 1651,
	"./svgs/duotone/fan-table.svg": 1652,
	"./svgs/duotone/fan.svg": 1653,
	"./svgs/duotone/farm.svg": 1654,
	"./svgs/duotone/fast-backward.svg": 1655,
	"./svgs/duotone/fast-forward.svg": 1656,
	"./svgs/duotone/faucet-drip.svg": 1657,
	"./svgs/duotone/faucet.svg": 1658,
	"./svgs/duotone/fax.svg": 1659,
	"./svgs/duotone/feather-alt.svg": 1660,
	"./svgs/duotone/feather.svg": 1661,
	"./svgs/duotone/female.svg": 1662,
	"./svgs/duotone/field-hockey.svg": 1663,
	"./svgs/duotone/fighter-jet.svg": 1664,
	"./svgs/duotone/file-alt.svg": 1665,
	"./svgs/duotone/file-archive.svg": 1666,
	"./svgs/duotone/file-audio.svg": 1667,
	"./svgs/duotone/file-certificate.svg": 1668,
	"./svgs/duotone/file-chart-line.svg": 1669,
	"./svgs/duotone/file-chart-pie.svg": 1670,
	"./svgs/duotone/file-check.svg": 1671,
	"./svgs/duotone/file-code.svg": 1672,
	"./svgs/duotone/file-contract.svg": 1673,
	"./svgs/duotone/file-csv.svg": 1674,
	"./svgs/duotone/file-download.svg": 1675,
	"./svgs/duotone/file-edit.svg": 1676,
	"./svgs/duotone/file-excel.svg": 1677,
	"./svgs/duotone/file-exclamation.svg": 1678,
	"./svgs/duotone/file-export.svg": 1679,
	"./svgs/duotone/file-image.svg": 1680,
	"./svgs/duotone/file-import.svg": 1681,
	"./svgs/duotone/file-invoice-dollar.svg": 1682,
	"./svgs/duotone/file-invoice.svg": 1683,
	"./svgs/duotone/file-medical-alt.svg": 1684,
	"./svgs/duotone/file-medical.svg": 1685,
	"./svgs/duotone/file-minus.svg": 1686,
	"./svgs/duotone/file-music.svg": 1687,
	"./svgs/duotone/file-pdf.svg": 1688,
	"./svgs/duotone/file-plus.svg": 1689,
	"./svgs/duotone/file-powerpoint.svg": 1690,
	"./svgs/duotone/file-prescription.svg": 1691,
	"./svgs/duotone/file-search.svg": 1692,
	"./svgs/duotone/file-signature.svg": 1693,
	"./svgs/duotone/file-spreadsheet.svg": 1694,
	"./svgs/duotone/file-times.svg": 1695,
	"./svgs/duotone/file-upload.svg": 1696,
	"./svgs/duotone/file-user.svg": 1697,
	"./svgs/duotone/file-video.svg": 1698,
	"./svgs/duotone/file-word.svg": 1699,
	"./svgs/duotone/file.svg": 1700,
	"./svgs/duotone/files-medical.svg": 1701,
	"./svgs/duotone/fill-drip.svg": 1702,
	"./svgs/duotone/fill.svg": 1703,
	"./svgs/duotone/film-alt.svg": 1704,
	"./svgs/duotone/film-canister.svg": 1705,
	"./svgs/duotone/film.svg": 1706,
	"./svgs/duotone/filter.svg": 1707,
	"./svgs/duotone/fingerprint.svg": 1708,
	"./svgs/duotone/fire-alt.svg": 1709,
	"./svgs/duotone/fire-extinguisher.svg": 1710,
	"./svgs/duotone/fire-smoke.svg": 1711,
	"./svgs/duotone/fire.svg": 1712,
	"./svgs/duotone/fireplace.svg": 1713,
	"./svgs/duotone/first-aid.svg": 1714,
	"./svgs/duotone/fish-cooked.svg": 1715,
	"./svgs/duotone/fish.svg": 1716,
	"./svgs/duotone/fist-raised.svg": 1717,
	"./svgs/duotone/flag-alt.svg": 1718,
	"./svgs/duotone/flag-checkered.svg": 1719,
	"./svgs/duotone/flag-usa.svg": 1720,
	"./svgs/duotone/flag.svg": 1721,
	"./svgs/duotone/flame.svg": 1722,
	"./svgs/duotone/flashlight.svg": 1723,
	"./svgs/duotone/flask-poison.svg": 1724,
	"./svgs/duotone/flask-potion.svg": 1725,
	"./svgs/duotone/flask.svg": 1726,
	"./svgs/duotone/flower-daffodil.svg": 1727,
	"./svgs/duotone/flower-tulip.svg": 1728,
	"./svgs/duotone/flower.svg": 1729,
	"./svgs/duotone/flushed.svg": 1730,
	"./svgs/duotone/flute.svg": 1731,
	"./svgs/duotone/flux-capacitor.svg": 1732,
	"./svgs/duotone/fog.svg": 1733,
	"./svgs/duotone/folder-minus.svg": 1734,
	"./svgs/duotone/folder-open.svg": 1735,
	"./svgs/duotone/folder-plus.svg": 1736,
	"./svgs/duotone/folder-times.svg": 1737,
	"./svgs/duotone/folder-tree.svg": 1738,
	"./svgs/duotone/folder.svg": 1739,
	"./svgs/duotone/folders.svg": 1740,
	"./svgs/duotone/font-awesome-logo-full.svg": 1741,
	"./svgs/duotone/font-case.svg": 1742,
	"./svgs/duotone/font.svg": 1743,
	"./svgs/duotone/football-ball.svg": 1744,
	"./svgs/duotone/football-helmet.svg": 1745,
	"./svgs/duotone/forklift.svg": 1746,
	"./svgs/duotone/forward.svg": 1747,
	"./svgs/duotone/fragile.svg": 1748,
	"./svgs/duotone/french-fries.svg": 1749,
	"./svgs/duotone/frog.svg": 1750,
	"./svgs/duotone/frosty-head.svg": 1751,
	"./svgs/duotone/frown-open.svg": 1752,
	"./svgs/duotone/frown.svg": 1753,
	"./svgs/duotone/function.svg": 1754,
	"./svgs/duotone/funnel-dollar.svg": 1755,
	"./svgs/duotone/futbol.svg": 1756,
	"./svgs/duotone/galaxy.svg": 1757,
	"./svgs/duotone/game-board-alt.svg": 1758,
	"./svgs/duotone/game-board.svg": 1759,
	"./svgs/duotone/game-console-handheld.svg": 1760,
	"./svgs/duotone/gamepad-alt.svg": 1761,
	"./svgs/duotone/gamepad.svg": 1762,
	"./svgs/duotone/garage-car.svg": 1763,
	"./svgs/duotone/garage-open.svg": 1764,
	"./svgs/duotone/garage.svg": 1765,
	"./svgs/duotone/gas-pump-slash.svg": 1766,
	"./svgs/duotone/gas-pump.svg": 1767,
	"./svgs/duotone/gavel.svg": 1768,
	"./svgs/duotone/gem.svg": 1769,
	"./svgs/duotone/genderless.svg": 1770,
	"./svgs/duotone/ghost.svg": 1771,
	"./svgs/duotone/gift-card.svg": 1772,
	"./svgs/duotone/gift.svg": 1773,
	"./svgs/duotone/gifts.svg": 1774,
	"./svgs/duotone/gingerbread-man.svg": 1775,
	"./svgs/duotone/glass-champagne.svg": 1776,
	"./svgs/duotone/glass-cheers.svg": 1777,
	"./svgs/duotone/glass-citrus.svg": 1778,
	"./svgs/duotone/glass-martini-alt.svg": 1779,
	"./svgs/duotone/glass-martini.svg": 1780,
	"./svgs/duotone/glass-whiskey-rocks.svg": 1781,
	"./svgs/duotone/glass-whiskey.svg": 1782,
	"./svgs/duotone/glass.svg": 1783,
	"./svgs/duotone/glasses-alt.svg": 1784,
	"./svgs/duotone/glasses.svg": 1785,
	"./svgs/duotone/globe-africa.svg": 1786,
	"./svgs/duotone/globe-americas.svg": 1787,
	"./svgs/duotone/globe-asia.svg": 1788,
	"./svgs/duotone/globe-europe.svg": 1789,
	"./svgs/duotone/globe-snow.svg": 1790,
	"./svgs/duotone/globe-stand.svg": 1791,
	"./svgs/duotone/globe.svg": 1792,
	"./svgs/duotone/golf-ball.svg": 1793,
	"./svgs/duotone/golf-club.svg": 1794,
	"./svgs/duotone/gopuram.svg": 1795,
	"./svgs/duotone/graduation-cap.svg": 1796,
	"./svgs/duotone/gramophone.svg": 1797,
	"./svgs/duotone/greater-than-equal.svg": 1798,
	"./svgs/duotone/greater-than.svg": 1799,
	"./svgs/duotone/grimace.svg": 1800,
	"./svgs/duotone/grin-alt.svg": 1801,
	"./svgs/duotone/grin-beam-sweat.svg": 1802,
	"./svgs/duotone/grin-beam.svg": 1803,
	"./svgs/duotone/grin-hearts.svg": 1804,
	"./svgs/duotone/grin-squint-tears.svg": 1805,
	"./svgs/duotone/grin-squint.svg": 1806,
	"./svgs/duotone/grin-stars.svg": 1807,
	"./svgs/duotone/grin-tears.svg": 1808,
	"./svgs/duotone/grin-tongue-squint.svg": 1809,
	"./svgs/duotone/grin-tongue-wink.svg": 1810,
	"./svgs/duotone/grin-tongue.svg": 1811,
	"./svgs/duotone/grin-wink.svg": 1812,
	"./svgs/duotone/grin.svg": 1813,
	"./svgs/duotone/grip-horizontal.svg": 1814,
	"./svgs/duotone/grip-lines-vertical.svg": 1815,
	"./svgs/duotone/grip-lines.svg": 1816,
	"./svgs/duotone/grip-vertical.svg": 1817,
	"./svgs/duotone/guitar-electric.svg": 1818,
	"./svgs/duotone/guitar.svg": 1819,
	"./svgs/duotone/guitars.svg": 1820,
	"./svgs/duotone/h-square.svg": 1821,
	"./svgs/duotone/h1.svg": 1822,
	"./svgs/duotone/h2.svg": 1823,
	"./svgs/duotone/h3.svg": 1824,
	"./svgs/duotone/h4.svg": 1825,
	"./svgs/duotone/hamburger.svg": 1826,
	"./svgs/duotone/hammer-war.svg": 1827,
	"./svgs/duotone/hammer.svg": 1828,
	"./svgs/duotone/hamsa.svg": 1829,
	"./svgs/duotone/hand-heart.svg": 1830,
	"./svgs/duotone/hand-holding-box.svg": 1831,
	"./svgs/duotone/hand-holding-heart.svg": 1832,
	"./svgs/duotone/hand-holding-magic.svg": 1833,
	"./svgs/duotone/hand-holding-seedling.svg": 1834,
	"./svgs/duotone/hand-holding-usd.svg": 1835,
	"./svgs/duotone/hand-holding-water.svg": 1836,
	"./svgs/duotone/hand-holding.svg": 1837,
	"./svgs/duotone/hand-lizard.svg": 1838,
	"./svgs/duotone/hand-middle-finger.svg": 1839,
	"./svgs/duotone/hand-paper.svg": 1840,
	"./svgs/duotone/hand-peace.svg": 1841,
	"./svgs/duotone/hand-point-down.svg": 1842,
	"./svgs/duotone/hand-point-left.svg": 1843,
	"./svgs/duotone/hand-point-right.svg": 1844,
	"./svgs/duotone/hand-point-up.svg": 1845,
	"./svgs/duotone/hand-pointer.svg": 1846,
	"./svgs/duotone/hand-receiving.svg": 1847,
	"./svgs/duotone/hand-rock.svg": 1848,
	"./svgs/duotone/hand-scissors.svg": 1849,
	"./svgs/duotone/hand-spock.svg": 1850,
	"./svgs/duotone/hands-heart.svg": 1851,
	"./svgs/duotone/hands-helping.svg": 1852,
	"./svgs/duotone/hands-usd.svg": 1853,
	"./svgs/duotone/hands.svg": 1854,
	"./svgs/duotone/handshake-alt.svg": 1855,
	"./svgs/duotone/handshake.svg": 1856,
	"./svgs/duotone/hanukiah.svg": 1857,
	"./svgs/duotone/hard-hat.svg": 1858,
	"./svgs/duotone/hashtag.svg": 1859,
	"./svgs/duotone/hat-chef.svg": 1860,
	"./svgs/duotone/hat-cowboy-side.svg": 1861,
	"./svgs/duotone/hat-cowboy.svg": 1862,
	"./svgs/duotone/hat-santa.svg": 1863,
	"./svgs/duotone/hat-winter.svg": 1864,
	"./svgs/duotone/hat-witch.svg": 1865,
	"./svgs/duotone/hat-wizard.svg": 1866,
	"./svgs/duotone/hdd.svg": 1867,
	"./svgs/duotone/head-side-brain.svg": 1868,
	"./svgs/duotone/head-side-headphones.svg": 1869,
	"./svgs/duotone/head-side-medical.svg": 1870,
	"./svgs/duotone/head-side.svg": 1871,
	"./svgs/duotone/head-vr.svg": 1872,
	"./svgs/duotone/heading.svg": 1873,
	"./svgs/duotone/headphones-alt.svg": 1874,
	"./svgs/duotone/headphones.svg": 1875,
	"./svgs/duotone/headset.svg": 1876,
	"./svgs/duotone/heart-broken.svg": 1877,
	"./svgs/duotone/heart-circle.svg": 1878,
	"./svgs/duotone/heart-rate.svg": 1879,
	"./svgs/duotone/heart-square.svg": 1880,
	"./svgs/duotone/heart.svg": 1881,
	"./svgs/duotone/heartbeat.svg": 1882,
	"./svgs/duotone/heat.svg": 1883,
	"./svgs/duotone/helicopter.svg": 1884,
	"./svgs/duotone/helmet-battle.svg": 1885,
	"./svgs/duotone/hexagon.svg": 1886,
	"./svgs/duotone/highlighter.svg": 1887,
	"./svgs/duotone/hiking.svg": 1888,
	"./svgs/duotone/hippo.svg": 1889,
	"./svgs/duotone/history.svg": 1890,
	"./svgs/duotone/hockey-mask.svg": 1891,
	"./svgs/duotone/hockey-puck.svg": 1892,
	"./svgs/duotone/hockey-sticks.svg": 1893,
	"./svgs/duotone/holly-berry.svg": 1894,
	"./svgs/duotone/home-alt.svg": 1895,
	"./svgs/duotone/home-heart.svg": 1896,
	"./svgs/duotone/home-lg-alt.svg": 1897,
	"./svgs/duotone/home-lg.svg": 1898,
	"./svgs/duotone/home.svg": 1899,
	"./svgs/duotone/hood-cloak.svg": 1900,
	"./svgs/duotone/horizontal-rule.svg": 1901,
	"./svgs/duotone/horse-head.svg": 1902,
	"./svgs/duotone/horse-saddle.svg": 1903,
	"./svgs/duotone/horse.svg": 1904,
	"./svgs/duotone/hospital-alt.svg": 1905,
	"./svgs/duotone/hospital-symbol.svg": 1906,
	"./svgs/duotone/hospital-user.svg": 1907,
	"./svgs/duotone/hospital.svg": 1908,
	"./svgs/duotone/hospitals.svg": 1909,
	"./svgs/duotone/hot-tub.svg": 1910,
	"./svgs/duotone/hotdog.svg": 1911,
	"./svgs/duotone/hotel.svg": 1912,
	"./svgs/duotone/hourglass-end.svg": 1913,
	"./svgs/duotone/hourglass-half.svg": 1914,
	"./svgs/duotone/hourglass-start.svg": 1915,
	"./svgs/duotone/hourglass.svg": 1916,
	"./svgs/duotone/house-damage.svg": 1917,
	"./svgs/duotone/house-day.svg": 1918,
	"./svgs/duotone/house-flood.svg": 1919,
	"./svgs/duotone/house-leave.svg": 1920,
	"./svgs/duotone/house-night.svg": 1921,
	"./svgs/duotone/house-return.svg": 1922,
	"./svgs/duotone/house-signal.svg": 1923,
	"./svgs/duotone/house.svg": 1924,
	"./svgs/duotone/hryvnia.svg": 1925,
	"./svgs/duotone/humidity.svg": 1926,
	"./svgs/duotone/hurricane.svg": 1927,
	"./svgs/duotone/i-cursor.svg": 1928,
	"./svgs/duotone/ice-cream.svg": 1929,
	"./svgs/duotone/ice-skate.svg": 1930,
	"./svgs/duotone/icicles.svg": 1931,
	"./svgs/duotone/icons-alt.svg": 1932,
	"./svgs/duotone/icons.svg": 1933,
	"./svgs/duotone/id-badge.svg": 1934,
	"./svgs/duotone/id-card-alt.svg": 1935,
	"./svgs/duotone/id-card.svg": 1936,
	"./svgs/duotone/igloo.svg": 1937,
	"./svgs/duotone/image-polaroid.svg": 1938,
	"./svgs/duotone/image.svg": 1939,
	"./svgs/duotone/images.svg": 1940,
	"./svgs/duotone/inbox-in.svg": 1941,
	"./svgs/duotone/inbox-out.svg": 1942,
	"./svgs/duotone/inbox.svg": 1943,
	"./svgs/duotone/indent.svg": 1944,
	"./svgs/duotone/industry-alt.svg": 1945,
	"./svgs/duotone/industry.svg": 1946,
	"./svgs/duotone/infinity.svg": 1947,
	"./svgs/duotone/info-circle.svg": 1948,
	"./svgs/duotone/info-square.svg": 1949,
	"./svgs/duotone/info.svg": 1950,
	"./svgs/duotone/inhaler.svg": 1951,
	"./svgs/duotone/integral.svg": 1952,
	"./svgs/duotone/intersection.svg": 1953,
	"./svgs/duotone/inventory.svg": 1954,
	"./svgs/duotone/island-tropical.svg": 1955,
	"./svgs/duotone/italic.svg": 1956,
	"./svgs/duotone/jack-o-lantern.svg": 1957,
	"./svgs/duotone/jedi.svg": 1958,
	"./svgs/duotone/joint.svg": 1959,
	"./svgs/duotone/journal-whills.svg": 1960,
	"./svgs/duotone/joystick.svg": 1961,
	"./svgs/duotone/jug.svg": 1962,
	"./svgs/duotone/kaaba.svg": 1963,
	"./svgs/duotone/kazoo.svg": 1964,
	"./svgs/duotone/kerning.svg": 1965,
	"./svgs/duotone/key-skeleton.svg": 1966,
	"./svgs/duotone/key.svg": 1967,
	"./svgs/duotone/keyboard.svg": 1968,
	"./svgs/duotone/keynote.svg": 1969,
	"./svgs/duotone/khanda.svg": 1970,
	"./svgs/duotone/kidneys.svg": 1971,
	"./svgs/duotone/kiss-beam.svg": 1972,
	"./svgs/duotone/kiss-wink-heart.svg": 1973,
	"./svgs/duotone/kiss.svg": 1974,
	"./svgs/duotone/kite.svg": 1975,
	"./svgs/duotone/kiwi-bird.svg": 1976,
	"./svgs/duotone/knife-kitchen.svg": 1977,
	"./svgs/duotone/lambda.svg": 1978,
	"./svgs/duotone/lamp-desk.svg": 1979,
	"./svgs/duotone/lamp-floor.svg": 1980,
	"./svgs/duotone/lamp.svg": 1981,
	"./svgs/duotone/landmark-alt.svg": 1982,
	"./svgs/duotone/landmark.svg": 1983,
	"./svgs/duotone/language.svg": 1984,
	"./svgs/duotone/laptop-code.svg": 1985,
	"./svgs/duotone/laptop-medical.svg": 1986,
	"./svgs/duotone/laptop.svg": 1987,
	"./svgs/duotone/lasso.svg": 1988,
	"./svgs/duotone/laugh-beam.svg": 1989,
	"./svgs/duotone/laugh-squint.svg": 1990,
	"./svgs/duotone/laugh-wink.svg": 1991,
	"./svgs/duotone/laugh.svg": 1992,
	"./svgs/duotone/layer-group.svg": 1993,
	"./svgs/duotone/layer-minus.svg": 1994,
	"./svgs/duotone/layer-plus.svg": 1995,
	"./svgs/duotone/leaf-heart.svg": 1996,
	"./svgs/duotone/leaf-maple.svg": 1997,
	"./svgs/duotone/leaf-oak.svg": 1998,
	"./svgs/duotone/leaf.svg": 1999,
	"./svgs/duotone/lemon.svg": 2000,
	"./svgs/duotone/less-than-equal.svg": 2001,
	"./svgs/duotone/less-than.svg": 2002,
	"./svgs/duotone/level-down-alt.svg": 2003,
	"./svgs/duotone/level-down.svg": 2004,
	"./svgs/duotone/level-up-alt.svg": 2005,
	"./svgs/duotone/level-up.svg": 2006,
	"./svgs/duotone/life-ring.svg": 2007,
	"./svgs/duotone/light-ceiling.svg": 2008,
	"./svgs/duotone/light-switch-off.svg": 2009,
	"./svgs/duotone/light-switch-on.svg": 2010,
	"./svgs/duotone/light-switch.svg": 2011,
	"./svgs/duotone/lightbulb-dollar.svg": 2012,
	"./svgs/duotone/lightbulb-exclamation.svg": 2013,
	"./svgs/duotone/lightbulb-on.svg": 2014,
	"./svgs/duotone/lightbulb-slash.svg": 2015,
	"./svgs/duotone/lightbulb.svg": 2016,
	"./svgs/duotone/lights-holiday.svg": 2017,
	"./svgs/duotone/line-columns.svg": 2018,
	"./svgs/duotone/line-height.svg": 2019,
	"./svgs/duotone/link.svg": 2020,
	"./svgs/duotone/lips.svg": 2021,
	"./svgs/duotone/lira-sign.svg": 2022,
	"./svgs/duotone/list-alt.svg": 2023,
	"./svgs/duotone/list-music.svg": 2024,
	"./svgs/duotone/list-ol.svg": 2025,
	"./svgs/duotone/list-ul.svg": 2026,
	"./svgs/duotone/list.svg": 2027,
	"./svgs/duotone/location-arrow.svg": 2028,
	"./svgs/duotone/location-circle.svg": 2029,
	"./svgs/duotone/location-slash.svg": 2030,
	"./svgs/duotone/location.svg": 2031,
	"./svgs/duotone/lock-alt.svg": 2032,
	"./svgs/duotone/lock-open-alt.svg": 2033,
	"./svgs/duotone/lock-open.svg": 2034,
	"./svgs/duotone/lock.svg": 2035,
	"./svgs/duotone/long-arrow-alt-down.svg": 2036,
	"./svgs/duotone/long-arrow-alt-left.svg": 2037,
	"./svgs/duotone/long-arrow-alt-right.svg": 2038,
	"./svgs/duotone/long-arrow-alt-up.svg": 2039,
	"./svgs/duotone/long-arrow-down.svg": 2040,
	"./svgs/duotone/long-arrow-left.svg": 2041,
	"./svgs/duotone/long-arrow-right.svg": 2042,
	"./svgs/duotone/long-arrow-up.svg": 2043,
	"./svgs/duotone/loveseat.svg": 2044,
	"./svgs/duotone/low-vision.svg": 2045,
	"./svgs/duotone/luchador.svg": 2046,
	"./svgs/duotone/luggage-cart.svg": 2047,
	"./svgs/duotone/lungs.svg": 2048,
	"./svgs/duotone/mace.svg": 2049,
	"./svgs/duotone/magic.svg": 2050,
	"./svgs/duotone/magnet.svg": 2051,
	"./svgs/duotone/mail-bulk.svg": 2052,
	"./svgs/duotone/mailbox.svg": 2053,
	"./svgs/duotone/male.svg": 2054,
	"./svgs/duotone/mandolin.svg": 2055,
	"./svgs/duotone/map-marked-alt.svg": 2056,
	"./svgs/duotone/map-marked.svg": 2057,
	"./svgs/duotone/map-marker-alt-slash.svg": 2058,
	"./svgs/duotone/map-marker-alt.svg": 2059,
	"./svgs/duotone/map-marker-check.svg": 2060,
	"./svgs/duotone/map-marker-edit.svg": 2061,
	"./svgs/duotone/map-marker-exclamation.svg": 2062,
	"./svgs/duotone/map-marker-minus.svg": 2063,
	"./svgs/duotone/map-marker-plus.svg": 2064,
	"./svgs/duotone/map-marker-question.svg": 2065,
	"./svgs/duotone/map-marker-slash.svg": 2066,
	"./svgs/duotone/map-marker-smile.svg": 2067,
	"./svgs/duotone/map-marker-times.svg": 2068,
	"./svgs/duotone/map-marker.svg": 2069,
	"./svgs/duotone/map-pin.svg": 2070,
	"./svgs/duotone/map-signs.svg": 2071,
	"./svgs/duotone/map.svg": 2072,
	"./svgs/duotone/marker.svg": 2073,
	"./svgs/duotone/mars-double.svg": 2074,
	"./svgs/duotone/mars-stroke-h.svg": 2075,
	"./svgs/duotone/mars-stroke-v.svg": 2076,
	"./svgs/duotone/mars-stroke.svg": 2077,
	"./svgs/duotone/mars.svg": 2078,
	"./svgs/duotone/mask.svg": 2079,
	"./svgs/duotone/meat.svg": 2080,
	"./svgs/duotone/medal.svg": 2081,
	"./svgs/duotone/medkit.svg": 2082,
	"./svgs/duotone/megaphone.svg": 2083,
	"./svgs/duotone/meh-blank.svg": 2084,
	"./svgs/duotone/meh-rolling-eyes.svg": 2085,
	"./svgs/duotone/meh.svg": 2086,
	"./svgs/duotone/memory.svg": 2087,
	"./svgs/duotone/menorah.svg": 2088,
	"./svgs/duotone/mercury.svg": 2089,
	"./svgs/duotone/meteor.svg": 2090,
	"./svgs/duotone/microchip.svg": 2091,
	"./svgs/duotone/microphone-alt-slash.svg": 2092,
	"./svgs/duotone/microphone-alt.svg": 2093,
	"./svgs/duotone/microphone-slash.svg": 2094,
	"./svgs/duotone/microphone-stand.svg": 2095,
	"./svgs/duotone/microphone.svg": 2096,
	"./svgs/duotone/microscope.svg": 2097,
	"./svgs/duotone/microwave.svg": 2098,
	"./svgs/duotone/mind-share.svg": 2099,
	"./svgs/duotone/minus-circle.svg": 2100,
	"./svgs/duotone/minus-hexagon.svg": 2101,
	"./svgs/duotone/minus-octagon.svg": 2102,
	"./svgs/duotone/minus-square.svg": 2103,
	"./svgs/duotone/minus.svg": 2104,
	"./svgs/duotone/mistletoe.svg": 2105,
	"./svgs/duotone/mitten.svg": 2106,
	"./svgs/duotone/mobile-alt.svg": 2107,
	"./svgs/duotone/mobile-android-alt.svg": 2108,
	"./svgs/duotone/mobile-android.svg": 2109,
	"./svgs/duotone/mobile.svg": 2110,
	"./svgs/duotone/money-bill-alt.svg": 2111,
	"./svgs/duotone/money-bill-wave-alt.svg": 2112,
	"./svgs/duotone/money-bill-wave.svg": 2113,
	"./svgs/duotone/money-bill.svg": 2114,
	"./svgs/duotone/money-check-alt.svg": 2115,
	"./svgs/duotone/money-check-edit-alt.svg": 2116,
	"./svgs/duotone/money-check-edit.svg": 2117,
	"./svgs/duotone/money-check.svg": 2118,
	"./svgs/duotone/monitor-heart-rate.svg": 2119,
	"./svgs/duotone/monkey.svg": 2120,
	"./svgs/duotone/monument.svg": 2121,
	"./svgs/duotone/moon-cloud.svg": 2122,
	"./svgs/duotone/moon-stars.svg": 2123,
	"./svgs/duotone/moon.svg": 2124,
	"./svgs/duotone/mortar-pestle.svg": 2125,
	"./svgs/duotone/mosque.svg": 2126,
	"./svgs/duotone/motorcycle.svg": 2127,
	"./svgs/duotone/mountain.svg": 2128,
	"./svgs/duotone/mountains.svg": 2129,
	"./svgs/duotone/mouse-alt.svg": 2130,
	"./svgs/duotone/mouse-pointer.svg": 2131,
	"./svgs/duotone/mouse.svg": 2132,
	"./svgs/duotone/mp3-player.svg": 2133,
	"./svgs/duotone/mug-hot.svg": 2134,
	"./svgs/duotone/mug-marshmallows.svg": 2135,
	"./svgs/duotone/mug-tea.svg": 2136,
	"./svgs/duotone/mug.svg": 2137,
	"./svgs/duotone/music-alt-slash.svg": 2138,
	"./svgs/duotone/music-alt.svg": 2139,
	"./svgs/duotone/music-slash.svg": 2140,
	"./svgs/duotone/music.svg": 2141,
	"./svgs/duotone/narwhal.svg": 2142,
	"./svgs/duotone/network-wired.svg": 2143,
	"./svgs/duotone/neuter.svg": 2144,
	"./svgs/duotone/newspaper.svg": 2145,
	"./svgs/duotone/not-equal.svg": 2146,
	"./svgs/duotone/notes-medical.svg": 2147,
	"./svgs/duotone/object-group.svg": 2148,
	"./svgs/duotone/object-ungroup.svg": 2149,
	"./svgs/duotone/octagon.svg": 2150,
	"./svgs/duotone/oil-can.svg": 2151,
	"./svgs/duotone/oil-temp.svg": 2152,
	"./svgs/duotone/om.svg": 2153,
	"./svgs/duotone/omega.svg": 2154,
	"./svgs/duotone/ornament.svg": 2155,
	"./svgs/duotone/otter.svg": 2156,
	"./svgs/duotone/outdent.svg": 2157,
	"./svgs/duotone/outlet.svg": 2158,
	"./svgs/duotone/oven.svg": 2159,
	"./svgs/duotone/overline.svg": 2160,
	"./svgs/duotone/page-break.svg": 2161,
	"./svgs/duotone/pager.svg": 2162,
	"./svgs/duotone/paint-brush-alt.svg": 2163,
	"./svgs/duotone/paint-brush.svg": 2164,
	"./svgs/duotone/paint-roller.svg": 2165,
	"./svgs/duotone/palette.svg": 2166,
	"./svgs/duotone/pallet-alt.svg": 2167,
	"./svgs/duotone/pallet.svg": 2168,
	"./svgs/duotone/paper-plane.svg": 2169,
	"./svgs/duotone/paperclip.svg": 2170,
	"./svgs/duotone/parachute-box.svg": 2171,
	"./svgs/duotone/paragraph-rtl.svg": 2172,
	"./svgs/duotone/paragraph.svg": 2173,
	"./svgs/duotone/parking-circle-slash.svg": 2174,
	"./svgs/duotone/parking-circle.svg": 2175,
	"./svgs/duotone/parking-slash.svg": 2176,
	"./svgs/duotone/parking.svg": 2177,
	"./svgs/duotone/passport.svg": 2178,
	"./svgs/duotone/pastafarianism.svg": 2179,
	"./svgs/duotone/paste.svg": 2180,
	"./svgs/duotone/pause-circle.svg": 2181,
	"./svgs/duotone/pause.svg": 2182,
	"./svgs/duotone/paw-alt.svg": 2183,
	"./svgs/duotone/paw-claws.svg": 2184,
	"./svgs/duotone/paw.svg": 2185,
	"./svgs/duotone/peace.svg": 2186,
	"./svgs/duotone/pegasus.svg": 2187,
	"./svgs/duotone/pen-alt.svg": 2188,
	"./svgs/duotone/pen-fancy.svg": 2189,
	"./svgs/duotone/pen-nib.svg": 2190,
	"./svgs/duotone/pen-square.svg": 2191,
	"./svgs/duotone/pen.svg": 2192,
	"./svgs/duotone/pencil-alt.svg": 2193,
	"./svgs/duotone/pencil-paintbrush.svg": 2194,
	"./svgs/duotone/pencil-ruler.svg": 2195,
	"./svgs/duotone/pencil.svg": 2196,
	"./svgs/duotone/pennant.svg": 2197,
	"./svgs/duotone/people-carry.svg": 2198,
	"./svgs/duotone/pepper-hot.svg": 2199,
	"./svgs/duotone/percent.svg": 2200,
	"./svgs/duotone/percentage.svg": 2201,
	"./svgs/duotone/person-booth.svg": 2202,
	"./svgs/duotone/person-carry.svg": 2203,
	"./svgs/duotone/person-dolly-empty.svg": 2204,
	"./svgs/duotone/person-dolly.svg": 2205,
	"./svgs/duotone/person-sign.svg": 2206,
	"./svgs/duotone/phone-alt.svg": 2207,
	"./svgs/duotone/phone-laptop.svg": 2208,
	"./svgs/duotone/phone-office.svg": 2209,
	"./svgs/duotone/phone-plus.svg": 2210,
	"./svgs/duotone/phone-rotary.svg": 2211,
	"./svgs/duotone/phone-slash.svg": 2212,
	"./svgs/duotone/phone-square-alt.svg": 2213,
	"./svgs/duotone/phone-square.svg": 2214,
	"./svgs/duotone/phone-volume.svg": 2215,
	"./svgs/duotone/phone.svg": 2216,
	"./svgs/duotone/photo-video.svg": 2217,
	"./svgs/duotone/pi.svg": 2218,
	"./svgs/duotone/piano-keyboard.svg": 2219,
	"./svgs/duotone/piano.svg": 2220,
	"./svgs/duotone/pie.svg": 2221,
	"./svgs/duotone/pig.svg": 2222,
	"./svgs/duotone/piggy-bank.svg": 2223,
	"./svgs/duotone/pills.svg": 2224,
	"./svgs/duotone/pizza-slice.svg": 2225,
	"./svgs/duotone/pizza.svg": 2226,
	"./svgs/duotone/place-of-worship.svg": 2227,
	"./svgs/duotone/plane-alt.svg": 2228,
	"./svgs/duotone/plane-arrival.svg": 2229,
	"./svgs/duotone/plane-departure.svg": 2230,
	"./svgs/duotone/plane.svg": 2231,
	"./svgs/duotone/planet-moon.svg": 2232,
	"./svgs/duotone/planet-ringed.svg": 2233,
	"./svgs/duotone/play-circle.svg": 2234,
	"./svgs/duotone/play.svg": 2235,
	"./svgs/duotone/plug.svg": 2236,
	"./svgs/duotone/plus-circle.svg": 2237,
	"./svgs/duotone/plus-hexagon.svg": 2238,
	"./svgs/duotone/plus-octagon.svg": 2239,
	"./svgs/duotone/plus-square.svg": 2240,
	"./svgs/duotone/plus.svg": 2241,
	"./svgs/duotone/podcast.svg": 2242,
	"./svgs/duotone/podium-star.svg": 2243,
	"./svgs/duotone/podium.svg": 2244,
	"./svgs/duotone/police-box.svg": 2245,
	"./svgs/duotone/poll-h.svg": 2246,
	"./svgs/duotone/poll-people.svg": 2247,
	"./svgs/duotone/poll.svg": 2248,
	"./svgs/duotone/poo-storm.svg": 2249,
	"./svgs/duotone/poo.svg": 2250,
	"./svgs/duotone/poop.svg": 2251,
	"./svgs/duotone/popcorn.svg": 2252,
	"./svgs/duotone/portal-enter.svg": 2253,
	"./svgs/duotone/portal-exit.svg": 2254,
	"./svgs/duotone/portrait.svg": 2255,
	"./svgs/duotone/pound-sign.svg": 2256,
	"./svgs/duotone/power-off.svg": 2257,
	"./svgs/duotone/pray.svg": 2258,
	"./svgs/duotone/praying-hands.svg": 2259,
	"./svgs/duotone/prescription-bottle-alt.svg": 2260,
	"./svgs/duotone/prescription-bottle.svg": 2261,
	"./svgs/duotone/prescription.svg": 2262,
	"./svgs/duotone/presentation.svg": 2263,
	"./svgs/duotone/print-search.svg": 2264,
	"./svgs/duotone/print-slash.svg": 2265,
	"./svgs/duotone/print.svg": 2266,
	"./svgs/duotone/procedures.svg": 2267,
	"./svgs/duotone/project-diagram.svg": 2268,
	"./svgs/duotone/projector.svg": 2269,
	"./svgs/duotone/pumpkin.svg": 2270,
	"./svgs/duotone/puzzle-piece.svg": 2271,
	"./svgs/duotone/qrcode.svg": 2272,
	"./svgs/duotone/question-circle.svg": 2273,
	"./svgs/duotone/question-square.svg": 2274,
	"./svgs/duotone/question.svg": 2275,
	"./svgs/duotone/quidditch.svg": 2276,
	"./svgs/duotone/quote-left.svg": 2277,
	"./svgs/duotone/quote-right.svg": 2278,
	"./svgs/duotone/quran.svg": 2279,
	"./svgs/duotone/rabbit-fast.svg": 2280,
	"./svgs/duotone/rabbit.svg": 2281,
	"./svgs/duotone/racquet.svg": 2282,
	"./svgs/duotone/radar.svg": 2283,
	"./svgs/duotone/radiation-alt.svg": 2284,
	"./svgs/duotone/radiation.svg": 2285,
	"./svgs/duotone/radio-alt.svg": 2286,
	"./svgs/duotone/radio.svg": 2287,
	"./svgs/duotone/rainbow.svg": 2288,
	"./svgs/duotone/raindrops.svg": 2289,
	"./svgs/duotone/ram.svg": 2290,
	"./svgs/duotone/ramp-loading.svg": 2291,
	"./svgs/duotone/random.svg": 2292,
	"./svgs/duotone/raygun.svg": 2293,
	"./svgs/duotone/receipt.svg": 2294,
	"./svgs/duotone/record-vinyl.svg": 2295,
	"./svgs/duotone/rectangle-landscape.svg": 2296,
	"./svgs/duotone/rectangle-portrait.svg": 2297,
	"./svgs/duotone/rectangle-wide.svg": 2298,
	"./svgs/duotone/recycle.svg": 2299,
	"./svgs/duotone/redo-alt.svg": 2300,
	"./svgs/duotone/redo.svg": 2301,
	"./svgs/duotone/refrigerator.svg": 2302,
	"./svgs/duotone/registered.svg": 2303,
	"./svgs/duotone/remove-format.svg": 2304,
	"./svgs/duotone/repeat-1-alt.svg": 2305,
	"./svgs/duotone/repeat-1.svg": 2306,
	"./svgs/duotone/repeat-alt.svg": 2307,
	"./svgs/duotone/repeat.svg": 2308,
	"./svgs/duotone/reply-all.svg": 2309,
	"./svgs/duotone/reply.svg": 2310,
	"./svgs/duotone/republican.svg": 2311,
	"./svgs/duotone/restroom.svg": 2312,
	"./svgs/duotone/retweet-alt.svg": 2313,
	"./svgs/duotone/retweet.svg": 2314,
	"./svgs/duotone/ribbon.svg": 2315,
	"./svgs/duotone/ring.svg": 2316,
	"./svgs/duotone/rings-wedding.svg": 2317,
	"./svgs/duotone/road.svg": 2318,
	"./svgs/duotone/robot.svg": 2319,
	"./svgs/duotone/rocket-launch.svg": 2320,
	"./svgs/duotone/rocket.svg": 2321,
	"./svgs/duotone/route-highway.svg": 2322,
	"./svgs/duotone/route-interstate.svg": 2323,
	"./svgs/duotone/route.svg": 2324,
	"./svgs/duotone/router.svg": 2325,
	"./svgs/duotone/rss-square.svg": 2326,
	"./svgs/duotone/rss.svg": 2327,
	"./svgs/duotone/ruble-sign.svg": 2328,
	"./svgs/duotone/ruler-combined.svg": 2329,
	"./svgs/duotone/ruler-horizontal.svg": 2330,
	"./svgs/duotone/ruler-triangle.svg": 2331,
	"./svgs/duotone/ruler-vertical.svg": 2332,
	"./svgs/duotone/ruler.svg": 2333,
	"./svgs/duotone/running.svg": 2334,
	"./svgs/duotone/rupee-sign.svg": 2335,
	"./svgs/duotone/rv.svg": 2336,
	"./svgs/duotone/sack-dollar.svg": 2337,
	"./svgs/duotone/sack.svg": 2338,
	"./svgs/duotone/sad-cry.svg": 2339,
	"./svgs/duotone/sad-tear.svg": 2340,
	"./svgs/duotone/salad.svg": 2341,
	"./svgs/duotone/sandwich.svg": 2342,
	"./svgs/duotone/satellite-dish.svg": 2343,
	"./svgs/duotone/satellite.svg": 2344,
	"./svgs/duotone/sausage.svg": 2345,
	"./svgs/duotone/save.svg": 2346,
	"./svgs/duotone/sax-hot.svg": 2347,
	"./svgs/duotone/saxophone.svg": 2348,
	"./svgs/duotone/scalpel-path.svg": 2349,
	"./svgs/duotone/scalpel.svg": 2350,
	"./svgs/duotone/scanner-image.svg": 2351,
	"./svgs/duotone/scanner-keyboard.svg": 2352,
	"./svgs/duotone/scanner-touchscreen.svg": 2353,
	"./svgs/duotone/scanner.svg": 2354,
	"./svgs/duotone/scarecrow.svg": 2355,
	"./svgs/duotone/scarf.svg": 2356,
	"./svgs/duotone/school.svg": 2357,
	"./svgs/duotone/screwdriver.svg": 2358,
	"./svgs/duotone/scroll-old.svg": 2359,
	"./svgs/duotone/scroll.svg": 2360,
	"./svgs/duotone/scrubber.svg": 2361,
	"./svgs/duotone/scythe.svg": 2362,
	"./svgs/duotone/sd-card.svg": 2363,
	"./svgs/duotone/search-dollar.svg": 2364,
	"./svgs/duotone/search-location.svg": 2365,
	"./svgs/duotone/search-minus.svg": 2366,
	"./svgs/duotone/search-plus.svg": 2367,
	"./svgs/duotone/search.svg": 2368,
	"./svgs/duotone/seedling.svg": 2369,
	"./svgs/duotone/send-back.svg": 2370,
	"./svgs/duotone/send-backward.svg": 2371,
	"./svgs/duotone/sensor-alert.svg": 2372,
	"./svgs/duotone/sensor-fire.svg": 2373,
	"./svgs/duotone/sensor-on.svg": 2374,
	"./svgs/duotone/sensor-smoke.svg": 2375,
	"./svgs/duotone/sensor.svg": 2376,
	"./svgs/duotone/server.svg": 2377,
	"./svgs/duotone/shapes.svg": 2378,
	"./svgs/duotone/share-all.svg": 2379,
	"./svgs/duotone/share-alt-square.svg": 2380,
	"./svgs/duotone/share-alt.svg": 2381,
	"./svgs/duotone/share-square.svg": 2382,
	"./svgs/duotone/share.svg": 2383,
	"./svgs/duotone/sheep.svg": 2384,
	"./svgs/duotone/shekel-sign.svg": 2385,
	"./svgs/duotone/shield-alt.svg": 2386,
	"./svgs/duotone/shield-check.svg": 2387,
	"./svgs/duotone/shield-cross.svg": 2388,
	"./svgs/duotone/shield.svg": 2389,
	"./svgs/duotone/ship.svg": 2390,
	"./svgs/duotone/shipping-fast.svg": 2391,
	"./svgs/duotone/shipping-timed.svg": 2392,
	"./svgs/duotone/shish-kebab.svg": 2393,
	"./svgs/duotone/shoe-prints.svg": 2394,
	"./svgs/duotone/shopping-bag.svg": 2395,
	"./svgs/duotone/shopping-basket.svg": 2396,
	"./svgs/duotone/shopping-cart.svg": 2397,
	"./svgs/duotone/shovel-snow.svg": 2398,
	"./svgs/duotone/shovel.svg": 2399,
	"./svgs/duotone/shower.svg": 2400,
	"./svgs/duotone/shredder.svg": 2401,
	"./svgs/duotone/shuttle-van.svg": 2402,
	"./svgs/duotone/shuttlecock.svg": 2403,
	"./svgs/duotone/sickle.svg": 2404,
	"./svgs/duotone/sigma.svg": 2405,
	"./svgs/duotone/sign-in-alt.svg": 2406,
	"./svgs/duotone/sign-in.svg": 2407,
	"./svgs/duotone/sign-language.svg": 2408,
	"./svgs/duotone/sign-out-alt.svg": 2409,
	"./svgs/duotone/sign-out.svg": 2410,
	"./svgs/duotone/sign.svg": 2411,
	"./svgs/duotone/signal-1.svg": 2412,
	"./svgs/duotone/signal-2.svg": 2413,
	"./svgs/duotone/signal-3.svg": 2414,
	"./svgs/duotone/signal-4.svg": 2415,
	"./svgs/duotone/signal-alt-1.svg": 2416,
	"./svgs/duotone/signal-alt-2.svg": 2417,
	"./svgs/duotone/signal-alt-3.svg": 2418,
	"./svgs/duotone/signal-alt-slash.svg": 2419,
	"./svgs/duotone/signal-alt.svg": 2420,
	"./svgs/duotone/signal-slash.svg": 2421,
	"./svgs/duotone/signal-stream.svg": 2422,
	"./svgs/duotone/signal.svg": 2423,
	"./svgs/duotone/signature.svg": 2424,
	"./svgs/duotone/sim-card.svg": 2425,
	"./svgs/duotone/siren-on.svg": 2426,
	"./svgs/duotone/siren.svg": 2427,
	"./svgs/duotone/sitemap.svg": 2428,
	"./svgs/duotone/skating.svg": 2429,
	"./svgs/duotone/skeleton.svg": 2430,
	"./svgs/duotone/ski-jump.svg": 2431,
	"./svgs/duotone/ski-lift.svg": 2432,
	"./svgs/duotone/skiing-nordic.svg": 2433,
	"./svgs/duotone/skiing.svg": 2434,
	"./svgs/duotone/skull-cow.svg": 2435,
	"./svgs/duotone/skull-crossbones.svg": 2436,
	"./svgs/duotone/skull.svg": 2437,
	"./svgs/duotone/slash.svg": 2438,
	"./svgs/duotone/sledding.svg": 2439,
	"./svgs/duotone/sleigh.svg": 2440,
	"./svgs/duotone/sliders-h-square.svg": 2441,
	"./svgs/duotone/sliders-h.svg": 2442,
	"./svgs/duotone/sliders-v-square.svg": 2443,
	"./svgs/duotone/sliders-v.svg": 2444,
	"./svgs/duotone/smile-beam.svg": 2445,
	"./svgs/duotone/smile-plus.svg": 2446,
	"./svgs/duotone/smile-wink.svg": 2447,
	"./svgs/duotone/smile.svg": 2448,
	"./svgs/duotone/smog.svg": 2449,
	"./svgs/duotone/smoke.svg": 2450,
	"./svgs/duotone/smoking-ban.svg": 2451,
	"./svgs/duotone/smoking.svg": 2452,
	"./svgs/duotone/sms.svg": 2453,
	"./svgs/duotone/snake.svg": 2454,
	"./svgs/duotone/snooze.svg": 2455,
	"./svgs/duotone/snow-blowing.svg": 2456,
	"./svgs/duotone/snowboarding.svg": 2457,
	"./svgs/duotone/snowflake.svg": 2458,
	"./svgs/duotone/snowflakes.svg": 2459,
	"./svgs/duotone/snowman.svg": 2460,
	"./svgs/duotone/snowmobile.svg": 2461,
	"./svgs/duotone/snowplow.svg": 2462,
	"./svgs/duotone/socks.svg": 2463,
	"./svgs/duotone/solar-panel.svg": 2464,
	"./svgs/duotone/solar-system.svg": 2465,
	"./svgs/duotone/sort-alpha-down-alt.svg": 2466,
	"./svgs/duotone/sort-alpha-down.svg": 2467,
	"./svgs/duotone/sort-alpha-up-alt.svg": 2468,
	"./svgs/duotone/sort-alpha-up.svg": 2469,
	"./svgs/duotone/sort-alt.svg": 2470,
	"./svgs/duotone/sort-amount-down-alt.svg": 2471,
	"./svgs/duotone/sort-amount-down.svg": 2472,
	"./svgs/duotone/sort-amount-up-alt.svg": 2473,
	"./svgs/duotone/sort-amount-up.svg": 2474,
	"./svgs/duotone/sort-circle-down.svg": 2475,
	"./svgs/duotone/sort-circle-up.svg": 2476,
	"./svgs/duotone/sort-circle.svg": 2477,
	"./svgs/duotone/sort-down.svg": 2478,
	"./svgs/duotone/sort-numeric-down-alt.svg": 2479,
	"./svgs/duotone/sort-numeric-down.svg": 2480,
	"./svgs/duotone/sort-numeric-up-alt.svg": 2481,
	"./svgs/duotone/sort-numeric-up.svg": 2482,
	"./svgs/duotone/sort-shapes-down-alt.svg": 2483,
	"./svgs/duotone/sort-shapes-down.svg": 2484,
	"./svgs/duotone/sort-shapes-up-alt.svg": 2485,
	"./svgs/duotone/sort-shapes-up.svg": 2486,
	"./svgs/duotone/sort-size-down-alt.svg": 2487,
	"./svgs/duotone/sort-size-down.svg": 2488,
	"./svgs/duotone/sort-size-up-alt.svg": 2489,
	"./svgs/duotone/sort-size-up.svg": 2490,
	"./svgs/duotone/sort-up.svg": 2491,
	"./svgs/duotone/sort.svg": 2492,
	"./svgs/duotone/soup.svg": 2493,
	"./svgs/duotone/spa.svg": 2494,
	"./svgs/duotone/space-shuttle.svg": 2495,
	"./svgs/duotone/space-station-moon-alt.svg": 2496,
	"./svgs/duotone/space-station-moon.svg": 2497,
	"./svgs/duotone/spade.svg": 2498,
	"./svgs/duotone/sparkles.svg": 2499,
	"./svgs/duotone/speaker.svg": 2500,
	"./svgs/duotone/speakers.svg": 2501,
	"./svgs/duotone/spell-check.svg": 2502,
	"./svgs/duotone/spider-black-widow.svg": 2503,
	"./svgs/duotone/spider-web.svg": 2504,
	"./svgs/duotone/spider.svg": 2505,
	"./svgs/duotone/spinner-third.svg": 2506,
	"./svgs/duotone/spinner.svg": 2507,
	"./svgs/duotone/splotch.svg": 2508,
	"./svgs/duotone/spray-can.svg": 2509,
	"./svgs/duotone/sprinkler.svg": 2510,
	"./svgs/duotone/square-full.svg": 2511,
	"./svgs/duotone/square-root-alt.svg": 2512,
	"./svgs/duotone/square-root.svg": 2513,
	"./svgs/duotone/square.svg": 2514,
	"./svgs/duotone/squirrel.svg": 2515,
	"./svgs/duotone/staff.svg": 2516,
	"./svgs/duotone/stamp.svg": 2517,
	"./svgs/duotone/star-and-crescent.svg": 2518,
	"./svgs/duotone/star-christmas.svg": 2519,
	"./svgs/duotone/star-exclamation.svg": 2520,
	"./svgs/duotone/star-half-alt.svg": 2521,
	"./svgs/duotone/star-half.svg": 2522,
	"./svgs/duotone/star-of-david.svg": 2523,
	"./svgs/duotone/star-of-life.svg": 2524,
	"./svgs/duotone/star-shooting.svg": 2525,
	"./svgs/duotone/star.svg": 2526,
	"./svgs/duotone/starfighter-alt.svg": 2527,
	"./svgs/duotone/starfighter.svg": 2528,
	"./svgs/duotone/stars.svg": 2529,
	"./svgs/duotone/starship-freighter.svg": 2530,
	"./svgs/duotone/starship.svg": 2531,
	"./svgs/duotone/steak.svg": 2532,
	"./svgs/duotone/steering-wheel.svg": 2533,
	"./svgs/duotone/step-backward.svg": 2534,
	"./svgs/duotone/step-forward.svg": 2535,
	"./svgs/duotone/stethoscope.svg": 2536,
	"./svgs/duotone/sticky-note.svg": 2537,
	"./svgs/duotone/stocking.svg": 2538,
	"./svgs/duotone/stomach.svg": 2539,
	"./svgs/duotone/stop-circle.svg": 2540,
	"./svgs/duotone/stop.svg": 2541,
	"./svgs/duotone/stopwatch.svg": 2542,
	"./svgs/duotone/store-alt.svg": 2543,
	"./svgs/duotone/store.svg": 2544,
	"./svgs/duotone/stream.svg": 2545,
	"./svgs/duotone/street-view.svg": 2546,
	"./svgs/duotone/stretcher.svg": 2547,
	"./svgs/duotone/strikethrough.svg": 2548,
	"./svgs/duotone/stroopwafel.svg": 2549,
	"./svgs/duotone/subscript.svg": 2550,
	"./svgs/duotone/subway.svg": 2551,
	"./svgs/duotone/suitcase-rolling.svg": 2552,
	"./svgs/duotone/suitcase.svg": 2553,
	"./svgs/duotone/sun-cloud.svg": 2554,
	"./svgs/duotone/sun-dust.svg": 2555,
	"./svgs/duotone/sun-haze.svg": 2556,
	"./svgs/duotone/sun.svg": 2557,
	"./svgs/duotone/sunglasses.svg": 2558,
	"./svgs/duotone/sunrise.svg": 2559,
	"./svgs/duotone/sunset.svg": 2560,
	"./svgs/duotone/superscript.svg": 2561,
	"./svgs/duotone/surprise.svg": 2562,
	"./svgs/duotone/swatchbook.svg": 2563,
	"./svgs/duotone/swimmer.svg": 2564,
	"./svgs/duotone/swimming-pool.svg": 2565,
	"./svgs/duotone/sword-laser-alt.svg": 2566,
	"./svgs/duotone/sword-laser.svg": 2567,
	"./svgs/duotone/sword.svg": 2568,
	"./svgs/duotone/swords-laser.svg": 2569,
	"./svgs/duotone/swords.svg": 2570,
	"./svgs/duotone/synagogue.svg": 2571,
	"./svgs/duotone/sync-alt.svg": 2572,
	"./svgs/duotone/sync.svg": 2573,
	"./svgs/duotone/syringe.svg": 2574,
	"./svgs/duotone/table-tennis.svg": 2575,
	"./svgs/duotone/table.svg": 2576,
	"./svgs/duotone/tablet-alt.svg": 2577,
	"./svgs/duotone/tablet-android-alt.svg": 2578,
	"./svgs/duotone/tablet-android.svg": 2579,
	"./svgs/duotone/tablet-rugged.svg": 2580,
	"./svgs/duotone/tablet.svg": 2581,
	"./svgs/duotone/tablets.svg": 2582,
	"./svgs/duotone/tachometer-alt-average.svg": 2583,
	"./svgs/duotone/tachometer-alt-fast.svg": 2584,
	"./svgs/duotone/tachometer-alt-fastest.svg": 2585,
	"./svgs/duotone/tachometer-alt-slow.svg": 2586,
	"./svgs/duotone/tachometer-alt-slowest.svg": 2587,
	"./svgs/duotone/tachometer-alt.svg": 2588,
	"./svgs/duotone/tachometer-average.svg": 2589,
	"./svgs/duotone/tachometer-fast.svg": 2590,
	"./svgs/duotone/tachometer-fastest.svg": 2591,
	"./svgs/duotone/tachometer-slow.svg": 2592,
	"./svgs/duotone/tachometer-slowest.svg": 2593,
	"./svgs/duotone/tachometer.svg": 2594,
	"./svgs/duotone/taco.svg": 2595,
	"./svgs/duotone/tag.svg": 2596,
	"./svgs/duotone/tags.svg": 2597,
	"./svgs/duotone/tally.svg": 2598,
	"./svgs/duotone/tanakh.svg": 2599,
	"./svgs/duotone/tape.svg": 2600,
	"./svgs/duotone/tasks-alt.svg": 2601,
	"./svgs/duotone/tasks.svg": 2602,
	"./svgs/duotone/taxi.svg": 2603,
	"./svgs/duotone/teeth-open.svg": 2604,
	"./svgs/duotone/teeth.svg": 2605,
	"./svgs/duotone/telescope.svg": 2606,
	"./svgs/duotone/temperature-down.svg": 2607,
	"./svgs/duotone/temperature-frigid.svg": 2608,
	"./svgs/duotone/temperature-high.svg": 2609,
	"./svgs/duotone/temperature-hot.svg": 2610,
	"./svgs/duotone/temperature-low.svg": 2611,
	"./svgs/duotone/temperature-up.svg": 2612,
	"./svgs/duotone/tenge.svg": 2613,
	"./svgs/duotone/tennis-ball.svg": 2614,
	"./svgs/duotone/terminal.svg": 2615,
	"./svgs/duotone/text-height.svg": 2616,
	"./svgs/duotone/text-size.svg": 2617,
	"./svgs/duotone/text-width.svg": 2618,
	"./svgs/duotone/text.svg": 2619,
	"./svgs/duotone/th-large.svg": 2620,
	"./svgs/duotone/th-list.svg": 2621,
	"./svgs/duotone/th.svg": 2622,
	"./svgs/duotone/theater-masks.svg": 2623,
	"./svgs/duotone/thermometer-empty.svg": 2624,
	"./svgs/duotone/thermometer-full.svg": 2625,
	"./svgs/duotone/thermometer-half.svg": 2626,
	"./svgs/duotone/thermometer-quarter.svg": 2627,
	"./svgs/duotone/thermometer-three-quarters.svg": 2628,
	"./svgs/duotone/thermometer.svg": 2629,
	"./svgs/duotone/theta.svg": 2630,
	"./svgs/duotone/thumbs-down.svg": 2631,
	"./svgs/duotone/thumbs-up.svg": 2632,
	"./svgs/duotone/thumbtack.svg": 2633,
	"./svgs/duotone/thunderstorm-moon.svg": 2634,
	"./svgs/duotone/thunderstorm-sun.svg": 2635,
	"./svgs/duotone/thunderstorm.svg": 2636,
	"./svgs/duotone/ticket-alt.svg": 2637,
	"./svgs/duotone/ticket.svg": 2638,
	"./svgs/duotone/tilde.svg": 2639,
	"./svgs/duotone/times-circle.svg": 2640,
	"./svgs/duotone/times-hexagon.svg": 2641,
	"./svgs/duotone/times-octagon.svg": 2642,
	"./svgs/duotone/times-square.svg": 2643,
	"./svgs/duotone/times.svg": 2644,
	"./svgs/duotone/tint-slash.svg": 2645,
	"./svgs/duotone/tint.svg": 2646,
	"./svgs/duotone/tire-flat.svg": 2647,
	"./svgs/duotone/tire-pressure-warning.svg": 2648,
	"./svgs/duotone/tire-rugged.svg": 2649,
	"./svgs/duotone/tire.svg": 2650,
	"./svgs/duotone/tired.svg": 2651,
	"./svgs/duotone/toggle-off.svg": 2652,
	"./svgs/duotone/toggle-on.svg": 2653,
	"./svgs/duotone/toilet-paper-alt.svg": 2654,
	"./svgs/duotone/toilet-paper.svg": 2655,
	"./svgs/duotone/toilet.svg": 2656,
	"./svgs/duotone/tombstone-alt.svg": 2657,
	"./svgs/duotone/tombstone.svg": 2658,
	"./svgs/duotone/toolbox.svg": 2659,
	"./svgs/duotone/tools.svg": 2660,
	"./svgs/duotone/tooth.svg": 2661,
	"./svgs/duotone/toothbrush.svg": 2662,
	"./svgs/duotone/torah.svg": 2663,
	"./svgs/duotone/torii-gate.svg": 2664,
	"./svgs/duotone/tornado.svg": 2665,
	"./svgs/duotone/tractor.svg": 2666,
	"./svgs/duotone/trademark.svg": 2667,
	"./svgs/duotone/traffic-cone.svg": 2668,
	"./svgs/duotone/traffic-light-go.svg": 2669,
	"./svgs/duotone/traffic-light-slow.svg": 2670,
	"./svgs/duotone/traffic-light-stop.svg": 2671,
	"./svgs/duotone/traffic-light.svg": 2672,
	"./svgs/duotone/trailer.svg": 2673,
	"./svgs/duotone/train.svg": 2674,
	"./svgs/duotone/tram.svg": 2675,
	"./svgs/duotone/transgender-alt.svg": 2676,
	"./svgs/duotone/transgender.svg": 2677,
	"./svgs/duotone/transporter-1.svg": 2678,
	"./svgs/duotone/transporter-2.svg": 2679,
	"./svgs/duotone/transporter-3.svg": 2680,
	"./svgs/duotone/transporter-empty.svg": 2681,
	"./svgs/duotone/transporter.svg": 2682,
	"./svgs/duotone/trash-alt.svg": 2683,
	"./svgs/duotone/trash-restore-alt.svg": 2684,
	"./svgs/duotone/trash-restore.svg": 2685,
	"./svgs/duotone/trash-undo-alt.svg": 2686,
	"./svgs/duotone/trash-undo.svg": 2687,
	"./svgs/duotone/trash.svg": 2688,
	"./svgs/duotone/treasure-chest.svg": 2689,
	"./svgs/duotone/tree-alt.svg": 2690,
	"./svgs/duotone/tree-christmas.svg": 2691,
	"./svgs/duotone/tree-decorated.svg": 2692,
	"./svgs/duotone/tree-large.svg": 2693,
	"./svgs/duotone/tree-palm.svg": 2694,
	"./svgs/duotone/tree.svg": 2695,
	"./svgs/duotone/trees.svg": 2696,
	"./svgs/duotone/triangle-music.svg": 2697,
	"./svgs/duotone/triangle.svg": 2698,
	"./svgs/duotone/trophy-alt.svg": 2699,
	"./svgs/duotone/trophy.svg": 2700,
	"./svgs/duotone/truck-container.svg": 2701,
	"./svgs/duotone/truck-couch.svg": 2702,
	"./svgs/duotone/truck-loading.svg": 2703,
	"./svgs/duotone/truck-monster.svg": 2704,
	"./svgs/duotone/truck-moving.svg": 2705,
	"./svgs/duotone/truck-pickup.svg": 2706,
	"./svgs/duotone/truck-plow.svg": 2707,
	"./svgs/duotone/truck-ramp.svg": 2708,
	"./svgs/duotone/truck.svg": 2709,
	"./svgs/duotone/trumpet.svg": 2710,
	"./svgs/duotone/tshirt.svg": 2711,
	"./svgs/duotone/tty.svg": 2712,
	"./svgs/duotone/turkey.svg": 2713,
	"./svgs/duotone/turntable.svg": 2714,
	"./svgs/duotone/turtle.svg": 2715,
	"./svgs/duotone/tv-alt.svg": 2716,
	"./svgs/duotone/tv-music.svg": 2717,
	"./svgs/duotone/tv-retro.svg": 2718,
	"./svgs/duotone/tv.svg": 2719,
	"./svgs/duotone/typewriter.svg": 2720,
	"./svgs/duotone/ufo-beam.svg": 2721,
	"./svgs/duotone/ufo.svg": 2722,
	"./svgs/duotone/umbrella-beach.svg": 2723,
	"./svgs/duotone/umbrella.svg": 2724,
	"./svgs/duotone/underline.svg": 2725,
	"./svgs/duotone/undo-alt.svg": 2726,
	"./svgs/duotone/undo.svg": 2727,
	"./svgs/duotone/unicorn.svg": 2728,
	"./svgs/duotone/union.svg": 2729,
	"./svgs/duotone/universal-access.svg": 2730,
	"./svgs/duotone/university.svg": 2731,
	"./svgs/duotone/unlink.svg": 2732,
	"./svgs/duotone/unlock-alt.svg": 2733,
	"./svgs/duotone/unlock.svg": 2734,
	"./svgs/duotone/upload.svg": 2735,
	"./svgs/duotone/usb-drive.svg": 2736,
	"./svgs/duotone/usd-circle.svg": 2737,
	"./svgs/duotone/usd-square.svg": 2738,
	"./svgs/duotone/user-alien.svg": 2739,
	"./svgs/duotone/user-alt-slash.svg": 2740,
	"./svgs/duotone/user-alt.svg": 2741,
	"./svgs/duotone/user-astronaut.svg": 2742,
	"./svgs/duotone/user-chart.svg": 2743,
	"./svgs/duotone/user-check.svg": 2744,
	"./svgs/duotone/user-circle.svg": 2745,
	"./svgs/duotone/user-clock.svg": 2746,
	"./svgs/duotone/user-cog.svg": 2747,
	"./svgs/duotone/user-cowboy.svg": 2748,
	"./svgs/duotone/user-crown.svg": 2749,
	"./svgs/duotone/user-edit.svg": 2750,
	"./svgs/duotone/user-friends.svg": 2751,
	"./svgs/duotone/user-graduate.svg": 2752,
	"./svgs/duotone/user-hard-hat.svg": 2753,
	"./svgs/duotone/user-headset.svg": 2754,
	"./svgs/duotone/user-injured.svg": 2755,
	"./svgs/duotone/user-lock.svg": 2756,
	"./svgs/duotone/user-md-chat.svg": 2757,
	"./svgs/duotone/user-md.svg": 2758,
	"./svgs/duotone/user-minus.svg": 2759,
	"./svgs/duotone/user-music.svg": 2760,
	"./svgs/duotone/user-ninja.svg": 2761,
	"./svgs/duotone/user-nurse.svg": 2762,
	"./svgs/duotone/user-plus.svg": 2763,
	"./svgs/duotone/user-robot.svg": 2764,
	"./svgs/duotone/user-secret.svg": 2765,
	"./svgs/duotone/user-shield.svg": 2766,
	"./svgs/duotone/user-slash.svg": 2767,
	"./svgs/duotone/user-tag.svg": 2768,
	"./svgs/duotone/user-tie.svg": 2769,
	"./svgs/duotone/user-times.svg": 2770,
	"./svgs/duotone/user-visor.svg": 2771,
	"./svgs/duotone/user.svg": 2772,
	"./svgs/duotone/users-class.svg": 2773,
	"./svgs/duotone/users-cog.svg": 2774,
	"./svgs/duotone/users-crown.svg": 2775,
	"./svgs/duotone/users-medical.svg": 2776,
	"./svgs/duotone/users.svg": 2777,
	"./svgs/duotone/utensil-fork.svg": 2778,
	"./svgs/duotone/utensil-knife.svg": 2779,
	"./svgs/duotone/utensil-spoon.svg": 2780,
	"./svgs/duotone/utensils-alt.svg": 2781,
	"./svgs/duotone/utensils.svg": 2782,
	"./svgs/duotone/vacuum-robot.svg": 2783,
	"./svgs/duotone/vacuum.svg": 2784,
	"./svgs/duotone/value-absolute.svg": 2785,
	"./svgs/duotone/vector-square.svg": 2786,
	"./svgs/duotone/venus-double.svg": 2787,
	"./svgs/duotone/venus-mars.svg": 2788,
	"./svgs/duotone/venus.svg": 2789,
	"./svgs/duotone/vhs.svg": 2790,
	"./svgs/duotone/vial.svg": 2791,
	"./svgs/duotone/vials.svg": 2792,
	"./svgs/duotone/video-plus.svg": 2793,
	"./svgs/duotone/video-slash.svg": 2794,
	"./svgs/duotone/video.svg": 2795,
	"./svgs/duotone/vihara.svg": 2796,
	"./svgs/duotone/violin.svg": 2797,
	"./svgs/duotone/voicemail.svg": 2798,
	"./svgs/duotone/volcano.svg": 2799,
	"./svgs/duotone/volleyball-ball.svg": 2800,
	"./svgs/duotone/volume-down.svg": 2801,
	"./svgs/duotone/volume-mute.svg": 2802,
	"./svgs/duotone/volume-off.svg": 2803,
	"./svgs/duotone/volume-slash.svg": 2804,
	"./svgs/duotone/volume-up.svg": 2805,
	"./svgs/duotone/volume.svg": 2806,
	"./svgs/duotone/vote-nay.svg": 2807,
	"./svgs/duotone/vote-yea.svg": 2808,
	"./svgs/duotone/vr-cardboard.svg": 2809,
	"./svgs/duotone/wagon-covered.svg": 2810,
	"./svgs/duotone/walker.svg": 2811,
	"./svgs/duotone/walkie-talkie.svg": 2812,
	"./svgs/duotone/walking.svg": 2813,
	"./svgs/duotone/wallet.svg": 2814,
	"./svgs/duotone/wand-magic.svg": 2815,
	"./svgs/duotone/wand.svg": 2816,
	"./svgs/duotone/warehouse-alt.svg": 2817,
	"./svgs/duotone/warehouse.svg": 2818,
	"./svgs/duotone/washer.svg": 2819,
	"./svgs/duotone/watch-calculator.svg": 2820,
	"./svgs/duotone/watch-fitness.svg": 2821,
	"./svgs/duotone/watch.svg": 2822,
	"./svgs/duotone/water-lower.svg": 2823,
	"./svgs/duotone/water-rise.svg": 2824,
	"./svgs/duotone/water.svg": 2825,
	"./svgs/duotone/wave-sine.svg": 2826,
	"./svgs/duotone/wave-square.svg": 2827,
	"./svgs/duotone/wave-triangle.svg": 2828,
	"./svgs/duotone/waveform-path.svg": 2829,
	"./svgs/duotone/waveform.svg": 2830,
	"./svgs/duotone/webcam-slash.svg": 2831,
	"./svgs/duotone/webcam.svg": 2832,
	"./svgs/duotone/weight-hanging.svg": 2833,
	"./svgs/duotone/weight.svg": 2834,
	"./svgs/duotone/whale.svg": 2835,
	"./svgs/duotone/wheat.svg": 2836,
	"./svgs/duotone/wheelchair.svg": 2837,
	"./svgs/duotone/whistle.svg": 2838,
	"./svgs/duotone/wifi-1.svg": 2839,
	"./svgs/duotone/wifi-2.svg": 2840,
	"./svgs/duotone/wifi-slash.svg": 2841,
	"./svgs/duotone/wifi.svg": 2842,
	"./svgs/duotone/wind-turbine.svg": 2843,
	"./svgs/duotone/wind-warning.svg": 2844,
	"./svgs/duotone/wind.svg": 2845,
	"./svgs/duotone/window-alt.svg": 2846,
	"./svgs/duotone/window-close.svg": 2847,
	"./svgs/duotone/window-frame-open.svg": 2848,
	"./svgs/duotone/window-frame.svg": 2849,
	"./svgs/duotone/window-maximize.svg": 2850,
	"./svgs/duotone/window-minimize.svg": 2851,
	"./svgs/duotone/window-restore.svg": 2852,
	"./svgs/duotone/window.svg": 2853,
	"./svgs/duotone/windsock.svg": 2854,
	"./svgs/duotone/wine-bottle.svg": 2855,
	"./svgs/duotone/wine-glass-alt.svg": 2856,
	"./svgs/duotone/wine-glass.svg": 2857,
	"./svgs/duotone/won-sign.svg": 2858,
	"./svgs/duotone/wreath.svg": 2859,
	"./svgs/duotone/wrench.svg": 2860,
	"./svgs/duotone/x-ray.svg": 2861,
	"./svgs/duotone/yen-sign.svg": 2862,
	"./svgs/duotone/yin-yang.svg": 2863,
	"./svgs/light/abacus.svg": 2864,
	"./svgs/light/acorn.svg": 2865,
	"./svgs/light/ad.svg": 2866,
	"./svgs/light/address-book.svg": 2867,
	"./svgs/light/address-card.svg": 2868,
	"./svgs/light/adjust.svg": 2869,
	"./svgs/light/air-conditioner.svg": 2870,
	"./svgs/light/air-freshener.svg": 2871,
	"./svgs/light/alarm-clock.svg": 2872,
	"./svgs/light/alarm-exclamation.svg": 2873,
	"./svgs/light/alarm-plus.svg": 2874,
	"./svgs/light/alarm-snooze.svg": 2875,
	"./svgs/light/album-collection.svg": 2876,
	"./svgs/light/album.svg": 2877,
	"./svgs/light/alicorn.svg": 2878,
	"./svgs/light/alien-monster.svg": 2879,
	"./svgs/light/alien.svg": 2880,
	"./svgs/light/align-center.svg": 2881,
	"./svgs/light/align-justify.svg": 2882,
	"./svgs/light/align-left.svg": 2883,
	"./svgs/light/align-right.svg": 2884,
	"./svgs/light/align-slash.svg": 2885,
	"./svgs/light/allergies.svg": 2886,
	"./svgs/light/ambulance.svg": 2887,
	"./svgs/light/american-sign-language-interpreting.svg": 2888,
	"./svgs/light/amp-guitar.svg": 2889,
	"./svgs/light/analytics.svg": 2890,
	"./svgs/light/anchor.svg": 2891,
	"./svgs/light/angel.svg": 2892,
	"./svgs/light/angle-double-down.svg": 2893,
	"./svgs/light/angle-double-left.svg": 2894,
	"./svgs/light/angle-double-right.svg": 2895,
	"./svgs/light/angle-double-up.svg": 2896,
	"./svgs/light/angle-down.svg": 2897,
	"./svgs/light/angle-left.svg": 2898,
	"./svgs/light/angle-right.svg": 2899,
	"./svgs/light/angle-up.svg": 2900,
	"./svgs/light/angry.svg": 2901,
	"./svgs/light/ankh.svg": 2902,
	"./svgs/light/apple-alt.svg": 2903,
	"./svgs/light/apple-crate.svg": 2904,
	"./svgs/light/archive.svg": 2905,
	"./svgs/light/archway.svg": 2906,
	"./svgs/light/arrow-alt-circle-down.svg": 2907,
	"./svgs/light/arrow-alt-circle-left.svg": 2908,
	"./svgs/light/arrow-alt-circle-right.svg": 2909,
	"./svgs/light/arrow-alt-circle-up.svg": 2910,
	"./svgs/light/arrow-alt-down.svg": 2911,
	"./svgs/light/arrow-alt-from-bottom.svg": 2912,
	"./svgs/light/arrow-alt-from-left.svg": 2913,
	"./svgs/light/arrow-alt-from-right.svg": 2914,
	"./svgs/light/arrow-alt-from-top.svg": 2915,
	"./svgs/light/arrow-alt-left.svg": 2916,
	"./svgs/light/arrow-alt-right.svg": 2917,
	"./svgs/light/arrow-alt-square-down.svg": 2918,
	"./svgs/light/arrow-alt-square-left.svg": 2919,
	"./svgs/light/arrow-alt-square-right.svg": 2920,
	"./svgs/light/arrow-alt-square-up.svg": 2921,
	"./svgs/light/arrow-alt-to-bottom.svg": 2922,
	"./svgs/light/arrow-alt-to-left.svg": 2923,
	"./svgs/light/arrow-alt-to-right.svg": 2924,
	"./svgs/light/arrow-alt-to-top.svg": 2925,
	"./svgs/light/arrow-alt-up.svg": 2926,
	"./svgs/light/arrow-circle-down.svg": 2927,
	"./svgs/light/arrow-circle-left.svg": 2928,
	"./svgs/light/arrow-circle-right.svg": 2929,
	"./svgs/light/arrow-circle-up.svg": 2930,
	"./svgs/light/arrow-down.svg": 2931,
	"./svgs/light/arrow-from-bottom.svg": 2932,
	"./svgs/light/arrow-from-left.svg": 2933,
	"./svgs/light/arrow-from-right.svg": 2934,
	"./svgs/light/arrow-from-top.svg": 2935,
	"./svgs/light/arrow-left.svg": 2936,
	"./svgs/light/arrow-right.svg": 2937,
	"./svgs/light/arrow-square-down.svg": 2938,
	"./svgs/light/arrow-square-left.svg": 2939,
	"./svgs/light/arrow-square-right.svg": 2940,
	"./svgs/light/arrow-square-up.svg": 2941,
	"./svgs/light/arrow-to-bottom.svg": 2942,
	"./svgs/light/arrow-to-left.svg": 2943,
	"./svgs/light/arrow-to-right.svg": 2944,
	"./svgs/light/arrow-to-top.svg": 2945,
	"./svgs/light/arrow-up.svg": 2946,
	"./svgs/light/arrows-alt-h.svg": 2947,
	"./svgs/light/arrows-alt-v.svg": 2948,
	"./svgs/light/arrows-alt.svg": 2949,
	"./svgs/light/arrows-h.svg": 2950,
	"./svgs/light/arrows-v.svg": 2951,
	"./svgs/light/arrows.svg": 2952,
	"./svgs/light/assistive-listening-systems.svg": 2953,
	"./svgs/light/asterisk.svg": 2954,
	"./svgs/light/at.svg": 2955,
	"./svgs/light/atlas.svg": 2956,
	"./svgs/light/atom-alt.svg": 2957,
	"./svgs/light/atom.svg": 2958,
	"./svgs/light/audio-description.svg": 2959,
	"./svgs/light/award.svg": 2960,
	"./svgs/light/axe-battle.svg": 2961,
	"./svgs/light/axe.svg": 2962,
	"./svgs/light/baby-carriage.svg": 2963,
	"./svgs/light/baby.svg": 2964,
	"./svgs/light/backpack.svg": 2965,
	"./svgs/light/backspace.svg": 2966,
	"./svgs/light/backward.svg": 2967,
	"./svgs/light/bacon.svg": 2968,
	"./svgs/light/badge-check.svg": 2969,
	"./svgs/light/badge-dollar.svg": 2970,
	"./svgs/light/badge-percent.svg": 2971,
	"./svgs/light/badge-sheriff.svg": 2972,
	"./svgs/light/badge.svg": 2973,
	"./svgs/light/badger-honey.svg": 2974,
	"./svgs/light/bags-shopping.svg": 2975,
	"./svgs/light/bahai.svg": 2976,
	"./svgs/light/balance-scale-left.svg": 2977,
	"./svgs/light/balance-scale-right.svg": 2978,
	"./svgs/light/balance-scale.svg": 2979,
	"./svgs/light/ball-pile.svg": 2980,
	"./svgs/light/ballot-check.svg": 2981,
	"./svgs/light/ballot.svg": 2982,
	"./svgs/light/ban.svg": 2983,
	"./svgs/light/band-aid.svg": 2984,
	"./svgs/light/banjo.svg": 2985,
	"./svgs/light/barcode-alt.svg": 2986,
	"./svgs/light/barcode-read.svg": 2987,
	"./svgs/light/barcode-scan.svg": 2988,
	"./svgs/light/barcode.svg": 2989,
	"./svgs/light/bars.svg": 2990,
	"./svgs/light/baseball-ball.svg": 2991,
	"./svgs/light/baseball.svg": 2992,
	"./svgs/light/basketball-ball.svg": 2993,
	"./svgs/light/basketball-hoop.svg": 2994,
	"./svgs/light/bat.svg": 2995,
	"./svgs/light/bath.svg": 2996,
	"./svgs/light/battery-bolt.svg": 2997,
	"./svgs/light/battery-empty.svg": 2998,
	"./svgs/light/battery-full.svg": 2999,
	"./svgs/light/battery-half.svg": 3000,
	"./svgs/light/battery-quarter.svg": 3001,
	"./svgs/light/battery-slash.svg": 3002,
	"./svgs/light/battery-three-quarters.svg": 3003,
	"./svgs/light/bed-alt.svg": 3004,
	"./svgs/light/bed-bunk.svg": 3005,
	"./svgs/light/bed-empty.svg": 3006,
	"./svgs/light/bed.svg": 3007,
	"./svgs/light/beer.svg": 3008,
	"./svgs/light/bell-exclamation.svg": 3009,
	"./svgs/light/bell-on.svg": 3010,
	"./svgs/light/bell-plus.svg": 3011,
	"./svgs/light/bell-school-slash.svg": 3012,
	"./svgs/light/bell-school.svg": 3013,
	"./svgs/light/bell-slash.svg": 3014,
	"./svgs/light/bell.svg": 3015,
	"./svgs/light/bells.svg": 3016,
	"./svgs/light/betamax.svg": 3017,
	"./svgs/light/bezier-curve.svg": 3018,
	"./svgs/light/bible.svg": 3019,
	"./svgs/light/bicycle.svg": 3020,
	"./svgs/light/biking-mountain.svg": 3021,
	"./svgs/light/biking.svg": 3022,
	"./svgs/light/binoculars.svg": 3023,
	"./svgs/light/biohazard.svg": 3024,
	"./svgs/light/birthday-cake.svg": 3025,
	"./svgs/light/blanket.svg": 3026,
	"./svgs/light/blender-phone.svg": 3027,
	"./svgs/light/blender.svg": 3028,
	"./svgs/light/blind.svg": 3029,
	"./svgs/light/blinds-open.svg": 3030,
	"./svgs/light/blinds-raised.svg": 3031,
	"./svgs/light/blinds.svg": 3032,
	"./svgs/light/blog.svg": 3033,
	"./svgs/light/bold.svg": 3034,
	"./svgs/light/bolt.svg": 3035,
	"./svgs/light/bomb.svg": 3036,
	"./svgs/light/bone-break.svg": 3037,
	"./svgs/light/bone.svg": 3038,
	"./svgs/light/bong.svg": 3039,
	"./svgs/light/book-alt.svg": 3040,
	"./svgs/light/book-dead.svg": 3041,
	"./svgs/light/book-heart.svg": 3042,
	"./svgs/light/book-medical.svg": 3043,
	"./svgs/light/book-open.svg": 3044,
	"./svgs/light/book-reader.svg": 3045,
	"./svgs/light/book-spells.svg": 3046,
	"./svgs/light/book-user.svg": 3047,
	"./svgs/light/book.svg": 3048,
	"./svgs/light/bookmark.svg": 3049,
	"./svgs/light/books-medical.svg": 3050,
	"./svgs/light/books.svg": 3051,
	"./svgs/light/boombox.svg": 3052,
	"./svgs/light/boot.svg": 3053,
	"./svgs/light/booth-curtain.svg": 3054,
	"./svgs/light/border-all.svg": 3055,
	"./svgs/light/border-bottom.svg": 3056,
	"./svgs/light/border-center-h.svg": 3057,
	"./svgs/light/border-center-v.svg": 3058,
	"./svgs/light/border-inner.svg": 3059,
	"./svgs/light/border-left.svg": 3060,
	"./svgs/light/border-none.svg": 3061,
	"./svgs/light/border-outer.svg": 3062,
	"./svgs/light/border-right.svg": 3063,
	"./svgs/light/border-style-alt.svg": 3064,
	"./svgs/light/border-style.svg": 3065,
	"./svgs/light/border-top.svg": 3066,
	"./svgs/light/bow-arrow.svg": 3067,
	"./svgs/light/bowling-ball.svg": 3068,
	"./svgs/light/bowling-pins.svg": 3069,
	"./svgs/light/box-alt.svg": 3070,
	"./svgs/light/box-ballot.svg": 3071,
	"./svgs/light/box-check.svg": 3072,
	"./svgs/light/box-fragile.svg": 3073,
	"./svgs/light/box-full.svg": 3074,
	"./svgs/light/box-heart.svg": 3075,
	"./svgs/light/box-open.svg": 3076,
	"./svgs/light/box-up.svg": 3077,
	"./svgs/light/box-usd.svg": 3078,
	"./svgs/light/box.svg": 3079,
	"./svgs/light/boxes-alt.svg": 3080,
	"./svgs/light/boxes.svg": 3081,
	"./svgs/light/boxing-glove.svg": 3082,
	"./svgs/light/brackets-curly.svg": 3083,
	"./svgs/light/brackets.svg": 3084,
	"./svgs/light/braille.svg": 3085,
	"./svgs/light/brain.svg": 3086,
	"./svgs/light/bread-loaf.svg": 3087,
	"./svgs/light/bread-slice.svg": 3088,
	"./svgs/light/briefcase-medical.svg": 3089,
	"./svgs/light/briefcase.svg": 3090,
	"./svgs/light/bring-forward.svg": 3091,
	"./svgs/light/bring-front.svg": 3092,
	"./svgs/light/broadcast-tower.svg": 3093,
	"./svgs/light/broom.svg": 3094,
	"./svgs/light/browser.svg": 3095,
	"./svgs/light/brush.svg": 3096,
	"./svgs/light/bug.svg": 3097,
	"./svgs/light/building.svg": 3098,
	"./svgs/light/bullhorn.svg": 3099,
	"./svgs/light/bullseye-arrow.svg": 3100,
	"./svgs/light/bullseye-pointer.svg": 3101,
	"./svgs/light/bullseye.svg": 3102,
	"./svgs/light/burger-soda.svg": 3103,
	"./svgs/light/burn.svg": 3104,
	"./svgs/light/burrito.svg": 3105,
	"./svgs/light/bus-alt.svg": 3106,
	"./svgs/light/bus-school.svg": 3107,
	"./svgs/light/bus.svg": 3108,
	"./svgs/light/business-time.svg": 3109,
	"./svgs/light/cabinet-filing.svg": 3110,
	"./svgs/light/cactus.svg": 3111,
	"./svgs/light/calculator-alt.svg": 3112,
	"./svgs/light/calculator.svg": 3113,
	"./svgs/light/calendar-alt.svg": 3114,
	"./svgs/light/calendar-check.svg": 3115,
	"./svgs/light/calendar-day.svg": 3116,
	"./svgs/light/calendar-edit.svg": 3117,
	"./svgs/light/calendar-exclamation.svg": 3118,
	"./svgs/light/calendar-minus.svg": 3119,
	"./svgs/light/calendar-plus.svg": 3120,
	"./svgs/light/calendar-star.svg": 3121,
	"./svgs/light/calendar-times.svg": 3122,
	"./svgs/light/calendar-week.svg": 3123,
	"./svgs/light/calendar.svg": 3124,
	"./svgs/light/camcorder.svg": 3125,
	"./svgs/light/camera-alt.svg": 3126,
	"./svgs/light/camera-home.svg": 3127,
	"./svgs/light/camera-movie.svg": 3128,
	"./svgs/light/camera-polaroid.svg": 3129,
	"./svgs/light/camera-retro.svg": 3130,
	"./svgs/light/camera.svg": 3131,
	"./svgs/light/campfire.svg": 3132,
	"./svgs/light/campground.svg": 3133,
	"./svgs/light/candle-holder.svg": 3134,
	"./svgs/light/candy-cane.svg": 3135,
	"./svgs/light/candy-corn.svg": 3136,
	"./svgs/light/cannabis.svg": 3137,
	"./svgs/light/capsules.svg": 3138,
	"./svgs/light/car-alt.svg": 3139,
	"./svgs/light/car-battery.svg": 3140,
	"./svgs/light/car-building.svg": 3141,
	"./svgs/light/car-bump.svg": 3142,
	"./svgs/light/car-bus.svg": 3143,
	"./svgs/light/car-crash.svg": 3144,
	"./svgs/light/car-garage.svg": 3145,
	"./svgs/light/car-mechanic.svg": 3146,
	"./svgs/light/car-side.svg": 3147,
	"./svgs/light/car-tilt.svg": 3148,
	"./svgs/light/car-wash.svg": 3149,
	"./svgs/light/car.svg": 3150,
	"./svgs/light/caravan-alt.svg": 3151,
	"./svgs/light/caravan.svg": 3152,
	"./svgs/light/caret-circle-down.svg": 3153,
	"./svgs/light/caret-circle-left.svg": 3154,
	"./svgs/light/caret-circle-right.svg": 3155,
	"./svgs/light/caret-circle-up.svg": 3156,
	"./svgs/light/caret-down.svg": 3157,
	"./svgs/light/caret-left.svg": 3158,
	"./svgs/light/caret-right.svg": 3159,
	"./svgs/light/caret-square-down.svg": 3160,
	"./svgs/light/caret-square-left.svg": 3161,
	"./svgs/light/caret-square-right.svg": 3162,
	"./svgs/light/caret-square-up.svg": 3163,
	"./svgs/light/caret-up.svg": 3164,
	"./svgs/light/carrot.svg": 3165,
	"./svgs/light/cars.svg": 3166,
	"./svgs/light/cart-arrow-down.svg": 3167,
	"./svgs/light/cart-plus.svg": 3168,
	"./svgs/light/cash-register.svg": 3169,
	"./svgs/light/cassette-tape.svg": 3170,
	"./svgs/light/cat-space.svg": 3171,
	"./svgs/light/cat.svg": 3172,
	"./svgs/light/cauldron.svg": 3173,
	"./svgs/light/cctv.svg": 3174,
	"./svgs/light/certificate.svg": 3175,
	"./svgs/light/chair-office.svg": 3176,
	"./svgs/light/chair.svg": 3177,
	"./svgs/light/chalkboard-teacher.svg": 3178,
	"./svgs/light/chalkboard.svg": 3179,
	"./svgs/light/charging-station.svg": 3180,
	"./svgs/light/chart-area.svg": 3181,
	"./svgs/light/chart-bar.svg": 3182,
	"./svgs/light/chart-line-down.svg": 3183,
	"./svgs/light/chart-line.svg": 3184,
	"./svgs/light/chart-network.svg": 3185,
	"./svgs/light/chart-pie-alt.svg": 3186,
	"./svgs/light/chart-pie.svg": 3187,
	"./svgs/light/chart-scatter.svg": 3188,
	"./svgs/light/check-circle.svg": 3189,
	"./svgs/light/check-double.svg": 3190,
	"./svgs/light/check-square.svg": 3191,
	"./svgs/light/check.svg": 3192,
	"./svgs/light/cheese-swiss.svg": 3193,
	"./svgs/light/cheese.svg": 3194,
	"./svgs/light/cheeseburger.svg": 3195,
	"./svgs/light/chess-bishop-alt.svg": 3196,
	"./svgs/light/chess-bishop.svg": 3197,
	"./svgs/light/chess-board.svg": 3198,
	"./svgs/light/chess-clock-alt.svg": 3199,
	"./svgs/light/chess-clock.svg": 3200,
	"./svgs/light/chess-king-alt.svg": 3201,
	"./svgs/light/chess-king.svg": 3202,
	"./svgs/light/chess-knight-alt.svg": 3203,
	"./svgs/light/chess-knight.svg": 3204,
	"./svgs/light/chess-pawn-alt.svg": 3205,
	"./svgs/light/chess-pawn.svg": 3206,
	"./svgs/light/chess-queen-alt.svg": 3207,
	"./svgs/light/chess-queen.svg": 3208,
	"./svgs/light/chess-rook-alt.svg": 3209,
	"./svgs/light/chess-rook.svg": 3210,
	"./svgs/light/chess.svg": 3211,
	"./svgs/light/chevron-circle-down.svg": 3212,
	"./svgs/light/chevron-circle-left.svg": 3213,
	"./svgs/light/chevron-circle-right.svg": 3214,
	"./svgs/light/chevron-circle-up.svg": 3215,
	"./svgs/light/chevron-double-down.svg": 3216,
	"./svgs/light/chevron-double-left.svg": 3217,
	"./svgs/light/chevron-double-right.svg": 3218,
	"./svgs/light/chevron-double-up.svg": 3219,
	"./svgs/light/chevron-down.svg": 3220,
	"./svgs/light/chevron-left.svg": 3221,
	"./svgs/light/chevron-right.svg": 3222,
	"./svgs/light/chevron-square-down.svg": 3223,
	"./svgs/light/chevron-square-left.svg": 3224,
	"./svgs/light/chevron-square-right.svg": 3225,
	"./svgs/light/chevron-square-up.svg": 3226,
	"./svgs/light/chevron-up.svg": 3227,
	"./svgs/light/child.svg": 3228,
	"./svgs/light/chimney.svg": 3229,
	"./svgs/light/church.svg": 3230,
	"./svgs/light/circle-notch.svg": 3231,
	"./svgs/light/circle.svg": 3232,
	"./svgs/light/city.svg": 3233,
	"./svgs/light/clarinet.svg": 3234,
	"./svgs/light/claw-marks.svg": 3235,
	"./svgs/light/clinic-medical.svg": 3236,
	"./svgs/light/clipboard-check.svg": 3237,
	"./svgs/light/clipboard-list-check.svg": 3238,
	"./svgs/light/clipboard-list.svg": 3239,
	"./svgs/light/clipboard-prescription.svg": 3240,
	"./svgs/light/clipboard-user.svg": 3241,
	"./svgs/light/clipboard.svg": 3242,
	"./svgs/light/clock.svg": 3243,
	"./svgs/light/clone.svg": 3244,
	"./svgs/light/closed-captioning.svg": 3245,
	"./svgs/light/cloud-download-alt.svg": 3246,
	"./svgs/light/cloud-download.svg": 3247,
	"./svgs/light/cloud-drizzle.svg": 3248,
	"./svgs/light/cloud-hail-mixed.svg": 3249,
	"./svgs/light/cloud-hail.svg": 3250,
	"./svgs/light/cloud-meatball.svg": 3251,
	"./svgs/light/cloud-moon-rain.svg": 3252,
	"./svgs/light/cloud-moon.svg": 3253,
	"./svgs/light/cloud-music.svg": 3254,
	"./svgs/light/cloud-rain.svg": 3255,
	"./svgs/light/cloud-rainbow.svg": 3256,
	"./svgs/light/cloud-showers-heavy.svg": 3257,
	"./svgs/light/cloud-showers.svg": 3258,
	"./svgs/light/cloud-sleet.svg": 3259,
	"./svgs/light/cloud-snow.svg": 3260,
	"./svgs/light/cloud-sun-rain.svg": 3261,
	"./svgs/light/cloud-sun.svg": 3262,
	"./svgs/light/cloud-upload-alt.svg": 3263,
	"./svgs/light/cloud-upload.svg": 3264,
	"./svgs/light/cloud.svg": 3265,
	"./svgs/light/clouds-moon.svg": 3266,
	"./svgs/light/clouds-sun.svg": 3267,
	"./svgs/light/clouds.svg": 3268,
	"./svgs/light/club.svg": 3269,
	"./svgs/light/cocktail.svg": 3270,
	"./svgs/light/code-branch.svg": 3271,
	"./svgs/light/code-commit.svg": 3272,
	"./svgs/light/code-merge.svg": 3273,
	"./svgs/light/code.svg": 3274,
	"./svgs/light/coffee-pot.svg": 3275,
	"./svgs/light/coffee-togo.svg": 3276,
	"./svgs/light/coffee.svg": 3277,
	"./svgs/light/coffin.svg": 3278,
	"./svgs/light/cog.svg": 3279,
	"./svgs/light/cogs.svg": 3280,
	"./svgs/light/coin.svg": 3281,
	"./svgs/light/coins.svg": 3282,
	"./svgs/light/columns.svg": 3283,
	"./svgs/light/comet.svg": 3284,
	"./svgs/light/comment-alt-check.svg": 3285,
	"./svgs/light/comment-alt-dollar.svg": 3286,
	"./svgs/light/comment-alt-dots.svg": 3287,
	"./svgs/light/comment-alt-edit.svg": 3288,
	"./svgs/light/comment-alt-exclamation.svg": 3289,
	"./svgs/light/comment-alt-lines.svg": 3290,
	"./svgs/light/comment-alt-medical.svg": 3291,
	"./svgs/light/comment-alt-minus.svg": 3292,
	"./svgs/light/comment-alt-music.svg": 3293,
	"./svgs/light/comment-alt-plus.svg": 3294,
	"./svgs/light/comment-alt-slash.svg": 3295,
	"./svgs/light/comment-alt-smile.svg": 3296,
	"./svgs/light/comment-alt-times.svg": 3297,
	"./svgs/light/comment-alt.svg": 3298,
	"./svgs/light/comment-check.svg": 3299,
	"./svgs/light/comment-dollar.svg": 3300,
	"./svgs/light/comment-dots.svg": 3301,
	"./svgs/light/comment-edit.svg": 3302,
	"./svgs/light/comment-exclamation.svg": 3303,
	"./svgs/light/comment-lines.svg": 3304,
	"./svgs/light/comment-medical.svg": 3305,
	"./svgs/light/comment-minus.svg": 3306,
	"./svgs/light/comment-music.svg": 3307,
	"./svgs/light/comment-plus.svg": 3308,
	"./svgs/light/comment-slash.svg": 3309,
	"./svgs/light/comment-smile.svg": 3310,
	"./svgs/light/comment-times.svg": 3311,
	"./svgs/light/comment.svg": 3312,
	"./svgs/light/comments-alt-dollar.svg": 3313,
	"./svgs/light/comments-alt.svg": 3314,
	"./svgs/light/comments-dollar.svg": 3315,
	"./svgs/light/comments.svg": 3316,
	"./svgs/light/compact-disc.svg": 3317,
	"./svgs/light/compass-slash.svg": 3318,
	"./svgs/light/compass.svg": 3319,
	"./svgs/light/compress-alt.svg": 3320,
	"./svgs/light/compress-arrows-alt.svg": 3321,
	"./svgs/light/compress-wide.svg": 3322,
	"./svgs/light/compress.svg": 3323,
	"./svgs/light/computer-classic.svg": 3324,
	"./svgs/light/computer-speaker.svg": 3325,
	"./svgs/light/concierge-bell.svg": 3326,
	"./svgs/light/construction.svg": 3327,
	"./svgs/light/container-storage.svg": 3328,
	"./svgs/light/conveyor-belt-alt.svg": 3329,
	"./svgs/light/conveyor-belt.svg": 3330,
	"./svgs/light/cookie-bite.svg": 3331,
	"./svgs/light/cookie.svg": 3332,
	"./svgs/light/copy.svg": 3333,
	"./svgs/light/copyright.svg": 3334,
	"./svgs/light/corn.svg": 3335,
	"./svgs/light/couch.svg": 3336,
	"./svgs/light/cow.svg": 3337,
	"./svgs/light/cowbell-more.svg": 3338,
	"./svgs/light/cowbell.svg": 3339,
	"./svgs/light/credit-card-blank.svg": 3340,
	"./svgs/light/credit-card-front.svg": 3341,
	"./svgs/light/credit-card.svg": 3342,
	"./svgs/light/cricket.svg": 3343,
	"./svgs/light/croissant.svg": 3344,
	"./svgs/light/crop-alt.svg": 3345,
	"./svgs/light/crop.svg": 3346,
	"./svgs/light/cross.svg": 3347,
	"./svgs/light/crosshairs.svg": 3348,
	"./svgs/light/crow.svg": 3349,
	"./svgs/light/crown.svg": 3350,
	"./svgs/light/crutch.svg": 3351,
	"./svgs/light/crutches.svg": 3352,
	"./svgs/light/cube.svg": 3353,
	"./svgs/light/cubes.svg": 3354,
	"./svgs/light/curling.svg": 3355,
	"./svgs/light/cut.svg": 3356,
	"./svgs/light/dagger.svg": 3357,
	"./svgs/light/database.svg": 3358,
	"./svgs/light/deaf.svg": 3359,
	"./svgs/light/debug.svg": 3360,
	"./svgs/light/deer-rudolph.svg": 3361,
	"./svgs/light/deer.svg": 3362,
	"./svgs/light/democrat.svg": 3363,
	"./svgs/light/desktop-alt.svg": 3364,
	"./svgs/light/desktop.svg": 3365,
	"./svgs/light/dewpoint.svg": 3366,
	"./svgs/light/dharmachakra.svg": 3367,
	"./svgs/light/diagnoses.svg": 3368,
	"./svgs/light/diamond.svg": 3369,
	"./svgs/light/dice-d10.svg": 3370,
	"./svgs/light/dice-d12.svg": 3371,
	"./svgs/light/dice-d20.svg": 3372,
	"./svgs/light/dice-d4.svg": 3373,
	"./svgs/light/dice-d6.svg": 3374,
	"./svgs/light/dice-d8.svg": 3375,
	"./svgs/light/dice-five.svg": 3376,
	"./svgs/light/dice-four.svg": 3377,
	"./svgs/light/dice-one.svg": 3378,
	"./svgs/light/dice-six.svg": 3379,
	"./svgs/light/dice-three.svg": 3380,
	"./svgs/light/dice-two.svg": 3381,
	"./svgs/light/dice.svg": 3382,
	"./svgs/light/digging.svg": 3383,
	"./svgs/light/digital-tachograph.svg": 3384,
	"./svgs/light/diploma.svg": 3385,
	"./svgs/light/directions.svg": 3386,
	"./svgs/light/disc-drive.svg": 3387,
	"./svgs/light/disease.svg": 3388,
	"./svgs/light/divide.svg": 3389,
	"./svgs/light/dizzy.svg": 3390,
	"./svgs/light/dna.svg": 3391,
	"./svgs/light/do-not-enter.svg": 3392,
	"./svgs/light/dog-leashed.svg": 3393,
	"./svgs/light/dog.svg": 3394,
	"./svgs/light/dollar-sign.svg": 3395,
	"./svgs/light/dolly-empty.svg": 3396,
	"./svgs/light/dolly-flatbed-alt.svg": 3397,
	"./svgs/light/dolly-flatbed-empty.svg": 3398,
	"./svgs/light/dolly-flatbed.svg": 3399,
	"./svgs/light/dolly.svg": 3400,
	"./svgs/light/donate.svg": 3401,
	"./svgs/light/door-closed.svg": 3402,
	"./svgs/light/door-open.svg": 3403,
	"./svgs/light/dot-circle.svg": 3404,
	"./svgs/light/dove.svg": 3405,
	"./svgs/light/download.svg": 3406,
	"./svgs/light/drafting-compass.svg": 3407,
	"./svgs/light/dragon.svg": 3408,
	"./svgs/light/draw-circle.svg": 3409,
	"./svgs/light/draw-polygon.svg": 3410,
	"./svgs/light/draw-square.svg": 3411,
	"./svgs/light/dreidel.svg": 3412,
	"./svgs/light/drone-alt.svg": 3413,
	"./svgs/light/drone.svg": 3414,
	"./svgs/light/drum-steelpan.svg": 3415,
	"./svgs/light/drum.svg": 3416,
	"./svgs/light/drumstick-bite.svg": 3417,
	"./svgs/light/drumstick.svg": 3418,
	"./svgs/light/dryer-alt.svg": 3419,
	"./svgs/light/dryer.svg": 3420,
	"./svgs/light/duck.svg": 3421,
	"./svgs/light/dumbbell.svg": 3422,
	"./svgs/light/dumpster-fire.svg": 3423,
	"./svgs/light/dumpster.svg": 3424,
	"./svgs/light/dungeon.svg": 3425,
	"./svgs/light/ear-muffs.svg": 3426,
	"./svgs/light/ear.svg": 3427,
	"./svgs/light/eclipse-alt.svg": 3428,
	"./svgs/light/eclipse.svg": 3429,
	"./svgs/light/edit.svg": 3430,
	"./svgs/light/egg-fried.svg": 3431,
	"./svgs/light/egg.svg": 3432,
	"./svgs/light/eject.svg": 3433,
	"./svgs/light/elephant.svg": 3434,
	"./svgs/light/ellipsis-h-alt.svg": 3435,
	"./svgs/light/ellipsis-h.svg": 3436,
	"./svgs/light/ellipsis-v-alt.svg": 3437,
	"./svgs/light/ellipsis-v.svg": 3438,
	"./svgs/light/empty-set.svg": 3439,
	"./svgs/light/engine-warning.svg": 3440,
	"./svgs/light/envelope-open-dollar.svg": 3441,
	"./svgs/light/envelope-open-text.svg": 3442,
	"./svgs/light/envelope-open.svg": 3443,
	"./svgs/light/envelope-square.svg": 3444,
	"./svgs/light/envelope.svg": 3445,
	"./svgs/light/equals.svg": 3446,
	"./svgs/light/eraser.svg": 3447,
	"./svgs/light/ethernet.svg": 3448,
	"./svgs/light/euro-sign.svg": 3449,
	"./svgs/light/exchange-alt.svg": 3450,
	"./svgs/light/exchange.svg": 3451,
	"./svgs/light/exclamation-circle.svg": 3452,
	"./svgs/light/exclamation-square.svg": 3453,
	"./svgs/light/exclamation-triangle.svg": 3454,
	"./svgs/light/exclamation.svg": 3455,
	"./svgs/light/expand-alt.svg": 3456,
	"./svgs/light/expand-arrows-alt.svg": 3457,
	"./svgs/light/expand-arrows.svg": 3458,
	"./svgs/light/expand-wide.svg": 3459,
	"./svgs/light/expand.svg": 3460,
	"./svgs/light/external-link-alt.svg": 3461,
	"./svgs/light/external-link-square-alt.svg": 3462,
	"./svgs/light/external-link-square.svg": 3463,
	"./svgs/light/external-link.svg": 3464,
	"./svgs/light/eye-dropper.svg": 3465,
	"./svgs/light/eye-evil.svg": 3466,
	"./svgs/light/eye-slash.svg": 3467,
	"./svgs/light/eye.svg": 3468,
	"./svgs/light/fan-table.svg": 3469,
	"./svgs/light/fan.svg": 3470,
	"./svgs/light/farm.svg": 3471,
	"./svgs/light/fast-backward.svg": 3472,
	"./svgs/light/fast-forward.svg": 3473,
	"./svgs/light/faucet-drip.svg": 3474,
	"./svgs/light/faucet.svg": 3475,
	"./svgs/light/fax.svg": 3476,
	"./svgs/light/feather-alt.svg": 3477,
	"./svgs/light/feather.svg": 3478,
	"./svgs/light/female.svg": 3479,
	"./svgs/light/field-hockey.svg": 3480,
	"./svgs/light/fighter-jet.svg": 3481,
	"./svgs/light/file-alt.svg": 3482,
	"./svgs/light/file-archive.svg": 3483,
	"./svgs/light/file-audio.svg": 3484,
	"./svgs/light/file-certificate.svg": 3485,
	"./svgs/light/file-chart-line.svg": 3486,
	"./svgs/light/file-chart-pie.svg": 3487,
	"./svgs/light/file-check.svg": 3488,
	"./svgs/light/file-code.svg": 3489,
	"./svgs/light/file-contract.svg": 3490,
	"./svgs/light/file-csv.svg": 3491,
	"./svgs/light/file-download.svg": 3492,
	"./svgs/light/file-edit.svg": 3493,
	"./svgs/light/file-excel.svg": 3494,
	"./svgs/light/file-exclamation.svg": 3495,
	"./svgs/light/file-export.svg": 3496,
	"./svgs/light/file-image.svg": 3497,
	"./svgs/light/file-import.svg": 3498,
	"./svgs/light/file-invoice-dollar.svg": 3499,
	"./svgs/light/file-invoice.svg": 3500,
	"./svgs/light/file-medical-alt.svg": 3501,
	"./svgs/light/file-medical.svg": 3502,
	"./svgs/light/file-minus.svg": 3503,
	"./svgs/light/file-music.svg": 3504,
	"./svgs/light/file-pdf.svg": 3505,
	"./svgs/light/file-plus.svg": 3506,
	"./svgs/light/file-powerpoint.svg": 3507,
	"./svgs/light/file-prescription.svg": 3508,
	"./svgs/light/file-search.svg": 3509,
	"./svgs/light/file-signature.svg": 3510,
	"./svgs/light/file-spreadsheet.svg": 3511,
	"./svgs/light/file-times.svg": 3512,
	"./svgs/light/file-upload.svg": 3513,
	"./svgs/light/file-user.svg": 3514,
	"./svgs/light/file-video.svg": 3515,
	"./svgs/light/file-word.svg": 3516,
	"./svgs/light/file.svg": 3517,
	"./svgs/light/files-medical.svg": 3518,
	"./svgs/light/fill-drip.svg": 3519,
	"./svgs/light/fill.svg": 3520,
	"./svgs/light/film-alt.svg": 3521,
	"./svgs/light/film-canister.svg": 3522,
	"./svgs/light/film.svg": 3523,
	"./svgs/light/filter.svg": 3524,
	"./svgs/light/fingerprint.svg": 3525,
	"./svgs/light/fire-alt.svg": 3526,
	"./svgs/light/fire-extinguisher.svg": 3527,
	"./svgs/light/fire-smoke.svg": 3528,
	"./svgs/light/fire.svg": 3529,
	"./svgs/light/fireplace.svg": 3530,
	"./svgs/light/first-aid.svg": 3531,
	"./svgs/light/fish-cooked.svg": 3532,
	"./svgs/light/fish.svg": 3533,
	"./svgs/light/fist-raised.svg": 3534,
	"./svgs/light/flag-alt.svg": 3535,
	"./svgs/light/flag-checkered.svg": 3536,
	"./svgs/light/flag-usa.svg": 3537,
	"./svgs/light/flag.svg": 3538,
	"./svgs/light/flame.svg": 3539,
	"./svgs/light/flashlight.svg": 3540,
	"./svgs/light/flask-poison.svg": 3541,
	"./svgs/light/flask-potion.svg": 3542,
	"./svgs/light/flask.svg": 3543,
	"./svgs/light/flower-daffodil.svg": 3544,
	"./svgs/light/flower-tulip.svg": 3545,
	"./svgs/light/flower.svg": 3546,
	"./svgs/light/flushed.svg": 3547,
	"./svgs/light/flute.svg": 3548,
	"./svgs/light/flux-capacitor.svg": 3549,
	"./svgs/light/fog.svg": 3550,
	"./svgs/light/folder-minus.svg": 3551,
	"./svgs/light/folder-open.svg": 3552,
	"./svgs/light/folder-plus.svg": 3553,
	"./svgs/light/folder-times.svg": 3554,
	"./svgs/light/folder-tree.svg": 3555,
	"./svgs/light/folder.svg": 3556,
	"./svgs/light/folders.svg": 3557,
	"./svgs/light/font-awesome-logo-full.svg": 3558,
	"./svgs/light/font-case.svg": 3559,
	"./svgs/light/font.svg": 3560,
	"./svgs/light/football-ball.svg": 3561,
	"./svgs/light/football-helmet.svg": 3562,
	"./svgs/light/forklift.svg": 3563,
	"./svgs/light/forward.svg": 3564,
	"./svgs/light/fragile.svg": 3565,
	"./svgs/light/french-fries.svg": 3566,
	"./svgs/light/frog.svg": 3567,
	"./svgs/light/frosty-head.svg": 3568,
	"./svgs/light/frown-open.svg": 3569,
	"./svgs/light/frown.svg": 3570,
	"./svgs/light/function.svg": 3571,
	"./svgs/light/funnel-dollar.svg": 3572,
	"./svgs/light/futbol.svg": 3573,
	"./svgs/light/galaxy.svg": 3574,
	"./svgs/light/game-board-alt.svg": 3575,
	"./svgs/light/game-board.svg": 3576,
	"./svgs/light/game-console-handheld.svg": 3577,
	"./svgs/light/gamepad-alt.svg": 3578,
	"./svgs/light/gamepad.svg": 3579,
	"./svgs/light/garage-car.svg": 3580,
	"./svgs/light/garage-open.svg": 3581,
	"./svgs/light/garage.svg": 3582,
	"./svgs/light/gas-pump-slash.svg": 3583,
	"./svgs/light/gas-pump.svg": 3584,
	"./svgs/light/gavel.svg": 3585,
	"./svgs/light/gem.svg": 3586,
	"./svgs/light/genderless.svg": 3587,
	"./svgs/light/ghost.svg": 3588,
	"./svgs/light/gift-card.svg": 3589,
	"./svgs/light/gift.svg": 3590,
	"./svgs/light/gifts.svg": 3591,
	"./svgs/light/gingerbread-man.svg": 3592,
	"./svgs/light/glass-champagne.svg": 3593,
	"./svgs/light/glass-cheers.svg": 3594,
	"./svgs/light/glass-citrus.svg": 3595,
	"./svgs/light/glass-martini-alt.svg": 3596,
	"./svgs/light/glass-martini.svg": 3597,
	"./svgs/light/glass-whiskey-rocks.svg": 3598,
	"./svgs/light/glass-whiskey.svg": 3599,
	"./svgs/light/glass.svg": 3600,
	"./svgs/light/glasses-alt.svg": 3601,
	"./svgs/light/glasses.svg": 3602,
	"./svgs/light/globe-africa.svg": 3603,
	"./svgs/light/globe-americas.svg": 3604,
	"./svgs/light/globe-asia.svg": 3605,
	"./svgs/light/globe-europe.svg": 3606,
	"./svgs/light/globe-snow.svg": 3607,
	"./svgs/light/globe-stand.svg": 3608,
	"./svgs/light/globe.svg": 3609,
	"./svgs/light/golf-ball.svg": 3610,
	"./svgs/light/golf-club.svg": 3611,
	"./svgs/light/gopuram.svg": 3612,
	"./svgs/light/graduation-cap.svg": 3613,
	"./svgs/light/gramophone.svg": 3614,
	"./svgs/light/greater-than-equal.svg": 3615,
	"./svgs/light/greater-than.svg": 3616,
	"./svgs/light/grimace.svg": 3617,
	"./svgs/light/grin-alt.svg": 3618,
	"./svgs/light/grin-beam-sweat.svg": 3619,
	"./svgs/light/grin-beam.svg": 3620,
	"./svgs/light/grin-hearts.svg": 3621,
	"./svgs/light/grin-squint-tears.svg": 3622,
	"./svgs/light/grin-squint.svg": 3623,
	"./svgs/light/grin-stars.svg": 3624,
	"./svgs/light/grin-tears.svg": 3625,
	"./svgs/light/grin-tongue-squint.svg": 3626,
	"./svgs/light/grin-tongue-wink.svg": 3627,
	"./svgs/light/grin-tongue.svg": 3628,
	"./svgs/light/grin-wink.svg": 3629,
	"./svgs/light/grin.svg": 3630,
	"./svgs/light/grip-horizontal.svg": 3631,
	"./svgs/light/grip-lines-vertical.svg": 3632,
	"./svgs/light/grip-lines.svg": 3633,
	"./svgs/light/grip-vertical.svg": 3634,
	"./svgs/light/guitar-electric.svg": 3635,
	"./svgs/light/guitar.svg": 3636,
	"./svgs/light/guitars.svg": 3637,
	"./svgs/light/h-square.svg": 3638,
	"./svgs/light/h1.svg": 3639,
	"./svgs/light/h2.svg": 3640,
	"./svgs/light/h3.svg": 3641,
	"./svgs/light/h4.svg": 3642,
	"./svgs/light/hamburger.svg": 3643,
	"./svgs/light/hammer-war.svg": 3644,
	"./svgs/light/hammer.svg": 3645,
	"./svgs/light/hamsa.svg": 3646,
	"./svgs/light/hand-heart.svg": 3647,
	"./svgs/light/hand-holding-box.svg": 3648,
	"./svgs/light/hand-holding-heart.svg": 3649,
	"./svgs/light/hand-holding-magic.svg": 3650,
	"./svgs/light/hand-holding-seedling.svg": 3651,
	"./svgs/light/hand-holding-usd.svg": 3652,
	"./svgs/light/hand-holding-water.svg": 3653,
	"./svgs/light/hand-holding.svg": 3654,
	"./svgs/light/hand-lizard.svg": 3655,
	"./svgs/light/hand-middle-finger.svg": 3656,
	"./svgs/light/hand-paper.svg": 3657,
	"./svgs/light/hand-peace.svg": 3658,
	"./svgs/light/hand-point-down.svg": 3659,
	"./svgs/light/hand-point-left.svg": 3660,
	"./svgs/light/hand-point-right.svg": 3661,
	"./svgs/light/hand-point-up.svg": 3662,
	"./svgs/light/hand-pointer.svg": 3663,
	"./svgs/light/hand-receiving.svg": 3664,
	"./svgs/light/hand-rock.svg": 3665,
	"./svgs/light/hand-scissors.svg": 3666,
	"./svgs/light/hand-spock.svg": 3667,
	"./svgs/light/hands-heart.svg": 3668,
	"./svgs/light/hands-helping.svg": 3669,
	"./svgs/light/hands-usd.svg": 3670,
	"./svgs/light/hands.svg": 3671,
	"./svgs/light/handshake-alt.svg": 3672,
	"./svgs/light/handshake.svg": 3673,
	"./svgs/light/hanukiah.svg": 3674,
	"./svgs/light/hard-hat.svg": 3675,
	"./svgs/light/hashtag.svg": 3676,
	"./svgs/light/hat-chef.svg": 3677,
	"./svgs/light/hat-cowboy-side.svg": 3678,
	"./svgs/light/hat-cowboy.svg": 3679,
	"./svgs/light/hat-santa.svg": 3680,
	"./svgs/light/hat-winter.svg": 3681,
	"./svgs/light/hat-witch.svg": 3682,
	"./svgs/light/hat-wizard.svg": 3683,
	"./svgs/light/hdd.svg": 3684,
	"./svgs/light/head-side-brain.svg": 3685,
	"./svgs/light/head-side-headphones.svg": 3686,
	"./svgs/light/head-side-medical.svg": 3687,
	"./svgs/light/head-side.svg": 3688,
	"./svgs/light/head-vr.svg": 3689,
	"./svgs/light/heading.svg": 3690,
	"./svgs/light/headphones-alt.svg": 3691,
	"./svgs/light/headphones.svg": 3692,
	"./svgs/light/headset.svg": 3693,
	"./svgs/light/heart-broken.svg": 3694,
	"./svgs/light/heart-circle.svg": 3695,
	"./svgs/light/heart-rate.svg": 3696,
	"./svgs/light/heart-square.svg": 3697,
	"./svgs/light/heart.svg": 3698,
	"./svgs/light/heartbeat.svg": 3699,
	"./svgs/light/heat.svg": 3700,
	"./svgs/light/helicopter.svg": 3701,
	"./svgs/light/helmet-battle.svg": 3702,
	"./svgs/light/hexagon.svg": 3703,
	"./svgs/light/highlighter.svg": 3704,
	"./svgs/light/hiking.svg": 3705,
	"./svgs/light/hippo.svg": 3706,
	"./svgs/light/history.svg": 3707,
	"./svgs/light/hockey-mask.svg": 3708,
	"./svgs/light/hockey-puck.svg": 3709,
	"./svgs/light/hockey-sticks.svg": 3710,
	"./svgs/light/holly-berry.svg": 3711,
	"./svgs/light/home-alt.svg": 3712,
	"./svgs/light/home-heart.svg": 3713,
	"./svgs/light/home-lg-alt.svg": 3714,
	"./svgs/light/home-lg.svg": 3715,
	"./svgs/light/home.svg": 3716,
	"./svgs/light/hood-cloak.svg": 3717,
	"./svgs/light/horizontal-rule.svg": 3718,
	"./svgs/light/horse-head.svg": 3719,
	"./svgs/light/horse-saddle.svg": 3720,
	"./svgs/light/horse.svg": 3721,
	"./svgs/light/hospital-alt.svg": 3722,
	"./svgs/light/hospital-symbol.svg": 3723,
	"./svgs/light/hospital-user.svg": 3724,
	"./svgs/light/hospital.svg": 3725,
	"./svgs/light/hospitals.svg": 3726,
	"./svgs/light/hot-tub.svg": 3727,
	"./svgs/light/hotdog.svg": 3728,
	"./svgs/light/hotel.svg": 3729,
	"./svgs/light/hourglass-end.svg": 3730,
	"./svgs/light/hourglass-half.svg": 3731,
	"./svgs/light/hourglass-start.svg": 3732,
	"./svgs/light/hourglass.svg": 3733,
	"./svgs/light/house-damage.svg": 3734,
	"./svgs/light/house-day.svg": 3735,
	"./svgs/light/house-flood.svg": 3736,
	"./svgs/light/house-leave.svg": 3737,
	"./svgs/light/house-night.svg": 3738,
	"./svgs/light/house-return.svg": 3739,
	"./svgs/light/house-signal.svg": 3740,
	"./svgs/light/house.svg": 3741,
	"./svgs/light/hryvnia.svg": 3742,
	"./svgs/light/humidity.svg": 3743,
	"./svgs/light/hurricane.svg": 3744,
	"./svgs/light/i-cursor.svg": 3745,
	"./svgs/light/ice-cream.svg": 3746,
	"./svgs/light/ice-skate.svg": 3747,
	"./svgs/light/icicles.svg": 3748,
	"./svgs/light/icons-alt.svg": 3749,
	"./svgs/light/icons.svg": 3750,
	"./svgs/light/id-badge.svg": 3751,
	"./svgs/light/id-card-alt.svg": 3752,
	"./svgs/light/id-card.svg": 3753,
	"./svgs/light/igloo.svg": 3754,
	"./svgs/light/image-polaroid.svg": 3755,
	"./svgs/light/image.svg": 3756,
	"./svgs/light/images.svg": 3757,
	"./svgs/light/inbox-in.svg": 3758,
	"./svgs/light/inbox-out.svg": 3759,
	"./svgs/light/inbox.svg": 3760,
	"./svgs/light/indent.svg": 3761,
	"./svgs/light/industry-alt.svg": 3762,
	"./svgs/light/industry.svg": 3763,
	"./svgs/light/infinity.svg": 3764,
	"./svgs/light/info-circle.svg": 3765,
	"./svgs/light/info-square.svg": 3766,
	"./svgs/light/info.svg": 3767,
	"./svgs/light/inhaler.svg": 3768,
	"./svgs/light/integral.svg": 3769,
	"./svgs/light/intersection.svg": 3770,
	"./svgs/light/inventory.svg": 3771,
	"./svgs/light/island-tropical.svg": 3772,
	"./svgs/light/italic.svg": 3773,
	"./svgs/light/jack-o-lantern.svg": 3774,
	"./svgs/light/jedi.svg": 3775,
	"./svgs/light/joint.svg": 3776,
	"./svgs/light/journal-whills.svg": 3777,
	"./svgs/light/joystick.svg": 3778,
	"./svgs/light/jug.svg": 3779,
	"./svgs/light/kaaba.svg": 3780,
	"./svgs/light/kazoo.svg": 3781,
	"./svgs/light/kerning.svg": 3782,
	"./svgs/light/key-skeleton.svg": 3783,
	"./svgs/light/key.svg": 3784,
	"./svgs/light/keyboard.svg": 3785,
	"./svgs/light/keynote.svg": 3786,
	"./svgs/light/khanda.svg": 3787,
	"./svgs/light/kidneys.svg": 3788,
	"./svgs/light/kiss-beam.svg": 3789,
	"./svgs/light/kiss-wink-heart.svg": 3790,
	"./svgs/light/kiss.svg": 3791,
	"./svgs/light/kite.svg": 3792,
	"./svgs/light/kiwi-bird.svg": 3793,
	"./svgs/light/knife-kitchen.svg": 3794,
	"./svgs/light/lambda.svg": 3795,
	"./svgs/light/lamp-desk.svg": 3796,
	"./svgs/light/lamp-floor.svg": 3797,
	"./svgs/light/lamp.svg": 3798,
	"./svgs/light/landmark-alt.svg": 3799,
	"./svgs/light/landmark.svg": 3800,
	"./svgs/light/language.svg": 3801,
	"./svgs/light/laptop-code.svg": 3802,
	"./svgs/light/laptop-medical.svg": 3803,
	"./svgs/light/laptop.svg": 3804,
	"./svgs/light/lasso.svg": 3805,
	"./svgs/light/laugh-beam.svg": 3806,
	"./svgs/light/laugh-squint.svg": 3807,
	"./svgs/light/laugh-wink.svg": 3808,
	"./svgs/light/laugh.svg": 3809,
	"./svgs/light/layer-group.svg": 3810,
	"./svgs/light/layer-minus.svg": 3811,
	"./svgs/light/layer-plus.svg": 3812,
	"./svgs/light/leaf-heart.svg": 3813,
	"./svgs/light/leaf-maple.svg": 3814,
	"./svgs/light/leaf-oak.svg": 3815,
	"./svgs/light/leaf.svg": 3816,
	"./svgs/light/lemon.svg": 3817,
	"./svgs/light/less-than-equal.svg": 3818,
	"./svgs/light/less-than.svg": 3819,
	"./svgs/light/level-down-alt.svg": 3820,
	"./svgs/light/level-down.svg": 3821,
	"./svgs/light/level-up-alt.svg": 3822,
	"./svgs/light/level-up.svg": 3823,
	"./svgs/light/life-ring.svg": 3824,
	"./svgs/light/light-ceiling.svg": 3825,
	"./svgs/light/light-switch-off.svg": 3826,
	"./svgs/light/light-switch-on.svg": 3827,
	"./svgs/light/light-switch.svg": 3828,
	"./svgs/light/lightbulb-dollar.svg": 3829,
	"./svgs/light/lightbulb-exclamation.svg": 3830,
	"./svgs/light/lightbulb-on.svg": 3831,
	"./svgs/light/lightbulb-slash.svg": 3832,
	"./svgs/light/lightbulb.svg": 3833,
	"./svgs/light/lights-holiday.svg": 3834,
	"./svgs/light/line-columns.svg": 3835,
	"./svgs/light/line-height.svg": 3836,
	"./svgs/light/link.svg": 3837,
	"./svgs/light/lips.svg": 3838,
	"./svgs/light/lira-sign.svg": 3839,
	"./svgs/light/list-alt.svg": 3840,
	"./svgs/light/list-music.svg": 3841,
	"./svgs/light/list-ol.svg": 3842,
	"./svgs/light/list-ul.svg": 3843,
	"./svgs/light/list.svg": 3844,
	"./svgs/light/location-arrow.svg": 3845,
	"./svgs/light/location-circle.svg": 3846,
	"./svgs/light/location-slash.svg": 3847,
	"./svgs/light/location.svg": 3848,
	"./svgs/light/lock-alt.svg": 3849,
	"./svgs/light/lock-open-alt.svg": 3850,
	"./svgs/light/lock-open.svg": 3851,
	"./svgs/light/lock.svg": 3852,
	"./svgs/light/long-arrow-alt-down.svg": 3853,
	"./svgs/light/long-arrow-alt-left.svg": 3854,
	"./svgs/light/long-arrow-alt-right.svg": 3855,
	"./svgs/light/long-arrow-alt-up.svg": 3856,
	"./svgs/light/long-arrow-down.svg": 3857,
	"./svgs/light/long-arrow-left.svg": 3858,
	"./svgs/light/long-arrow-right.svg": 3859,
	"./svgs/light/long-arrow-up.svg": 3860,
	"./svgs/light/loveseat.svg": 3861,
	"./svgs/light/low-vision.svg": 3862,
	"./svgs/light/luchador.svg": 3863,
	"./svgs/light/luggage-cart.svg": 3864,
	"./svgs/light/lungs.svg": 3865,
	"./svgs/light/mace.svg": 3866,
	"./svgs/light/magic.svg": 3867,
	"./svgs/light/magnet.svg": 3868,
	"./svgs/light/mail-bulk.svg": 3869,
	"./svgs/light/mailbox.svg": 3870,
	"./svgs/light/male.svg": 3871,
	"./svgs/light/mandolin.svg": 3872,
	"./svgs/light/map-marked-alt.svg": 3873,
	"./svgs/light/map-marked.svg": 3874,
	"./svgs/light/map-marker-alt-slash.svg": 3875,
	"./svgs/light/map-marker-alt.svg": 3876,
	"./svgs/light/map-marker-check.svg": 3877,
	"./svgs/light/map-marker-edit.svg": 3878,
	"./svgs/light/map-marker-exclamation.svg": 3879,
	"./svgs/light/map-marker-minus.svg": 3880,
	"./svgs/light/map-marker-plus.svg": 3881,
	"./svgs/light/map-marker-question.svg": 3882,
	"./svgs/light/map-marker-slash.svg": 3883,
	"./svgs/light/map-marker-smile.svg": 3884,
	"./svgs/light/map-marker-times.svg": 3885,
	"./svgs/light/map-marker.svg": 3886,
	"./svgs/light/map-pin.svg": 3887,
	"./svgs/light/map-signs.svg": 3888,
	"./svgs/light/map.svg": 3889,
	"./svgs/light/marker.svg": 3890,
	"./svgs/light/mars-double.svg": 3891,
	"./svgs/light/mars-stroke-h.svg": 3892,
	"./svgs/light/mars-stroke-v.svg": 3893,
	"./svgs/light/mars-stroke.svg": 3894,
	"./svgs/light/mars.svg": 3895,
	"./svgs/light/mask.svg": 3896,
	"./svgs/light/meat.svg": 3897,
	"./svgs/light/medal.svg": 3898,
	"./svgs/light/medkit.svg": 3899,
	"./svgs/light/megaphone.svg": 3900,
	"./svgs/light/meh-blank.svg": 3901,
	"./svgs/light/meh-rolling-eyes.svg": 3902,
	"./svgs/light/meh.svg": 3903,
	"./svgs/light/memory.svg": 3904,
	"./svgs/light/menorah.svg": 3905,
	"./svgs/light/mercury.svg": 3906,
	"./svgs/light/meteor.svg": 3907,
	"./svgs/light/microchip.svg": 3908,
	"./svgs/light/microphone-alt-slash.svg": 3909,
	"./svgs/light/microphone-alt.svg": 3910,
	"./svgs/light/microphone-slash.svg": 3911,
	"./svgs/light/microphone-stand.svg": 3912,
	"./svgs/light/microphone.svg": 3913,
	"./svgs/light/microscope.svg": 3914,
	"./svgs/light/microwave.svg": 3915,
	"./svgs/light/mind-share.svg": 3916,
	"./svgs/light/minus-circle.svg": 3917,
	"./svgs/light/minus-hexagon.svg": 3918,
	"./svgs/light/minus-octagon.svg": 3919,
	"./svgs/light/minus-square.svg": 3920,
	"./svgs/light/minus.svg": 3921,
	"./svgs/light/mistletoe.svg": 3922,
	"./svgs/light/mitten.svg": 3923,
	"./svgs/light/mobile-alt.svg": 3924,
	"./svgs/light/mobile-android-alt.svg": 3925,
	"./svgs/light/mobile-android.svg": 3926,
	"./svgs/light/mobile.svg": 3927,
	"./svgs/light/money-bill-alt.svg": 3928,
	"./svgs/light/money-bill-wave-alt.svg": 3929,
	"./svgs/light/money-bill-wave.svg": 3930,
	"./svgs/light/money-bill.svg": 3931,
	"./svgs/light/money-check-alt.svg": 3932,
	"./svgs/light/money-check-edit-alt.svg": 3933,
	"./svgs/light/money-check-edit.svg": 3934,
	"./svgs/light/money-check.svg": 3935,
	"./svgs/light/monitor-heart-rate.svg": 3936,
	"./svgs/light/monkey.svg": 3937,
	"./svgs/light/monument.svg": 3938,
	"./svgs/light/moon-cloud.svg": 3939,
	"./svgs/light/moon-stars.svg": 3940,
	"./svgs/light/moon.svg": 3941,
	"./svgs/light/mortar-pestle.svg": 3942,
	"./svgs/light/mosque.svg": 3943,
	"./svgs/light/motorcycle.svg": 3944,
	"./svgs/light/mountain.svg": 3945,
	"./svgs/light/mountains.svg": 3946,
	"./svgs/light/mouse-alt.svg": 3947,
	"./svgs/light/mouse-pointer.svg": 3948,
	"./svgs/light/mouse.svg": 3949,
	"./svgs/light/mp3-player.svg": 3950,
	"./svgs/light/mug-hot.svg": 3951,
	"./svgs/light/mug-marshmallows.svg": 3952,
	"./svgs/light/mug-tea.svg": 3953,
	"./svgs/light/mug.svg": 3954,
	"./svgs/light/music-alt-slash.svg": 3955,
	"./svgs/light/music-alt.svg": 3956,
	"./svgs/light/music-slash.svg": 3957,
	"./svgs/light/music.svg": 3958,
	"./svgs/light/narwhal.svg": 3959,
	"./svgs/light/network-wired.svg": 3960,
	"./svgs/light/neuter.svg": 3961,
	"./svgs/light/newspaper.svg": 3962,
	"./svgs/light/not-equal.svg": 3963,
	"./svgs/light/notes-medical.svg": 3964,
	"./svgs/light/object-group.svg": 3965,
	"./svgs/light/object-ungroup.svg": 3966,
	"./svgs/light/octagon.svg": 3967,
	"./svgs/light/oil-can.svg": 3968,
	"./svgs/light/oil-temp.svg": 3969,
	"./svgs/light/om.svg": 3970,
	"./svgs/light/omega.svg": 3971,
	"./svgs/light/ornament.svg": 3972,
	"./svgs/light/otter.svg": 3973,
	"./svgs/light/outdent.svg": 3974,
	"./svgs/light/outlet.svg": 3975,
	"./svgs/light/oven.svg": 3976,
	"./svgs/light/overline.svg": 3977,
	"./svgs/light/page-break.svg": 3978,
	"./svgs/light/pager.svg": 3979,
	"./svgs/light/paint-brush-alt.svg": 3980,
	"./svgs/light/paint-brush.svg": 3981,
	"./svgs/light/paint-roller.svg": 3982,
	"./svgs/light/palette.svg": 3983,
	"./svgs/light/pallet-alt.svg": 3984,
	"./svgs/light/pallet.svg": 3985,
	"./svgs/light/paper-plane.svg": 3986,
	"./svgs/light/paperclip.svg": 3987,
	"./svgs/light/parachute-box.svg": 3988,
	"./svgs/light/paragraph-rtl.svg": 3989,
	"./svgs/light/paragraph.svg": 3990,
	"./svgs/light/parking-circle-slash.svg": 3991,
	"./svgs/light/parking-circle.svg": 3992,
	"./svgs/light/parking-slash.svg": 3993,
	"./svgs/light/parking.svg": 3994,
	"./svgs/light/passport.svg": 3995,
	"./svgs/light/pastafarianism.svg": 3996,
	"./svgs/light/paste.svg": 3997,
	"./svgs/light/pause-circle.svg": 3998,
	"./svgs/light/pause.svg": 3999,
	"./svgs/light/paw-alt.svg": 4000,
	"./svgs/light/paw-claws.svg": 4001,
	"./svgs/light/paw.svg": 4002,
	"./svgs/light/peace.svg": 4003,
	"./svgs/light/pegasus.svg": 4004,
	"./svgs/light/pen-alt.svg": 4005,
	"./svgs/light/pen-fancy.svg": 4006,
	"./svgs/light/pen-nib.svg": 4007,
	"./svgs/light/pen-square.svg": 4008,
	"./svgs/light/pen.svg": 4009,
	"./svgs/light/pencil-alt.svg": 4010,
	"./svgs/light/pencil-paintbrush.svg": 4011,
	"./svgs/light/pencil-ruler.svg": 4012,
	"./svgs/light/pencil.svg": 4013,
	"./svgs/light/pennant.svg": 4014,
	"./svgs/light/people-carry.svg": 4015,
	"./svgs/light/pepper-hot.svg": 4016,
	"./svgs/light/percent.svg": 4017,
	"./svgs/light/percentage.svg": 4018,
	"./svgs/light/person-booth.svg": 4019,
	"./svgs/light/person-carry.svg": 4020,
	"./svgs/light/person-dolly-empty.svg": 4021,
	"./svgs/light/person-dolly.svg": 4022,
	"./svgs/light/person-sign.svg": 4023,
	"./svgs/light/phone-alt.svg": 4024,
	"./svgs/light/phone-laptop.svg": 4025,
	"./svgs/light/phone-office.svg": 4026,
	"./svgs/light/phone-plus.svg": 4027,
	"./svgs/light/phone-rotary.svg": 4028,
	"./svgs/light/phone-slash.svg": 4029,
	"./svgs/light/phone-square-alt.svg": 4030,
	"./svgs/light/phone-square.svg": 4031,
	"./svgs/light/phone-volume.svg": 4032,
	"./svgs/light/phone.svg": 4033,
	"./svgs/light/photo-video.svg": 4034,
	"./svgs/light/pi.svg": 4035,
	"./svgs/light/piano-keyboard.svg": 4036,
	"./svgs/light/piano.svg": 4037,
	"./svgs/light/pie.svg": 4038,
	"./svgs/light/pig.svg": 4039,
	"./svgs/light/piggy-bank.svg": 4040,
	"./svgs/light/pills.svg": 4041,
	"./svgs/light/pizza-slice.svg": 4042,
	"./svgs/light/pizza.svg": 4043,
	"./svgs/light/place-of-worship.svg": 4044,
	"./svgs/light/plane-alt.svg": 4045,
	"./svgs/light/plane-arrival.svg": 4046,
	"./svgs/light/plane-departure.svg": 4047,
	"./svgs/light/plane.svg": 4048,
	"./svgs/light/planet-moon.svg": 4049,
	"./svgs/light/planet-ringed.svg": 4050,
	"./svgs/light/play-circle.svg": 4051,
	"./svgs/light/play.svg": 4052,
	"./svgs/light/plug.svg": 4053,
	"./svgs/light/plus-circle.svg": 4054,
	"./svgs/light/plus-hexagon.svg": 4055,
	"./svgs/light/plus-octagon.svg": 4056,
	"./svgs/light/plus-square.svg": 4057,
	"./svgs/light/plus.svg": 4058,
	"./svgs/light/podcast.svg": 4059,
	"./svgs/light/podium-star.svg": 4060,
	"./svgs/light/podium.svg": 4061,
	"./svgs/light/police-box.svg": 4062,
	"./svgs/light/poll-h.svg": 4063,
	"./svgs/light/poll-people.svg": 4064,
	"./svgs/light/poll.svg": 4065,
	"./svgs/light/poo-storm.svg": 4066,
	"./svgs/light/poo.svg": 4067,
	"./svgs/light/poop.svg": 4068,
	"./svgs/light/popcorn.svg": 4069,
	"./svgs/light/portal-enter.svg": 4070,
	"./svgs/light/portal-exit.svg": 4071,
	"./svgs/light/portrait.svg": 4072,
	"./svgs/light/pound-sign.svg": 4073,
	"./svgs/light/power-off.svg": 4074,
	"./svgs/light/pray.svg": 4075,
	"./svgs/light/praying-hands.svg": 4076,
	"./svgs/light/prescription-bottle-alt.svg": 4077,
	"./svgs/light/prescription-bottle.svg": 4078,
	"./svgs/light/prescription.svg": 4079,
	"./svgs/light/presentation.svg": 4080,
	"./svgs/light/print-search.svg": 4081,
	"./svgs/light/print-slash.svg": 4082,
	"./svgs/light/print.svg": 4083,
	"./svgs/light/procedures.svg": 4084,
	"./svgs/light/project-diagram.svg": 4085,
	"./svgs/light/projector.svg": 4086,
	"./svgs/light/pumpkin.svg": 4087,
	"./svgs/light/puzzle-piece.svg": 4088,
	"./svgs/light/qrcode.svg": 4089,
	"./svgs/light/question-circle.svg": 4090,
	"./svgs/light/question-square.svg": 4091,
	"./svgs/light/question.svg": 4092,
	"./svgs/light/quidditch.svg": 4093,
	"./svgs/light/quote-left.svg": 4094,
	"./svgs/light/quote-right.svg": 4095,
	"./svgs/light/quran.svg": 4096,
	"./svgs/light/rabbit-fast.svg": 4097,
	"./svgs/light/rabbit.svg": 4098,
	"./svgs/light/racquet.svg": 4099,
	"./svgs/light/radar.svg": 4100,
	"./svgs/light/radiation-alt.svg": 4101,
	"./svgs/light/radiation.svg": 4102,
	"./svgs/light/radio-alt.svg": 4103,
	"./svgs/light/radio.svg": 4104,
	"./svgs/light/rainbow.svg": 4105,
	"./svgs/light/raindrops.svg": 4106,
	"./svgs/light/ram.svg": 4107,
	"./svgs/light/ramp-loading.svg": 4108,
	"./svgs/light/random.svg": 4109,
	"./svgs/light/raygun.svg": 4110,
	"./svgs/light/receipt.svg": 4111,
	"./svgs/light/record-vinyl.svg": 4112,
	"./svgs/light/rectangle-landscape.svg": 4113,
	"./svgs/light/rectangle-portrait.svg": 4114,
	"./svgs/light/rectangle-wide.svg": 4115,
	"./svgs/light/recycle.svg": 4116,
	"./svgs/light/redo-alt.svg": 4117,
	"./svgs/light/redo.svg": 4118,
	"./svgs/light/refrigerator.svg": 4119,
	"./svgs/light/registered.svg": 4120,
	"./svgs/light/remove-format.svg": 4121,
	"./svgs/light/repeat-1-alt.svg": 4122,
	"./svgs/light/repeat-1.svg": 4123,
	"./svgs/light/repeat-alt.svg": 4124,
	"./svgs/light/repeat.svg": 4125,
	"./svgs/light/reply-all.svg": 4126,
	"./svgs/light/reply.svg": 4127,
	"./svgs/light/republican.svg": 4128,
	"./svgs/light/restroom.svg": 4129,
	"./svgs/light/retweet-alt.svg": 4130,
	"./svgs/light/retweet.svg": 4131,
	"./svgs/light/ribbon.svg": 4132,
	"./svgs/light/ring.svg": 4133,
	"./svgs/light/rings-wedding.svg": 4134,
	"./svgs/light/road.svg": 4135,
	"./svgs/light/robot.svg": 4136,
	"./svgs/light/rocket-launch.svg": 4137,
	"./svgs/light/rocket.svg": 4138,
	"./svgs/light/route-highway.svg": 4139,
	"./svgs/light/route-interstate.svg": 4140,
	"./svgs/light/route.svg": 4141,
	"./svgs/light/router.svg": 4142,
	"./svgs/light/rss-square.svg": 4143,
	"./svgs/light/rss.svg": 4144,
	"./svgs/light/ruble-sign.svg": 4145,
	"./svgs/light/ruler-combined.svg": 4146,
	"./svgs/light/ruler-horizontal.svg": 4147,
	"./svgs/light/ruler-triangle.svg": 4148,
	"./svgs/light/ruler-vertical.svg": 4149,
	"./svgs/light/ruler.svg": 4150,
	"./svgs/light/running.svg": 4151,
	"./svgs/light/rupee-sign.svg": 4152,
	"./svgs/light/rv.svg": 4153,
	"./svgs/light/sack-dollar.svg": 4154,
	"./svgs/light/sack.svg": 4155,
	"./svgs/light/sad-cry.svg": 4156,
	"./svgs/light/sad-tear.svg": 4157,
	"./svgs/light/salad.svg": 4158,
	"./svgs/light/sandwich.svg": 4159,
	"./svgs/light/satellite-dish.svg": 4160,
	"./svgs/light/satellite.svg": 4161,
	"./svgs/light/sausage.svg": 4162,
	"./svgs/light/save.svg": 4163,
	"./svgs/light/sax-hot.svg": 4164,
	"./svgs/light/saxophone.svg": 4165,
	"./svgs/light/scalpel-path.svg": 4166,
	"./svgs/light/scalpel.svg": 4167,
	"./svgs/light/scanner-image.svg": 4168,
	"./svgs/light/scanner-keyboard.svg": 4169,
	"./svgs/light/scanner-touchscreen.svg": 4170,
	"./svgs/light/scanner.svg": 4171,
	"./svgs/light/scarecrow.svg": 4172,
	"./svgs/light/scarf.svg": 4173,
	"./svgs/light/school.svg": 4174,
	"./svgs/light/screwdriver.svg": 4175,
	"./svgs/light/scroll-old.svg": 4176,
	"./svgs/light/scroll.svg": 4177,
	"./svgs/light/scrubber.svg": 4178,
	"./svgs/light/scythe.svg": 4179,
	"./svgs/light/sd-card.svg": 4180,
	"./svgs/light/search-dollar.svg": 4181,
	"./svgs/light/search-location.svg": 4182,
	"./svgs/light/search-minus.svg": 4183,
	"./svgs/light/search-plus.svg": 4184,
	"./svgs/light/search.svg": 4185,
	"./svgs/light/seedling.svg": 4186,
	"./svgs/light/send-back.svg": 4187,
	"./svgs/light/send-backward.svg": 4188,
	"./svgs/light/sensor-alert.svg": 4189,
	"./svgs/light/sensor-fire.svg": 4190,
	"./svgs/light/sensor-on.svg": 4191,
	"./svgs/light/sensor-smoke.svg": 4192,
	"./svgs/light/sensor.svg": 4193,
	"./svgs/light/server.svg": 4194,
	"./svgs/light/shapes.svg": 4195,
	"./svgs/light/share-all.svg": 4196,
	"./svgs/light/share-alt-square.svg": 4197,
	"./svgs/light/share-alt.svg": 4198,
	"./svgs/light/share-square.svg": 4199,
	"./svgs/light/share.svg": 4200,
	"./svgs/light/sheep.svg": 4201,
	"./svgs/light/shekel-sign.svg": 4202,
	"./svgs/light/shield-alt.svg": 4203,
	"./svgs/light/shield-check.svg": 4204,
	"./svgs/light/shield-cross.svg": 4205,
	"./svgs/light/shield.svg": 4206,
	"./svgs/light/ship.svg": 4207,
	"./svgs/light/shipping-fast.svg": 4208,
	"./svgs/light/shipping-timed.svg": 4209,
	"./svgs/light/shish-kebab.svg": 4210,
	"./svgs/light/shoe-prints.svg": 4211,
	"./svgs/light/shopping-bag.svg": 4212,
	"./svgs/light/shopping-basket.svg": 4213,
	"./svgs/light/shopping-cart.svg": 4214,
	"./svgs/light/shovel-snow.svg": 4215,
	"./svgs/light/shovel.svg": 4216,
	"./svgs/light/shower.svg": 4217,
	"./svgs/light/shredder.svg": 4218,
	"./svgs/light/shuttle-van.svg": 4219,
	"./svgs/light/shuttlecock.svg": 4220,
	"./svgs/light/sickle.svg": 4221,
	"./svgs/light/sigma.svg": 4222,
	"./svgs/light/sign-in-alt.svg": 4223,
	"./svgs/light/sign-in.svg": 4224,
	"./svgs/light/sign-language.svg": 4225,
	"./svgs/light/sign-out-alt.svg": 4226,
	"./svgs/light/sign-out.svg": 4227,
	"./svgs/light/sign.svg": 4228,
	"./svgs/light/signal-1.svg": 4229,
	"./svgs/light/signal-2.svg": 4230,
	"./svgs/light/signal-3.svg": 4231,
	"./svgs/light/signal-4.svg": 4232,
	"./svgs/light/signal-alt-1.svg": 4233,
	"./svgs/light/signal-alt-2.svg": 4234,
	"./svgs/light/signal-alt-3.svg": 4235,
	"./svgs/light/signal-alt-slash.svg": 4236,
	"./svgs/light/signal-alt.svg": 4237,
	"./svgs/light/signal-slash.svg": 4238,
	"./svgs/light/signal-stream.svg": 4239,
	"./svgs/light/signal.svg": 4240,
	"./svgs/light/signature.svg": 4241,
	"./svgs/light/sim-card.svg": 4242,
	"./svgs/light/siren-on.svg": 4243,
	"./svgs/light/siren.svg": 4244,
	"./svgs/light/sitemap.svg": 4245,
	"./svgs/light/skating.svg": 4246,
	"./svgs/light/skeleton.svg": 4247,
	"./svgs/light/ski-jump.svg": 4248,
	"./svgs/light/ski-lift.svg": 4249,
	"./svgs/light/skiing-nordic.svg": 4250,
	"./svgs/light/skiing.svg": 4251,
	"./svgs/light/skull-cow.svg": 4252,
	"./svgs/light/skull-crossbones.svg": 4253,
	"./svgs/light/skull.svg": 4254,
	"./svgs/light/slash.svg": 4255,
	"./svgs/light/sledding.svg": 4256,
	"./svgs/light/sleigh.svg": 4257,
	"./svgs/light/sliders-h-square.svg": 4258,
	"./svgs/light/sliders-h.svg": 4259,
	"./svgs/light/sliders-v-square.svg": 4260,
	"./svgs/light/sliders-v.svg": 4261,
	"./svgs/light/smile-beam.svg": 4262,
	"./svgs/light/smile-plus.svg": 4263,
	"./svgs/light/smile-wink.svg": 4264,
	"./svgs/light/smile.svg": 4265,
	"./svgs/light/smog.svg": 4266,
	"./svgs/light/smoke.svg": 4267,
	"./svgs/light/smoking-ban.svg": 4268,
	"./svgs/light/smoking.svg": 4269,
	"./svgs/light/sms.svg": 4270,
	"./svgs/light/snake.svg": 4271,
	"./svgs/light/snooze.svg": 4272,
	"./svgs/light/snow-blowing.svg": 4273,
	"./svgs/light/snowboarding.svg": 4274,
	"./svgs/light/snowflake.svg": 4275,
	"./svgs/light/snowflakes.svg": 4276,
	"./svgs/light/snowman.svg": 4277,
	"./svgs/light/snowmobile.svg": 4278,
	"./svgs/light/snowplow.svg": 4279,
	"./svgs/light/socks.svg": 4280,
	"./svgs/light/solar-panel.svg": 4281,
	"./svgs/light/solar-system.svg": 4282,
	"./svgs/light/sort-alpha-down-alt.svg": 4283,
	"./svgs/light/sort-alpha-down.svg": 4284,
	"./svgs/light/sort-alpha-up-alt.svg": 4285,
	"./svgs/light/sort-alpha-up.svg": 4286,
	"./svgs/light/sort-alt.svg": 4287,
	"./svgs/light/sort-amount-down-alt.svg": 4288,
	"./svgs/light/sort-amount-down.svg": 4289,
	"./svgs/light/sort-amount-up-alt.svg": 4290,
	"./svgs/light/sort-amount-up.svg": 4291,
	"./svgs/light/sort-circle-down.svg": 4292,
	"./svgs/light/sort-circle-up.svg": 4293,
	"./svgs/light/sort-circle.svg": 4294,
	"./svgs/light/sort-down.svg": 4295,
	"./svgs/light/sort-numeric-down-alt.svg": 4296,
	"./svgs/light/sort-numeric-down.svg": 4297,
	"./svgs/light/sort-numeric-up-alt.svg": 4298,
	"./svgs/light/sort-numeric-up.svg": 4299,
	"./svgs/light/sort-shapes-down-alt.svg": 4300,
	"./svgs/light/sort-shapes-down.svg": 4301,
	"./svgs/light/sort-shapes-up-alt.svg": 4302,
	"./svgs/light/sort-shapes-up.svg": 4303,
	"./svgs/light/sort-size-down-alt.svg": 4304,
	"./svgs/light/sort-size-down.svg": 4305,
	"./svgs/light/sort-size-up-alt.svg": 4306,
	"./svgs/light/sort-size-up.svg": 4307,
	"./svgs/light/sort-up.svg": 4308,
	"./svgs/light/sort.svg": 4309,
	"./svgs/light/soup.svg": 4310,
	"./svgs/light/spa.svg": 4311,
	"./svgs/light/space-shuttle.svg": 4312,
	"./svgs/light/space-station-moon-alt.svg": 4313,
	"./svgs/light/space-station-moon.svg": 4314,
	"./svgs/light/spade.svg": 4315,
	"./svgs/light/sparkles.svg": 4316,
	"./svgs/light/speaker.svg": 4317,
	"./svgs/light/speakers.svg": 4318,
	"./svgs/light/spell-check.svg": 4319,
	"./svgs/light/spider-black-widow.svg": 4320,
	"./svgs/light/spider-web.svg": 4321,
	"./svgs/light/spider.svg": 4322,
	"./svgs/light/spinner-third.svg": 4323,
	"./svgs/light/spinner.svg": 4324,
	"./svgs/light/splotch.svg": 4325,
	"./svgs/light/spray-can.svg": 4326,
	"./svgs/light/sprinkler.svg": 4327,
	"./svgs/light/square-full.svg": 4328,
	"./svgs/light/square-root-alt.svg": 4329,
	"./svgs/light/square-root.svg": 4330,
	"./svgs/light/square.svg": 4331,
	"./svgs/light/squirrel.svg": 4332,
	"./svgs/light/staff.svg": 4333,
	"./svgs/light/stamp.svg": 4334,
	"./svgs/light/star-and-crescent.svg": 4335,
	"./svgs/light/star-christmas.svg": 4336,
	"./svgs/light/star-exclamation.svg": 4337,
	"./svgs/light/star-half-alt.svg": 4338,
	"./svgs/light/star-half.svg": 4339,
	"./svgs/light/star-of-david.svg": 4340,
	"./svgs/light/star-of-life.svg": 4341,
	"./svgs/light/star-shooting.svg": 4342,
	"./svgs/light/star.svg": 4343,
	"./svgs/light/starfighter-alt.svg": 4344,
	"./svgs/light/starfighter.svg": 4345,
	"./svgs/light/stars.svg": 4346,
	"./svgs/light/starship-freighter.svg": 4347,
	"./svgs/light/starship.svg": 4348,
	"./svgs/light/steak.svg": 4349,
	"./svgs/light/steering-wheel.svg": 4350,
	"./svgs/light/step-backward.svg": 4351,
	"./svgs/light/step-forward.svg": 4352,
	"./svgs/light/stethoscope.svg": 4353,
	"./svgs/light/sticky-note.svg": 4354,
	"./svgs/light/stocking.svg": 4355,
	"./svgs/light/stomach.svg": 4356,
	"./svgs/light/stop-circle.svg": 4357,
	"./svgs/light/stop.svg": 4358,
	"./svgs/light/stopwatch.svg": 4359,
	"./svgs/light/store-alt.svg": 4360,
	"./svgs/light/store.svg": 4361,
	"./svgs/light/stream.svg": 4362,
	"./svgs/light/street-view.svg": 4363,
	"./svgs/light/stretcher.svg": 4364,
	"./svgs/light/strikethrough.svg": 4365,
	"./svgs/light/stroopwafel.svg": 4366,
	"./svgs/light/subscript.svg": 4367,
	"./svgs/light/subway.svg": 4368,
	"./svgs/light/suitcase-rolling.svg": 4369,
	"./svgs/light/suitcase.svg": 4370,
	"./svgs/light/sun-cloud.svg": 4371,
	"./svgs/light/sun-dust.svg": 4372,
	"./svgs/light/sun-haze.svg": 4373,
	"./svgs/light/sun.svg": 4374,
	"./svgs/light/sunglasses.svg": 4375,
	"./svgs/light/sunrise.svg": 4376,
	"./svgs/light/sunset.svg": 4377,
	"./svgs/light/superscript.svg": 4378,
	"./svgs/light/surprise.svg": 4379,
	"./svgs/light/swatchbook.svg": 4380,
	"./svgs/light/swimmer.svg": 4381,
	"./svgs/light/swimming-pool.svg": 4382,
	"./svgs/light/sword-laser-alt.svg": 4383,
	"./svgs/light/sword-laser.svg": 4384,
	"./svgs/light/sword.svg": 4385,
	"./svgs/light/swords-laser.svg": 4386,
	"./svgs/light/swords.svg": 4387,
	"./svgs/light/synagogue.svg": 4388,
	"./svgs/light/sync-alt.svg": 4389,
	"./svgs/light/sync.svg": 4390,
	"./svgs/light/syringe.svg": 4391,
	"./svgs/light/table-tennis.svg": 4392,
	"./svgs/light/table.svg": 4393,
	"./svgs/light/tablet-alt.svg": 4394,
	"./svgs/light/tablet-android-alt.svg": 4395,
	"./svgs/light/tablet-android.svg": 4396,
	"./svgs/light/tablet-rugged.svg": 4397,
	"./svgs/light/tablet.svg": 4398,
	"./svgs/light/tablets.svg": 4399,
	"./svgs/light/tachometer-alt-average.svg": 4400,
	"./svgs/light/tachometer-alt-fast.svg": 4401,
	"./svgs/light/tachometer-alt-fastest.svg": 4402,
	"./svgs/light/tachometer-alt-slow.svg": 4403,
	"./svgs/light/tachometer-alt-slowest.svg": 4404,
	"./svgs/light/tachometer-alt.svg": 4405,
	"./svgs/light/tachometer-average.svg": 4406,
	"./svgs/light/tachometer-fast.svg": 4407,
	"./svgs/light/tachometer-fastest.svg": 4408,
	"./svgs/light/tachometer-slow.svg": 4409,
	"./svgs/light/tachometer-slowest.svg": 4410,
	"./svgs/light/tachometer.svg": 4411,
	"./svgs/light/taco.svg": 4412,
	"./svgs/light/tag.svg": 4413,
	"./svgs/light/tags.svg": 4414,
	"./svgs/light/tally.svg": 4415,
	"./svgs/light/tanakh.svg": 4416,
	"./svgs/light/tape.svg": 4417,
	"./svgs/light/tasks-alt.svg": 4418,
	"./svgs/light/tasks.svg": 4419,
	"./svgs/light/taxi.svg": 4420,
	"./svgs/light/teeth-open.svg": 4421,
	"./svgs/light/teeth.svg": 4422,
	"./svgs/light/telescope.svg": 4423,
	"./svgs/light/temperature-down.svg": 4424,
	"./svgs/light/temperature-frigid.svg": 4425,
	"./svgs/light/temperature-high.svg": 4426,
	"./svgs/light/temperature-hot.svg": 4427,
	"./svgs/light/temperature-low.svg": 4428,
	"./svgs/light/temperature-up.svg": 4429,
	"./svgs/light/tenge.svg": 4430,
	"./svgs/light/tennis-ball.svg": 4431,
	"./svgs/light/terminal.svg": 4432,
	"./svgs/light/text-height.svg": 4433,
	"./svgs/light/text-size.svg": 4434,
	"./svgs/light/text-width.svg": 4435,
	"./svgs/light/text.svg": 4436,
	"./svgs/light/th-large.svg": 4437,
	"./svgs/light/th-list.svg": 4438,
	"./svgs/light/th.svg": 4439,
	"./svgs/light/theater-masks.svg": 4440,
	"./svgs/light/thermometer-empty.svg": 4441,
	"./svgs/light/thermometer-full.svg": 4442,
	"./svgs/light/thermometer-half.svg": 4443,
	"./svgs/light/thermometer-quarter.svg": 4444,
	"./svgs/light/thermometer-three-quarters.svg": 4445,
	"./svgs/light/thermometer.svg": 4446,
	"./svgs/light/theta.svg": 4447,
	"./svgs/light/thumbs-down.svg": 4448,
	"./svgs/light/thumbs-up.svg": 4449,
	"./svgs/light/thumbtack.svg": 4450,
	"./svgs/light/thunderstorm-moon.svg": 4451,
	"./svgs/light/thunderstorm-sun.svg": 4452,
	"./svgs/light/thunderstorm.svg": 4453,
	"./svgs/light/ticket-alt.svg": 4454,
	"./svgs/light/ticket.svg": 4455,
	"./svgs/light/tilde.svg": 4456,
	"./svgs/light/times-circle.svg": 4457,
	"./svgs/light/times-hexagon.svg": 4458,
	"./svgs/light/times-octagon.svg": 4459,
	"./svgs/light/times-square.svg": 4460,
	"./svgs/light/times.svg": 4461,
	"./svgs/light/tint-slash.svg": 4462,
	"./svgs/light/tint.svg": 4463,
	"./svgs/light/tire-flat.svg": 4464,
	"./svgs/light/tire-pressure-warning.svg": 4465,
	"./svgs/light/tire-rugged.svg": 4466,
	"./svgs/light/tire.svg": 4467,
	"./svgs/light/tired.svg": 4468,
	"./svgs/light/toggle-off.svg": 4469,
	"./svgs/light/toggle-on.svg": 4470,
	"./svgs/light/toilet-paper-alt.svg": 4471,
	"./svgs/light/toilet-paper.svg": 4472,
	"./svgs/light/toilet.svg": 4473,
	"./svgs/light/tombstone-alt.svg": 4474,
	"./svgs/light/tombstone.svg": 4475,
	"./svgs/light/toolbox.svg": 4476,
	"./svgs/light/tools.svg": 4477,
	"./svgs/light/tooth.svg": 4478,
	"./svgs/light/toothbrush.svg": 4479,
	"./svgs/light/torah.svg": 4480,
	"./svgs/light/torii-gate.svg": 4481,
	"./svgs/light/tornado.svg": 4482,
	"./svgs/light/tractor.svg": 4483,
	"./svgs/light/trademark.svg": 4484,
	"./svgs/light/traffic-cone.svg": 4485,
	"./svgs/light/traffic-light-go.svg": 4486,
	"./svgs/light/traffic-light-slow.svg": 4487,
	"./svgs/light/traffic-light-stop.svg": 4488,
	"./svgs/light/traffic-light.svg": 4489,
	"./svgs/light/trailer.svg": 4490,
	"./svgs/light/train.svg": 4491,
	"./svgs/light/tram.svg": 4492,
	"./svgs/light/transgender-alt.svg": 4493,
	"./svgs/light/transgender.svg": 4494,
	"./svgs/light/transporter-1.svg": 4495,
	"./svgs/light/transporter-2.svg": 4496,
	"./svgs/light/transporter-3.svg": 4497,
	"./svgs/light/transporter-empty.svg": 4498,
	"./svgs/light/transporter.svg": 4499,
	"./svgs/light/trash-alt.svg": 4500,
	"./svgs/light/trash-restore-alt.svg": 4501,
	"./svgs/light/trash-restore.svg": 4502,
	"./svgs/light/trash-undo-alt.svg": 4503,
	"./svgs/light/trash-undo.svg": 4504,
	"./svgs/light/trash.svg": 4505,
	"./svgs/light/treasure-chest.svg": 4506,
	"./svgs/light/tree-alt.svg": 4507,
	"./svgs/light/tree-christmas.svg": 4508,
	"./svgs/light/tree-decorated.svg": 4509,
	"./svgs/light/tree-large.svg": 4510,
	"./svgs/light/tree-palm.svg": 4511,
	"./svgs/light/tree.svg": 4512,
	"./svgs/light/trees.svg": 4513,
	"./svgs/light/triangle-music.svg": 4514,
	"./svgs/light/triangle.svg": 4515,
	"./svgs/light/trophy-alt.svg": 4516,
	"./svgs/light/trophy.svg": 4517,
	"./svgs/light/truck-container.svg": 4518,
	"./svgs/light/truck-couch.svg": 4519,
	"./svgs/light/truck-loading.svg": 4520,
	"./svgs/light/truck-monster.svg": 4521,
	"./svgs/light/truck-moving.svg": 4522,
	"./svgs/light/truck-pickup.svg": 4523,
	"./svgs/light/truck-plow.svg": 4524,
	"./svgs/light/truck-ramp.svg": 4525,
	"./svgs/light/truck.svg": 4526,
	"./svgs/light/trumpet.svg": 4527,
	"./svgs/light/tshirt.svg": 4528,
	"./svgs/light/tty.svg": 4529,
	"./svgs/light/turkey.svg": 4530,
	"./svgs/light/turntable.svg": 4531,
	"./svgs/light/turtle.svg": 4532,
	"./svgs/light/tv-alt.svg": 4533,
	"./svgs/light/tv-music.svg": 4534,
	"./svgs/light/tv-retro.svg": 4535,
	"./svgs/light/tv.svg": 4536,
	"./svgs/light/typewriter.svg": 4537,
	"./svgs/light/ufo-beam.svg": 4538,
	"./svgs/light/ufo.svg": 4539,
	"./svgs/light/umbrella-beach.svg": 4540,
	"./svgs/light/umbrella.svg": 4541,
	"./svgs/light/underline.svg": 4542,
	"./svgs/light/undo-alt.svg": 4543,
	"./svgs/light/undo.svg": 4544,
	"./svgs/light/unicorn.svg": 4545,
	"./svgs/light/union.svg": 4546,
	"./svgs/light/universal-access.svg": 4547,
	"./svgs/light/university.svg": 4548,
	"./svgs/light/unlink.svg": 4549,
	"./svgs/light/unlock-alt.svg": 4550,
	"./svgs/light/unlock.svg": 4551,
	"./svgs/light/upload.svg": 4552,
	"./svgs/light/usb-drive.svg": 4553,
	"./svgs/light/usd-circle.svg": 4554,
	"./svgs/light/usd-square.svg": 4555,
	"./svgs/light/user-alien.svg": 4556,
	"./svgs/light/user-alt-slash.svg": 4557,
	"./svgs/light/user-alt.svg": 4558,
	"./svgs/light/user-astronaut.svg": 4559,
	"./svgs/light/user-chart.svg": 4560,
	"./svgs/light/user-check.svg": 4561,
	"./svgs/light/user-circle.svg": 4562,
	"./svgs/light/user-clock.svg": 4563,
	"./svgs/light/user-cog.svg": 4564,
	"./svgs/light/user-cowboy.svg": 4565,
	"./svgs/light/user-crown.svg": 4566,
	"./svgs/light/user-edit.svg": 4567,
	"./svgs/light/user-friends.svg": 4568,
	"./svgs/light/user-graduate.svg": 4569,
	"./svgs/light/user-hard-hat.svg": 4570,
	"./svgs/light/user-headset.svg": 4571,
	"./svgs/light/user-injured.svg": 4572,
	"./svgs/light/user-lock.svg": 4573,
	"./svgs/light/user-md-chat.svg": 4574,
	"./svgs/light/user-md.svg": 4575,
	"./svgs/light/user-minus.svg": 4576,
	"./svgs/light/user-music.svg": 4577,
	"./svgs/light/user-ninja.svg": 4578,
	"./svgs/light/user-nurse.svg": 4579,
	"./svgs/light/user-plus.svg": 4580,
	"./svgs/light/user-robot.svg": 4581,
	"./svgs/light/user-secret.svg": 4582,
	"./svgs/light/user-shield.svg": 4583,
	"./svgs/light/user-slash.svg": 4584,
	"./svgs/light/user-tag.svg": 4585,
	"./svgs/light/user-tie.svg": 4586,
	"./svgs/light/user-times.svg": 4587,
	"./svgs/light/user-visor.svg": 4588,
	"./svgs/light/user.svg": 4589,
	"./svgs/light/users-class.svg": 4590,
	"./svgs/light/users-cog.svg": 4591,
	"./svgs/light/users-crown.svg": 4592,
	"./svgs/light/users-medical.svg": 4593,
	"./svgs/light/users.svg": 4594,
	"./svgs/light/utensil-fork.svg": 4595,
	"./svgs/light/utensil-knife.svg": 4596,
	"./svgs/light/utensil-spoon.svg": 4597,
	"./svgs/light/utensils-alt.svg": 4598,
	"./svgs/light/utensils.svg": 4599,
	"./svgs/light/vacuum-robot.svg": 4600,
	"./svgs/light/vacuum.svg": 4601,
	"./svgs/light/value-absolute.svg": 4602,
	"./svgs/light/vector-square.svg": 4603,
	"./svgs/light/venus-double.svg": 4604,
	"./svgs/light/venus-mars.svg": 4605,
	"./svgs/light/venus.svg": 4606,
	"./svgs/light/vhs.svg": 4607,
	"./svgs/light/vial.svg": 4608,
	"./svgs/light/vials.svg": 4609,
	"./svgs/light/video-plus.svg": 4610,
	"./svgs/light/video-slash.svg": 4611,
	"./svgs/light/video.svg": 4612,
	"./svgs/light/vihara.svg": 4613,
	"./svgs/light/violin.svg": 4614,
	"./svgs/light/voicemail.svg": 4615,
	"./svgs/light/volcano.svg": 4616,
	"./svgs/light/volleyball-ball.svg": 4617,
	"./svgs/light/volume-down.svg": 4618,
	"./svgs/light/volume-mute.svg": 4619,
	"./svgs/light/volume-off.svg": 4620,
	"./svgs/light/volume-slash.svg": 4621,
	"./svgs/light/volume-up.svg": 4622,
	"./svgs/light/volume.svg": 4623,
	"./svgs/light/vote-nay.svg": 4624,
	"./svgs/light/vote-yea.svg": 4625,
	"./svgs/light/vr-cardboard.svg": 4626,
	"./svgs/light/wagon-covered.svg": 4627,
	"./svgs/light/walker.svg": 4628,
	"./svgs/light/walkie-talkie.svg": 4629,
	"./svgs/light/walking.svg": 4630,
	"./svgs/light/wallet.svg": 4631,
	"./svgs/light/wand-magic.svg": 4632,
	"./svgs/light/wand.svg": 4633,
	"./svgs/light/warehouse-alt.svg": 4634,
	"./svgs/light/warehouse.svg": 4635,
	"./svgs/light/washer.svg": 4636,
	"./svgs/light/watch-calculator.svg": 4637,
	"./svgs/light/watch-fitness.svg": 4638,
	"./svgs/light/watch.svg": 4639,
	"./svgs/light/water-lower.svg": 4640,
	"./svgs/light/water-rise.svg": 4641,
	"./svgs/light/water.svg": 4642,
	"./svgs/light/wave-sine.svg": 4643,
	"./svgs/light/wave-square.svg": 4644,
	"./svgs/light/wave-triangle.svg": 4645,
	"./svgs/light/waveform-path.svg": 4646,
	"./svgs/light/waveform.svg": 4647,
	"./svgs/light/webcam-slash.svg": 4648,
	"./svgs/light/webcam.svg": 4649,
	"./svgs/light/weight-hanging.svg": 4650,
	"./svgs/light/weight.svg": 4651,
	"./svgs/light/whale.svg": 4652,
	"./svgs/light/wheat.svg": 4653,
	"./svgs/light/wheelchair.svg": 4654,
	"./svgs/light/whistle.svg": 4655,
	"./svgs/light/wifi-1.svg": 4656,
	"./svgs/light/wifi-2.svg": 4657,
	"./svgs/light/wifi-slash.svg": 4658,
	"./svgs/light/wifi.svg": 4659,
	"./svgs/light/wind-turbine.svg": 4660,
	"./svgs/light/wind-warning.svg": 4661,
	"./svgs/light/wind.svg": 4662,
	"./svgs/light/window-alt.svg": 4663,
	"./svgs/light/window-close.svg": 4664,
	"./svgs/light/window-frame-open.svg": 4665,
	"./svgs/light/window-frame.svg": 4666,
	"./svgs/light/window-maximize.svg": 4667,
	"./svgs/light/window-minimize.svg": 4668,
	"./svgs/light/window-restore.svg": 4669,
	"./svgs/light/window.svg": 4670,
	"./svgs/light/windsock.svg": 4671,
	"./svgs/light/wine-bottle.svg": 4672,
	"./svgs/light/wine-glass-alt.svg": 4673,
	"./svgs/light/wine-glass.svg": 4674,
	"./svgs/light/won-sign.svg": 4675,
	"./svgs/light/wreath.svg": 4676,
	"./svgs/light/wrench.svg": 4677,
	"./svgs/light/x-ray.svg": 4678,
	"./svgs/light/yen-sign.svg": 4679,
	"./svgs/light/yin-yang.svg": 4680,
	"./svgs/regular/abacus.svg": 4681,
	"./svgs/regular/acorn.svg": 4682,
	"./svgs/regular/ad.svg": 4683,
	"./svgs/regular/address-book.svg": 4684,
	"./svgs/regular/address-card.svg": 4685,
	"./svgs/regular/adjust.svg": 4686,
	"./svgs/regular/air-conditioner.svg": 4687,
	"./svgs/regular/air-freshener.svg": 4688,
	"./svgs/regular/alarm-clock.svg": 4689,
	"./svgs/regular/alarm-exclamation.svg": 4690,
	"./svgs/regular/alarm-plus.svg": 4691,
	"./svgs/regular/alarm-snooze.svg": 4692,
	"./svgs/regular/album-collection.svg": 4693,
	"./svgs/regular/album.svg": 4694,
	"./svgs/regular/alicorn.svg": 4695,
	"./svgs/regular/alien-monster.svg": 4696,
	"./svgs/regular/alien.svg": 4697,
	"./svgs/regular/align-center.svg": 4698,
	"./svgs/regular/align-justify.svg": 4699,
	"./svgs/regular/align-left.svg": 4700,
	"./svgs/regular/align-right.svg": 4701,
	"./svgs/regular/align-slash.svg": 4702,
	"./svgs/regular/allergies.svg": 4703,
	"./svgs/regular/ambulance.svg": 4704,
	"./svgs/regular/american-sign-language-interpreting.svg": 4705,
	"./svgs/regular/amp-guitar.svg": 4706,
	"./svgs/regular/analytics.svg": 4707,
	"./svgs/regular/anchor.svg": 4708,
	"./svgs/regular/angel.svg": 4709,
	"./svgs/regular/angle-double-down.svg": 4710,
	"./svgs/regular/angle-double-left.svg": 4711,
	"./svgs/regular/angle-double-right.svg": 4712,
	"./svgs/regular/angle-double-up.svg": 4713,
	"./svgs/regular/angle-down.svg": 4714,
	"./svgs/regular/angle-left.svg": 4715,
	"./svgs/regular/angle-right.svg": 4716,
	"./svgs/regular/angle-up.svg": 4717,
	"./svgs/regular/angry.svg": 4718,
	"./svgs/regular/ankh.svg": 4719,
	"./svgs/regular/apple-alt.svg": 4720,
	"./svgs/regular/apple-crate.svg": 4721,
	"./svgs/regular/archive.svg": 4722,
	"./svgs/regular/archway.svg": 4723,
	"./svgs/regular/arrow-alt-circle-down.svg": 4724,
	"./svgs/regular/arrow-alt-circle-left.svg": 4725,
	"./svgs/regular/arrow-alt-circle-right.svg": 4726,
	"./svgs/regular/arrow-alt-circle-up.svg": 4727,
	"./svgs/regular/arrow-alt-down.svg": 4728,
	"./svgs/regular/arrow-alt-from-bottom.svg": 4729,
	"./svgs/regular/arrow-alt-from-left.svg": 4730,
	"./svgs/regular/arrow-alt-from-right.svg": 4731,
	"./svgs/regular/arrow-alt-from-top.svg": 4732,
	"./svgs/regular/arrow-alt-left.svg": 4733,
	"./svgs/regular/arrow-alt-right.svg": 4734,
	"./svgs/regular/arrow-alt-square-down.svg": 4735,
	"./svgs/regular/arrow-alt-square-left.svg": 4736,
	"./svgs/regular/arrow-alt-square-right.svg": 4737,
	"./svgs/regular/arrow-alt-square-up.svg": 4738,
	"./svgs/regular/arrow-alt-to-bottom.svg": 4739,
	"./svgs/regular/arrow-alt-to-left.svg": 4740,
	"./svgs/regular/arrow-alt-to-right.svg": 4741,
	"./svgs/regular/arrow-alt-to-top.svg": 4742,
	"./svgs/regular/arrow-alt-up.svg": 4743,
	"./svgs/regular/arrow-circle-down.svg": 4744,
	"./svgs/regular/arrow-circle-left.svg": 4745,
	"./svgs/regular/arrow-circle-right.svg": 4746,
	"./svgs/regular/arrow-circle-up.svg": 4747,
	"./svgs/regular/arrow-down.svg": 4748,
	"./svgs/regular/arrow-from-bottom.svg": 4749,
	"./svgs/regular/arrow-from-left.svg": 4750,
	"./svgs/regular/arrow-from-right.svg": 4751,
	"./svgs/regular/arrow-from-top.svg": 4752,
	"./svgs/regular/arrow-left.svg": 4753,
	"./svgs/regular/arrow-right.svg": 4754,
	"./svgs/regular/arrow-square-down.svg": 4755,
	"./svgs/regular/arrow-square-left.svg": 4756,
	"./svgs/regular/arrow-square-right.svg": 4757,
	"./svgs/regular/arrow-square-up.svg": 4758,
	"./svgs/regular/arrow-to-bottom.svg": 4759,
	"./svgs/regular/arrow-to-left.svg": 4760,
	"./svgs/regular/arrow-to-right.svg": 4761,
	"./svgs/regular/arrow-to-top.svg": 4762,
	"./svgs/regular/arrow-up.svg": 4763,
	"./svgs/regular/arrows-alt-h.svg": 4764,
	"./svgs/regular/arrows-alt-v.svg": 4765,
	"./svgs/regular/arrows-alt.svg": 4766,
	"./svgs/regular/arrows-h.svg": 4767,
	"./svgs/regular/arrows-v.svg": 4768,
	"./svgs/regular/arrows.svg": 4769,
	"./svgs/regular/assistive-listening-systems.svg": 4770,
	"./svgs/regular/asterisk.svg": 4771,
	"./svgs/regular/at.svg": 4772,
	"./svgs/regular/atlas.svg": 4773,
	"./svgs/regular/atom-alt.svg": 4774,
	"./svgs/regular/atom.svg": 4775,
	"./svgs/regular/audio-description.svg": 4776,
	"./svgs/regular/award.svg": 4777,
	"./svgs/regular/axe-battle.svg": 4778,
	"./svgs/regular/axe.svg": 4779,
	"./svgs/regular/baby-carriage.svg": 4780,
	"./svgs/regular/baby.svg": 4781,
	"./svgs/regular/backpack.svg": 4782,
	"./svgs/regular/backspace.svg": 4783,
	"./svgs/regular/backward.svg": 4784,
	"./svgs/regular/bacon.svg": 4785,
	"./svgs/regular/badge-check.svg": 4786,
	"./svgs/regular/badge-dollar.svg": 4787,
	"./svgs/regular/badge-percent.svg": 4788,
	"./svgs/regular/badge-sheriff.svg": 4789,
	"./svgs/regular/badge.svg": 4790,
	"./svgs/regular/badger-honey.svg": 4791,
	"./svgs/regular/bags-shopping.svg": 4792,
	"./svgs/regular/bahai.svg": 4793,
	"./svgs/regular/balance-scale-left.svg": 4794,
	"./svgs/regular/balance-scale-right.svg": 4795,
	"./svgs/regular/balance-scale.svg": 4796,
	"./svgs/regular/ball-pile.svg": 4797,
	"./svgs/regular/ballot-check.svg": 4798,
	"./svgs/regular/ballot.svg": 4799,
	"./svgs/regular/ban.svg": 4800,
	"./svgs/regular/band-aid.svg": 4801,
	"./svgs/regular/banjo.svg": 4802,
	"./svgs/regular/barcode-alt.svg": 4803,
	"./svgs/regular/barcode-read.svg": 4804,
	"./svgs/regular/barcode-scan.svg": 4805,
	"./svgs/regular/barcode.svg": 4806,
	"./svgs/regular/bars.svg": 4807,
	"./svgs/regular/baseball-ball.svg": 4808,
	"./svgs/regular/baseball.svg": 4809,
	"./svgs/regular/basketball-ball.svg": 4810,
	"./svgs/regular/basketball-hoop.svg": 4811,
	"./svgs/regular/bat.svg": 4812,
	"./svgs/regular/bath.svg": 4813,
	"./svgs/regular/battery-bolt.svg": 4814,
	"./svgs/regular/battery-empty.svg": 4815,
	"./svgs/regular/battery-full.svg": 4816,
	"./svgs/regular/battery-half.svg": 4817,
	"./svgs/regular/battery-quarter.svg": 4818,
	"./svgs/regular/battery-slash.svg": 4819,
	"./svgs/regular/battery-three-quarters.svg": 4820,
	"./svgs/regular/bed-alt.svg": 4821,
	"./svgs/regular/bed-bunk.svg": 4822,
	"./svgs/regular/bed-empty.svg": 4823,
	"./svgs/regular/bed.svg": 4824,
	"./svgs/regular/beer.svg": 4825,
	"./svgs/regular/bell-exclamation.svg": 4826,
	"./svgs/regular/bell-on.svg": 4827,
	"./svgs/regular/bell-plus.svg": 4828,
	"./svgs/regular/bell-school-slash.svg": 4829,
	"./svgs/regular/bell-school.svg": 4830,
	"./svgs/regular/bell-slash.svg": 4831,
	"./svgs/regular/bell.svg": 4832,
	"./svgs/regular/bells.svg": 4833,
	"./svgs/regular/betamax.svg": 4834,
	"./svgs/regular/bezier-curve.svg": 4835,
	"./svgs/regular/bible.svg": 4836,
	"./svgs/regular/bicycle.svg": 4837,
	"./svgs/regular/biking-mountain.svg": 4838,
	"./svgs/regular/biking.svg": 4839,
	"./svgs/regular/binoculars.svg": 4840,
	"./svgs/regular/biohazard.svg": 4841,
	"./svgs/regular/birthday-cake.svg": 4842,
	"./svgs/regular/blanket.svg": 4843,
	"./svgs/regular/blender-phone.svg": 4844,
	"./svgs/regular/blender.svg": 4845,
	"./svgs/regular/blind.svg": 4846,
	"./svgs/regular/blinds-open.svg": 4847,
	"./svgs/regular/blinds-raised.svg": 4848,
	"./svgs/regular/blinds.svg": 4849,
	"./svgs/regular/blog.svg": 4850,
	"./svgs/regular/bold.svg": 4851,
	"./svgs/regular/bolt.svg": 4852,
	"./svgs/regular/bomb.svg": 4853,
	"./svgs/regular/bone-break.svg": 4854,
	"./svgs/regular/bone.svg": 4855,
	"./svgs/regular/bong.svg": 4856,
	"./svgs/regular/book-alt.svg": 4857,
	"./svgs/regular/book-dead.svg": 4858,
	"./svgs/regular/book-heart.svg": 4859,
	"./svgs/regular/book-medical.svg": 4860,
	"./svgs/regular/book-open.svg": 4861,
	"./svgs/regular/book-reader.svg": 4862,
	"./svgs/regular/book-spells.svg": 4863,
	"./svgs/regular/book-user.svg": 4864,
	"./svgs/regular/book.svg": 4865,
	"./svgs/regular/bookmark.svg": 4866,
	"./svgs/regular/books-medical.svg": 4867,
	"./svgs/regular/books.svg": 4868,
	"./svgs/regular/boombox.svg": 4869,
	"./svgs/regular/boot.svg": 4870,
	"./svgs/regular/booth-curtain.svg": 4871,
	"./svgs/regular/border-all.svg": 4872,
	"./svgs/regular/border-bottom.svg": 4873,
	"./svgs/regular/border-center-h.svg": 4874,
	"./svgs/regular/border-center-v.svg": 4875,
	"./svgs/regular/border-inner.svg": 4876,
	"./svgs/regular/border-left.svg": 4877,
	"./svgs/regular/border-none.svg": 4878,
	"./svgs/regular/border-outer.svg": 4879,
	"./svgs/regular/border-right.svg": 4880,
	"./svgs/regular/border-style-alt.svg": 4881,
	"./svgs/regular/border-style.svg": 4882,
	"./svgs/regular/border-top.svg": 4883,
	"./svgs/regular/bow-arrow.svg": 4884,
	"./svgs/regular/bowling-ball.svg": 4885,
	"./svgs/regular/bowling-pins.svg": 4886,
	"./svgs/regular/box-alt.svg": 4887,
	"./svgs/regular/box-ballot.svg": 4888,
	"./svgs/regular/box-check.svg": 4889,
	"./svgs/regular/box-fragile.svg": 4890,
	"./svgs/regular/box-full.svg": 4891,
	"./svgs/regular/box-heart.svg": 4892,
	"./svgs/regular/box-open.svg": 4893,
	"./svgs/regular/box-up.svg": 4894,
	"./svgs/regular/box-usd.svg": 4895,
	"./svgs/regular/box.svg": 4896,
	"./svgs/regular/boxes-alt.svg": 4897,
	"./svgs/regular/boxes.svg": 4898,
	"./svgs/regular/boxing-glove.svg": 4899,
	"./svgs/regular/brackets-curly.svg": 4900,
	"./svgs/regular/brackets.svg": 4901,
	"./svgs/regular/braille.svg": 4902,
	"./svgs/regular/brain.svg": 4903,
	"./svgs/regular/bread-loaf.svg": 4904,
	"./svgs/regular/bread-slice.svg": 4905,
	"./svgs/regular/briefcase-medical.svg": 4906,
	"./svgs/regular/briefcase.svg": 4907,
	"./svgs/regular/bring-forward.svg": 4908,
	"./svgs/regular/bring-front.svg": 4909,
	"./svgs/regular/broadcast-tower.svg": 4910,
	"./svgs/regular/broom.svg": 4911,
	"./svgs/regular/browser.svg": 4912,
	"./svgs/regular/brush.svg": 4913,
	"./svgs/regular/bug.svg": 4914,
	"./svgs/regular/building.svg": 4915,
	"./svgs/regular/bullhorn.svg": 4916,
	"./svgs/regular/bullseye-arrow.svg": 4917,
	"./svgs/regular/bullseye-pointer.svg": 4918,
	"./svgs/regular/bullseye.svg": 4919,
	"./svgs/regular/burger-soda.svg": 4920,
	"./svgs/regular/burn.svg": 4921,
	"./svgs/regular/burrito.svg": 4922,
	"./svgs/regular/bus-alt.svg": 4923,
	"./svgs/regular/bus-school.svg": 4924,
	"./svgs/regular/bus.svg": 4925,
	"./svgs/regular/business-time.svg": 4926,
	"./svgs/regular/cabinet-filing.svg": 4927,
	"./svgs/regular/cactus.svg": 4928,
	"./svgs/regular/calculator-alt.svg": 4929,
	"./svgs/regular/calculator.svg": 4930,
	"./svgs/regular/calendar-alt.svg": 4931,
	"./svgs/regular/calendar-check.svg": 4932,
	"./svgs/regular/calendar-day.svg": 4933,
	"./svgs/regular/calendar-edit.svg": 4934,
	"./svgs/regular/calendar-exclamation.svg": 4935,
	"./svgs/regular/calendar-minus.svg": 4936,
	"./svgs/regular/calendar-plus.svg": 4937,
	"./svgs/regular/calendar-star.svg": 4938,
	"./svgs/regular/calendar-times.svg": 4939,
	"./svgs/regular/calendar-week.svg": 4940,
	"./svgs/regular/calendar.svg": 4941,
	"./svgs/regular/camcorder.svg": 4942,
	"./svgs/regular/camera-alt.svg": 4943,
	"./svgs/regular/camera-home.svg": 4944,
	"./svgs/regular/camera-movie.svg": 4945,
	"./svgs/regular/camera-polaroid.svg": 4946,
	"./svgs/regular/camera-retro.svg": 4947,
	"./svgs/regular/camera.svg": 4948,
	"./svgs/regular/campfire.svg": 4949,
	"./svgs/regular/campground.svg": 4950,
	"./svgs/regular/candle-holder.svg": 4951,
	"./svgs/regular/candy-cane.svg": 4952,
	"./svgs/regular/candy-corn.svg": 4953,
	"./svgs/regular/cannabis.svg": 4954,
	"./svgs/regular/capsules.svg": 4955,
	"./svgs/regular/car-alt.svg": 4956,
	"./svgs/regular/car-battery.svg": 4957,
	"./svgs/regular/car-building.svg": 4958,
	"./svgs/regular/car-bump.svg": 4959,
	"./svgs/regular/car-bus.svg": 4960,
	"./svgs/regular/car-crash.svg": 4961,
	"./svgs/regular/car-garage.svg": 4962,
	"./svgs/regular/car-mechanic.svg": 4963,
	"./svgs/regular/car-side.svg": 4964,
	"./svgs/regular/car-tilt.svg": 4965,
	"./svgs/regular/car-wash.svg": 4966,
	"./svgs/regular/car.svg": 4967,
	"./svgs/regular/caravan-alt.svg": 4968,
	"./svgs/regular/caravan.svg": 4969,
	"./svgs/regular/caret-circle-down.svg": 4970,
	"./svgs/regular/caret-circle-left.svg": 4971,
	"./svgs/regular/caret-circle-right.svg": 4972,
	"./svgs/regular/caret-circle-up.svg": 4973,
	"./svgs/regular/caret-down.svg": 4974,
	"./svgs/regular/caret-left.svg": 4975,
	"./svgs/regular/caret-right.svg": 4976,
	"./svgs/regular/caret-square-down.svg": 4977,
	"./svgs/regular/caret-square-left.svg": 4978,
	"./svgs/regular/caret-square-right.svg": 4979,
	"./svgs/regular/caret-square-up.svg": 4980,
	"./svgs/regular/caret-up.svg": 4981,
	"./svgs/regular/carrot.svg": 4982,
	"./svgs/regular/cars.svg": 4983,
	"./svgs/regular/cart-arrow-down.svg": 4984,
	"./svgs/regular/cart-plus.svg": 4985,
	"./svgs/regular/cash-register.svg": 4986,
	"./svgs/regular/cassette-tape.svg": 4987,
	"./svgs/regular/cat-space.svg": 4988,
	"./svgs/regular/cat.svg": 4989,
	"./svgs/regular/cauldron.svg": 4990,
	"./svgs/regular/cctv.svg": 4991,
	"./svgs/regular/certificate.svg": 4992,
	"./svgs/regular/chair-office.svg": 4993,
	"./svgs/regular/chair.svg": 4994,
	"./svgs/regular/chalkboard-teacher.svg": 4995,
	"./svgs/regular/chalkboard.svg": 4996,
	"./svgs/regular/charging-station.svg": 4997,
	"./svgs/regular/chart-area.svg": 4998,
	"./svgs/regular/chart-bar.svg": 4999,
	"./svgs/regular/chart-line-down.svg": 5000,
	"./svgs/regular/chart-line.svg": 5001,
	"./svgs/regular/chart-network.svg": 5002,
	"./svgs/regular/chart-pie-alt.svg": 5003,
	"./svgs/regular/chart-pie.svg": 5004,
	"./svgs/regular/chart-scatter.svg": 5005,
	"./svgs/regular/check-circle.svg": 5006,
	"./svgs/regular/check-double.svg": 5007,
	"./svgs/regular/check-square.svg": 5008,
	"./svgs/regular/check.svg": 5009,
	"./svgs/regular/cheese-swiss.svg": 5010,
	"./svgs/regular/cheese.svg": 5011,
	"./svgs/regular/cheeseburger.svg": 5012,
	"./svgs/regular/chess-bishop-alt.svg": 5013,
	"./svgs/regular/chess-bishop.svg": 5014,
	"./svgs/regular/chess-board.svg": 5015,
	"./svgs/regular/chess-clock-alt.svg": 5016,
	"./svgs/regular/chess-clock.svg": 5017,
	"./svgs/regular/chess-king-alt.svg": 5018,
	"./svgs/regular/chess-king.svg": 5019,
	"./svgs/regular/chess-knight-alt.svg": 5020,
	"./svgs/regular/chess-knight.svg": 5021,
	"./svgs/regular/chess-pawn-alt.svg": 5022,
	"./svgs/regular/chess-pawn.svg": 5023,
	"./svgs/regular/chess-queen-alt.svg": 5024,
	"./svgs/regular/chess-queen.svg": 5025,
	"./svgs/regular/chess-rook-alt.svg": 5026,
	"./svgs/regular/chess-rook.svg": 5027,
	"./svgs/regular/chess.svg": 5028,
	"./svgs/regular/chevron-circle-down.svg": 5029,
	"./svgs/regular/chevron-circle-left.svg": 5030,
	"./svgs/regular/chevron-circle-right.svg": 5031,
	"./svgs/regular/chevron-circle-up.svg": 5032,
	"./svgs/regular/chevron-double-down.svg": 5033,
	"./svgs/regular/chevron-double-left.svg": 5034,
	"./svgs/regular/chevron-double-right.svg": 5035,
	"./svgs/regular/chevron-double-up.svg": 5036,
	"./svgs/regular/chevron-down.svg": 5037,
	"./svgs/regular/chevron-left.svg": 5038,
	"./svgs/regular/chevron-right.svg": 5039,
	"./svgs/regular/chevron-square-down.svg": 5040,
	"./svgs/regular/chevron-square-left.svg": 5041,
	"./svgs/regular/chevron-square-right.svg": 5042,
	"./svgs/regular/chevron-square-up.svg": 5043,
	"./svgs/regular/chevron-up.svg": 5044,
	"./svgs/regular/child.svg": 5045,
	"./svgs/regular/chimney.svg": 5046,
	"./svgs/regular/church.svg": 5047,
	"./svgs/regular/circle-notch.svg": 5048,
	"./svgs/regular/circle.svg": 5049,
	"./svgs/regular/city.svg": 5050,
	"./svgs/regular/clarinet.svg": 5051,
	"./svgs/regular/claw-marks.svg": 5052,
	"./svgs/regular/clinic-medical.svg": 5053,
	"./svgs/regular/clipboard-check.svg": 5054,
	"./svgs/regular/clipboard-list-check.svg": 5055,
	"./svgs/regular/clipboard-list.svg": 5056,
	"./svgs/regular/clipboard-prescription.svg": 5057,
	"./svgs/regular/clipboard-user.svg": 5058,
	"./svgs/regular/clipboard.svg": 5059,
	"./svgs/regular/clock.svg": 5060,
	"./svgs/regular/clone.svg": 5061,
	"./svgs/regular/closed-captioning.svg": 5062,
	"./svgs/regular/cloud-download-alt.svg": 5063,
	"./svgs/regular/cloud-download.svg": 5064,
	"./svgs/regular/cloud-drizzle.svg": 5065,
	"./svgs/regular/cloud-hail-mixed.svg": 5066,
	"./svgs/regular/cloud-hail.svg": 5067,
	"./svgs/regular/cloud-meatball.svg": 5068,
	"./svgs/regular/cloud-moon-rain.svg": 5069,
	"./svgs/regular/cloud-moon.svg": 5070,
	"./svgs/regular/cloud-music.svg": 5071,
	"./svgs/regular/cloud-rain.svg": 5072,
	"./svgs/regular/cloud-rainbow.svg": 5073,
	"./svgs/regular/cloud-showers-heavy.svg": 5074,
	"./svgs/regular/cloud-showers.svg": 5075,
	"./svgs/regular/cloud-sleet.svg": 5076,
	"./svgs/regular/cloud-snow.svg": 5077,
	"./svgs/regular/cloud-sun-rain.svg": 5078,
	"./svgs/regular/cloud-sun.svg": 5079,
	"./svgs/regular/cloud-upload-alt.svg": 5080,
	"./svgs/regular/cloud-upload.svg": 5081,
	"./svgs/regular/cloud.svg": 5082,
	"./svgs/regular/clouds-moon.svg": 5083,
	"./svgs/regular/clouds-sun.svg": 5084,
	"./svgs/regular/clouds.svg": 5085,
	"./svgs/regular/club.svg": 5086,
	"./svgs/regular/cocktail.svg": 5087,
	"./svgs/regular/code-branch.svg": 5088,
	"./svgs/regular/code-commit.svg": 5089,
	"./svgs/regular/code-merge.svg": 5090,
	"./svgs/regular/code.svg": 5091,
	"./svgs/regular/coffee-pot.svg": 5092,
	"./svgs/regular/coffee-togo.svg": 5093,
	"./svgs/regular/coffee.svg": 5094,
	"./svgs/regular/coffin.svg": 5095,
	"./svgs/regular/cog.svg": 5096,
	"./svgs/regular/cogs.svg": 5097,
	"./svgs/regular/coin.svg": 5098,
	"./svgs/regular/coins.svg": 5099,
	"./svgs/regular/columns.svg": 5100,
	"./svgs/regular/comet.svg": 5101,
	"./svgs/regular/comment-alt-check.svg": 5102,
	"./svgs/regular/comment-alt-dollar.svg": 5103,
	"./svgs/regular/comment-alt-dots.svg": 5104,
	"./svgs/regular/comment-alt-edit.svg": 5105,
	"./svgs/regular/comment-alt-exclamation.svg": 5106,
	"./svgs/regular/comment-alt-lines.svg": 5107,
	"./svgs/regular/comment-alt-medical.svg": 5108,
	"./svgs/regular/comment-alt-minus.svg": 5109,
	"./svgs/regular/comment-alt-music.svg": 5110,
	"./svgs/regular/comment-alt-plus.svg": 5111,
	"./svgs/regular/comment-alt-slash.svg": 5112,
	"./svgs/regular/comment-alt-smile.svg": 5113,
	"./svgs/regular/comment-alt-times.svg": 5114,
	"./svgs/regular/comment-alt.svg": 5115,
	"./svgs/regular/comment-check.svg": 5116,
	"./svgs/regular/comment-dollar.svg": 5117,
	"./svgs/regular/comment-dots.svg": 5118,
	"./svgs/regular/comment-edit.svg": 5119,
	"./svgs/regular/comment-exclamation.svg": 5120,
	"./svgs/regular/comment-lines.svg": 5121,
	"./svgs/regular/comment-medical.svg": 5122,
	"./svgs/regular/comment-minus.svg": 5123,
	"./svgs/regular/comment-music.svg": 5124,
	"./svgs/regular/comment-plus.svg": 5125,
	"./svgs/regular/comment-slash.svg": 5126,
	"./svgs/regular/comment-smile.svg": 5127,
	"./svgs/regular/comment-times.svg": 5128,
	"./svgs/regular/comment.svg": 5129,
	"./svgs/regular/comments-alt-dollar.svg": 5130,
	"./svgs/regular/comments-alt.svg": 5131,
	"./svgs/regular/comments-dollar.svg": 5132,
	"./svgs/regular/comments.svg": 5133,
	"./svgs/regular/compact-disc.svg": 5134,
	"./svgs/regular/compass-slash.svg": 5135,
	"./svgs/regular/compass.svg": 5136,
	"./svgs/regular/compress-alt.svg": 5137,
	"./svgs/regular/compress-arrows-alt.svg": 5138,
	"./svgs/regular/compress-wide.svg": 5139,
	"./svgs/regular/compress.svg": 5140,
	"./svgs/regular/computer-classic.svg": 5141,
	"./svgs/regular/computer-speaker.svg": 5142,
	"./svgs/regular/concierge-bell.svg": 5143,
	"./svgs/regular/construction.svg": 5144,
	"./svgs/regular/container-storage.svg": 5145,
	"./svgs/regular/conveyor-belt-alt.svg": 5146,
	"./svgs/regular/conveyor-belt.svg": 5147,
	"./svgs/regular/cookie-bite.svg": 5148,
	"./svgs/regular/cookie.svg": 5149,
	"./svgs/regular/copy.svg": 5150,
	"./svgs/regular/copyright.svg": 5151,
	"./svgs/regular/corn.svg": 5152,
	"./svgs/regular/couch.svg": 5153,
	"./svgs/regular/cow.svg": 5154,
	"./svgs/regular/cowbell-more.svg": 5155,
	"./svgs/regular/cowbell.svg": 5156,
	"./svgs/regular/credit-card-blank.svg": 5157,
	"./svgs/regular/credit-card-front.svg": 5158,
	"./svgs/regular/credit-card.svg": 5159,
	"./svgs/regular/cricket.svg": 5160,
	"./svgs/regular/croissant.svg": 5161,
	"./svgs/regular/crop-alt.svg": 5162,
	"./svgs/regular/crop.svg": 5163,
	"./svgs/regular/cross.svg": 5164,
	"./svgs/regular/crosshairs.svg": 5165,
	"./svgs/regular/crow.svg": 5166,
	"./svgs/regular/crown.svg": 5167,
	"./svgs/regular/crutch.svg": 5168,
	"./svgs/regular/crutches.svg": 5169,
	"./svgs/regular/cube.svg": 5170,
	"./svgs/regular/cubes.svg": 5171,
	"./svgs/regular/curling.svg": 5172,
	"./svgs/regular/cut.svg": 5173,
	"./svgs/regular/dagger.svg": 5174,
	"./svgs/regular/database.svg": 5175,
	"./svgs/regular/deaf.svg": 5176,
	"./svgs/regular/debug.svg": 5177,
	"./svgs/regular/deer-rudolph.svg": 5178,
	"./svgs/regular/deer.svg": 5179,
	"./svgs/regular/democrat.svg": 5180,
	"./svgs/regular/desktop-alt.svg": 5181,
	"./svgs/regular/desktop.svg": 5182,
	"./svgs/regular/dewpoint.svg": 5183,
	"./svgs/regular/dharmachakra.svg": 5184,
	"./svgs/regular/diagnoses.svg": 5185,
	"./svgs/regular/diamond.svg": 5186,
	"./svgs/regular/dice-d10.svg": 5187,
	"./svgs/regular/dice-d12.svg": 5188,
	"./svgs/regular/dice-d20.svg": 5189,
	"./svgs/regular/dice-d4.svg": 5190,
	"./svgs/regular/dice-d6.svg": 5191,
	"./svgs/regular/dice-d8.svg": 5192,
	"./svgs/regular/dice-five.svg": 5193,
	"./svgs/regular/dice-four.svg": 5194,
	"./svgs/regular/dice-one.svg": 5195,
	"./svgs/regular/dice-six.svg": 5196,
	"./svgs/regular/dice-three.svg": 5197,
	"./svgs/regular/dice-two.svg": 5198,
	"./svgs/regular/dice.svg": 5199,
	"./svgs/regular/digging.svg": 5200,
	"./svgs/regular/digital-tachograph.svg": 5201,
	"./svgs/regular/diploma.svg": 5202,
	"./svgs/regular/directions.svg": 5203,
	"./svgs/regular/disc-drive.svg": 5204,
	"./svgs/regular/disease.svg": 5205,
	"./svgs/regular/divide.svg": 5206,
	"./svgs/regular/dizzy.svg": 5207,
	"./svgs/regular/dna.svg": 5208,
	"./svgs/regular/do-not-enter.svg": 5209,
	"./svgs/regular/dog-leashed.svg": 5210,
	"./svgs/regular/dog.svg": 5211,
	"./svgs/regular/dollar-sign.svg": 5212,
	"./svgs/regular/dolly-empty.svg": 5213,
	"./svgs/regular/dolly-flatbed-alt.svg": 5214,
	"./svgs/regular/dolly-flatbed-empty.svg": 5215,
	"./svgs/regular/dolly-flatbed.svg": 5216,
	"./svgs/regular/dolly.svg": 5217,
	"./svgs/regular/donate.svg": 5218,
	"./svgs/regular/door-closed.svg": 5219,
	"./svgs/regular/door-open.svg": 5220,
	"./svgs/regular/dot-circle.svg": 5221,
	"./svgs/regular/dove.svg": 5222,
	"./svgs/regular/download.svg": 5223,
	"./svgs/regular/drafting-compass.svg": 5224,
	"./svgs/regular/dragon.svg": 5225,
	"./svgs/regular/draw-circle.svg": 5226,
	"./svgs/regular/draw-polygon.svg": 5227,
	"./svgs/regular/draw-square.svg": 5228,
	"./svgs/regular/dreidel.svg": 5229,
	"./svgs/regular/drone-alt.svg": 5230,
	"./svgs/regular/drone.svg": 5231,
	"./svgs/regular/drum-steelpan.svg": 5232,
	"./svgs/regular/drum.svg": 5233,
	"./svgs/regular/drumstick-bite.svg": 5234,
	"./svgs/regular/drumstick.svg": 5235,
	"./svgs/regular/dryer-alt.svg": 5236,
	"./svgs/regular/dryer.svg": 5237,
	"./svgs/regular/duck.svg": 5238,
	"./svgs/regular/dumbbell.svg": 5239,
	"./svgs/regular/dumpster-fire.svg": 5240,
	"./svgs/regular/dumpster.svg": 5241,
	"./svgs/regular/dungeon.svg": 5242,
	"./svgs/regular/ear-muffs.svg": 5243,
	"./svgs/regular/ear.svg": 5244,
	"./svgs/regular/eclipse-alt.svg": 5245,
	"./svgs/regular/eclipse.svg": 5246,
	"./svgs/regular/edit.svg": 5247,
	"./svgs/regular/egg-fried.svg": 5248,
	"./svgs/regular/egg.svg": 5249,
	"./svgs/regular/eject.svg": 5250,
	"./svgs/regular/elephant.svg": 5251,
	"./svgs/regular/ellipsis-h-alt.svg": 5252,
	"./svgs/regular/ellipsis-h.svg": 5253,
	"./svgs/regular/ellipsis-v-alt.svg": 5254,
	"./svgs/regular/ellipsis-v.svg": 5255,
	"./svgs/regular/empty-set.svg": 5256,
	"./svgs/regular/engine-warning.svg": 5257,
	"./svgs/regular/envelope-open-dollar.svg": 5258,
	"./svgs/regular/envelope-open-text.svg": 5259,
	"./svgs/regular/envelope-open.svg": 5260,
	"./svgs/regular/envelope-square.svg": 5261,
	"./svgs/regular/envelope.svg": 5262,
	"./svgs/regular/equals.svg": 5263,
	"./svgs/regular/eraser.svg": 5264,
	"./svgs/regular/ethernet.svg": 5265,
	"./svgs/regular/euro-sign.svg": 5266,
	"./svgs/regular/exchange-alt.svg": 5267,
	"./svgs/regular/exchange.svg": 5268,
	"./svgs/regular/exclamation-circle.svg": 5269,
	"./svgs/regular/exclamation-square.svg": 5270,
	"./svgs/regular/exclamation-triangle.svg": 5271,
	"./svgs/regular/exclamation.svg": 5272,
	"./svgs/regular/expand-alt.svg": 5273,
	"./svgs/regular/expand-arrows-alt.svg": 5274,
	"./svgs/regular/expand-arrows.svg": 5275,
	"./svgs/regular/expand-wide.svg": 5276,
	"./svgs/regular/expand.svg": 5277,
	"./svgs/regular/external-link-alt.svg": 5278,
	"./svgs/regular/external-link-square-alt.svg": 5279,
	"./svgs/regular/external-link-square.svg": 5280,
	"./svgs/regular/external-link.svg": 5281,
	"./svgs/regular/eye-dropper.svg": 5282,
	"./svgs/regular/eye-evil.svg": 5283,
	"./svgs/regular/eye-slash.svg": 5284,
	"./svgs/regular/eye.svg": 5285,
	"./svgs/regular/fan-table.svg": 5286,
	"./svgs/regular/fan.svg": 5287,
	"./svgs/regular/farm.svg": 5288,
	"./svgs/regular/fast-backward.svg": 5289,
	"./svgs/regular/fast-forward.svg": 5290,
	"./svgs/regular/faucet-drip.svg": 5291,
	"./svgs/regular/faucet.svg": 5292,
	"./svgs/regular/fax.svg": 5293,
	"./svgs/regular/feather-alt.svg": 5294,
	"./svgs/regular/feather.svg": 5295,
	"./svgs/regular/female.svg": 5296,
	"./svgs/regular/field-hockey.svg": 5297,
	"./svgs/regular/fighter-jet.svg": 5298,
	"./svgs/regular/file-alt.svg": 5299,
	"./svgs/regular/file-archive.svg": 5300,
	"./svgs/regular/file-audio.svg": 5301,
	"./svgs/regular/file-certificate.svg": 5302,
	"./svgs/regular/file-chart-line.svg": 5303,
	"./svgs/regular/file-chart-pie.svg": 5304,
	"./svgs/regular/file-check.svg": 5305,
	"./svgs/regular/file-code.svg": 5306,
	"./svgs/regular/file-contract.svg": 5307,
	"./svgs/regular/file-csv.svg": 5308,
	"./svgs/regular/file-download.svg": 5309,
	"./svgs/regular/file-edit.svg": 5310,
	"./svgs/regular/file-excel.svg": 5311,
	"./svgs/regular/file-exclamation.svg": 5312,
	"./svgs/regular/file-export.svg": 5313,
	"./svgs/regular/file-image.svg": 5314,
	"./svgs/regular/file-import.svg": 5315,
	"./svgs/regular/file-invoice-dollar.svg": 5316,
	"./svgs/regular/file-invoice.svg": 5317,
	"./svgs/regular/file-medical-alt.svg": 5318,
	"./svgs/regular/file-medical.svg": 5319,
	"./svgs/regular/file-minus.svg": 5320,
	"./svgs/regular/file-music.svg": 5321,
	"./svgs/regular/file-pdf.svg": 5322,
	"./svgs/regular/file-plus.svg": 5323,
	"./svgs/regular/file-powerpoint.svg": 5324,
	"./svgs/regular/file-prescription.svg": 5325,
	"./svgs/regular/file-search.svg": 5326,
	"./svgs/regular/file-signature.svg": 5327,
	"./svgs/regular/file-spreadsheet.svg": 5328,
	"./svgs/regular/file-times.svg": 5329,
	"./svgs/regular/file-upload.svg": 5330,
	"./svgs/regular/file-user.svg": 5331,
	"./svgs/regular/file-video.svg": 5332,
	"./svgs/regular/file-word.svg": 5333,
	"./svgs/regular/file.svg": 5334,
	"./svgs/regular/files-medical.svg": 5335,
	"./svgs/regular/fill-drip.svg": 5336,
	"./svgs/regular/fill.svg": 5337,
	"./svgs/regular/film-alt.svg": 5338,
	"./svgs/regular/film-canister.svg": 5339,
	"./svgs/regular/film.svg": 5340,
	"./svgs/regular/filter.svg": 5341,
	"./svgs/regular/fingerprint.svg": 5342,
	"./svgs/regular/fire-alt.svg": 5343,
	"./svgs/regular/fire-extinguisher.svg": 5344,
	"./svgs/regular/fire-smoke.svg": 5345,
	"./svgs/regular/fire.svg": 5346,
	"./svgs/regular/fireplace.svg": 5347,
	"./svgs/regular/first-aid.svg": 5348,
	"./svgs/regular/fish-cooked.svg": 5349,
	"./svgs/regular/fish.svg": 5350,
	"./svgs/regular/fist-raised.svg": 5351,
	"./svgs/regular/flag-alt.svg": 5352,
	"./svgs/regular/flag-checkered.svg": 5353,
	"./svgs/regular/flag-usa.svg": 5354,
	"./svgs/regular/flag.svg": 5355,
	"./svgs/regular/flame.svg": 5356,
	"./svgs/regular/flashlight.svg": 5357,
	"./svgs/regular/flask-poison.svg": 5358,
	"./svgs/regular/flask-potion.svg": 5359,
	"./svgs/regular/flask.svg": 5360,
	"./svgs/regular/flower-daffodil.svg": 5361,
	"./svgs/regular/flower-tulip.svg": 5362,
	"./svgs/regular/flower.svg": 5363,
	"./svgs/regular/flushed.svg": 5364,
	"./svgs/regular/flute.svg": 5365,
	"./svgs/regular/flux-capacitor.svg": 5366,
	"./svgs/regular/fog.svg": 5367,
	"./svgs/regular/folder-minus.svg": 5368,
	"./svgs/regular/folder-open.svg": 5369,
	"./svgs/regular/folder-plus.svg": 5370,
	"./svgs/regular/folder-times.svg": 5371,
	"./svgs/regular/folder-tree.svg": 5372,
	"./svgs/regular/folder.svg": 5373,
	"./svgs/regular/folders.svg": 5374,
	"./svgs/regular/font-awesome-logo-full.svg": 5375,
	"./svgs/regular/font-case.svg": 5376,
	"./svgs/regular/font.svg": 5377,
	"./svgs/regular/football-ball.svg": 5378,
	"./svgs/regular/football-helmet.svg": 5379,
	"./svgs/regular/forklift.svg": 5380,
	"./svgs/regular/forward.svg": 5381,
	"./svgs/regular/fragile.svg": 5382,
	"./svgs/regular/french-fries.svg": 5383,
	"./svgs/regular/frog.svg": 5384,
	"./svgs/regular/frosty-head.svg": 5385,
	"./svgs/regular/frown-open.svg": 5386,
	"./svgs/regular/frown.svg": 5387,
	"./svgs/regular/function.svg": 5388,
	"./svgs/regular/funnel-dollar.svg": 5389,
	"./svgs/regular/futbol.svg": 5390,
	"./svgs/regular/galaxy.svg": 5391,
	"./svgs/regular/game-board-alt.svg": 5392,
	"./svgs/regular/game-board.svg": 5393,
	"./svgs/regular/game-console-handheld.svg": 5394,
	"./svgs/regular/gamepad-alt.svg": 5395,
	"./svgs/regular/gamepad.svg": 5396,
	"./svgs/regular/garage-car.svg": 5397,
	"./svgs/regular/garage-open.svg": 5398,
	"./svgs/regular/garage.svg": 5399,
	"./svgs/regular/gas-pump-slash.svg": 5400,
	"./svgs/regular/gas-pump.svg": 5401,
	"./svgs/regular/gavel.svg": 5402,
	"./svgs/regular/gem.svg": 5403,
	"./svgs/regular/genderless.svg": 5404,
	"./svgs/regular/ghost.svg": 5405,
	"./svgs/regular/gift-card.svg": 5406,
	"./svgs/regular/gift.svg": 5407,
	"./svgs/regular/gifts.svg": 5408,
	"./svgs/regular/gingerbread-man.svg": 5409,
	"./svgs/regular/glass-champagne.svg": 5410,
	"./svgs/regular/glass-cheers.svg": 5411,
	"./svgs/regular/glass-citrus.svg": 5412,
	"./svgs/regular/glass-martini-alt.svg": 5413,
	"./svgs/regular/glass-martini.svg": 5414,
	"./svgs/regular/glass-whiskey-rocks.svg": 5415,
	"./svgs/regular/glass-whiskey.svg": 5416,
	"./svgs/regular/glass.svg": 5417,
	"./svgs/regular/glasses-alt.svg": 5418,
	"./svgs/regular/glasses.svg": 5419,
	"./svgs/regular/globe-africa.svg": 5420,
	"./svgs/regular/globe-americas.svg": 5421,
	"./svgs/regular/globe-asia.svg": 5422,
	"./svgs/regular/globe-europe.svg": 5423,
	"./svgs/regular/globe-snow.svg": 5424,
	"./svgs/regular/globe-stand.svg": 5425,
	"./svgs/regular/globe.svg": 5426,
	"./svgs/regular/golf-ball.svg": 5427,
	"./svgs/regular/golf-club.svg": 5428,
	"./svgs/regular/gopuram.svg": 5429,
	"./svgs/regular/graduation-cap.svg": 5430,
	"./svgs/regular/gramophone.svg": 5431,
	"./svgs/regular/greater-than-equal.svg": 5432,
	"./svgs/regular/greater-than.svg": 5433,
	"./svgs/regular/grimace.svg": 5434,
	"./svgs/regular/grin-alt.svg": 5435,
	"./svgs/regular/grin-beam-sweat.svg": 5436,
	"./svgs/regular/grin-beam.svg": 5437,
	"./svgs/regular/grin-hearts.svg": 5438,
	"./svgs/regular/grin-squint-tears.svg": 5439,
	"./svgs/regular/grin-squint.svg": 5440,
	"./svgs/regular/grin-stars.svg": 5441,
	"./svgs/regular/grin-tears.svg": 5442,
	"./svgs/regular/grin-tongue-squint.svg": 5443,
	"./svgs/regular/grin-tongue-wink.svg": 5444,
	"./svgs/regular/grin-tongue.svg": 5445,
	"./svgs/regular/grin-wink.svg": 5446,
	"./svgs/regular/grin.svg": 5447,
	"./svgs/regular/grip-horizontal.svg": 5448,
	"./svgs/regular/grip-lines-vertical.svg": 5449,
	"./svgs/regular/grip-lines.svg": 5450,
	"./svgs/regular/grip-vertical.svg": 5451,
	"./svgs/regular/guitar-electric.svg": 5452,
	"./svgs/regular/guitar.svg": 5453,
	"./svgs/regular/guitars.svg": 5454,
	"./svgs/regular/h-square.svg": 5455,
	"./svgs/regular/h1.svg": 5456,
	"./svgs/regular/h2.svg": 5457,
	"./svgs/regular/h3.svg": 5458,
	"./svgs/regular/h4.svg": 5459,
	"./svgs/regular/hamburger.svg": 5460,
	"./svgs/regular/hammer-war.svg": 5461,
	"./svgs/regular/hammer.svg": 5462,
	"./svgs/regular/hamsa.svg": 5463,
	"./svgs/regular/hand-heart.svg": 5464,
	"./svgs/regular/hand-holding-box.svg": 5465,
	"./svgs/regular/hand-holding-heart.svg": 5466,
	"./svgs/regular/hand-holding-magic.svg": 5467,
	"./svgs/regular/hand-holding-seedling.svg": 5468,
	"./svgs/regular/hand-holding-usd.svg": 5469,
	"./svgs/regular/hand-holding-water.svg": 5470,
	"./svgs/regular/hand-holding.svg": 5471,
	"./svgs/regular/hand-lizard.svg": 5472,
	"./svgs/regular/hand-middle-finger.svg": 5473,
	"./svgs/regular/hand-paper.svg": 5474,
	"./svgs/regular/hand-peace.svg": 5475,
	"./svgs/regular/hand-point-down.svg": 5476,
	"./svgs/regular/hand-point-left.svg": 5477,
	"./svgs/regular/hand-point-right.svg": 5478,
	"./svgs/regular/hand-point-up.svg": 5479,
	"./svgs/regular/hand-pointer.svg": 5480,
	"./svgs/regular/hand-receiving.svg": 5481,
	"./svgs/regular/hand-rock.svg": 5482,
	"./svgs/regular/hand-scissors.svg": 5483,
	"./svgs/regular/hand-spock.svg": 5484,
	"./svgs/regular/hands-heart.svg": 5485,
	"./svgs/regular/hands-helping.svg": 5486,
	"./svgs/regular/hands-usd.svg": 5487,
	"./svgs/regular/hands.svg": 5488,
	"./svgs/regular/handshake-alt.svg": 5489,
	"./svgs/regular/handshake.svg": 5490,
	"./svgs/regular/hanukiah.svg": 5491,
	"./svgs/regular/hard-hat.svg": 5492,
	"./svgs/regular/hashtag.svg": 5493,
	"./svgs/regular/hat-chef.svg": 5494,
	"./svgs/regular/hat-cowboy-side.svg": 5495,
	"./svgs/regular/hat-cowboy.svg": 5496,
	"./svgs/regular/hat-santa.svg": 5497,
	"./svgs/regular/hat-winter.svg": 5498,
	"./svgs/regular/hat-witch.svg": 5499,
	"./svgs/regular/hat-wizard.svg": 5500,
	"./svgs/regular/hdd.svg": 5501,
	"./svgs/regular/head-side-brain.svg": 5502,
	"./svgs/regular/head-side-headphones.svg": 5503,
	"./svgs/regular/head-side-medical.svg": 5504,
	"./svgs/regular/head-side.svg": 5505,
	"./svgs/regular/head-vr.svg": 5506,
	"./svgs/regular/heading.svg": 5507,
	"./svgs/regular/headphones-alt.svg": 5508,
	"./svgs/regular/headphones.svg": 5509,
	"./svgs/regular/headset.svg": 5510,
	"./svgs/regular/heart-broken.svg": 5511,
	"./svgs/regular/heart-circle.svg": 5512,
	"./svgs/regular/heart-rate.svg": 5513,
	"./svgs/regular/heart-square.svg": 5514,
	"./svgs/regular/heart.svg": 5515,
	"./svgs/regular/heartbeat.svg": 5516,
	"./svgs/regular/heat.svg": 5517,
	"./svgs/regular/helicopter.svg": 5518,
	"./svgs/regular/helmet-battle.svg": 5519,
	"./svgs/regular/hexagon.svg": 5520,
	"./svgs/regular/highlighter.svg": 5521,
	"./svgs/regular/hiking.svg": 5522,
	"./svgs/regular/hippo.svg": 5523,
	"./svgs/regular/history.svg": 5524,
	"./svgs/regular/hockey-mask.svg": 5525,
	"./svgs/regular/hockey-puck.svg": 5526,
	"./svgs/regular/hockey-sticks.svg": 5527,
	"./svgs/regular/holly-berry.svg": 5528,
	"./svgs/regular/home-alt.svg": 5529,
	"./svgs/regular/home-heart.svg": 5530,
	"./svgs/regular/home-lg-alt.svg": 5531,
	"./svgs/regular/home-lg.svg": 5532,
	"./svgs/regular/home.svg": 5533,
	"./svgs/regular/hood-cloak.svg": 5534,
	"./svgs/regular/horizontal-rule.svg": 5535,
	"./svgs/regular/horse-head.svg": 5536,
	"./svgs/regular/horse-saddle.svg": 5537,
	"./svgs/regular/horse.svg": 5538,
	"./svgs/regular/hospital-alt.svg": 5539,
	"./svgs/regular/hospital-symbol.svg": 5540,
	"./svgs/regular/hospital-user.svg": 5541,
	"./svgs/regular/hospital.svg": 5542,
	"./svgs/regular/hospitals.svg": 5543,
	"./svgs/regular/hot-tub.svg": 5544,
	"./svgs/regular/hotdog.svg": 5545,
	"./svgs/regular/hotel.svg": 5546,
	"./svgs/regular/hourglass-end.svg": 5547,
	"./svgs/regular/hourglass-half.svg": 5548,
	"./svgs/regular/hourglass-start.svg": 5549,
	"./svgs/regular/hourglass.svg": 5550,
	"./svgs/regular/house-damage.svg": 5551,
	"./svgs/regular/house-day.svg": 5552,
	"./svgs/regular/house-flood.svg": 5553,
	"./svgs/regular/house-leave.svg": 5554,
	"./svgs/regular/house-night.svg": 5555,
	"./svgs/regular/house-return.svg": 5556,
	"./svgs/regular/house-signal.svg": 5557,
	"./svgs/regular/house.svg": 5558,
	"./svgs/regular/hryvnia.svg": 5559,
	"./svgs/regular/humidity.svg": 5560,
	"./svgs/regular/hurricane.svg": 5561,
	"./svgs/regular/i-cursor.svg": 5562,
	"./svgs/regular/ice-cream.svg": 5563,
	"./svgs/regular/ice-skate.svg": 5564,
	"./svgs/regular/icicles.svg": 5565,
	"./svgs/regular/icons-alt.svg": 5566,
	"./svgs/regular/icons.svg": 5567,
	"./svgs/regular/id-badge.svg": 5568,
	"./svgs/regular/id-card-alt.svg": 5569,
	"./svgs/regular/id-card.svg": 5570,
	"./svgs/regular/igloo.svg": 5571,
	"./svgs/regular/image-polaroid.svg": 5572,
	"./svgs/regular/image.svg": 5573,
	"./svgs/regular/images.svg": 5574,
	"./svgs/regular/inbox-in.svg": 5575,
	"./svgs/regular/inbox-out.svg": 5576,
	"./svgs/regular/inbox.svg": 5577,
	"./svgs/regular/indent.svg": 5578,
	"./svgs/regular/industry-alt.svg": 5579,
	"./svgs/regular/industry.svg": 5580,
	"./svgs/regular/infinity.svg": 5581,
	"./svgs/regular/info-circle.svg": 5582,
	"./svgs/regular/info-square.svg": 5583,
	"./svgs/regular/info.svg": 5584,
	"./svgs/regular/inhaler.svg": 5585,
	"./svgs/regular/integral.svg": 5586,
	"./svgs/regular/intersection.svg": 5587,
	"./svgs/regular/inventory.svg": 5588,
	"./svgs/regular/island-tropical.svg": 5589,
	"./svgs/regular/italic.svg": 5590,
	"./svgs/regular/jack-o-lantern.svg": 5591,
	"./svgs/regular/jedi.svg": 5592,
	"./svgs/regular/joint.svg": 5593,
	"./svgs/regular/journal-whills.svg": 5594,
	"./svgs/regular/joystick.svg": 5595,
	"./svgs/regular/jug.svg": 5596,
	"./svgs/regular/kaaba.svg": 5597,
	"./svgs/regular/kazoo.svg": 5598,
	"./svgs/regular/kerning.svg": 5599,
	"./svgs/regular/key-skeleton.svg": 5600,
	"./svgs/regular/key.svg": 5601,
	"./svgs/regular/keyboard.svg": 5602,
	"./svgs/regular/keynote.svg": 5603,
	"./svgs/regular/khanda.svg": 5604,
	"./svgs/regular/kidneys.svg": 5605,
	"./svgs/regular/kiss-beam.svg": 5606,
	"./svgs/regular/kiss-wink-heart.svg": 5607,
	"./svgs/regular/kiss.svg": 5608,
	"./svgs/regular/kite.svg": 5609,
	"./svgs/regular/kiwi-bird.svg": 5610,
	"./svgs/regular/knife-kitchen.svg": 5611,
	"./svgs/regular/lambda.svg": 5612,
	"./svgs/regular/lamp-desk.svg": 5613,
	"./svgs/regular/lamp-floor.svg": 5614,
	"./svgs/regular/lamp.svg": 5615,
	"./svgs/regular/landmark-alt.svg": 5616,
	"./svgs/regular/landmark.svg": 5617,
	"./svgs/regular/language.svg": 5618,
	"./svgs/regular/laptop-code.svg": 5619,
	"./svgs/regular/laptop-medical.svg": 5620,
	"./svgs/regular/laptop.svg": 5621,
	"./svgs/regular/lasso.svg": 5622,
	"./svgs/regular/laugh-beam.svg": 5623,
	"./svgs/regular/laugh-squint.svg": 5624,
	"./svgs/regular/laugh-wink.svg": 5625,
	"./svgs/regular/laugh.svg": 5626,
	"./svgs/regular/layer-group.svg": 5627,
	"./svgs/regular/layer-minus.svg": 5628,
	"./svgs/regular/layer-plus.svg": 5629,
	"./svgs/regular/leaf-heart.svg": 5630,
	"./svgs/regular/leaf-maple.svg": 5631,
	"./svgs/regular/leaf-oak.svg": 5632,
	"./svgs/regular/leaf.svg": 5633,
	"./svgs/regular/lemon.svg": 5634,
	"./svgs/regular/less-than-equal.svg": 5635,
	"./svgs/regular/less-than.svg": 5636,
	"./svgs/regular/level-down-alt.svg": 5637,
	"./svgs/regular/level-down.svg": 5638,
	"./svgs/regular/level-up-alt.svg": 5639,
	"./svgs/regular/level-up.svg": 5640,
	"./svgs/regular/life-ring.svg": 5641,
	"./svgs/regular/light-ceiling.svg": 5642,
	"./svgs/regular/light-switch-off.svg": 5643,
	"./svgs/regular/light-switch-on.svg": 5644,
	"./svgs/regular/light-switch.svg": 5645,
	"./svgs/regular/lightbulb-dollar.svg": 5646,
	"./svgs/regular/lightbulb-exclamation.svg": 5647,
	"./svgs/regular/lightbulb-on.svg": 5648,
	"./svgs/regular/lightbulb-slash.svg": 5649,
	"./svgs/regular/lightbulb.svg": 5650,
	"./svgs/regular/lights-holiday.svg": 5651,
	"./svgs/regular/line-columns.svg": 5652,
	"./svgs/regular/line-height.svg": 5653,
	"./svgs/regular/link.svg": 5654,
	"./svgs/regular/lips.svg": 5655,
	"./svgs/regular/lira-sign.svg": 5656,
	"./svgs/regular/list-alt.svg": 5657,
	"./svgs/regular/list-music.svg": 5658,
	"./svgs/regular/list-ol.svg": 5659,
	"./svgs/regular/list-ul.svg": 5660,
	"./svgs/regular/list.svg": 5661,
	"./svgs/regular/location-arrow.svg": 5662,
	"./svgs/regular/location-circle.svg": 5663,
	"./svgs/regular/location-slash.svg": 5664,
	"./svgs/regular/location.svg": 5665,
	"./svgs/regular/lock-alt.svg": 5666,
	"./svgs/regular/lock-open-alt.svg": 5667,
	"./svgs/regular/lock-open.svg": 5668,
	"./svgs/regular/lock.svg": 5669,
	"./svgs/regular/long-arrow-alt-down.svg": 5670,
	"./svgs/regular/long-arrow-alt-left.svg": 5671,
	"./svgs/regular/long-arrow-alt-right.svg": 5672,
	"./svgs/regular/long-arrow-alt-up.svg": 5673,
	"./svgs/regular/long-arrow-down.svg": 5674,
	"./svgs/regular/long-arrow-left.svg": 5675,
	"./svgs/regular/long-arrow-right.svg": 5676,
	"./svgs/regular/long-arrow-up.svg": 5677,
	"./svgs/regular/loveseat.svg": 5678,
	"./svgs/regular/low-vision.svg": 5679,
	"./svgs/regular/luchador.svg": 5680,
	"./svgs/regular/luggage-cart.svg": 5681,
	"./svgs/regular/lungs.svg": 5682,
	"./svgs/regular/mace.svg": 5683,
	"./svgs/regular/magic.svg": 5684,
	"./svgs/regular/magnet.svg": 5685,
	"./svgs/regular/mail-bulk.svg": 5686,
	"./svgs/regular/mailbox.svg": 5687,
	"./svgs/regular/male.svg": 5688,
	"./svgs/regular/mandolin.svg": 5689,
	"./svgs/regular/map-marked-alt.svg": 5690,
	"./svgs/regular/map-marked.svg": 5691,
	"./svgs/regular/map-marker-alt-slash.svg": 5692,
	"./svgs/regular/map-marker-alt.svg": 5693,
	"./svgs/regular/map-marker-check.svg": 5694,
	"./svgs/regular/map-marker-edit.svg": 5695,
	"./svgs/regular/map-marker-exclamation.svg": 5696,
	"./svgs/regular/map-marker-minus.svg": 5697,
	"./svgs/regular/map-marker-plus.svg": 5698,
	"./svgs/regular/map-marker-question.svg": 5699,
	"./svgs/regular/map-marker-slash.svg": 5700,
	"./svgs/regular/map-marker-smile.svg": 5701,
	"./svgs/regular/map-marker-times.svg": 5702,
	"./svgs/regular/map-marker.svg": 5703,
	"./svgs/regular/map-pin.svg": 5704,
	"./svgs/regular/map-signs.svg": 5705,
	"./svgs/regular/map.svg": 5706,
	"./svgs/regular/marker.svg": 5707,
	"./svgs/regular/mars-double.svg": 5708,
	"./svgs/regular/mars-stroke-h.svg": 5709,
	"./svgs/regular/mars-stroke-v.svg": 5710,
	"./svgs/regular/mars-stroke.svg": 5711,
	"./svgs/regular/mars.svg": 5712,
	"./svgs/regular/mask.svg": 5713,
	"./svgs/regular/meat.svg": 5714,
	"./svgs/regular/medal.svg": 5715,
	"./svgs/regular/medkit.svg": 5716,
	"./svgs/regular/megaphone.svg": 5717,
	"./svgs/regular/meh-blank.svg": 5718,
	"./svgs/regular/meh-rolling-eyes.svg": 5719,
	"./svgs/regular/meh.svg": 5720,
	"./svgs/regular/memory.svg": 5721,
	"./svgs/regular/menorah.svg": 5722,
	"./svgs/regular/mercury.svg": 5723,
	"./svgs/regular/meteor.svg": 5724,
	"./svgs/regular/microchip.svg": 5725,
	"./svgs/regular/microphone-alt-slash.svg": 5726,
	"./svgs/regular/microphone-alt.svg": 5727,
	"./svgs/regular/microphone-slash.svg": 5728,
	"./svgs/regular/microphone-stand.svg": 5729,
	"./svgs/regular/microphone.svg": 5730,
	"./svgs/regular/microscope.svg": 5731,
	"./svgs/regular/microwave.svg": 5732,
	"./svgs/regular/mind-share.svg": 5733,
	"./svgs/regular/minus-circle.svg": 5734,
	"./svgs/regular/minus-hexagon.svg": 5735,
	"./svgs/regular/minus-octagon.svg": 5736,
	"./svgs/regular/minus-square.svg": 5737,
	"./svgs/regular/minus.svg": 5738,
	"./svgs/regular/mistletoe.svg": 5739,
	"./svgs/regular/mitten.svg": 5740,
	"./svgs/regular/mobile-alt.svg": 5741,
	"./svgs/regular/mobile-android-alt.svg": 5742,
	"./svgs/regular/mobile-android.svg": 5743,
	"./svgs/regular/mobile.svg": 5744,
	"./svgs/regular/money-bill-alt.svg": 5745,
	"./svgs/regular/money-bill-wave-alt.svg": 5746,
	"./svgs/regular/money-bill-wave.svg": 5747,
	"./svgs/regular/money-bill.svg": 5748,
	"./svgs/regular/money-check-alt.svg": 5749,
	"./svgs/regular/money-check-edit-alt.svg": 5750,
	"./svgs/regular/money-check-edit.svg": 5751,
	"./svgs/regular/money-check.svg": 5752,
	"./svgs/regular/monitor-heart-rate.svg": 5753,
	"./svgs/regular/monkey.svg": 5754,
	"./svgs/regular/monument.svg": 5755,
	"./svgs/regular/moon-cloud.svg": 5756,
	"./svgs/regular/moon-stars.svg": 5757,
	"./svgs/regular/moon.svg": 5758,
	"./svgs/regular/mortar-pestle.svg": 5759,
	"./svgs/regular/mosque.svg": 5760,
	"./svgs/regular/motorcycle.svg": 5761,
	"./svgs/regular/mountain.svg": 5762,
	"./svgs/regular/mountains.svg": 5763,
	"./svgs/regular/mouse-alt.svg": 5764,
	"./svgs/regular/mouse-pointer.svg": 5765,
	"./svgs/regular/mouse.svg": 5766,
	"./svgs/regular/mp3-player.svg": 5767,
	"./svgs/regular/mug-hot.svg": 5768,
	"./svgs/regular/mug-marshmallows.svg": 5769,
	"./svgs/regular/mug-tea.svg": 5770,
	"./svgs/regular/mug.svg": 5771,
	"./svgs/regular/music-alt-slash.svg": 5772,
	"./svgs/regular/music-alt.svg": 5773,
	"./svgs/regular/music-slash.svg": 5774,
	"./svgs/regular/music.svg": 5775,
	"./svgs/regular/narwhal.svg": 5776,
	"./svgs/regular/network-wired.svg": 5777,
	"./svgs/regular/neuter.svg": 5778,
	"./svgs/regular/newspaper.svg": 5779,
	"./svgs/regular/not-equal.svg": 5780,
	"./svgs/regular/notes-medical.svg": 5781,
	"./svgs/regular/object-group.svg": 5782,
	"./svgs/regular/object-ungroup.svg": 5783,
	"./svgs/regular/octagon.svg": 5784,
	"./svgs/regular/oil-can.svg": 5785,
	"./svgs/regular/oil-temp.svg": 5786,
	"./svgs/regular/om.svg": 5787,
	"./svgs/regular/omega.svg": 5788,
	"./svgs/regular/ornament.svg": 5789,
	"./svgs/regular/otter.svg": 5790,
	"./svgs/regular/outdent.svg": 5791,
	"./svgs/regular/outlet.svg": 5792,
	"./svgs/regular/oven.svg": 5793,
	"./svgs/regular/overline.svg": 5794,
	"./svgs/regular/page-break.svg": 5795,
	"./svgs/regular/pager.svg": 5796,
	"./svgs/regular/paint-brush-alt.svg": 5797,
	"./svgs/regular/paint-brush.svg": 5798,
	"./svgs/regular/paint-roller.svg": 5799,
	"./svgs/regular/palette.svg": 5800,
	"./svgs/regular/pallet-alt.svg": 5801,
	"./svgs/regular/pallet.svg": 5802,
	"./svgs/regular/paper-plane.svg": 5803,
	"./svgs/regular/paperclip.svg": 5804,
	"./svgs/regular/parachute-box.svg": 5805,
	"./svgs/regular/paragraph-rtl.svg": 5806,
	"./svgs/regular/paragraph.svg": 5807,
	"./svgs/regular/parking-circle-slash.svg": 5808,
	"./svgs/regular/parking-circle.svg": 5809,
	"./svgs/regular/parking-slash.svg": 5810,
	"./svgs/regular/parking.svg": 5811,
	"./svgs/regular/passport.svg": 5812,
	"./svgs/regular/pastafarianism.svg": 5813,
	"./svgs/regular/paste.svg": 5814,
	"./svgs/regular/pause-circle.svg": 5815,
	"./svgs/regular/pause.svg": 5816,
	"./svgs/regular/paw-alt.svg": 5817,
	"./svgs/regular/paw-claws.svg": 5818,
	"./svgs/regular/paw.svg": 5819,
	"./svgs/regular/peace.svg": 5820,
	"./svgs/regular/pegasus.svg": 5821,
	"./svgs/regular/pen-alt.svg": 5822,
	"./svgs/regular/pen-fancy.svg": 5823,
	"./svgs/regular/pen-nib.svg": 5824,
	"./svgs/regular/pen-square.svg": 5825,
	"./svgs/regular/pen.svg": 5826,
	"./svgs/regular/pencil-alt.svg": 5827,
	"./svgs/regular/pencil-paintbrush.svg": 5828,
	"./svgs/regular/pencil-ruler.svg": 5829,
	"./svgs/regular/pencil.svg": 5830,
	"./svgs/regular/pennant.svg": 5831,
	"./svgs/regular/people-carry.svg": 5832,
	"./svgs/regular/pepper-hot.svg": 5833,
	"./svgs/regular/percent.svg": 5834,
	"./svgs/regular/percentage.svg": 5835,
	"./svgs/regular/person-booth.svg": 5836,
	"./svgs/regular/person-carry.svg": 5837,
	"./svgs/regular/person-dolly-empty.svg": 5838,
	"./svgs/regular/person-dolly.svg": 5839,
	"./svgs/regular/person-sign.svg": 5840,
	"./svgs/regular/phone-alt.svg": 5841,
	"./svgs/regular/phone-laptop.svg": 5842,
	"./svgs/regular/phone-office.svg": 5843,
	"./svgs/regular/phone-plus.svg": 5844,
	"./svgs/regular/phone-rotary.svg": 5845,
	"./svgs/regular/phone-slash.svg": 5846,
	"./svgs/regular/phone-square-alt.svg": 5847,
	"./svgs/regular/phone-square.svg": 5848,
	"./svgs/regular/phone-volume.svg": 5849,
	"./svgs/regular/phone.svg": 5850,
	"./svgs/regular/photo-video.svg": 5851,
	"./svgs/regular/pi.svg": 5852,
	"./svgs/regular/piano-keyboard.svg": 5853,
	"./svgs/regular/piano.svg": 5854,
	"./svgs/regular/pie.svg": 5855,
	"./svgs/regular/pig.svg": 5856,
	"./svgs/regular/piggy-bank.svg": 5857,
	"./svgs/regular/pills.svg": 5858,
	"./svgs/regular/pizza-slice.svg": 5859,
	"./svgs/regular/pizza.svg": 5860,
	"./svgs/regular/place-of-worship.svg": 5861,
	"./svgs/regular/plane-alt.svg": 5862,
	"./svgs/regular/plane-arrival.svg": 5863,
	"./svgs/regular/plane-departure.svg": 5864,
	"./svgs/regular/plane.svg": 5865,
	"./svgs/regular/planet-moon.svg": 5866,
	"./svgs/regular/planet-ringed.svg": 5867,
	"./svgs/regular/play-circle.svg": 5868,
	"./svgs/regular/play.svg": 5869,
	"./svgs/regular/plug.svg": 5870,
	"./svgs/regular/plus-circle.svg": 5871,
	"./svgs/regular/plus-hexagon.svg": 5872,
	"./svgs/regular/plus-octagon.svg": 5873,
	"./svgs/regular/plus-square.svg": 5874,
	"./svgs/regular/plus.svg": 5875,
	"./svgs/regular/podcast.svg": 5876,
	"./svgs/regular/podium-star.svg": 5877,
	"./svgs/regular/podium.svg": 5878,
	"./svgs/regular/police-box.svg": 5879,
	"./svgs/regular/poll-h.svg": 5880,
	"./svgs/regular/poll-people.svg": 5881,
	"./svgs/regular/poll.svg": 5882,
	"./svgs/regular/poo-storm.svg": 5883,
	"./svgs/regular/poo.svg": 5884,
	"./svgs/regular/poop.svg": 5885,
	"./svgs/regular/popcorn.svg": 5886,
	"./svgs/regular/portal-enter.svg": 5887,
	"./svgs/regular/portal-exit.svg": 5888,
	"./svgs/regular/portrait.svg": 5889,
	"./svgs/regular/pound-sign.svg": 5890,
	"./svgs/regular/power-off.svg": 5891,
	"./svgs/regular/pray.svg": 5892,
	"./svgs/regular/praying-hands.svg": 5893,
	"./svgs/regular/prescription-bottle-alt.svg": 5894,
	"./svgs/regular/prescription-bottle.svg": 5895,
	"./svgs/regular/prescription.svg": 5896,
	"./svgs/regular/presentation.svg": 5897,
	"./svgs/regular/print-search.svg": 5898,
	"./svgs/regular/print-slash.svg": 5899,
	"./svgs/regular/print.svg": 5900,
	"./svgs/regular/procedures.svg": 5901,
	"./svgs/regular/project-diagram.svg": 5902,
	"./svgs/regular/projector.svg": 5903,
	"./svgs/regular/pumpkin.svg": 5904,
	"./svgs/regular/puzzle-piece.svg": 5905,
	"./svgs/regular/qrcode.svg": 5906,
	"./svgs/regular/question-circle.svg": 5907,
	"./svgs/regular/question-square.svg": 5908,
	"./svgs/regular/question.svg": 5909,
	"./svgs/regular/quidditch.svg": 5910,
	"./svgs/regular/quote-left.svg": 5911,
	"./svgs/regular/quote-right.svg": 5912,
	"./svgs/regular/quran.svg": 5913,
	"./svgs/regular/rabbit-fast.svg": 5914,
	"./svgs/regular/rabbit.svg": 5915,
	"./svgs/regular/racquet.svg": 5916,
	"./svgs/regular/radar.svg": 5917,
	"./svgs/regular/radiation-alt.svg": 5918,
	"./svgs/regular/radiation.svg": 5919,
	"./svgs/regular/radio-alt.svg": 5920,
	"./svgs/regular/radio.svg": 5921,
	"./svgs/regular/rainbow.svg": 5922,
	"./svgs/regular/raindrops.svg": 5923,
	"./svgs/regular/ram.svg": 5924,
	"./svgs/regular/ramp-loading.svg": 5925,
	"./svgs/regular/random.svg": 5926,
	"./svgs/regular/raygun.svg": 5927,
	"./svgs/regular/receipt.svg": 5928,
	"./svgs/regular/record-vinyl.svg": 5929,
	"./svgs/regular/rectangle-landscape.svg": 5930,
	"./svgs/regular/rectangle-portrait.svg": 5931,
	"./svgs/regular/rectangle-wide.svg": 5932,
	"./svgs/regular/recycle.svg": 5933,
	"./svgs/regular/redo-alt.svg": 5934,
	"./svgs/regular/redo.svg": 5935,
	"./svgs/regular/refrigerator.svg": 5936,
	"./svgs/regular/registered.svg": 5937,
	"./svgs/regular/remove-format.svg": 5938,
	"./svgs/regular/repeat-1-alt.svg": 5939,
	"./svgs/regular/repeat-1.svg": 5940,
	"./svgs/regular/repeat-alt.svg": 5941,
	"./svgs/regular/repeat.svg": 5942,
	"./svgs/regular/reply-all.svg": 5943,
	"./svgs/regular/reply.svg": 5944,
	"./svgs/regular/republican.svg": 5945,
	"./svgs/regular/restroom.svg": 5946,
	"./svgs/regular/retweet-alt.svg": 5947,
	"./svgs/regular/retweet.svg": 5948,
	"./svgs/regular/ribbon.svg": 5949,
	"./svgs/regular/ring.svg": 5950,
	"./svgs/regular/rings-wedding.svg": 5951,
	"./svgs/regular/road.svg": 5952,
	"./svgs/regular/robot.svg": 5953,
	"./svgs/regular/rocket-launch.svg": 5954,
	"./svgs/regular/rocket.svg": 5955,
	"./svgs/regular/route-highway.svg": 5956,
	"./svgs/regular/route-interstate.svg": 5957,
	"./svgs/regular/route.svg": 5958,
	"./svgs/regular/router.svg": 5959,
	"./svgs/regular/rss-square.svg": 5960,
	"./svgs/regular/rss.svg": 5961,
	"./svgs/regular/ruble-sign.svg": 5962,
	"./svgs/regular/ruler-combined.svg": 5963,
	"./svgs/regular/ruler-horizontal.svg": 5964,
	"./svgs/regular/ruler-triangle.svg": 5965,
	"./svgs/regular/ruler-vertical.svg": 5966,
	"./svgs/regular/ruler.svg": 5967,
	"./svgs/regular/running.svg": 5968,
	"./svgs/regular/rupee-sign.svg": 5969,
	"./svgs/regular/rv.svg": 5970,
	"./svgs/regular/sack-dollar.svg": 5971,
	"./svgs/regular/sack.svg": 5972,
	"./svgs/regular/sad-cry.svg": 5973,
	"./svgs/regular/sad-tear.svg": 5974,
	"./svgs/regular/salad.svg": 5975,
	"./svgs/regular/sandwich.svg": 5976,
	"./svgs/regular/satellite-dish.svg": 5977,
	"./svgs/regular/satellite.svg": 5978,
	"./svgs/regular/sausage.svg": 5979,
	"./svgs/regular/save.svg": 5980,
	"./svgs/regular/sax-hot.svg": 5981,
	"./svgs/regular/saxophone.svg": 5982,
	"./svgs/regular/scalpel-path.svg": 5983,
	"./svgs/regular/scalpel.svg": 5984,
	"./svgs/regular/scanner-image.svg": 5985,
	"./svgs/regular/scanner-keyboard.svg": 5986,
	"./svgs/regular/scanner-touchscreen.svg": 5987,
	"./svgs/regular/scanner.svg": 5988,
	"./svgs/regular/scarecrow.svg": 5989,
	"./svgs/regular/scarf.svg": 5990,
	"./svgs/regular/school.svg": 5991,
	"./svgs/regular/screwdriver.svg": 5992,
	"./svgs/regular/scroll-old.svg": 5993,
	"./svgs/regular/scroll.svg": 5994,
	"./svgs/regular/scrubber.svg": 5995,
	"./svgs/regular/scythe.svg": 5996,
	"./svgs/regular/sd-card.svg": 5997,
	"./svgs/regular/search-dollar.svg": 5998,
	"./svgs/regular/search-location.svg": 5999,
	"./svgs/regular/search-minus.svg": 6000,
	"./svgs/regular/search-plus.svg": 6001,
	"./svgs/regular/search.svg": 6002,
	"./svgs/regular/seedling.svg": 6003,
	"./svgs/regular/send-back.svg": 6004,
	"./svgs/regular/send-backward.svg": 6005,
	"./svgs/regular/sensor-alert.svg": 6006,
	"./svgs/regular/sensor-fire.svg": 6007,
	"./svgs/regular/sensor-on.svg": 6008,
	"./svgs/regular/sensor-smoke.svg": 6009,
	"./svgs/regular/sensor.svg": 6010,
	"./svgs/regular/server.svg": 6011,
	"./svgs/regular/shapes.svg": 6012,
	"./svgs/regular/share-all.svg": 6013,
	"./svgs/regular/share-alt-square.svg": 6014,
	"./svgs/regular/share-alt.svg": 6015,
	"./svgs/regular/share-square.svg": 6016,
	"./svgs/regular/share.svg": 6017,
	"./svgs/regular/sheep.svg": 6018,
	"./svgs/regular/shekel-sign.svg": 6019,
	"./svgs/regular/shield-alt.svg": 6020,
	"./svgs/regular/shield-check.svg": 6021,
	"./svgs/regular/shield-cross.svg": 6022,
	"./svgs/regular/shield.svg": 6023,
	"./svgs/regular/ship.svg": 6024,
	"./svgs/regular/shipping-fast.svg": 6025,
	"./svgs/regular/shipping-timed.svg": 6026,
	"./svgs/regular/shish-kebab.svg": 6027,
	"./svgs/regular/shoe-prints.svg": 6028,
	"./svgs/regular/shopping-bag.svg": 6029,
	"./svgs/regular/shopping-basket.svg": 6030,
	"./svgs/regular/shopping-cart.svg": 6031,
	"./svgs/regular/shovel-snow.svg": 6032,
	"./svgs/regular/shovel.svg": 6033,
	"./svgs/regular/shower.svg": 6034,
	"./svgs/regular/shredder.svg": 6035,
	"./svgs/regular/shuttle-van.svg": 6036,
	"./svgs/regular/shuttlecock.svg": 6037,
	"./svgs/regular/sickle.svg": 6038,
	"./svgs/regular/sigma.svg": 6039,
	"./svgs/regular/sign-in-alt.svg": 6040,
	"./svgs/regular/sign-in.svg": 6041,
	"./svgs/regular/sign-language.svg": 6042,
	"./svgs/regular/sign-out-alt.svg": 6043,
	"./svgs/regular/sign-out.svg": 6044,
	"./svgs/regular/sign.svg": 6045,
	"./svgs/regular/signal-1.svg": 6046,
	"./svgs/regular/signal-2.svg": 6047,
	"./svgs/regular/signal-3.svg": 6048,
	"./svgs/regular/signal-4.svg": 6049,
	"./svgs/regular/signal-alt-1.svg": 6050,
	"./svgs/regular/signal-alt-2.svg": 6051,
	"./svgs/regular/signal-alt-3.svg": 6052,
	"./svgs/regular/signal-alt-slash.svg": 6053,
	"./svgs/regular/signal-alt.svg": 6054,
	"./svgs/regular/signal-slash.svg": 6055,
	"./svgs/regular/signal-stream.svg": 6056,
	"./svgs/regular/signal.svg": 6057,
	"./svgs/regular/signature.svg": 6058,
	"./svgs/regular/sim-card.svg": 6059,
	"./svgs/regular/siren-on.svg": 6060,
	"./svgs/regular/siren.svg": 6061,
	"./svgs/regular/sitemap.svg": 6062,
	"./svgs/regular/skating.svg": 6063,
	"./svgs/regular/skeleton.svg": 6064,
	"./svgs/regular/ski-jump.svg": 6065,
	"./svgs/regular/ski-lift.svg": 6066,
	"./svgs/regular/skiing-nordic.svg": 6067,
	"./svgs/regular/skiing.svg": 6068,
	"./svgs/regular/skull-cow.svg": 6069,
	"./svgs/regular/skull-crossbones.svg": 6070,
	"./svgs/regular/skull.svg": 6071,
	"./svgs/regular/slash.svg": 6072,
	"./svgs/regular/sledding.svg": 6073,
	"./svgs/regular/sleigh.svg": 6074,
	"./svgs/regular/sliders-h-square.svg": 6075,
	"./svgs/regular/sliders-h.svg": 6076,
	"./svgs/regular/sliders-v-square.svg": 6077,
	"./svgs/regular/sliders-v.svg": 6078,
	"./svgs/regular/smile-beam.svg": 6079,
	"./svgs/regular/smile-plus.svg": 6080,
	"./svgs/regular/smile-wink.svg": 6081,
	"./svgs/regular/smile.svg": 6082,
	"./svgs/regular/smog.svg": 6083,
	"./svgs/regular/smoke.svg": 6084,
	"./svgs/regular/smoking-ban.svg": 6085,
	"./svgs/regular/smoking.svg": 6086,
	"./svgs/regular/sms.svg": 6087,
	"./svgs/regular/snake.svg": 6088,
	"./svgs/regular/snooze.svg": 6089,
	"./svgs/regular/snow-blowing.svg": 6090,
	"./svgs/regular/snowboarding.svg": 6091,
	"./svgs/regular/snowflake.svg": 6092,
	"./svgs/regular/snowflakes.svg": 6093,
	"./svgs/regular/snowman.svg": 6094,
	"./svgs/regular/snowmobile.svg": 6095,
	"./svgs/regular/snowplow.svg": 6096,
	"./svgs/regular/socks.svg": 6097,
	"./svgs/regular/solar-panel.svg": 6098,
	"./svgs/regular/solar-system.svg": 6099,
	"./svgs/regular/sort-alpha-down-alt.svg": 6100,
	"./svgs/regular/sort-alpha-down.svg": 6101,
	"./svgs/regular/sort-alpha-up-alt.svg": 6102,
	"./svgs/regular/sort-alpha-up.svg": 6103,
	"./svgs/regular/sort-alt.svg": 6104,
	"./svgs/regular/sort-amount-down-alt.svg": 6105,
	"./svgs/regular/sort-amount-down.svg": 6106,
	"./svgs/regular/sort-amount-up-alt.svg": 6107,
	"./svgs/regular/sort-amount-up.svg": 6108,
	"./svgs/regular/sort-circle-down.svg": 6109,
	"./svgs/regular/sort-circle-up.svg": 6110,
	"./svgs/regular/sort-circle.svg": 6111,
	"./svgs/regular/sort-down.svg": 6112,
	"./svgs/regular/sort-numeric-down-alt.svg": 6113,
	"./svgs/regular/sort-numeric-down.svg": 6114,
	"./svgs/regular/sort-numeric-up-alt.svg": 6115,
	"./svgs/regular/sort-numeric-up.svg": 6116,
	"./svgs/regular/sort-shapes-down-alt.svg": 6117,
	"./svgs/regular/sort-shapes-down.svg": 6118,
	"./svgs/regular/sort-shapes-up-alt.svg": 6119,
	"./svgs/regular/sort-shapes-up.svg": 6120,
	"./svgs/regular/sort-size-down-alt.svg": 6121,
	"./svgs/regular/sort-size-down.svg": 6122,
	"./svgs/regular/sort-size-up-alt.svg": 6123,
	"./svgs/regular/sort-size-up.svg": 6124,
	"./svgs/regular/sort-up.svg": 6125,
	"./svgs/regular/sort.svg": 6126,
	"./svgs/regular/soup.svg": 6127,
	"./svgs/regular/spa.svg": 6128,
	"./svgs/regular/space-shuttle.svg": 6129,
	"./svgs/regular/space-station-moon-alt.svg": 6130,
	"./svgs/regular/space-station-moon.svg": 6131,
	"./svgs/regular/spade.svg": 6132,
	"./svgs/regular/sparkles.svg": 6133,
	"./svgs/regular/speaker.svg": 6134,
	"./svgs/regular/speakers.svg": 6135,
	"./svgs/regular/spell-check.svg": 6136,
	"./svgs/regular/spider-black-widow.svg": 6137,
	"./svgs/regular/spider-web.svg": 6138,
	"./svgs/regular/spider.svg": 6139,
	"./svgs/regular/spinner-third.svg": 6140,
	"./svgs/regular/spinner.svg": 6141,
	"./svgs/regular/splotch.svg": 6142,
	"./svgs/regular/spray-can.svg": 6143,
	"./svgs/regular/sprinkler.svg": 6144,
	"./svgs/regular/square-full.svg": 6145,
	"./svgs/regular/square-root-alt.svg": 6146,
	"./svgs/regular/square-root.svg": 6147,
	"./svgs/regular/square.svg": 6148,
	"./svgs/regular/squirrel.svg": 6149,
	"./svgs/regular/staff.svg": 6150,
	"./svgs/regular/stamp.svg": 6151,
	"./svgs/regular/star-and-crescent.svg": 6152,
	"./svgs/regular/star-christmas.svg": 6153,
	"./svgs/regular/star-exclamation.svg": 6154,
	"./svgs/regular/star-half-alt.svg": 6155,
	"./svgs/regular/star-half.svg": 6156,
	"./svgs/regular/star-of-david.svg": 6157,
	"./svgs/regular/star-of-life.svg": 6158,
	"./svgs/regular/star-shooting.svg": 6159,
	"./svgs/regular/star.svg": 6160,
	"./svgs/regular/starfighter-alt.svg": 6161,
	"./svgs/regular/starfighter.svg": 6162,
	"./svgs/regular/stars.svg": 6163,
	"./svgs/regular/starship-freighter.svg": 6164,
	"./svgs/regular/starship.svg": 6165,
	"./svgs/regular/steak.svg": 6166,
	"./svgs/regular/steering-wheel.svg": 6167,
	"./svgs/regular/step-backward.svg": 6168,
	"./svgs/regular/step-forward.svg": 6169,
	"./svgs/regular/stethoscope.svg": 6170,
	"./svgs/regular/sticky-note.svg": 6171,
	"./svgs/regular/stocking.svg": 6172,
	"./svgs/regular/stomach.svg": 6173,
	"./svgs/regular/stop-circle.svg": 6174,
	"./svgs/regular/stop.svg": 6175,
	"./svgs/regular/stopwatch.svg": 6176,
	"./svgs/regular/store-alt.svg": 6177,
	"./svgs/regular/store.svg": 6178,
	"./svgs/regular/stream.svg": 6179,
	"./svgs/regular/street-view.svg": 6180,
	"./svgs/regular/stretcher.svg": 6181,
	"./svgs/regular/strikethrough.svg": 6182,
	"./svgs/regular/stroopwafel.svg": 6183,
	"./svgs/regular/subscript.svg": 6184,
	"./svgs/regular/subway.svg": 6185,
	"./svgs/regular/suitcase-rolling.svg": 6186,
	"./svgs/regular/suitcase.svg": 6187,
	"./svgs/regular/sun-cloud.svg": 6188,
	"./svgs/regular/sun-dust.svg": 6189,
	"./svgs/regular/sun-haze.svg": 6190,
	"./svgs/regular/sun.svg": 6191,
	"./svgs/regular/sunglasses.svg": 6192,
	"./svgs/regular/sunrise.svg": 6193,
	"./svgs/regular/sunset.svg": 6194,
	"./svgs/regular/superscript.svg": 6195,
	"./svgs/regular/surprise.svg": 6196,
	"./svgs/regular/swatchbook.svg": 6197,
	"./svgs/regular/swimmer.svg": 6198,
	"./svgs/regular/swimming-pool.svg": 6199,
	"./svgs/regular/sword-laser-alt.svg": 6200,
	"./svgs/regular/sword-laser.svg": 6201,
	"./svgs/regular/sword.svg": 6202,
	"./svgs/regular/swords-laser.svg": 6203,
	"./svgs/regular/swords.svg": 6204,
	"./svgs/regular/synagogue.svg": 6205,
	"./svgs/regular/sync-alt.svg": 6206,
	"./svgs/regular/sync.svg": 6207,
	"./svgs/regular/syringe.svg": 6208,
	"./svgs/regular/table-tennis.svg": 6209,
	"./svgs/regular/table.svg": 6210,
	"./svgs/regular/tablet-alt.svg": 6211,
	"./svgs/regular/tablet-android-alt.svg": 6212,
	"./svgs/regular/tablet-android.svg": 6213,
	"./svgs/regular/tablet-rugged.svg": 6214,
	"./svgs/regular/tablet.svg": 6215,
	"./svgs/regular/tablets.svg": 6216,
	"./svgs/regular/tachometer-alt-average.svg": 6217,
	"./svgs/regular/tachometer-alt-fast.svg": 6218,
	"./svgs/regular/tachometer-alt-fastest.svg": 6219,
	"./svgs/regular/tachometer-alt-slow.svg": 6220,
	"./svgs/regular/tachometer-alt-slowest.svg": 6221,
	"./svgs/regular/tachometer-alt.svg": 6222,
	"./svgs/regular/tachometer-average.svg": 6223,
	"./svgs/regular/tachometer-fast.svg": 6224,
	"./svgs/regular/tachometer-fastest.svg": 6225,
	"./svgs/regular/tachometer-slow.svg": 6226,
	"./svgs/regular/tachometer-slowest.svg": 6227,
	"./svgs/regular/tachometer.svg": 6228,
	"./svgs/regular/taco.svg": 6229,
	"./svgs/regular/tag.svg": 6230,
	"./svgs/regular/tags.svg": 6231,
	"./svgs/regular/tally.svg": 6232,
	"./svgs/regular/tanakh.svg": 6233,
	"./svgs/regular/tape.svg": 6234,
	"./svgs/regular/tasks-alt.svg": 6235,
	"./svgs/regular/tasks.svg": 6236,
	"./svgs/regular/taxi.svg": 6237,
	"./svgs/regular/teeth-open.svg": 6238,
	"./svgs/regular/teeth.svg": 6239,
	"./svgs/regular/telescope.svg": 6240,
	"./svgs/regular/temperature-down.svg": 6241,
	"./svgs/regular/temperature-frigid.svg": 6242,
	"./svgs/regular/temperature-high.svg": 6243,
	"./svgs/regular/temperature-hot.svg": 6244,
	"./svgs/regular/temperature-low.svg": 6245,
	"./svgs/regular/temperature-up.svg": 6246,
	"./svgs/regular/tenge.svg": 6247,
	"./svgs/regular/tennis-ball.svg": 6248,
	"./svgs/regular/terminal.svg": 6249,
	"./svgs/regular/text-height.svg": 6250,
	"./svgs/regular/text-size.svg": 6251,
	"./svgs/regular/text-width.svg": 6252,
	"./svgs/regular/text.svg": 6253,
	"./svgs/regular/th-large.svg": 6254,
	"./svgs/regular/th-list.svg": 6255,
	"./svgs/regular/th.svg": 6256,
	"./svgs/regular/theater-masks.svg": 6257,
	"./svgs/regular/thermometer-empty.svg": 6258,
	"./svgs/regular/thermometer-full.svg": 6259,
	"./svgs/regular/thermometer-half.svg": 6260,
	"./svgs/regular/thermometer-quarter.svg": 6261,
	"./svgs/regular/thermometer-three-quarters.svg": 6262,
	"./svgs/regular/thermometer.svg": 6263,
	"./svgs/regular/theta.svg": 6264,
	"./svgs/regular/thumbs-down.svg": 6265,
	"./svgs/regular/thumbs-up.svg": 6266,
	"./svgs/regular/thumbtack.svg": 6267,
	"./svgs/regular/thunderstorm-moon.svg": 6268,
	"./svgs/regular/thunderstorm-sun.svg": 6269,
	"./svgs/regular/thunderstorm.svg": 6270,
	"./svgs/regular/ticket-alt.svg": 6271,
	"./svgs/regular/ticket.svg": 6272,
	"./svgs/regular/tilde.svg": 6273,
	"./svgs/regular/times-circle.svg": 6274,
	"./svgs/regular/times-hexagon.svg": 6275,
	"./svgs/regular/times-octagon.svg": 6276,
	"./svgs/regular/times-square.svg": 6277,
	"./svgs/regular/times.svg": 6278,
	"./svgs/regular/tint-slash.svg": 6279,
	"./svgs/regular/tint.svg": 6280,
	"./svgs/regular/tire-flat.svg": 6281,
	"./svgs/regular/tire-pressure-warning.svg": 6282,
	"./svgs/regular/tire-rugged.svg": 6283,
	"./svgs/regular/tire.svg": 6284,
	"./svgs/regular/tired.svg": 6285,
	"./svgs/regular/toggle-off.svg": 6286,
	"./svgs/regular/toggle-on.svg": 6287,
	"./svgs/regular/toilet-paper-alt.svg": 6288,
	"./svgs/regular/toilet-paper.svg": 6289,
	"./svgs/regular/toilet.svg": 6290,
	"./svgs/regular/tombstone-alt.svg": 6291,
	"./svgs/regular/tombstone.svg": 6292,
	"./svgs/regular/toolbox.svg": 6293,
	"./svgs/regular/tools.svg": 6294,
	"./svgs/regular/tooth.svg": 6295,
	"./svgs/regular/toothbrush.svg": 6296,
	"./svgs/regular/torah.svg": 6297,
	"./svgs/regular/torii-gate.svg": 6298,
	"./svgs/regular/tornado.svg": 6299,
	"./svgs/regular/tractor.svg": 6300,
	"./svgs/regular/trademark.svg": 6301,
	"./svgs/regular/traffic-cone.svg": 6302,
	"./svgs/regular/traffic-light-go.svg": 6303,
	"./svgs/regular/traffic-light-slow.svg": 6304,
	"./svgs/regular/traffic-light-stop.svg": 6305,
	"./svgs/regular/traffic-light.svg": 6306,
	"./svgs/regular/trailer.svg": 6307,
	"./svgs/regular/train.svg": 6308,
	"./svgs/regular/tram.svg": 6309,
	"./svgs/regular/transgender-alt.svg": 6310,
	"./svgs/regular/transgender.svg": 6311,
	"./svgs/regular/transporter-1.svg": 6312,
	"./svgs/regular/transporter-2.svg": 6313,
	"./svgs/regular/transporter-3.svg": 6314,
	"./svgs/regular/transporter-empty.svg": 6315,
	"./svgs/regular/transporter.svg": 6316,
	"./svgs/regular/trash-alt.svg": 6317,
	"./svgs/regular/trash-restore-alt.svg": 6318,
	"./svgs/regular/trash-restore.svg": 6319,
	"./svgs/regular/trash-undo-alt.svg": 6320,
	"./svgs/regular/trash-undo.svg": 6321,
	"./svgs/regular/trash.svg": 6322,
	"./svgs/regular/treasure-chest.svg": 6323,
	"./svgs/regular/tree-alt.svg": 6324,
	"./svgs/regular/tree-christmas.svg": 6325,
	"./svgs/regular/tree-decorated.svg": 6326,
	"./svgs/regular/tree-large.svg": 6327,
	"./svgs/regular/tree-palm.svg": 6328,
	"./svgs/regular/tree.svg": 6329,
	"./svgs/regular/trees.svg": 6330,
	"./svgs/regular/triangle-music.svg": 6331,
	"./svgs/regular/triangle.svg": 6332,
	"./svgs/regular/trophy-alt.svg": 6333,
	"./svgs/regular/trophy.svg": 6334,
	"./svgs/regular/truck-container.svg": 6335,
	"./svgs/regular/truck-couch.svg": 6336,
	"./svgs/regular/truck-loading.svg": 6337,
	"./svgs/regular/truck-monster.svg": 6338,
	"./svgs/regular/truck-moving.svg": 6339,
	"./svgs/regular/truck-pickup.svg": 6340,
	"./svgs/regular/truck-plow.svg": 6341,
	"./svgs/regular/truck-ramp.svg": 6342,
	"./svgs/regular/truck.svg": 6343,
	"./svgs/regular/trumpet.svg": 6344,
	"./svgs/regular/tshirt.svg": 6345,
	"./svgs/regular/tty.svg": 6346,
	"./svgs/regular/turkey.svg": 6347,
	"./svgs/regular/turntable.svg": 6348,
	"./svgs/regular/turtle.svg": 6349,
	"./svgs/regular/tv-alt.svg": 6350,
	"./svgs/regular/tv-music.svg": 6351,
	"./svgs/regular/tv-retro.svg": 6352,
	"./svgs/regular/tv.svg": 6353,
	"./svgs/regular/typewriter.svg": 6354,
	"./svgs/regular/ufo-beam.svg": 6355,
	"./svgs/regular/ufo.svg": 6356,
	"./svgs/regular/umbrella-beach.svg": 6357,
	"./svgs/regular/umbrella.svg": 6358,
	"./svgs/regular/underline.svg": 6359,
	"./svgs/regular/undo-alt.svg": 6360,
	"./svgs/regular/undo.svg": 6361,
	"./svgs/regular/unicorn.svg": 6362,
	"./svgs/regular/union.svg": 6363,
	"./svgs/regular/universal-access.svg": 6364,
	"./svgs/regular/university.svg": 6365,
	"./svgs/regular/unlink.svg": 6366,
	"./svgs/regular/unlock-alt.svg": 6367,
	"./svgs/regular/unlock.svg": 6368,
	"./svgs/regular/upload.svg": 6369,
	"./svgs/regular/usb-drive.svg": 6370,
	"./svgs/regular/usd-circle.svg": 6371,
	"./svgs/regular/usd-square.svg": 6372,
	"./svgs/regular/user-alien.svg": 6373,
	"./svgs/regular/user-alt-slash.svg": 6374,
	"./svgs/regular/user-alt.svg": 6375,
	"./svgs/regular/user-astronaut.svg": 6376,
	"./svgs/regular/user-chart.svg": 6377,
	"./svgs/regular/user-check.svg": 6378,
	"./svgs/regular/user-circle.svg": 6379,
	"./svgs/regular/user-clock.svg": 6380,
	"./svgs/regular/user-cog.svg": 6381,
	"./svgs/regular/user-cowboy.svg": 6382,
	"./svgs/regular/user-crown.svg": 6383,
	"./svgs/regular/user-edit.svg": 6384,
	"./svgs/regular/user-friends.svg": 6385,
	"./svgs/regular/user-graduate.svg": 6386,
	"./svgs/regular/user-hard-hat.svg": 6387,
	"./svgs/regular/user-headset.svg": 6388,
	"./svgs/regular/user-injured.svg": 6389,
	"./svgs/regular/user-lock.svg": 6390,
	"./svgs/regular/user-md-chat.svg": 6391,
	"./svgs/regular/user-md.svg": 6392,
	"./svgs/regular/user-minus.svg": 6393,
	"./svgs/regular/user-music.svg": 6394,
	"./svgs/regular/user-ninja.svg": 6395,
	"./svgs/regular/user-nurse.svg": 6396,
	"./svgs/regular/user-plus.svg": 6397,
	"./svgs/regular/user-robot.svg": 6398,
	"./svgs/regular/user-secret.svg": 6399,
	"./svgs/regular/user-shield.svg": 6400,
	"./svgs/regular/user-slash.svg": 6401,
	"./svgs/regular/user-tag.svg": 6402,
	"./svgs/regular/user-tie.svg": 6403,
	"./svgs/regular/user-times.svg": 6404,
	"./svgs/regular/user-visor.svg": 6405,
	"./svgs/regular/user.svg": 6406,
	"./svgs/regular/users-class.svg": 6407,
	"./svgs/regular/users-cog.svg": 6408,
	"./svgs/regular/users-crown.svg": 6409,
	"./svgs/regular/users-medical.svg": 6410,
	"./svgs/regular/users.svg": 6411,
	"./svgs/regular/utensil-fork.svg": 6412,
	"./svgs/regular/utensil-knife.svg": 6413,
	"./svgs/regular/utensil-spoon.svg": 6414,
	"./svgs/regular/utensils-alt.svg": 6415,
	"./svgs/regular/utensils.svg": 6416,
	"./svgs/regular/vacuum-robot.svg": 6417,
	"./svgs/regular/vacuum.svg": 6418,
	"./svgs/regular/value-absolute.svg": 6419,
	"./svgs/regular/vector-square.svg": 6420,
	"./svgs/regular/venus-double.svg": 6421,
	"./svgs/regular/venus-mars.svg": 6422,
	"./svgs/regular/venus.svg": 6423,
	"./svgs/regular/vhs.svg": 6424,
	"./svgs/regular/vial.svg": 6425,
	"./svgs/regular/vials.svg": 6426,
	"./svgs/regular/video-plus.svg": 6427,
	"./svgs/regular/video-slash.svg": 6428,
	"./svgs/regular/video.svg": 6429,
	"./svgs/regular/vihara.svg": 6430,
	"./svgs/regular/violin.svg": 6431,
	"./svgs/regular/voicemail.svg": 6432,
	"./svgs/regular/volcano.svg": 6433,
	"./svgs/regular/volleyball-ball.svg": 6434,
	"./svgs/regular/volume-down.svg": 6435,
	"./svgs/regular/volume-mute.svg": 6436,
	"./svgs/regular/volume-off.svg": 6437,
	"./svgs/regular/volume-slash.svg": 6438,
	"./svgs/regular/volume-up.svg": 6439,
	"./svgs/regular/volume.svg": 6440,
	"./svgs/regular/vote-nay.svg": 6441,
	"./svgs/regular/vote-yea.svg": 6442,
	"./svgs/regular/vr-cardboard.svg": 6443,
	"./svgs/regular/wagon-covered.svg": 6444,
	"./svgs/regular/walker.svg": 6445,
	"./svgs/regular/walkie-talkie.svg": 6446,
	"./svgs/regular/walking.svg": 6447,
	"./svgs/regular/wallet.svg": 6448,
	"./svgs/regular/wand-magic.svg": 6449,
	"./svgs/regular/wand.svg": 6450,
	"./svgs/regular/warehouse-alt.svg": 6451,
	"./svgs/regular/warehouse.svg": 6452,
	"./svgs/regular/washer.svg": 6453,
	"./svgs/regular/watch-calculator.svg": 6454,
	"./svgs/regular/watch-fitness.svg": 6455,
	"./svgs/regular/watch.svg": 6456,
	"./svgs/regular/water-lower.svg": 6457,
	"./svgs/regular/water-rise.svg": 6458,
	"./svgs/regular/water.svg": 6459,
	"./svgs/regular/wave-sine.svg": 6460,
	"./svgs/regular/wave-square.svg": 6461,
	"./svgs/regular/wave-triangle.svg": 6462,
	"./svgs/regular/waveform-path.svg": 6463,
	"./svgs/regular/waveform.svg": 6464,
	"./svgs/regular/webcam-slash.svg": 6465,
	"./svgs/regular/webcam.svg": 6466,
	"./svgs/regular/weight-hanging.svg": 6467,
	"./svgs/regular/weight.svg": 6468,
	"./svgs/regular/whale.svg": 6469,
	"./svgs/regular/wheat.svg": 6470,
	"./svgs/regular/wheelchair.svg": 6471,
	"./svgs/regular/whistle.svg": 6472,
	"./svgs/regular/wifi-1.svg": 6473,
	"./svgs/regular/wifi-2.svg": 6474,
	"./svgs/regular/wifi-slash.svg": 6475,
	"./svgs/regular/wifi.svg": 6476,
	"./svgs/regular/wind-turbine.svg": 6477,
	"./svgs/regular/wind-warning.svg": 6478,
	"./svgs/regular/wind.svg": 6479,
	"./svgs/regular/window-alt.svg": 6480,
	"./svgs/regular/window-close.svg": 6481,
	"./svgs/regular/window-frame-open.svg": 6482,
	"./svgs/regular/window-frame.svg": 6483,
	"./svgs/regular/window-maximize.svg": 6484,
	"./svgs/regular/window-minimize.svg": 6485,
	"./svgs/regular/window-restore.svg": 6486,
	"./svgs/regular/window.svg": 6487,
	"./svgs/regular/windsock.svg": 6488,
	"./svgs/regular/wine-bottle.svg": 6489,
	"./svgs/regular/wine-glass-alt.svg": 6490,
	"./svgs/regular/wine-glass.svg": 6491,
	"./svgs/regular/won-sign.svg": 6492,
	"./svgs/regular/wreath.svg": 6493,
	"./svgs/regular/wrench.svg": 6494,
	"./svgs/regular/x-ray.svg": 6495,
	"./svgs/regular/yen-sign.svg": 6496,
	"./svgs/regular/yin-yang.svg": 6497,
	"./svgs/solid/abacus.svg": 6498,
	"./svgs/solid/acorn.svg": 6499,
	"./svgs/solid/ad.svg": 6500,
	"./svgs/solid/address-book.svg": 6501,
	"./svgs/solid/address-card.svg": 6502,
	"./svgs/solid/adjust.svg": 6503,
	"./svgs/solid/air-conditioner.svg": 6504,
	"./svgs/solid/air-freshener.svg": 6505,
	"./svgs/solid/alarm-clock.svg": 6506,
	"./svgs/solid/alarm-exclamation.svg": 6507,
	"./svgs/solid/alarm-plus.svg": 6508,
	"./svgs/solid/alarm-snooze.svg": 6509,
	"./svgs/solid/album-collection.svg": 6510,
	"./svgs/solid/album.svg": 6511,
	"./svgs/solid/alicorn.svg": 6512,
	"./svgs/solid/alien-monster.svg": 6513,
	"./svgs/solid/alien.svg": 6514,
	"./svgs/solid/align-center.svg": 6515,
	"./svgs/solid/align-justify.svg": 6516,
	"./svgs/solid/align-left.svg": 6517,
	"./svgs/solid/align-right.svg": 6518,
	"./svgs/solid/align-slash.svg": 6519,
	"./svgs/solid/allergies.svg": 6520,
	"./svgs/solid/ambulance.svg": 6521,
	"./svgs/solid/american-sign-language-interpreting.svg": 6522,
	"./svgs/solid/amp-guitar.svg": 6523,
	"./svgs/solid/analytics.svg": 6524,
	"./svgs/solid/anchor.svg": 6525,
	"./svgs/solid/angel.svg": 6526,
	"./svgs/solid/angle-double-down.svg": 6527,
	"./svgs/solid/angle-double-left.svg": 6528,
	"./svgs/solid/angle-double-right.svg": 6529,
	"./svgs/solid/angle-double-up.svg": 6530,
	"./svgs/solid/angle-down.svg": 6531,
	"./svgs/solid/angle-left.svg": 6532,
	"./svgs/solid/angle-right.svg": 6533,
	"./svgs/solid/angle-up.svg": 6534,
	"./svgs/solid/angry.svg": 6535,
	"./svgs/solid/ankh.svg": 6536,
	"./svgs/solid/apple-alt.svg": 6537,
	"./svgs/solid/apple-crate.svg": 6538,
	"./svgs/solid/archive.svg": 6539,
	"./svgs/solid/archway.svg": 6540,
	"./svgs/solid/arrow-alt-circle-down.svg": 6541,
	"./svgs/solid/arrow-alt-circle-left.svg": 6542,
	"./svgs/solid/arrow-alt-circle-right.svg": 6543,
	"./svgs/solid/arrow-alt-circle-up.svg": 6544,
	"./svgs/solid/arrow-alt-down.svg": 6545,
	"./svgs/solid/arrow-alt-from-bottom.svg": 6546,
	"./svgs/solid/arrow-alt-from-left.svg": 6547,
	"./svgs/solid/arrow-alt-from-right.svg": 6548,
	"./svgs/solid/arrow-alt-from-top.svg": 6549,
	"./svgs/solid/arrow-alt-left.svg": 6550,
	"./svgs/solid/arrow-alt-right.svg": 6551,
	"./svgs/solid/arrow-alt-square-down.svg": 6552,
	"./svgs/solid/arrow-alt-square-left.svg": 6553,
	"./svgs/solid/arrow-alt-square-right.svg": 6554,
	"./svgs/solid/arrow-alt-square-up.svg": 6555,
	"./svgs/solid/arrow-alt-to-bottom.svg": 6556,
	"./svgs/solid/arrow-alt-to-left.svg": 6557,
	"./svgs/solid/arrow-alt-to-right.svg": 6558,
	"./svgs/solid/arrow-alt-to-top.svg": 6559,
	"./svgs/solid/arrow-alt-up.svg": 6560,
	"./svgs/solid/arrow-circle-down.svg": 6561,
	"./svgs/solid/arrow-circle-left.svg": 6562,
	"./svgs/solid/arrow-circle-right.svg": 6563,
	"./svgs/solid/arrow-circle-up.svg": 6564,
	"./svgs/solid/arrow-down.svg": 6565,
	"./svgs/solid/arrow-from-bottom.svg": 6566,
	"./svgs/solid/arrow-from-left.svg": 6567,
	"./svgs/solid/arrow-from-right.svg": 6568,
	"./svgs/solid/arrow-from-top.svg": 6569,
	"./svgs/solid/arrow-left.svg": 6570,
	"./svgs/solid/arrow-right.svg": 6571,
	"./svgs/solid/arrow-square-down.svg": 6572,
	"./svgs/solid/arrow-square-left.svg": 6573,
	"./svgs/solid/arrow-square-right.svg": 6574,
	"./svgs/solid/arrow-square-up.svg": 6575,
	"./svgs/solid/arrow-to-bottom.svg": 6576,
	"./svgs/solid/arrow-to-left.svg": 6577,
	"./svgs/solid/arrow-to-right.svg": 6578,
	"./svgs/solid/arrow-to-top.svg": 6579,
	"./svgs/solid/arrow-up.svg": 6580,
	"./svgs/solid/arrows-alt-h.svg": 6581,
	"./svgs/solid/arrows-alt-v.svg": 6582,
	"./svgs/solid/arrows-alt.svg": 6583,
	"./svgs/solid/arrows-h.svg": 6584,
	"./svgs/solid/arrows-v.svg": 6585,
	"./svgs/solid/arrows.svg": 6586,
	"./svgs/solid/assistive-listening-systems.svg": 6587,
	"./svgs/solid/asterisk.svg": 6588,
	"./svgs/solid/at.svg": 6589,
	"./svgs/solid/atlas.svg": 6590,
	"./svgs/solid/atom-alt.svg": 6591,
	"./svgs/solid/atom.svg": 6592,
	"./svgs/solid/audio-description.svg": 6593,
	"./svgs/solid/award.svg": 6594,
	"./svgs/solid/axe-battle.svg": 6595,
	"./svgs/solid/axe.svg": 6596,
	"./svgs/solid/baby-carriage.svg": 6597,
	"./svgs/solid/baby.svg": 6598,
	"./svgs/solid/backpack.svg": 6599,
	"./svgs/solid/backspace.svg": 6600,
	"./svgs/solid/backward.svg": 6601,
	"./svgs/solid/bacon.svg": 6602,
	"./svgs/solid/badge-check.svg": 6603,
	"./svgs/solid/badge-dollar.svg": 6604,
	"./svgs/solid/badge-percent.svg": 6605,
	"./svgs/solid/badge-sheriff.svg": 6606,
	"./svgs/solid/badge.svg": 6607,
	"./svgs/solid/badger-honey.svg": 6608,
	"./svgs/solid/bags-shopping.svg": 6609,
	"./svgs/solid/bahai.svg": 6610,
	"./svgs/solid/balance-scale-left.svg": 6611,
	"./svgs/solid/balance-scale-right.svg": 6612,
	"./svgs/solid/balance-scale.svg": 6613,
	"./svgs/solid/ball-pile.svg": 6614,
	"./svgs/solid/ballot-check.svg": 6615,
	"./svgs/solid/ballot.svg": 6616,
	"./svgs/solid/ban.svg": 6617,
	"./svgs/solid/band-aid.svg": 6618,
	"./svgs/solid/banjo.svg": 6619,
	"./svgs/solid/barcode-alt.svg": 6620,
	"./svgs/solid/barcode-read.svg": 6621,
	"./svgs/solid/barcode-scan.svg": 6622,
	"./svgs/solid/barcode.svg": 6623,
	"./svgs/solid/bars.svg": 6624,
	"./svgs/solid/baseball-ball.svg": 6625,
	"./svgs/solid/baseball.svg": 6626,
	"./svgs/solid/basketball-ball.svg": 6627,
	"./svgs/solid/basketball-hoop.svg": 6628,
	"./svgs/solid/bat.svg": 6629,
	"./svgs/solid/bath.svg": 6630,
	"./svgs/solid/battery-bolt.svg": 6631,
	"./svgs/solid/battery-empty.svg": 6632,
	"./svgs/solid/battery-full.svg": 6633,
	"./svgs/solid/battery-half.svg": 6634,
	"./svgs/solid/battery-quarter.svg": 6635,
	"./svgs/solid/battery-slash.svg": 6636,
	"./svgs/solid/battery-three-quarters.svg": 6637,
	"./svgs/solid/bed-alt.svg": 6638,
	"./svgs/solid/bed-bunk.svg": 6639,
	"./svgs/solid/bed-empty.svg": 6640,
	"./svgs/solid/bed.svg": 6641,
	"./svgs/solid/beer.svg": 6642,
	"./svgs/solid/bell-exclamation.svg": 6643,
	"./svgs/solid/bell-on.svg": 6644,
	"./svgs/solid/bell-plus.svg": 6645,
	"./svgs/solid/bell-school-slash.svg": 6646,
	"./svgs/solid/bell-school.svg": 6647,
	"./svgs/solid/bell-slash.svg": 6648,
	"./svgs/solid/bell.svg": 6649,
	"./svgs/solid/bells.svg": 6650,
	"./svgs/solid/betamax.svg": 6651,
	"./svgs/solid/bezier-curve.svg": 6652,
	"./svgs/solid/bible.svg": 6653,
	"./svgs/solid/bicycle.svg": 6654,
	"./svgs/solid/biking-mountain.svg": 6655,
	"./svgs/solid/biking.svg": 6656,
	"./svgs/solid/binoculars.svg": 6657,
	"./svgs/solid/biohazard.svg": 6658,
	"./svgs/solid/birthday-cake.svg": 6659,
	"./svgs/solid/blanket.svg": 6660,
	"./svgs/solid/blender-phone.svg": 6661,
	"./svgs/solid/blender.svg": 6662,
	"./svgs/solid/blind.svg": 6663,
	"./svgs/solid/blinds-open.svg": 6664,
	"./svgs/solid/blinds-raised.svg": 6665,
	"./svgs/solid/blinds.svg": 6666,
	"./svgs/solid/blog.svg": 6667,
	"./svgs/solid/bold.svg": 6668,
	"./svgs/solid/bolt.svg": 6669,
	"./svgs/solid/bomb.svg": 6670,
	"./svgs/solid/bone-break.svg": 6671,
	"./svgs/solid/bone.svg": 6672,
	"./svgs/solid/bong.svg": 6673,
	"./svgs/solid/book-alt.svg": 6674,
	"./svgs/solid/book-dead.svg": 6675,
	"./svgs/solid/book-heart.svg": 6676,
	"./svgs/solid/book-medical.svg": 6677,
	"./svgs/solid/book-open.svg": 6678,
	"./svgs/solid/book-reader.svg": 6679,
	"./svgs/solid/book-spells.svg": 6680,
	"./svgs/solid/book-user.svg": 6681,
	"./svgs/solid/book.svg": 6682,
	"./svgs/solid/bookmark.svg": 6683,
	"./svgs/solid/books-medical.svg": 6684,
	"./svgs/solid/books.svg": 6685,
	"./svgs/solid/boombox.svg": 6686,
	"./svgs/solid/boot.svg": 6687,
	"./svgs/solid/booth-curtain.svg": 6688,
	"./svgs/solid/border-all.svg": 6689,
	"./svgs/solid/border-bottom.svg": 6690,
	"./svgs/solid/border-center-h.svg": 6691,
	"./svgs/solid/border-center-v.svg": 6692,
	"./svgs/solid/border-inner.svg": 6693,
	"./svgs/solid/border-left.svg": 6694,
	"./svgs/solid/border-none.svg": 6695,
	"./svgs/solid/border-outer.svg": 6696,
	"./svgs/solid/border-right.svg": 6697,
	"./svgs/solid/border-style-alt.svg": 6698,
	"./svgs/solid/border-style.svg": 6699,
	"./svgs/solid/border-top.svg": 6700,
	"./svgs/solid/bow-arrow.svg": 6701,
	"./svgs/solid/bowling-ball.svg": 6702,
	"./svgs/solid/bowling-pins.svg": 6703,
	"./svgs/solid/box-alt.svg": 6704,
	"./svgs/solid/box-ballot.svg": 6705,
	"./svgs/solid/box-check.svg": 6706,
	"./svgs/solid/box-fragile.svg": 6707,
	"./svgs/solid/box-full.svg": 6708,
	"./svgs/solid/box-heart.svg": 6709,
	"./svgs/solid/box-open.svg": 6710,
	"./svgs/solid/box-up.svg": 6711,
	"./svgs/solid/box-usd.svg": 6712,
	"./svgs/solid/box.svg": 6713,
	"./svgs/solid/boxes-alt.svg": 6714,
	"./svgs/solid/boxes.svg": 6715,
	"./svgs/solid/boxing-glove.svg": 6716,
	"./svgs/solid/brackets-curly.svg": 6717,
	"./svgs/solid/brackets.svg": 6718,
	"./svgs/solid/braille.svg": 6719,
	"./svgs/solid/brain.svg": 6720,
	"./svgs/solid/bread-loaf.svg": 6721,
	"./svgs/solid/bread-slice.svg": 6722,
	"./svgs/solid/briefcase-medical.svg": 6723,
	"./svgs/solid/briefcase.svg": 6724,
	"./svgs/solid/bring-forward.svg": 6725,
	"./svgs/solid/bring-front.svg": 6726,
	"./svgs/solid/broadcast-tower.svg": 6727,
	"./svgs/solid/broom.svg": 6728,
	"./svgs/solid/browser.svg": 6729,
	"./svgs/solid/brush.svg": 6730,
	"./svgs/solid/bug.svg": 6731,
	"./svgs/solid/building.svg": 6732,
	"./svgs/solid/bullhorn.svg": 6733,
	"./svgs/solid/bullseye-arrow.svg": 6734,
	"./svgs/solid/bullseye-pointer.svg": 6735,
	"./svgs/solid/bullseye.svg": 6736,
	"./svgs/solid/burger-soda.svg": 6737,
	"./svgs/solid/burn.svg": 6738,
	"./svgs/solid/burrito.svg": 6739,
	"./svgs/solid/bus-alt.svg": 6740,
	"./svgs/solid/bus-school.svg": 6741,
	"./svgs/solid/bus.svg": 6742,
	"./svgs/solid/business-time.svg": 6743,
	"./svgs/solid/cabinet-filing.svg": 6744,
	"./svgs/solid/cactus.svg": 6745,
	"./svgs/solid/calculator-alt.svg": 6746,
	"./svgs/solid/calculator.svg": 6747,
	"./svgs/solid/calendar-alt.svg": 6748,
	"./svgs/solid/calendar-check.svg": 6749,
	"./svgs/solid/calendar-day.svg": 6750,
	"./svgs/solid/calendar-edit.svg": 6751,
	"./svgs/solid/calendar-exclamation.svg": 6752,
	"./svgs/solid/calendar-minus.svg": 6753,
	"./svgs/solid/calendar-plus.svg": 6754,
	"./svgs/solid/calendar-star.svg": 6755,
	"./svgs/solid/calendar-times.svg": 6756,
	"./svgs/solid/calendar-week.svg": 6757,
	"./svgs/solid/calendar.svg": 6758,
	"./svgs/solid/camcorder.svg": 6759,
	"./svgs/solid/camera-alt.svg": 6760,
	"./svgs/solid/camera-home.svg": 6761,
	"./svgs/solid/camera-movie.svg": 6762,
	"./svgs/solid/camera-polaroid.svg": 6763,
	"./svgs/solid/camera-retro.svg": 6764,
	"./svgs/solid/camera.svg": 6765,
	"./svgs/solid/campfire.svg": 6766,
	"./svgs/solid/campground.svg": 6767,
	"./svgs/solid/candle-holder.svg": 6768,
	"./svgs/solid/candy-cane.svg": 6769,
	"./svgs/solid/candy-corn.svg": 6770,
	"./svgs/solid/cannabis.svg": 6771,
	"./svgs/solid/capsules.svg": 6772,
	"./svgs/solid/car-alt.svg": 6773,
	"./svgs/solid/car-battery.svg": 6774,
	"./svgs/solid/car-building.svg": 6775,
	"./svgs/solid/car-bump.svg": 6776,
	"./svgs/solid/car-bus.svg": 6777,
	"./svgs/solid/car-crash.svg": 6778,
	"./svgs/solid/car-garage.svg": 6779,
	"./svgs/solid/car-mechanic.svg": 6780,
	"./svgs/solid/car-side.svg": 6781,
	"./svgs/solid/car-tilt.svg": 6782,
	"./svgs/solid/car-wash.svg": 6783,
	"./svgs/solid/car.svg": 6784,
	"./svgs/solid/caravan-alt.svg": 6785,
	"./svgs/solid/caravan.svg": 6786,
	"./svgs/solid/caret-circle-down.svg": 6787,
	"./svgs/solid/caret-circle-left.svg": 6788,
	"./svgs/solid/caret-circle-right.svg": 6789,
	"./svgs/solid/caret-circle-up.svg": 6790,
	"./svgs/solid/caret-down.svg": 6791,
	"./svgs/solid/caret-left.svg": 6792,
	"./svgs/solid/caret-right.svg": 6793,
	"./svgs/solid/caret-square-down.svg": 6794,
	"./svgs/solid/caret-square-left.svg": 6795,
	"./svgs/solid/caret-square-right.svg": 6796,
	"./svgs/solid/caret-square-up.svg": 6797,
	"./svgs/solid/caret-up.svg": 6798,
	"./svgs/solid/carrot.svg": 6799,
	"./svgs/solid/cars.svg": 6800,
	"./svgs/solid/cart-arrow-down.svg": 6801,
	"./svgs/solid/cart-plus.svg": 6802,
	"./svgs/solid/cash-register.svg": 6803,
	"./svgs/solid/cassette-tape.svg": 6804,
	"./svgs/solid/cat-space.svg": 6805,
	"./svgs/solid/cat.svg": 6806,
	"./svgs/solid/cauldron.svg": 6807,
	"./svgs/solid/cctv.svg": 6808,
	"./svgs/solid/certificate.svg": 6809,
	"./svgs/solid/chair-office.svg": 6810,
	"./svgs/solid/chair.svg": 6811,
	"./svgs/solid/chalkboard-teacher.svg": 6812,
	"./svgs/solid/chalkboard.svg": 6813,
	"./svgs/solid/charging-station.svg": 6814,
	"./svgs/solid/chart-area.svg": 6815,
	"./svgs/solid/chart-bar.svg": 6816,
	"./svgs/solid/chart-line-down.svg": 6817,
	"./svgs/solid/chart-line.svg": 6818,
	"./svgs/solid/chart-network.svg": 6819,
	"./svgs/solid/chart-pie-alt.svg": 6820,
	"./svgs/solid/chart-pie.svg": 6821,
	"./svgs/solid/chart-scatter.svg": 6822,
	"./svgs/solid/check-circle.svg": 6823,
	"./svgs/solid/check-double.svg": 6824,
	"./svgs/solid/check-square.svg": 6825,
	"./svgs/solid/check.svg": 6826,
	"./svgs/solid/cheese-swiss.svg": 6827,
	"./svgs/solid/cheese.svg": 6828,
	"./svgs/solid/cheeseburger.svg": 6829,
	"./svgs/solid/chess-bishop-alt.svg": 6830,
	"./svgs/solid/chess-bishop.svg": 6831,
	"./svgs/solid/chess-board.svg": 6832,
	"./svgs/solid/chess-clock-alt.svg": 6833,
	"./svgs/solid/chess-clock.svg": 6834,
	"./svgs/solid/chess-king-alt.svg": 6835,
	"./svgs/solid/chess-king.svg": 6836,
	"./svgs/solid/chess-knight-alt.svg": 6837,
	"./svgs/solid/chess-knight.svg": 6838,
	"./svgs/solid/chess-pawn-alt.svg": 6839,
	"./svgs/solid/chess-pawn.svg": 6840,
	"./svgs/solid/chess-queen-alt.svg": 6841,
	"./svgs/solid/chess-queen.svg": 6842,
	"./svgs/solid/chess-rook-alt.svg": 6843,
	"./svgs/solid/chess-rook.svg": 6844,
	"./svgs/solid/chess.svg": 6845,
	"./svgs/solid/chevron-circle-down.svg": 6846,
	"./svgs/solid/chevron-circle-left.svg": 6847,
	"./svgs/solid/chevron-circle-right.svg": 6848,
	"./svgs/solid/chevron-circle-up.svg": 6849,
	"./svgs/solid/chevron-double-down.svg": 6850,
	"./svgs/solid/chevron-double-left.svg": 6851,
	"./svgs/solid/chevron-double-right.svg": 6852,
	"./svgs/solid/chevron-double-up.svg": 6853,
	"./svgs/solid/chevron-down.svg": 6854,
	"./svgs/solid/chevron-left.svg": 6855,
	"./svgs/solid/chevron-right.svg": 6856,
	"./svgs/solid/chevron-square-down.svg": 6857,
	"./svgs/solid/chevron-square-left.svg": 6858,
	"./svgs/solid/chevron-square-right.svg": 6859,
	"./svgs/solid/chevron-square-up.svg": 6860,
	"./svgs/solid/chevron-up.svg": 6861,
	"./svgs/solid/child.svg": 6862,
	"./svgs/solid/chimney.svg": 6863,
	"./svgs/solid/church.svg": 6864,
	"./svgs/solid/circle-notch.svg": 6865,
	"./svgs/solid/circle.svg": 6866,
	"./svgs/solid/city.svg": 6867,
	"./svgs/solid/clarinet.svg": 6868,
	"./svgs/solid/claw-marks.svg": 6869,
	"./svgs/solid/clinic-medical.svg": 6870,
	"./svgs/solid/clipboard-check.svg": 6871,
	"./svgs/solid/clipboard-list-check.svg": 6872,
	"./svgs/solid/clipboard-list.svg": 6873,
	"./svgs/solid/clipboard-prescription.svg": 6874,
	"./svgs/solid/clipboard-user.svg": 6875,
	"./svgs/solid/clipboard.svg": 6876,
	"./svgs/solid/clock.svg": 6877,
	"./svgs/solid/clone.svg": 6878,
	"./svgs/solid/closed-captioning.svg": 6879,
	"./svgs/solid/cloud-download-alt.svg": 6880,
	"./svgs/solid/cloud-download.svg": 6881,
	"./svgs/solid/cloud-drizzle.svg": 6882,
	"./svgs/solid/cloud-hail-mixed.svg": 6883,
	"./svgs/solid/cloud-hail.svg": 6884,
	"./svgs/solid/cloud-meatball.svg": 6885,
	"./svgs/solid/cloud-moon-rain.svg": 6886,
	"./svgs/solid/cloud-moon.svg": 6887,
	"./svgs/solid/cloud-music.svg": 6888,
	"./svgs/solid/cloud-rain.svg": 6889,
	"./svgs/solid/cloud-rainbow.svg": 6890,
	"./svgs/solid/cloud-showers-heavy.svg": 6891,
	"./svgs/solid/cloud-showers.svg": 6892,
	"./svgs/solid/cloud-sleet.svg": 6893,
	"./svgs/solid/cloud-snow.svg": 6894,
	"./svgs/solid/cloud-sun-rain.svg": 6895,
	"./svgs/solid/cloud-sun.svg": 6896,
	"./svgs/solid/cloud-upload-alt.svg": 6897,
	"./svgs/solid/cloud-upload.svg": 6898,
	"./svgs/solid/cloud.svg": 6899,
	"./svgs/solid/clouds-moon.svg": 6900,
	"./svgs/solid/clouds-sun.svg": 6901,
	"./svgs/solid/clouds.svg": 6902,
	"./svgs/solid/club.svg": 6903,
	"./svgs/solid/cocktail.svg": 6904,
	"./svgs/solid/code-branch.svg": 6905,
	"./svgs/solid/code-commit.svg": 6906,
	"./svgs/solid/code-merge.svg": 6907,
	"./svgs/solid/code.svg": 6908,
	"./svgs/solid/coffee-pot.svg": 6909,
	"./svgs/solid/coffee-togo.svg": 6910,
	"./svgs/solid/coffee.svg": 6911,
	"./svgs/solid/coffin.svg": 6912,
	"./svgs/solid/cog.svg": 6913,
	"./svgs/solid/cogs.svg": 6914,
	"./svgs/solid/coin.svg": 6915,
	"./svgs/solid/coins.svg": 6916,
	"./svgs/solid/columns.svg": 6917,
	"./svgs/solid/comet.svg": 6918,
	"./svgs/solid/comment-alt-check.svg": 6919,
	"./svgs/solid/comment-alt-dollar.svg": 6920,
	"./svgs/solid/comment-alt-dots.svg": 6921,
	"./svgs/solid/comment-alt-edit.svg": 6922,
	"./svgs/solid/comment-alt-exclamation.svg": 6923,
	"./svgs/solid/comment-alt-lines.svg": 6924,
	"./svgs/solid/comment-alt-medical.svg": 6925,
	"./svgs/solid/comment-alt-minus.svg": 6926,
	"./svgs/solid/comment-alt-music.svg": 6927,
	"./svgs/solid/comment-alt-plus.svg": 6928,
	"./svgs/solid/comment-alt-slash.svg": 6929,
	"./svgs/solid/comment-alt-smile.svg": 6930,
	"./svgs/solid/comment-alt-times.svg": 6931,
	"./svgs/solid/comment-alt.svg": 6932,
	"./svgs/solid/comment-check.svg": 6933,
	"./svgs/solid/comment-dollar.svg": 6934,
	"./svgs/solid/comment-dots.svg": 6935,
	"./svgs/solid/comment-edit.svg": 6936,
	"./svgs/solid/comment-exclamation.svg": 6937,
	"./svgs/solid/comment-lines.svg": 6938,
	"./svgs/solid/comment-medical.svg": 6939,
	"./svgs/solid/comment-minus.svg": 6940,
	"./svgs/solid/comment-music.svg": 6941,
	"./svgs/solid/comment-plus.svg": 6942,
	"./svgs/solid/comment-slash.svg": 6943,
	"./svgs/solid/comment-smile.svg": 6944,
	"./svgs/solid/comment-times.svg": 6945,
	"./svgs/solid/comment.svg": 6946,
	"./svgs/solid/comments-alt-dollar.svg": 6947,
	"./svgs/solid/comments-alt.svg": 6948,
	"./svgs/solid/comments-dollar.svg": 6949,
	"./svgs/solid/comments.svg": 6950,
	"./svgs/solid/compact-disc.svg": 6951,
	"./svgs/solid/compass-slash.svg": 6952,
	"./svgs/solid/compass.svg": 6953,
	"./svgs/solid/compress-alt.svg": 6954,
	"./svgs/solid/compress-arrows-alt.svg": 6955,
	"./svgs/solid/compress-wide.svg": 6956,
	"./svgs/solid/compress.svg": 6957,
	"./svgs/solid/computer-classic.svg": 6958,
	"./svgs/solid/computer-speaker.svg": 6959,
	"./svgs/solid/concierge-bell.svg": 6960,
	"./svgs/solid/construction.svg": 6961,
	"./svgs/solid/container-storage.svg": 6962,
	"./svgs/solid/conveyor-belt-alt.svg": 6963,
	"./svgs/solid/conveyor-belt.svg": 6964,
	"./svgs/solid/cookie-bite.svg": 6965,
	"./svgs/solid/cookie.svg": 6966,
	"./svgs/solid/copy.svg": 6967,
	"./svgs/solid/copyright.svg": 6968,
	"./svgs/solid/corn.svg": 6969,
	"./svgs/solid/couch.svg": 6970,
	"./svgs/solid/cow.svg": 6971,
	"./svgs/solid/cowbell-more.svg": 6972,
	"./svgs/solid/cowbell.svg": 6973,
	"./svgs/solid/credit-card-blank.svg": 6974,
	"./svgs/solid/credit-card-front.svg": 6975,
	"./svgs/solid/credit-card.svg": 6976,
	"./svgs/solid/cricket.svg": 6977,
	"./svgs/solid/croissant.svg": 6978,
	"./svgs/solid/crop-alt.svg": 6979,
	"./svgs/solid/crop.svg": 6980,
	"./svgs/solid/cross.svg": 6981,
	"./svgs/solid/crosshairs.svg": 6982,
	"./svgs/solid/crow.svg": 6983,
	"./svgs/solid/crown.svg": 6984,
	"./svgs/solid/crutch.svg": 6985,
	"./svgs/solid/crutches.svg": 6986,
	"./svgs/solid/cube.svg": 6987,
	"./svgs/solid/cubes.svg": 6988,
	"./svgs/solid/curling.svg": 6989,
	"./svgs/solid/cut.svg": 6990,
	"./svgs/solid/dagger.svg": 6991,
	"./svgs/solid/database.svg": 6992,
	"./svgs/solid/deaf.svg": 6993,
	"./svgs/solid/debug.svg": 6994,
	"./svgs/solid/deer-rudolph.svg": 6995,
	"./svgs/solid/deer.svg": 6996,
	"./svgs/solid/democrat.svg": 6997,
	"./svgs/solid/desktop-alt.svg": 6998,
	"./svgs/solid/desktop.svg": 6999,
	"./svgs/solid/dewpoint.svg": 7000,
	"./svgs/solid/dharmachakra.svg": 7001,
	"./svgs/solid/diagnoses.svg": 7002,
	"./svgs/solid/diamond.svg": 7003,
	"./svgs/solid/dice-d10.svg": 7004,
	"./svgs/solid/dice-d12.svg": 7005,
	"./svgs/solid/dice-d20.svg": 7006,
	"./svgs/solid/dice-d4.svg": 7007,
	"./svgs/solid/dice-d6.svg": 7008,
	"./svgs/solid/dice-d8.svg": 7009,
	"./svgs/solid/dice-five.svg": 7010,
	"./svgs/solid/dice-four.svg": 7011,
	"./svgs/solid/dice-one.svg": 7012,
	"./svgs/solid/dice-six.svg": 7013,
	"./svgs/solid/dice-three.svg": 7014,
	"./svgs/solid/dice-two.svg": 7015,
	"./svgs/solid/dice.svg": 7016,
	"./svgs/solid/digging.svg": 7017,
	"./svgs/solid/digital-tachograph.svg": 7018,
	"./svgs/solid/diploma.svg": 7019,
	"./svgs/solid/directions.svg": 7020,
	"./svgs/solid/disc-drive.svg": 7021,
	"./svgs/solid/disease.svg": 7022,
	"./svgs/solid/divide.svg": 7023,
	"./svgs/solid/dizzy.svg": 7024,
	"./svgs/solid/dna.svg": 7025,
	"./svgs/solid/do-not-enter.svg": 7026,
	"./svgs/solid/dog-leashed.svg": 7027,
	"./svgs/solid/dog.svg": 7028,
	"./svgs/solid/dollar-sign.svg": 7029,
	"./svgs/solid/dolly-empty.svg": 7030,
	"./svgs/solid/dolly-flatbed-alt.svg": 7031,
	"./svgs/solid/dolly-flatbed-empty.svg": 7032,
	"./svgs/solid/dolly-flatbed.svg": 7033,
	"./svgs/solid/dolly.svg": 7034,
	"./svgs/solid/donate.svg": 7035,
	"./svgs/solid/door-closed.svg": 7036,
	"./svgs/solid/door-open.svg": 7037,
	"./svgs/solid/dot-circle.svg": 7038,
	"./svgs/solid/dove.svg": 7039,
	"./svgs/solid/download.svg": 7040,
	"./svgs/solid/drafting-compass.svg": 7041,
	"./svgs/solid/dragon.svg": 7042,
	"./svgs/solid/draw-circle.svg": 7043,
	"./svgs/solid/draw-polygon.svg": 7044,
	"./svgs/solid/draw-square.svg": 7045,
	"./svgs/solid/dreidel.svg": 7046,
	"./svgs/solid/drone-alt.svg": 7047,
	"./svgs/solid/drone.svg": 7048,
	"./svgs/solid/drum-steelpan.svg": 7049,
	"./svgs/solid/drum.svg": 7050,
	"./svgs/solid/drumstick-bite.svg": 7051,
	"./svgs/solid/drumstick.svg": 7052,
	"./svgs/solid/dryer-alt.svg": 7053,
	"./svgs/solid/dryer.svg": 7054,
	"./svgs/solid/duck.svg": 7055,
	"./svgs/solid/dumbbell.svg": 7056,
	"./svgs/solid/dumpster-fire.svg": 7057,
	"./svgs/solid/dumpster.svg": 7058,
	"./svgs/solid/dungeon.svg": 7059,
	"./svgs/solid/ear-muffs.svg": 7060,
	"./svgs/solid/ear.svg": 7061,
	"./svgs/solid/eclipse-alt.svg": 7062,
	"./svgs/solid/eclipse.svg": 7063,
	"./svgs/solid/edit.svg": 7064,
	"./svgs/solid/egg-fried.svg": 7065,
	"./svgs/solid/egg.svg": 7066,
	"./svgs/solid/eject.svg": 7067,
	"./svgs/solid/elephant.svg": 7068,
	"./svgs/solid/ellipsis-h-alt.svg": 7069,
	"./svgs/solid/ellipsis-h.svg": 7070,
	"./svgs/solid/ellipsis-v-alt.svg": 7071,
	"./svgs/solid/ellipsis-v.svg": 7072,
	"./svgs/solid/empty-set.svg": 7073,
	"./svgs/solid/engine-warning.svg": 7074,
	"./svgs/solid/envelope-open-dollar.svg": 7075,
	"./svgs/solid/envelope-open-text.svg": 7076,
	"./svgs/solid/envelope-open.svg": 7077,
	"./svgs/solid/envelope-square.svg": 7078,
	"./svgs/solid/envelope.svg": 7079,
	"./svgs/solid/equals.svg": 7080,
	"./svgs/solid/eraser.svg": 7081,
	"./svgs/solid/ethernet.svg": 7082,
	"./svgs/solid/euro-sign.svg": 7083,
	"./svgs/solid/exchange-alt.svg": 7084,
	"./svgs/solid/exchange.svg": 7085,
	"./svgs/solid/exclamation-circle.svg": 7086,
	"./svgs/solid/exclamation-square.svg": 7087,
	"./svgs/solid/exclamation-triangle.svg": 7088,
	"./svgs/solid/exclamation.svg": 7089,
	"./svgs/solid/expand-alt.svg": 7090,
	"./svgs/solid/expand-arrows-alt.svg": 7091,
	"./svgs/solid/expand-arrows.svg": 7092,
	"./svgs/solid/expand-wide.svg": 7093,
	"./svgs/solid/expand.svg": 7094,
	"./svgs/solid/external-link-alt.svg": 7095,
	"./svgs/solid/external-link-square-alt.svg": 7096,
	"./svgs/solid/external-link-square.svg": 7097,
	"./svgs/solid/external-link.svg": 7098,
	"./svgs/solid/eye-dropper.svg": 7099,
	"./svgs/solid/eye-evil.svg": 7100,
	"./svgs/solid/eye-slash.svg": 7101,
	"./svgs/solid/eye.svg": 7102,
	"./svgs/solid/fan-table.svg": 7103,
	"./svgs/solid/fan.svg": 7104,
	"./svgs/solid/farm.svg": 7105,
	"./svgs/solid/fast-backward.svg": 7106,
	"./svgs/solid/fast-forward.svg": 7107,
	"./svgs/solid/faucet-drip.svg": 7108,
	"./svgs/solid/faucet.svg": 7109,
	"./svgs/solid/fax.svg": 7110,
	"./svgs/solid/feather-alt.svg": 7111,
	"./svgs/solid/feather.svg": 7112,
	"./svgs/solid/female.svg": 7113,
	"./svgs/solid/field-hockey.svg": 7114,
	"./svgs/solid/fighter-jet.svg": 7115,
	"./svgs/solid/file-alt.svg": 7116,
	"./svgs/solid/file-archive.svg": 7117,
	"./svgs/solid/file-audio.svg": 7118,
	"./svgs/solid/file-certificate.svg": 7119,
	"./svgs/solid/file-chart-line.svg": 7120,
	"./svgs/solid/file-chart-pie.svg": 7121,
	"./svgs/solid/file-check.svg": 7122,
	"./svgs/solid/file-code.svg": 7123,
	"./svgs/solid/file-contract.svg": 7124,
	"./svgs/solid/file-csv.svg": 7125,
	"./svgs/solid/file-download.svg": 7126,
	"./svgs/solid/file-edit.svg": 7127,
	"./svgs/solid/file-excel.svg": 7128,
	"./svgs/solid/file-exclamation.svg": 7129,
	"./svgs/solid/file-export.svg": 7130,
	"./svgs/solid/file-image.svg": 7131,
	"./svgs/solid/file-import.svg": 7132,
	"./svgs/solid/file-invoice-dollar.svg": 7133,
	"./svgs/solid/file-invoice.svg": 7134,
	"./svgs/solid/file-medical-alt.svg": 7135,
	"./svgs/solid/file-medical.svg": 7136,
	"./svgs/solid/file-minus.svg": 7137,
	"./svgs/solid/file-music.svg": 7138,
	"./svgs/solid/file-pdf.svg": 7139,
	"./svgs/solid/file-plus.svg": 7140,
	"./svgs/solid/file-powerpoint.svg": 7141,
	"./svgs/solid/file-prescription.svg": 7142,
	"./svgs/solid/file-search.svg": 7143,
	"./svgs/solid/file-signature.svg": 7144,
	"./svgs/solid/file-spreadsheet.svg": 7145,
	"./svgs/solid/file-times.svg": 7146,
	"./svgs/solid/file-upload.svg": 7147,
	"./svgs/solid/file-user.svg": 7148,
	"./svgs/solid/file-video.svg": 7149,
	"./svgs/solid/file-word.svg": 7150,
	"./svgs/solid/file.svg": 7151,
	"./svgs/solid/files-medical.svg": 7152,
	"./svgs/solid/fill-drip.svg": 7153,
	"./svgs/solid/fill.svg": 7154,
	"./svgs/solid/film-alt.svg": 7155,
	"./svgs/solid/film-canister.svg": 7156,
	"./svgs/solid/film.svg": 7157,
	"./svgs/solid/filter.svg": 7158,
	"./svgs/solid/fingerprint.svg": 7159,
	"./svgs/solid/fire-alt.svg": 7160,
	"./svgs/solid/fire-extinguisher.svg": 7161,
	"./svgs/solid/fire-smoke.svg": 7162,
	"./svgs/solid/fire.svg": 7163,
	"./svgs/solid/fireplace.svg": 7164,
	"./svgs/solid/first-aid.svg": 7165,
	"./svgs/solid/fish-cooked.svg": 7166,
	"./svgs/solid/fish.svg": 7167,
	"./svgs/solid/fist-raised.svg": 7168,
	"./svgs/solid/flag-alt.svg": 7169,
	"./svgs/solid/flag-checkered.svg": 7170,
	"./svgs/solid/flag-usa.svg": 7171,
	"./svgs/solid/flag.svg": 7172,
	"./svgs/solid/flame.svg": 7173,
	"./svgs/solid/flashlight.svg": 7174,
	"./svgs/solid/flask-poison.svg": 7175,
	"./svgs/solid/flask-potion.svg": 7176,
	"./svgs/solid/flask.svg": 7177,
	"./svgs/solid/flower-daffodil.svg": 7178,
	"./svgs/solid/flower-tulip.svg": 7179,
	"./svgs/solid/flower.svg": 7180,
	"./svgs/solid/flushed.svg": 7181,
	"./svgs/solid/flute.svg": 7182,
	"./svgs/solid/flux-capacitor.svg": 7183,
	"./svgs/solid/fog.svg": 7184,
	"./svgs/solid/folder-minus.svg": 7185,
	"./svgs/solid/folder-open.svg": 7186,
	"./svgs/solid/folder-plus.svg": 7187,
	"./svgs/solid/folder-times.svg": 7188,
	"./svgs/solid/folder-tree.svg": 7189,
	"./svgs/solid/folder.svg": 7190,
	"./svgs/solid/folders.svg": 7191,
	"./svgs/solid/font-awesome-logo-full.svg": 7192,
	"./svgs/solid/font-case.svg": 7193,
	"./svgs/solid/font.svg": 7194,
	"./svgs/solid/football-ball.svg": 7195,
	"./svgs/solid/football-helmet.svg": 7196,
	"./svgs/solid/forklift.svg": 7197,
	"./svgs/solid/forward.svg": 7198,
	"./svgs/solid/fragile.svg": 7199,
	"./svgs/solid/french-fries.svg": 7200,
	"./svgs/solid/frog.svg": 7201,
	"./svgs/solid/frosty-head.svg": 7202,
	"./svgs/solid/frown-open.svg": 7203,
	"./svgs/solid/frown.svg": 7204,
	"./svgs/solid/function.svg": 7205,
	"./svgs/solid/funnel-dollar.svg": 7206,
	"./svgs/solid/futbol.svg": 7207,
	"./svgs/solid/galaxy.svg": 7208,
	"./svgs/solid/game-board-alt.svg": 7209,
	"./svgs/solid/game-board.svg": 7210,
	"./svgs/solid/game-console-handheld.svg": 7211,
	"./svgs/solid/gamepad-alt.svg": 7212,
	"./svgs/solid/gamepad.svg": 7213,
	"./svgs/solid/garage-car.svg": 7214,
	"./svgs/solid/garage-open.svg": 7215,
	"./svgs/solid/garage.svg": 7216,
	"./svgs/solid/gas-pump-slash.svg": 7217,
	"./svgs/solid/gas-pump.svg": 7218,
	"./svgs/solid/gavel.svg": 7219,
	"./svgs/solid/gem.svg": 7220,
	"./svgs/solid/genderless.svg": 7221,
	"./svgs/solid/ghost.svg": 7222,
	"./svgs/solid/gift-card.svg": 7223,
	"./svgs/solid/gift.svg": 7224,
	"./svgs/solid/gifts.svg": 7225,
	"./svgs/solid/gingerbread-man.svg": 7226,
	"./svgs/solid/glass-champagne.svg": 7227,
	"./svgs/solid/glass-cheers.svg": 7228,
	"./svgs/solid/glass-citrus.svg": 7229,
	"./svgs/solid/glass-martini-alt.svg": 7230,
	"./svgs/solid/glass-martini.svg": 7231,
	"./svgs/solid/glass-whiskey-rocks.svg": 7232,
	"./svgs/solid/glass-whiskey.svg": 7233,
	"./svgs/solid/glass.svg": 7234,
	"./svgs/solid/glasses-alt.svg": 7235,
	"./svgs/solid/glasses.svg": 7236,
	"./svgs/solid/globe-africa.svg": 7237,
	"./svgs/solid/globe-americas.svg": 7238,
	"./svgs/solid/globe-asia.svg": 7239,
	"./svgs/solid/globe-europe.svg": 7240,
	"./svgs/solid/globe-snow.svg": 7241,
	"./svgs/solid/globe-stand.svg": 7242,
	"./svgs/solid/globe.svg": 7243,
	"./svgs/solid/golf-ball.svg": 7244,
	"./svgs/solid/golf-club.svg": 7245,
	"./svgs/solid/gopuram.svg": 7246,
	"./svgs/solid/graduation-cap.svg": 7247,
	"./svgs/solid/gramophone.svg": 7248,
	"./svgs/solid/greater-than-equal.svg": 7249,
	"./svgs/solid/greater-than.svg": 7250,
	"./svgs/solid/grimace.svg": 7251,
	"./svgs/solid/grin-alt.svg": 7252,
	"./svgs/solid/grin-beam-sweat.svg": 7253,
	"./svgs/solid/grin-beam.svg": 7254,
	"./svgs/solid/grin-hearts.svg": 7255,
	"./svgs/solid/grin-squint-tears.svg": 7256,
	"./svgs/solid/grin-squint.svg": 7257,
	"./svgs/solid/grin-stars.svg": 7258,
	"./svgs/solid/grin-tears.svg": 7259,
	"./svgs/solid/grin-tongue-squint.svg": 7260,
	"./svgs/solid/grin-tongue-wink.svg": 7261,
	"./svgs/solid/grin-tongue.svg": 7262,
	"./svgs/solid/grin-wink.svg": 7263,
	"./svgs/solid/grin.svg": 7264,
	"./svgs/solid/grip-horizontal.svg": 7265,
	"./svgs/solid/grip-lines-vertical.svg": 7266,
	"./svgs/solid/grip-lines.svg": 7267,
	"./svgs/solid/grip-vertical.svg": 7268,
	"./svgs/solid/guitar-electric.svg": 7269,
	"./svgs/solid/guitar.svg": 7270,
	"./svgs/solid/guitars.svg": 7271,
	"./svgs/solid/h-square.svg": 7272,
	"./svgs/solid/h1.svg": 7273,
	"./svgs/solid/h2.svg": 7274,
	"./svgs/solid/h3.svg": 7275,
	"./svgs/solid/h4.svg": 7276,
	"./svgs/solid/hamburger.svg": 7277,
	"./svgs/solid/hammer-war.svg": 7278,
	"./svgs/solid/hammer.svg": 7279,
	"./svgs/solid/hamsa.svg": 7280,
	"./svgs/solid/hand-heart.svg": 7281,
	"./svgs/solid/hand-holding-box.svg": 7282,
	"./svgs/solid/hand-holding-heart.svg": 7283,
	"./svgs/solid/hand-holding-magic.svg": 7284,
	"./svgs/solid/hand-holding-seedling.svg": 7285,
	"./svgs/solid/hand-holding-usd.svg": 7286,
	"./svgs/solid/hand-holding-water.svg": 7287,
	"./svgs/solid/hand-holding.svg": 7288,
	"./svgs/solid/hand-lizard.svg": 7289,
	"./svgs/solid/hand-middle-finger.svg": 7290,
	"./svgs/solid/hand-paper.svg": 7291,
	"./svgs/solid/hand-peace.svg": 7292,
	"./svgs/solid/hand-point-down.svg": 7293,
	"./svgs/solid/hand-point-left.svg": 7294,
	"./svgs/solid/hand-point-right.svg": 7295,
	"./svgs/solid/hand-point-up.svg": 7296,
	"./svgs/solid/hand-pointer.svg": 7297,
	"./svgs/solid/hand-receiving.svg": 7298,
	"./svgs/solid/hand-rock.svg": 7299,
	"./svgs/solid/hand-scissors.svg": 7300,
	"./svgs/solid/hand-spock.svg": 7301,
	"./svgs/solid/hands-heart.svg": 7302,
	"./svgs/solid/hands-helping.svg": 7303,
	"./svgs/solid/hands-usd.svg": 7304,
	"./svgs/solid/hands.svg": 7305,
	"./svgs/solid/handshake-alt.svg": 7306,
	"./svgs/solid/handshake.svg": 7307,
	"./svgs/solid/hanukiah.svg": 7308,
	"./svgs/solid/hard-hat.svg": 7309,
	"./svgs/solid/hashtag.svg": 7310,
	"./svgs/solid/hat-chef.svg": 7311,
	"./svgs/solid/hat-cowboy-side.svg": 7312,
	"./svgs/solid/hat-cowboy.svg": 7313,
	"./svgs/solid/hat-santa.svg": 7314,
	"./svgs/solid/hat-winter.svg": 7315,
	"./svgs/solid/hat-witch.svg": 7316,
	"./svgs/solid/hat-wizard.svg": 7317,
	"./svgs/solid/hdd.svg": 7318,
	"./svgs/solid/head-side-brain.svg": 7319,
	"./svgs/solid/head-side-headphones.svg": 7320,
	"./svgs/solid/head-side-medical.svg": 7321,
	"./svgs/solid/head-side.svg": 7322,
	"./svgs/solid/head-vr.svg": 7323,
	"./svgs/solid/heading.svg": 7324,
	"./svgs/solid/headphones-alt.svg": 7325,
	"./svgs/solid/headphones.svg": 7326,
	"./svgs/solid/headset.svg": 7327,
	"./svgs/solid/heart-broken.svg": 7328,
	"./svgs/solid/heart-circle.svg": 7329,
	"./svgs/solid/heart-rate.svg": 7330,
	"./svgs/solid/heart-square.svg": 7331,
	"./svgs/solid/heart.svg": 7332,
	"./svgs/solid/heartbeat.svg": 7333,
	"./svgs/solid/heat.svg": 7334,
	"./svgs/solid/helicopter.svg": 7335,
	"./svgs/solid/helmet-battle.svg": 7336,
	"./svgs/solid/hexagon.svg": 7337,
	"./svgs/solid/highlighter.svg": 7338,
	"./svgs/solid/hiking.svg": 7339,
	"./svgs/solid/hippo.svg": 7340,
	"./svgs/solid/history.svg": 7341,
	"./svgs/solid/hockey-mask.svg": 7342,
	"./svgs/solid/hockey-puck.svg": 7343,
	"./svgs/solid/hockey-sticks.svg": 7344,
	"./svgs/solid/holly-berry.svg": 7345,
	"./svgs/solid/home-alt.svg": 7346,
	"./svgs/solid/home-heart.svg": 7347,
	"./svgs/solid/home-lg-alt.svg": 7348,
	"./svgs/solid/home-lg.svg": 7349,
	"./svgs/solid/home.svg": 7350,
	"./svgs/solid/hood-cloak.svg": 7351,
	"./svgs/solid/horizontal-rule.svg": 7352,
	"./svgs/solid/horse-head.svg": 7353,
	"./svgs/solid/horse-saddle.svg": 7354,
	"./svgs/solid/horse.svg": 7355,
	"./svgs/solid/hospital-alt.svg": 7356,
	"./svgs/solid/hospital-symbol.svg": 7357,
	"./svgs/solid/hospital-user.svg": 7358,
	"./svgs/solid/hospital.svg": 7359,
	"./svgs/solid/hospitals.svg": 7360,
	"./svgs/solid/hot-tub.svg": 7361,
	"./svgs/solid/hotdog.svg": 7362,
	"./svgs/solid/hotel.svg": 7363,
	"./svgs/solid/hourglass-end.svg": 7364,
	"./svgs/solid/hourglass-half.svg": 7365,
	"./svgs/solid/hourglass-start.svg": 7366,
	"./svgs/solid/hourglass.svg": 7367,
	"./svgs/solid/house-damage.svg": 7368,
	"./svgs/solid/house-day.svg": 7369,
	"./svgs/solid/house-flood.svg": 7370,
	"./svgs/solid/house-leave.svg": 7371,
	"./svgs/solid/house-night.svg": 7372,
	"./svgs/solid/house-return.svg": 7373,
	"./svgs/solid/house-signal.svg": 7374,
	"./svgs/solid/house.svg": 7375,
	"./svgs/solid/hryvnia.svg": 7376,
	"./svgs/solid/humidity.svg": 7377,
	"./svgs/solid/hurricane.svg": 7378,
	"./svgs/solid/i-cursor.svg": 7379,
	"./svgs/solid/ice-cream.svg": 7380,
	"./svgs/solid/ice-skate.svg": 7381,
	"./svgs/solid/icicles.svg": 7382,
	"./svgs/solid/icons-alt.svg": 7383,
	"./svgs/solid/icons.svg": 7384,
	"./svgs/solid/id-badge.svg": 7385,
	"./svgs/solid/id-card-alt.svg": 7386,
	"./svgs/solid/id-card.svg": 7387,
	"./svgs/solid/igloo.svg": 7388,
	"./svgs/solid/image-polaroid.svg": 7389,
	"./svgs/solid/image.svg": 7390,
	"./svgs/solid/images.svg": 7391,
	"./svgs/solid/inbox-in.svg": 7392,
	"./svgs/solid/inbox-out.svg": 7393,
	"./svgs/solid/inbox.svg": 7394,
	"./svgs/solid/indent.svg": 7395,
	"./svgs/solid/industry-alt.svg": 7396,
	"./svgs/solid/industry.svg": 7397,
	"./svgs/solid/infinity.svg": 7398,
	"./svgs/solid/info-circle.svg": 7399,
	"./svgs/solid/info-square.svg": 7400,
	"./svgs/solid/info.svg": 7401,
	"./svgs/solid/inhaler.svg": 7402,
	"./svgs/solid/integral.svg": 7403,
	"./svgs/solid/intersection.svg": 7404,
	"./svgs/solid/inventory.svg": 7405,
	"./svgs/solid/island-tropical.svg": 7406,
	"./svgs/solid/italic.svg": 7407,
	"./svgs/solid/jack-o-lantern.svg": 7408,
	"./svgs/solid/jedi.svg": 7409,
	"./svgs/solid/joint.svg": 7410,
	"./svgs/solid/journal-whills.svg": 7411,
	"./svgs/solid/joystick.svg": 7412,
	"./svgs/solid/jug.svg": 7413,
	"./svgs/solid/kaaba.svg": 7414,
	"./svgs/solid/kazoo.svg": 7415,
	"./svgs/solid/kerning.svg": 7416,
	"./svgs/solid/key-skeleton.svg": 7417,
	"./svgs/solid/key.svg": 7418,
	"./svgs/solid/keyboard.svg": 7419,
	"./svgs/solid/keynote.svg": 7420,
	"./svgs/solid/khanda.svg": 7421,
	"./svgs/solid/kidneys.svg": 7422,
	"./svgs/solid/kiss-beam.svg": 7423,
	"./svgs/solid/kiss-wink-heart.svg": 7424,
	"./svgs/solid/kiss.svg": 7425,
	"./svgs/solid/kite.svg": 7426,
	"./svgs/solid/kiwi-bird.svg": 7427,
	"./svgs/solid/knife-kitchen.svg": 7428,
	"./svgs/solid/lambda.svg": 7429,
	"./svgs/solid/lamp-desk.svg": 7430,
	"./svgs/solid/lamp-floor.svg": 7431,
	"./svgs/solid/lamp.svg": 7432,
	"./svgs/solid/landmark-alt.svg": 7433,
	"./svgs/solid/landmark.svg": 7434,
	"./svgs/solid/language.svg": 7435,
	"./svgs/solid/laptop-code.svg": 7436,
	"./svgs/solid/laptop-medical.svg": 7437,
	"./svgs/solid/laptop.svg": 7438,
	"./svgs/solid/lasso.svg": 7439,
	"./svgs/solid/laugh-beam.svg": 7440,
	"./svgs/solid/laugh-squint.svg": 7441,
	"./svgs/solid/laugh-wink.svg": 7442,
	"./svgs/solid/laugh.svg": 7443,
	"./svgs/solid/layer-group.svg": 7444,
	"./svgs/solid/layer-minus.svg": 7445,
	"./svgs/solid/layer-plus.svg": 7446,
	"./svgs/solid/leaf-heart.svg": 7447,
	"./svgs/solid/leaf-maple.svg": 7448,
	"./svgs/solid/leaf-oak.svg": 7449,
	"./svgs/solid/leaf.svg": 7450,
	"./svgs/solid/lemon.svg": 7451,
	"./svgs/solid/less-than-equal.svg": 7452,
	"./svgs/solid/less-than.svg": 7453,
	"./svgs/solid/level-down-alt.svg": 7454,
	"./svgs/solid/level-down.svg": 7455,
	"./svgs/solid/level-up-alt.svg": 7456,
	"./svgs/solid/level-up.svg": 7457,
	"./svgs/solid/life-ring.svg": 7458,
	"./svgs/solid/light-ceiling.svg": 7459,
	"./svgs/solid/light-switch-off.svg": 7460,
	"./svgs/solid/light-switch-on.svg": 7461,
	"./svgs/solid/light-switch.svg": 7462,
	"./svgs/solid/lightbulb-dollar.svg": 7463,
	"./svgs/solid/lightbulb-exclamation.svg": 7464,
	"./svgs/solid/lightbulb-on.svg": 7465,
	"./svgs/solid/lightbulb-slash.svg": 7466,
	"./svgs/solid/lightbulb.svg": 7467,
	"./svgs/solid/lights-holiday.svg": 7468,
	"./svgs/solid/line-columns.svg": 7469,
	"./svgs/solid/line-height.svg": 7470,
	"./svgs/solid/link.svg": 7471,
	"./svgs/solid/lips.svg": 7472,
	"./svgs/solid/lira-sign.svg": 7473,
	"./svgs/solid/list-alt.svg": 7474,
	"./svgs/solid/list-music.svg": 7475,
	"./svgs/solid/list-ol.svg": 7476,
	"./svgs/solid/list-ul.svg": 7477,
	"./svgs/solid/list.svg": 7478,
	"./svgs/solid/location-arrow.svg": 7479,
	"./svgs/solid/location-circle.svg": 7480,
	"./svgs/solid/location-slash.svg": 7481,
	"./svgs/solid/location.svg": 7482,
	"./svgs/solid/lock-alt.svg": 7483,
	"./svgs/solid/lock-open-alt.svg": 7484,
	"./svgs/solid/lock-open.svg": 7485,
	"./svgs/solid/lock.svg": 7486,
	"./svgs/solid/long-arrow-alt-down.svg": 7487,
	"./svgs/solid/long-arrow-alt-left.svg": 7488,
	"./svgs/solid/long-arrow-alt-right.svg": 7489,
	"./svgs/solid/long-arrow-alt-up.svg": 7490,
	"./svgs/solid/long-arrow-down.svg": 7491,
	"./svgs/solid/long-arrow-left.svg": 7492,
	"./svgs/solid/long-arrow-right.svg": 7493,
	"./svgs/solid/long-arrow-up.svg": 7494,
	"./svgs/solid/loveseat.svg": 7495,
	"./svgs/solid/low-vision.svg": 7496,
	"./svgs/solid/luchador.svg": 7497,
	"./svgs/solid/luggage-cart.svg": 7498,
	"./svgs/solid/lungs.svg": 7499,
	"./svgs/solid/mace.svg": 7500,
	"./svgs/solid/magic.svg": 7501,
	"./svgs/solid/magnet.svg": 7502,
	"./svgs/solid/mail-bulk.svg": 7503,
	"./svgs/solid/mailbox.svg": 7504,
	"./svgs/solid/male.svg": 7505,
	"./svgs/solid/mandolin.svg": 7506,
	"./svgs/solid/map-marked-alt.svg": 7507,
	"./svgs/solid/map-marked.svg": 7508,
	"./svgs/solid/map-marker-alt-slash.svg": 7509,
	"./svgs/solid/map-marker-alt.svg": 7510,
	"./svgs/solid/map-marker-check.svg": 7511,
	"./svgs/solid/map-marker-edit.svg": 7512,
	"./svgs/solid/map-marker-exclamation.svg": 7513,
	"./svgs/solid/map-marker-minus.svg": 7514,
	"./svgs/solid/map-marker-plus.svg": 7515,
	"./svgs/solid/map-marker-question.svg": 7516,
	"./svgs/solid/map-marker-slash.svg": 7517,
	"./svgs/solid/map-marker-smile.svg": 7518,
	"./svgs/solid/map-marker-times.svg": 7519,
	"./svgs/solid/map-marker.svg": 7520,
	"./svgs/solid/map-pin.svg": 7521,
	"./svgs/solid/map-signs.svg": 7522,
	"./svgs/solid/map.svg": 7523,
	"./svgs/solid/marker.svg": 7524,
	"./svgs/solid/mars-double.svg": 7525,
	"./svgs/solid/mars-stroke-h.svg": 7526,
	"./svgs/solid/mars-stroke-v.svg": 7527,
	"./svgs/solid/mars-stroke.svg": 7528,
	"./svgs/solid/mars.svg": 7529,
	"./svgs/solid/mask.svg": 7530,
	"./svgs/solid/meat.svg": 7531,
	"./svgs/solid/medal.svg": 7532,
	"./svgs/solid/medkit.svg": 7533,
	"./svgs/solid/megaphone.svg": 7534,
	"./svgs/solid/meh-blank.svg": 7535,
	"./svgs/solid/meh-rolling-eyes.svg": 7536,
	"./svgs/solid/meh.svg": 7537,
	"./svgs/solid/memory.svg": 7538,
	"./svgs/solid/menorah.svg": 7539,
	"./svgs/solid/mercury.svg": 7540,
	"./svgs/solid/meteor.svg": 7541,
	"./svgs/solid/microchip.svg": 7542,
	"./svgs/solid/microphone-alt-slash.svg": 7543,
	"./svgs/solid/microphone-alt.svg": 7544,
	"./svgs/solid/microphone-slash.svg": 7545,
	"./svgs/solid/microphone-stand.svg": 7546,
	"./svgs/solid/microphone.svg": 7547,
	"./svgs/solid/microscope.svg": 7548,
	"./svgs/solid/microwave.svg": 7549,
	"./svgs/solid/mind-share.svg": 7550,
	"./svgs/solid/minus-circle.svg": 7551,
	"./svgs/solid/minus-hexagon.svg": 7552,
	"./svgs/solid/minus-octagon.svg": 7553,
	"./svgs/solid/minus-square.svg": 7554,
	"./svgs/solid/minus.svg": 7555,
	"./svgs/solid/mistletoe.svg": 7556,
	"./svgs/solid/mitten.svg": 7557,
	"./svgs/solid/mobile-alt.svg": 7558,
	"./svgs/solid/mobile-android-alt.svg": 7559,
	"./svgs/solid/mobile-android.svg": 7560,
	"./svgs/solid/mobile.svg": 7561,
	"./svgs/solid/money-bill-alt.svg": 7562,
	"./svgs/solid/money-bill-wave-alt.svg": 7563,
	"./svgs/solid/money-bill-wave.svg": 7564,
	"./svgs/solid/money-bill.svg": 7565,
	"./svgs/solid/money-check-alt.svg": 7566,
	"./svgs/solid/money-check-edit-alt.svg": 7567,
	"./svgs/solid/money-check-edit.svg": 7568,
	"./svgs/solid/money-check.svg": 7569,
	"./svgs/solid/monitor-heart-rate.svg": 7570,
	"./svgs/solid/monkey.svg": 7571,
	"./svgs/solid/monument.svg": 7572,
	"./svgs/solid/moon-cloud.svg": 7573,
	"./svgs/solid/moon-stars.svg": 7574,
	"./svgs/solid/moon.svg": 7575,
	"./svgs/solid/mortar-pestle.svg": 7576,
	"./svgs/solid/mosque.svg": 7577,
	"./svgs/solid/motorcycle.svg": 7578,
	"./svgs/solid/mountain.svg": 7579,
	"./svgs/solid/mountains.svg": 7580,
	"./svgs/solid/mouse-alt.svg": 7581,
	"./svgs/solid/mouse-pointer.svg": 7582,
	"./svgs/solid/mouse.svg": 7583,
	"./svgs/solid/mp3-player.svg": 7584,
	"./svgs/solid/mug-hot.svg": 7585,
	"./svgs/solid/mug-marshmallows.svg": 7586,
	"./svgs/solid/mug-tea.svg": 7587,
	"./svgs/solid/mug.svg": 7588,
	"./svgs/solid/music-alt-slash.svg": 7589,
	"./svgs/solid/music-alt.svg": 7590,
	"./svgs/solid/music-slash.svg": 7591,
	"./svgs/solid/music.svg": 7592,
	"./svgs/solid/narwhal.svg": 7593,
	"./svgs/solid/network-wired.svg": 7594,
	"./svgs/solid/neuter.svg": 7595,
	"./svgs/solid/newspaper.svg": 7596,
	"./svgs/solid/not-equal.svg": 7597,
	"./svgs/solid/notes-medical.svg": 7598,
	"./svgs/solid/object-group.svg": 7599,
	"./svgs/solid/object-ungroup.svg": 7600,
	"./svgs/solid/octagon.svg": 7601,
	"./svgs/solid/oil-can.svg": 7602,
	"./svgs/solid/oil-temp.svg": 7603,
	"./svgs/solid/om.svg": 7604,
	"./svgs/solid/omega.svg": 7605,
	"./svgs/solid/ornament.svg": 7606,
	"./svgs/solid/otter.svg": 7607,
	"./svgs/solid/outdent.svg": 7608,
	"./svgs/solid/outlet.svg": 7609,
	"./svgs/solid/oven.svg": 7610,
	"./svgs/solid/overline.svg": 7611,
	"./svgs/solid/page-break.svg": 7612,
	"./svgs/solid/pager.svg": 7613,
	"./svgs/solid/paint-brush-alt.svg": 7614,
	"./svgs/solid/paint-brush.svg": 7615,
	"./svgs/solid/paint-roller.svg": 7616,
	"./svgs/solid/palette.svg": 7617,
	"./svgs/solid/pallet-alt.svg": 7618,
	"./svgs/solid/pallet.svg": 7619,
	"./svgs/solid/paper-plane.svg": 7620,
	"./svgs/solid/paperclip.svg": 7621,
	"./svgs/solid/parachute-box.svg": 7622,
	"./svgs/solid/paragraph-rtl.svg": 7623,
	"./svgs/solid/paragraph.svg": 7624,
	"./svgs/solid/parking-circle-slash.svg": 7625,
	"./svgs/solid/parking-circle.svg": 7626,
	"./svgs/solid/parking-slash.svg": 7627,
	"./svgs/solid/parking.svg": 7628,
	"./svgs/solid/passport.svg": 7629,
	"./svgs/solid/pastafarianism.svg": 7630,
	"./svgs/solid/paste.svg": 7631,
	"./svgs/solid/pause-circle.svg": 7632,
	"./svgs/solid/pause.svg": 7633,
	"./svgs/solid/paw-alt.svg": 7634,
	"./svgs/solid/paw-claws.svg": 7635,
	"./svgs/solid/paw.svg": 7636,
	"./svgs/solid/peace.svg": 7637,
	"./svgs/solid/pegasus.svg": 7638,
	"./svgs/solid/pen-alt.svg": 7639,
	"./svgs/solid/pen-fancy.svg": 7640,
	"./svgs/solid/pen-nib.svg": 7641,
	"./svgs/solid/pen-square.svg": 7642,
	"./svgs/solid/pen.svg": 7643,
	"./svgs/solid/pencil-alt.svg": 7644,
	"./svgs/solid/pencil-paintbrush.svg": 7645,
	"./svgs/solid/pencil-ruler.svg": 7646,
	"./svgs/solid/pencil.svg": 7647,
	"./svgs/solid/pennant.svg": 7648,
	"./svgs/solid/people-carry.svg": 7649,
	"./svgs/solid/pepper-hot.svg": 7650,
	"./svgs/solid/percent.svg": 7651,
	"./svgs/solid/percentage.svg": 7652,
	"./svgs/solid/person-booth.svg": 7653,
	"./svgs/solid/person-carry.svg": 7654,
	"./svgs/solid/person-dolly-empty.svg": 7655,
	"./svgs/solid/person-dolly.svg": 7656,
	"./svgs/solid/person-sign.svg": 7657,
	"./svgs/solid/phone-alt.svg": 7658,
	"./svgs/solid/phone-laptop.svg": 7659,
	"./svgs/solid/phone-office.svg": 7660,
	"./svgs/solid/phone-plus.svg": 7661,
	"./svgs/solid/phone-rotary.svg": 7662,
	"./svgs/solid/phone-slash.svg": 7663,
	"./svgs/solid/phone-square-alt.svg": 7664,
	"./svgs/solid/phone-square.svg": 7665,
	"./svgs/solid/phone-volume.svg": 7666,
	"./svgs/solid/phone.svg": 7667,
	"./svgs/solid/photo-video.svg": 7668,
	"./svgs/solid/pi.svg": 7669,
	"./svgs/solid/piano-keyboard.svg": 7670,
	"./svgs/solid/piano.svg": 7671,
	"./svgs/solid/pie.svg": 7672,
	"./svgs/solid/pig.svg": 7673,
	"./svgs/solid/piggy-bank.svg": 7674,
	"./svgs/solid/pills.svg": 7675,
	"./svgs/solid/pizza-slice.svg": 7676,
	"./svgs/solid/pizza.svg": 7677,
	"./svgs/solid/place-of-worship.svg": 7678,
	"./svgs/solid/plane-alt.svg": 7679,
	"./svgs/solid/plane-arrival.svg": 7680,
	"./svgs/solid/plane-departure.svg": 7681,
	"./svgs/solid/plane.svg": 7682,
	"./svgs/solid/planet-moon.svg": 7683,
	"./svgs/solid/planet-ringed.svg": 7684,
	"./svgs/solid/play-circle.svg": 7685,
	"./svgs/solid/play.svg": 7686,
	"./svgs/solid/plug.svg": 7687,
	"./svgs/solid/plus-circle.svg": 7688,
	"./svgs/solid/plus-hexagon.svg": 7689,
	"./svgs/solid/plus-octagon.svg": 7690,
	"./svgs/solid/plus-square.svg": 7691,
	"./svgs/solid/plus.svg": 7692,
	"./svgs/solid/podcast.svg": 7693,
	"./svgs/solid/podium-star.svg": 7694,
	"./svgs/solid/podium.svg": 7695,
	"./svgs/solid/police-box.svg": 7696,
	"./svgs/solid/poll-h.svg": 7697,
	"./svgs/solid/poll-people.svg": 7698,
	"./svgs/solid/poll.svg": 7699,
	"./svgs/solid/poo-storm.svg": 7700,
	"./svgs/solid/poo.svg": 7701,
	"./svgs/solid/poop.svg": 7702,
	"./svgs/solid/popcorn.svg": 7703,
	"./svgs/solid/portal-enter.svg": 7704,
	"./svgs/solid/portal-exit.svg": 7705,
	"./svgs/solid/portrait.svg": 7706,
	"./svgs/solid/pound-sign.svg": 7707,
	"./svgs/solid/power-off.svg": 7708,
	"./svgs/solid/pray.svg": 7709,
	"./svgs/solid/praying-hands.svg": 7710,
	"./svgs/solid/prescription-bottle-alt.svg": 7711,
	"./svgs/solid/prescription-bottle.svg": 7712,
	"./svgs/solid/prescription.svg": 7713,
	"./svgs/solid/presentation.svg": 7714,
	"./svgs/solid/print-search.svg": 7715,
	"./svgs/solid/print-slash.svg": 7716,
	"./svgs/solid/print.svg": 7717,
	"./svgs/solid/procedures.svg": 7718,
	"./svgs/solid/project-diagram.svg": 7719,
	"./svgs/solid/projector.svg": 7720,
	"./svgs/solid/pumpkin.svg": 7721,
	"./svgs/solid/puzzle-piece.svg": 7722,
	"./svgs/solid/qrcode.svg": 7723,
	"./svgs/solid/question-circle.svg": 7724,
	"./svgs/solid/question-square.svg": 7725,
	"./svgs/solid/question.svg": 7726,
	"./svgs/solid/quidditch.svg": 7727,
	"./svgs/solid/quote-left.svg": 7728,
	"./svgs/solid/quote-right.svg": 7729,
	"./svgs/solid/quran.svg": 7730,
	"./svgs/solid/rabbit-fast.svg": 7731,
	"./svgs/solid/rabbit.svg": 7732,
	"./svgs/solid/racquet.svg": 7733,
	"./svgs/solid/radar.svg": 7734,
	"./svgs/solid/radiation-alt.svg": 7735,
	"./svgs/solid/radiation.svg": 7736,
	"./svgs/solid/radio-alt.svg": 7737,
	"./svgs/solid/radio.svg": 7738,
	"./svgs/solid/rainbow.svg": 7739,
	"./svgs/solid/raindrops.svg": 7740,
	"./svgs/solid/ram.svg": 7741,
	"./svgs/solid/ramp-loading.svg": 7742,
	"./svgs/solid/random.svg": 7743,
	"./svgs/solid/raygun.svg": 7744,
	"./svgs/solid/receipt.svg": 7745,
	"./svgs/solid/record-vinyl.svg": 7746,
	"./svgs/solid/rectangle-landscape.svg": 7747,
	"./svgs/solid/rectangle-portrait.svg": 7748,
	"./svgs/solid/rectangle-wide.svg": 7749,
	"./svgs/solid/recycle.svg": 7750,
	"./svgs/solid/redo-alt.svg": 7751,
	"./svgs/solid/redo.svg": 7752,
	"./svgs/solid/refrigerator.svg": 7753,
	"./svgs/solid/registered.svg": 7754,
	"./svgs/solid/remove-format.svg": 7755,
	"./svgs/solid/repeat-1-alt.svg": 7756,
	"./svgs/solid/repeat-1.svg": 7757,
	"./svgs/solid/repeat-alt.svg": 7758,
	"./svgs/solid/repeat.svg": 7759,
	"./svgs/solid/reply-all.svg": 7760,
	"./svgs/solid/reply.svg": 7761,
	"./svgs/solid/republican.svg": 7762,
	"./svgs/solid/restroom.svg": 7763,
	"./svgs/solid/retweet-alt.svg": 7764,
	"./svgs/solid/retweet.svg": 7765,
	"./svgs/solid/ribbon.svg": 7766,
	"./svgs/solid/ring.svg": 7767,
	"./svgs/solid/rings-wedding.svg": 7768,
	"./svgs/solid/road.svg": 7769,
	"./svgs/solid/robot.svg": 7770,
	"./svgs/solid/rocket-launch.svg": 7771,
	"./svgs/solid/rocket.svg": 7772,
	"./svgs/solid/route-highway.svg": 7773,
	"./svgs/solid/route-interstate.svg": 7774,
	"./svgs/solid/route.svg": 7775,
	"./svgs/solid/router.svg": 7776,
	"./svgs/solid/rss-square.svg": 7777,
	"./svgs/solid/rss.svg": 7778,
	"./svgs/solid/ruble-sign.svg": 7779,
	"./svgs/solid/ruler-combined.svg": 7780,
	"./svgs/solid/ruler-horizontal.svg": 7781,
	"./svgs/solid/ruler-triangle.svg": 7782,
	"./svgs/solid/ruler-vertical.svg": 7783,
	"./svgs/solid/ruler.svg": 7784,
	"./svgs/solid/running.svg": 7785,
	"./svgs/solid/rupee-sign.svg": 7786,
	"./svgs/solid/rv.svg": 7787,
	"./svgs/solid/sack-dollar.svg": 7788,
	"./svgs/solid/sack.svg": 7789,
	"./svgs/solid/sad-cry.svg": 7790,
	"./svgs/solid/sad-tear.svg": 7791,
	"./svgs/solid/salad.svg": 7792,
	"./svgs/solid/sandwich.svg": 7793,
	"./svgs/solid/satellite-dish.svg": 7794,
	"./svgs/solid/satellite.svg": 7795,
	"./svgs/solid/sausage.svg": 7796,
	"./svgs/solid/save.svg": 7797,
	"./svgs/solid/sax-hot.svg": 7798,
	"./svgs/solid/saxophone.svg": 7799,
	"./svgs/solid/scalpel-path.svg": 7800,
	"./svgs/solid/scalpel.svg": 7801,
	"./svgs/solid/scanner-image.svg": 7802,
	"./svgs/solid/scanner-keyboard.svg": 7803,
	"./svgs/solid/scanner-touchscreen.svg": 7804,
	"./svgs/solid/scanner.svg": 7805,
	"./svgs/solid/scarecrow.svg": 7806,
	"./svgs/solid/scarf.svg": 7807,
	"./svgs/solid/school.svg": 7808,
	"./svgs/solid/screwdriver.svg": 7809,
	"./svgs/solid/scroll-old.svg": 7810,
	"./svgs/solid/scroll.svg": 7811,
	"./svgs/solid/scrubber.svg": 7812,
	"./svgs/solid/scythe.svg": 7813,
	"./svgs/solid/sd-card.svg": 7814,
	"./svgs/solid/search-dollar.svg": 7815,
	"./svgs/solid/search-location.svg": 7816,
	"./svgs/solid/search-minus.svg": 7817,
	"./svgs/solid/search-plus.svg": 7818,
	"./svgs/solid/search.svg": 7819,
	"./svgs/solid/seedling.svg": 7820,
	"./svgs/solid/send-back.svg": 7821,
	"./svgs/solid/send-backward.svg": 7822,
	"./svgs/solid/sensor-alert.svg": 7823,
	"./svgs/solid/sensor-fire.svg": 7824,
	"./svgs/solid/sensor-on.svg": 7825,
	"./svgs/solid/sensor-smoke.svg": 7826,
	"./svgs/solid/sensor.svg": 7827,
	"./svgs/solid/server.svg": 7828,
	"./svgs/solid/shapes.svg": 7829,
	"./svgs/solid/share-all.svg": 7830,
	"./svgs/solid/share-alt-square.svg": 7831,
	"./svgs/solid/share-alt.svg": 7832,
	"./svgs/solid/share-square.svg": 7833,
	"./svgs/solid/share.svg": 7834,
	"./svgs/solid/sheep.svg": 7835,
	"./svgs/solid/shekel-sign.svg": 7836,
	"./svgs/solid/shield-alt.svg": 7837,
	"./svgs/solid/shield-check.svg": 7838,
	"./svgs/solid/shield-cross.svg": 7839,
	"./svgs/solid/shield.svg": 7840,
	"./svgs/solid/ship.svg": 7841,
	"./svgs/solid/shipping-fast.svg": 7842,
	"./svgs/solid/shipping-timed.svg": 7843,
	"./svgs/solid/shish-kebab.svg": 7844,
	"./svgs/solid/shoe-prints.svg": 7845,
	"./svgs/solid/shopping-bag.svg": 7846,
	"./svgs/solid/shopping-basket.svg": 7847,
	"./svgs/solid/shopping-cart.svg": 7848,
	"./svgs/solid/shovel-snow.svg": 7849,
	"./svgs/solid/shovel.svg": 7850,
	"./svgs/solid/shower.svg": 7851,
	"./svgs/solid/shredder.svg": 7852,
	"./svgs/solid/shuttle-van.svg": 7853,
	"./svgs/solid/shuttlecock.svg": 7854,
	"./svgs/solid/sickle.svg": 7855,
	"./svgs/solid/sigma.svg": 7856,
	"./svgs/solid/sign-in-alt.svg": 7857,
	"./svgs/solid/sign-in.svg": 7858,
	"./svgs/solid/sign-language.svg": 7859,
	"./svgs/solid/sign-out-alt.svg": 7860,
	"./svgs/solid/sign-out.svg": 7861,
	"./svgs/solid/sign.svg": 7862,
	"./svgs/solid/signal-1.svg": 7863,
	"./svgs/solid/signal-2.svg": 7864,
	"./svgs/solid/signal-3.svg": 7865,
	"./svgs/solid/signal-4.svg": 7866,
	"./svgs/solid/signal-alt-1.svg": 7867,
	"./svgs/solid/signal-alt-2.svg": 7868,
	"./svgs/solid/signal-alt-3.svg": 7869,
	"./svgs/solid/signal-alt-slash.svg": 7870,
	"./svgs/solid/signal-alt.svg": 7871,
	"./svgs/solid/signal-slash.svg": 7872,
	"./svgs/solid/signal-stream.svg": 7873,
	"./svgs/solid/signal.svg": 7874,
	"./svgs/solid/signature.svg": 7875,
	"./svgs/solid/sim-card.svg": 7876,
	"./svgs/solid/siren-on.svg": 7877,
	"./svgs/solid/siren.svg": 7878,
	"./svgs/solid/sitemap.svg": 7879,
	"./svgs/solid/skating.svg": 7880,
	"./svgs/solid/skeleton.svg": 7881,
	"./svgs/solid/ski-jump.svg": 7882,
	"./svgs/solid/ski-lift.svg": 7883,
	"./svgs/solid/skiing-nordic.svg": 7884,
	"./svgs/solid/skiing.svg": 7885,
	"./svgs/solid/skull-cow.svg": 7886,
	"./svgs/solid/skull-crossbones.svg": 7887,
	"./svgs/solid/skull.svg": 7888,
	"./svgs/solid/slash.svg": 7889,
	"./svgs/solid/sledding.svg": 7890,
	"./svgs/solid/sleigh.svg": 7891,
	"./svgs/solid/sliders-h-square.svg": 7892,
	"./svgs/solid/sliders-h.svg": 7893,
	"./svgs/solid/sliders-v-square.svg": 7894,
	"./svgs/solid/sliders-v.svg": 7895,
	"./svgs/solid/smile-beam.svg": 7896,
	"./svgs/solid/smile-plus.svg": 7897,
	"./svgs/solid/smile-wink.svg": 7898,
	"./svgs/solid/smile.svg": 7899,
	"./svgs/solid/smog.svg": 7900,
	"./svgs/solid/smoke.svg": 7901,
	"./svgs/solid/smoking-ban.svg": 7902,
	"./svgs/solid/smoking.svg": 7903,
	"./svgs/solid/sms.svg": 7904,
	"./svgs/solid/snake.svg": 7905,
	"./svgs/solid/snooze.svg": 7906,
	"./svgs/solid/snow-blowing.svg": 7907,
	"./svgs/solid/snowboarding.svg": 7908,
	"./svgs/solid/snowflake.svg": 7909,
	"./svgs/solid/snowflakes.svg": 7910,
	"./svgs/solid/snowman.svg": 7911,
	"./svgs/solid/snowmobile.svg": 7912,
	"./svgs/solid/snowplow.svg": 7913,
	"./svgs/solid/socks.svg": 7914,
	"./svgs/solid/solar-panel.svg": 7915,
	"./svgs/solid/solar-system.svg": 7916,
	"./svgs/solid/sort-alpha-down-alt.svg": 7917,
	"./svgs/solid/sort-alpha-down.svg": 7918,
	"./svgs/solid/sort-alpha-up-alt.svg": 7919,
	"./svgs/solid/sort-alpha-up.svg": 7920,
	"./svgs/solid/sort-alt.svg": 7921,
	"./svgs/solid/sort-amount-down-alt.svg": 7922,
	"./svgs/solid/sort-amount-down.svg": 7923,
	"./svgs/solid/sort-amount-up-alt.svg": 7924,
	"./svgs/solid/sort-amount-up.svg": 7925,
	"./svgs/solid/sort-circle-down.svg": 7926,
	"./svgs/solid/sort-circle-up.svg": 7927,
	"./svgs/solid/sort-circle.svg": 7928,
	"./svgs/solid/sort-down.svg": 7929,
	"./svgs/solid/sort-numeric-down-alt.svg": 7930,
	"./svgs/solid/sort-numeric-down.svg": 7931,
	"./svgs/solid/sort-numeric-up-alt.svg": 7932,
	"./svgs/solid/sort-numeric-up.svg": 7933,
	"./svgs/solid/sort-shapes-down-alt.svg": 7934,
	"./svgs/solid/sort-shapes-down.svg": 7935,
	"./svgs/solid/sort-shapes-up-alt.svg": 7936,
	"./svgs/solid/sort-shapes-up.svg": 7937,
	"./svgs/solid/sort-size-down-alt.svg": 7938,
	"./svgs/solid/sort-size-down.svg": 7939,
	"./svgs/solid/sort-size-up-alt.svg": 7940,
	"./svgs/solid/sort-size-up.svg": 7941,
	"./svgs/solid/sort-up.svg": 7942,
	"./svgs/solid/sort.svg": 7943,
	"./svgs/solid/soup.svg": 7944,
	"./svgs/solid/spa.svg": 7945,
	"./svgs/solid/space-shuttle.svg": 7946,
	"./svgs/solid/space-station-moon-alt.svg": 7947,
	"./svgs/solid/space-station-moon.svg": 7948,
	"./svgs/solid/spade.svg": 7949,
	"./svgs/solid/sparkles.svg": 7950,
	"./svgs/solid/speaker.svg": 7951,
	"./svgs/solid/speakers.svg": 7952,
	"./svgs/solid/spell-check.svg": 7953,
	"./svgs/solid/spider-black-widow.svg": 7954,
	"./svgs/solid/spider-web.svg": 7955,
	"./svgs/solid/spider.svg": 7956,
	"./svgs/solid/spinner-third.svg": 7957,
	"./svgs/solid/spinner.svg": 7958,
	"./svgs/solid/splotch.svg": 7959,
	"./svgs/solid/spray-can.svg": 7960,
	"./svgs/solid/sprinkler.svg": 7961,
	"./svgs/solid/square-full.svg": 7962,
	"./svgs/solid/square-root-alt.svg": 7963,
	"./svgs/solid/square-root.svg": 7964,
	"./svgs/solid/square.svg": 7965,
	"./svgs/solid/squirrel.svg": 7966,
	"./svgs/solid/staff.svg": 7967,
	"./svgs/solid/stamp.svg": 7968,
	"./svgs/solid/star-and-crescent.svg": 7969,
	"./svgs/solid/star-christmas.svg": 7970,
	"./svgs/solid/star-exclamation.svg": 7971,
	"./svgs/solid/star-half-alt.svg": 7972,
	"./svgs/solid/star-half.svg": 7973,
	"./svgs/solid/star-of-david.svg": 7974,
	"./svgs/solid/star-of-life.svg": 7975,
	"./svgs/solid/star-shooting.svg": 7976,
	"./svgs/solid/star.svg": 7977,
	"./svgs/solid/starfighter-alt.svg": 7978,
	"./svgs/solid/starfighter.svg": 7979,
	"./svgs/solid/stars.svg": 7980,
	"./svgs/solid/starship-freighter.svg": 7981,
	"./svgs/solid/starship.svg": 7982,
	"./svgs/solid/steak.svg": 7983,
	"./svgs/solid/steering-wheel.svg": 7984,
	"./svgs/solid/step-backward.svg": 7985,
	"./svgs/solid/step-forward.svg": 7986,
	"./svgs/solid/stethoscope.svg": 7987,
	"./svgs/solid/sticky-note.svg": 7988,
	"./svgs/solid/stocking.svg": 7989,
	"./svgs/solid/stomach.svg": 7990,
	"./svgs/solid/stop-circle.svg": 7991,
	"./svgs/solid/stop.svg": 7992,
	"./svgs/solid/stopwatch.svg": 7993,
	"./svgs/solid/store-alt.svg": 7994,
	"./svgs/solid/store.svg": 7995,
	"./svgs/solid/stream.svg": 7996,
	"./svgs/solid/street-view.svg": 7997,
	"./svgs/solid/stretcher.svg": 7998,
	"./svgs/solid/strikethrough.svg": 7999,
	"./svgs/solid/stroopwafel.svg": 8000,
	"./svgs/solid/subscript.svg": 8001,
	"./svgs/solid/subway.svg": 8002,
	"./svgs/solid/suitcase-rolling.svg": 8003,
	"./svgs/solid/suitcase.svg": 8004,
	"./svgs/solid/sun-cloud.svg": 8005,
	"./svgs/solid/sun-dust.svg": 8006,
	"./svgs/solid/sun-haze.svg": 8007,
	"./svgs/solid/sun.svg": 8008,
	"./svgs/solid/sunglasses.svg": 8009,
	"./svgs/solid/sunrise.svg": 8010,
	"./svgs/solid/sunset.svg": 8011,
	"./svgs/solid/superscript.svg": 8012,
	"./svgs/solid/surprise.svg": 8013,
	"./svgs/solid/swatchbook.svg": 8014,
	"./svgs/solid/swimmer.svg": 8015,
	"./svgs/solid/swimming-pool.svg": 8016,
	"./svgs/solid/sword-laser-alt.svg": 8017,
	"./svgs/solid/sword-laser.svg": 8018,
	"./svgs/solid/sword.svg": 8019,
	"./svgs/solid/swords-laser.svg": 8020,
	"./svgs/solid/swords.svg": 8021,
	"./svgs/solid/synagogue.svg": 8022,
	"./svgs/solid/sync-alt.svg": 8023,
	"./svgs/solid/sync.svg": 8024,
	"./svgs/solid/syringe.svg": 8025,
	"./svgs/solid/table-tennis.svg": 8026,
	"./svgs/solid/table.svg": 8027,
	"./svgs/solid/tablet-alt.svg": 8028,
	"./svgs/solid/tablet-android-alt.svg": 8029,
	"./svgs/solid/tablet-android.svg": 8030,
	"./svgs/solid/tablet-rugged.svg": 8031,
	"./svgs/solid/tablet.svg": 8032,
	"./svgs/solid/tablets.svg": 8033,
	"./svgs/solid/tachometer-alt-average.svg": 8034,
	"./svgs/solid/tachometer-alt-fast.svg": 8035,
	"./svgs/solid/tachometer-alt-fastest.svg": 8036,
	"./svgs/solid/tachometer-alt-slow.svg": 8037,
	"./svgs/solid/tachometer-alt-slowest.svg": 8038,
	"./svgs/solid/tachometer-alt.svg": 8039,
	"./svgs/solid/tachometer-average.svg": 8040,
	"./svgs/solid/tachometer-fast.svg": 8041,
	"./svgs/solid/tachometer-fastest.svg": 8042,
	"./svgs/solid/tachometer-slow.svg": 8043,
	"./svgs/solid/tachometer-slowest.svg": 8044,
	"./svgs/solid/tachometer.svg": 8045,
	"./svgs/solid/taco.svg": 8046,
	"./svgs/solid/tag.svg": 8047,
	"./svgs/solid/tags.svg": 8048,
	"./svgs/solid/tally.svg": 8049,
	"./svgs/solid/tanakh.svg": 8050,
	"./svgs/solid/tape.svg": 8051,
	"./svgs/solid/tasks-alt.svg": 8052,
	"./svgs/solid/tasks.svg": 8053,
	"./svgs/solid/taxi.svg": 8054,
	"./svgs/solid/teeth-open.svg": 8055,
	"./svgs/solid/teeth.svg": 8056,
	"./svgs/solid/telescope.svg": 8057,
	"./svgs/solid/temperature-down.svg": 8058,
	"./svgs/solid/temperature-frigid.svg": 8059,
	"./svgs/solid/temperature-high.svg": 8060,
	"./svgs/solid/temperature-hot.svg": 8061,
	"./svgs/solid/temperature-low.svg": 8062,
	"./svgs/solid/temperature-up.svg": 8063,
	"./svgs/solid/tenge.svg": 8064,
	"./svgs/solid/tennis-ball.svg": 8065,
	"./svgs/solid/terminal.svg": 8066,
	"./svgs/solid/text-height.svg": 8067,
	"./svgs/solid/text-size.svg": 8068,
	"./svgs/solid/text-width.svg": 8069,
	"./svgs/solid/text.svg": 8070,
	"./svgs/solid/th-large.svg": 8071,
	"./svgs/solid/th-list.svg": 8072,
	"./svgs/solid/th.svg": 8073,
	"./svgs/solid/theater-masks.svg": 8074,
	"./svgs/solid/thermometer-empty.svg": 8075,
	"./svgs/solid/thermometer-full.svg": 8076,
	"./svgs/solid/thermometer-half.svg": 8077,
	"./svgs/solid/thermometer-quarter.svg": 8078,
	"./svgs/solid/thermometer-three-quarters.svg": 8079,
	"./svgs/solid/thermometer.svg": 8080,
	"./svgs/solid/theta.svg": 8081,
	"./svgs/solid/thumbs-down.svg": 8082,
	"./svgs/solid/thumbs-up.svg": 8083,
	"./svgs/solid/thumbtack.svg": 8084,
	"./svgs/solid/thunderstorm-moon.svg": 8085,
	"./svgs/solid/thunderstorm-sun.svg": 8086,
	"./svgs/solid/thunderstorm.svg": 8087,
	"./svgs/solid/ticket-alt.svg": 8088,
	"./svgs/solid/ticket.svg": 8089,
	"./svgs/solid/tilde.svg": 8090,
	"./svgs/solid/times-circle.svg": 8091,
	"./svgs/solid/times-hexagon.svg": 8092,
	"./svgs/solid/times-octagon.svg": 8093,
	"./svgs/solid/times-square.svg": 8094,
	"./svgs/solid/times.svg": 8095,
	"./svgs/solid/tint-slash.svg": 8096,
	"./svgs/solid/tint.svg": 8097,
	"./svgs/solid/tire-flat.svg": 8098,
	"./svgs/solid/tire-pressure-warning.svg": 8099,
	"./svgs/solid/tire-rugged.svg": 8100,
	"./svgs/solid/tire.svg": 8101,
	"./svgs/solid/tired.svg": 8102,
	"./svgs/solid/toggle-off.svg": 8103,
	"./svgs/solid/toggle-on.svg": 8104,
	"./svgs/solid/toilet-paper-alt.svg": 8105,
	"./svgs/solid/toilet-paper.svg": 8106,
	"./svgs/solid/toilet.svg": 8107,
	"./svgs/solid/tombstone-alt.svg": 8108,
	"./svgs/solid/tombstone.svg": 8109,
	"./svgs/solid/toolbox.svg": 8110,
	"./svgs/solid/tools.svg": 8111,
	"./svgs/solid/tooth.svg": 8112,
	"./svgs/solid/toothbrush.svg": 8113,
	"./svgs/solid/torah.svg": 8114,
	"./svgs/solid/torii-gate.svg": 8115,
	"./svgs/solid/tornado.svg": 8116,
	"./svgs/solid/tractor.svg": 8117,
	"./svgs/solid/trademark.svg": 8118,
	"./svgs/solid/traffic-cone.svg": 8119,
	"./svgs/solid/traffic-light-go.svg": 8120,
	"./svgs/solid/traffic-light-slow.svg": 8121,
	"./svgs/solid/traffic-light-stop.svg": 8122,
	"./svgs/solid/traffic-light.svg": 8123,
	"./svgs/solid/trailer.svg": 8124,
	"./svgs/solid/train.svg": 8125,
	"./svgs/solid/tram.svg": 8126,
	"./svgs/solid/transgender-alt.svg": 8127,
	"./svgs/solid/transgender.svg": 8128,
	"./svgs/solid/transporter-1.svg": 8129,
	"./svgs/solid/transporter-2.svg": 8130,
	"./svgs/solid/transporter-3.svg": 8131,
	"./svgs/solid/transporter-empty.svg": 8132,
	"./svgs/solid/transporter.svg": 8133,
	"./svgs/solid/trash-alt.svg": 8134,
	"./svgs/solid/trash-restore-alt.svg": 8135,
	"./svgs/solid/trash-restore.svg": 8136,
	"./svgs/solid/trash-undo-alt.svg": 8137,
	"./svgs/solid/trash-undo.svg": 8138,
	"./svgs/solid/trash.svg": 8139,
	"./svgs/solid/treasure-chest.svg": 8140,
	"./svgs/solid/tree-alt.svg": 8141,
	"./svgs/solid/tree-christmas.svg": 8142,
	"./svgs/solid/tree-decorated.svg": 8143,
	"./svgs/solid/tree-large.svg": 8144,
	"./svgs/solid/tree-palm.svg": 8145,
	"./svgs/solid/tree.svg": 8146,
	"./svgs/solid/trees.svg": 8147,
	"./svgs/solid/triangle-music.svg": 8148,
	"./svgs/solid/triangle.svg": 8149,
	"./svgs/solid/trophy-alt.svg": 8150,
	"./svgs/solid/trophy.svg": 8151,
	"./svgs/solid/truck-container.svg": 8152,
	"./svgs/solid/truck-couch.svg": 8153,
	"./svgs/solid/truck-loading.svg": 8154,
	"./svgs/solid/truck-monster.svg": 8155,
	"./svgs/solid/truck-moving.svg": 8156,
	"./svgs/solid/truck-pickup.svg": 8157,
	"./svgs/solid/truck-plow.svg": 8158,
	"./svgs/solid/truck-ramp.svg": 8159,
	"./svgs/solid/truck.svg": 8160,
	"./svgs/solid/trumpet.svg": 8161,
	"./svgs/solid/tshirt.svg": 8162,
	"./svgs/solid/tty.svg": 8163,
	"./svgs/solid/turkey.svg": 8164,
	"./svgs/solid/turntable.svg": 8165,
	"./svgs/solid/turtle.svg": 8166,
	"./svgs/solid/tv-alt.svg": 8167,
	"./svgs/solid/tv-music.svg": 8168,
	"./svgs/solid/tv-retro.svg": 8169,
	"./svgs/solid/tv.svg": 8170,
	"./svgs/solid/typewriter.svg": 8171,
	"./svgs/solid/ufo-beam.svg": 8172,
	"./svgs/solid/ufo.svg": 8173,
	"./svgs/solid/umbrella-beach.svg": 8174,
	"./svgs/solid/umbrella.svg": 8175,
	"./svgs/solid/underline.svg": 8176,
	"./svgs/solid/undo-alt.svg": 8177,
	"./svgs/solid/undo.svg": 8178,
	"./svgs/solid/unicorn.svg": 8179,
	"./svgs/solid/union.svg": 8180,
	"./svgs/solid/universal-access.svg": 8181,
	"./svgs/solid/university.svg": 8182,
	"./svgs/solid/unlink.svg": 8183,
	"./svgs/solid/unlock-alt.svg": 8184,
	"./svgs/solid/unlock.svg": 8185,
	"./svgs/solid/upload.svg": 8186,
	"./svgs/solid/usb-drive.svg": 8187,
	"./svgs/solid/usd-circle.svg": 8188,
	"./svgs/solid/usd-square.svg": 8189,
	"./svgs/solid/user-alien.svg": 8190,
	"./svgs/solid/user-alt-slash.svg": 8191,
	"./svgs/solid/user-alt.svg": 8192,
	"./svgs/solid/user-astronaut.svg": 8193,
	"./svgs/solid/user-chart.svg": 8194,
	"./svgs/solid/user-check.svg": 8195,
	"./svgs/solid/user-circle.svg": 8196,
	"./svgs/solid/user-clock.svg": 8197,
	"./svgs/solid/user-cog.svg": 8198,
	"./svgs/solid/user-cowboy.svg": 8199,
	"./svgs/solid/user-crown.svg": 8200,
	"./svgs/solid/user-edit.svg": 8201,
	"./svgs/solid/user-friends.svg": 8202,
	"./svgs/solid/user-graduate.svg": 8203,
	"./svgs/solid/user-hard-hat.svg": 8204,
	"./svgs/solid/user-headset.svg": 8205,
	"./svgs/solid/user-injured.svg": 8206,
	"./svgs/solid/user-lock.svg": 8207,
	"./svgs/solid/user-md-chat.svg": 8208,
	"./svgs/solid/user-md.svg": 8209,
	"./svgs/solid/user-minus.svg": 8210,
	"./svgs/solid/user-music.svg": 8211,
	"./svgs/solid/user-ninja.svg": 8212,
	"./svgs/solid/user-nurse.svg": 8213,
	"./svgs/solid/user-plus.svg": 8214,
	"./svgs/solid/user-robot.svg": 8215,
	"./svgs/solid/user-secret.svg": 8216,
	"./svgs/solid/user-shield.svg": 8217,
	"./svgs/solid/user-slash.svg": 8218,
	"./svgs/solid/user-tag.svg": 8219,
	"./svgs/solid/user-tie.svg": 8220,
	"./svgs/solid/user-times.svg": 8221,
	"./svgs/solid/user-visor.svg": 8222,
	"./svgs/solid/user.svg": 8223,
	"./svgs/solid/users-class.svg": 8224,
	"./svgs/solid/users-cog.svg": 8225,
	"./svgs/solid/users-crown.svg": 8226,
	"./svgs/solid/users-medical.svg": 8227,
	"./svgs/solid/users.svg": 8228,
	"./svgs/solid/utensil-fork.svg": 8229,
	"./svgs/solid/utensil-knife.svg": 8230,
	"./svgs/solid/utensil-spoon.svg": 8231,
	"./svgs/solid/utensils-alt.svg": 8232,
	"./svgs/solid/utensils.svg": 8233,
	"./svgs/solid/vacuum-robot.svg": 8234,
	"./svgs/solid/vacuum.svg": 8235,
	"./svgs/solid/value-absolute.svg": 8236,
	"./svgs/solid/vector-square.svg": 8237,
	"./svgs/solid/venus-double.svg": 8238,
	"./svgs/solid/venus-mars.svg": 8239,
	"./svgs/solid/venus.svg": 8240,
	"./svgs/solid/vhs.svg": 8241,
	"./svgs/solid/vial.svg": 8242,
	"./svgs/solid/vials.svg": 8243,
	"./svgs/solid/video-plus.svg": 8244,
	"./svgs/solid/video-slash.svg": 8245,
	"./svgs/solid/video.svg": 8246,
	"./svgs/solid/vihara.svg": 8247,
	"./svgs/solid/violin.svg": 8248,
	"./svgs/solid/voicemail.svg": 8249,
	"./svgs/solid/volcano.svg": 8250,
	"./svgs/solid/volleyball-ball.svg": 8251,
	"./svgs/solid/volume-down.svg": 8252,
	"./svgs/solid/volume-mute.svg": 8253,
	"./svgs/solid/volume-off.svg": 8254,
	"./svgs/solid/volume-slash.svg": 8255,
	"./svgs/solid/volume-up.svg": 8256,
	"./svgs/solid/volume.svg": 8257,
	"./svgs/solid/vote-nay.svg": 8258,
	"./svgs/solid/vote-yea.svg": 8259,
	"./svgs/solid/vr-cardboard.svg": 8260,
	"./svgs/solid/wagon-covered.svg": 8261,
	"./svgs/solid/walker.svg": 8262,
	"./svgs/solid/walkie-talkie.svg": 8263,
	"./svgs/solid/walking.svg": 8264,
	"./svgs/solid/wallet.svg": 8265,
	"./svgs/solid/wand-magic.svg": 8266,
	"./svgs/solid/wand.svg": 8267,
	"./svgs/solid/warehouse-alt.svg": 8268,
	"./svgs/solid/warehouse.svg": 8269,
	"./svgs/solid/washer.svg": 8270,
	"./svgs/solid/watch-calculator.svg": 8271,
	"./svgs/solid/watch-fitness.svg": 8272,
	"./svgs/solid/watch.svg": 8273,
	"./svgs/solid/water-lower.svg": 8274,
	"./svgs/solid/water-rise.svg": 8275,
	"./svgs/solid/water.svg": 8276,
	"./svgs/solid/wave-sine.svg": 8277,
	"./svgs/solid/wave-square.svg": 8278,
	"./svgs/solid/wave-triangle.svg": 8279,
	"./svgs/solid/waveform-path.svg": 8280,
	"./svgs/solid/waveform.svg": 8281,
	"./svgs/solid/webcam-slash.svg": 8282,
	"./svgs/solid/webcam.svg": 8283,
	"./svgs/solid/weight-hanging.svg": 8284,
	"./svgs/solid/weight.svg": 8285,
	"./svgs/solid/whale.svg": 8286,
	"./svgs/solid/wheat.svg": 8287,
	"./svgs/solid/wheelchair.svg": 8288,
	"./svgs/solid/whistle.svg": 8289,
	"./svgs/solid/wifi-1.svg": 8290,
	"./svgs/solid/wifi-2.svg": 8291,
	"./svgs/solid/wifi-slash.svg": 8292,
	"./svgs/solid/wifi.svg": 8293,
	"./svgs/solid/wind-turbine.svg": 8294,
	"./svgs/solid/wind-warning.svg": 8295,
	"./svgs/solid/wind.svg": 8296,
	"./svgs/solid/window-alt.svg": 8297,
	"./svgs/solid/window-close.svg": 8298,
	"./svgs/solid/window-frame-open.svg": 8299,
	"./svgs/solid/window-frame.svg": 8300,
	"./svgs/solid/window-maximize.svg": 8301,
	"./svgs/solid/window-minimize.svg": 8302,
	"./svgs/solid/window-restore.svg": 8303,
	"./svgs/solid/window.svg": 8304,
	"./svgs/solid/windsock.svg": 8305,
	"./svgs/solid/wine-bottle.svg": 8306,
	"./svgs/solid/wine-glass-alt.svg": 8307,
	"./svgs/solid/wine-glass.svg": 8308,
	"./svgs/solid/won-sign.svg": 8309,
	"./svgs/solid/wreath.svg": 8310,
	"./svgs/solid/wrench.svg": 8311,
	"./svgs/solid/x-ray.svg": 8312,
	"./svgs/solid/yen-sign.svg": 8313,
	"./svgs/solid/yin-yang.svg": 8314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 607;